import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigInt: any;
  DateTime: any;
  JSONData: any;
  Time: any;
  UploadedFile: any;
};

export type AddDagTemplateToOrganization = {
  dagTemplateId: Scalars['ID'];
  /** Provide the organization ID to add. */
  organizationId: Scalars['ID'];
};

export type AddLibraryDataset = {
  /** Id of the selected library */
  libraryId: Scalars['ID'];
  /** List of tdo ids to add to the selected library */
  tdoIds: Array<InputMaybe<Scalars['ID']>>;
};

export type AddMediaSegment = {
  /** ID of the TemporalDataObject container for the segment */
  containerId: Scalars['ID'];
  /** Details for the segment, such as start and stop offset */
  details: Scalars['JSONData'];
  /** ID of the segment group (Optional) */
  segmentGroupId?: InputMaybe<Scalars['ID']>;
  /** The url to the segment content. */
  url: Scalars['String'];
};

export type AddMediaSegments = {
  /** Details for the segment, such as start and stop offset */
  details: Scalars['JSONData'];
  /** The url to the segment content. */
  url: Scalars['String'];
};

export type AddNotificationAction = {
  actionName?: InputMaybe<Scalars['String']>;
  application?: InputMaybe<Scalars['String']>;
  eventName: Scalars['String'];
  eventType: Scalars['String'];
  icon?: InputMaybe<Scalars['String']>;
  mailboxId?: InputMaybe<Scalars['ID']>;
  /** Handlebars template */
  urlTemplate: Scalars['String'];
};

export type AddNotificationTemplate = {
  /** ApplicationId of notification template */
  application?: InputMaybe<Scalars['String']>;
  /** Body of notification template (handlebars) */
  body: Scalars['String'];
  /** The event name of notification template */
  eventName: Scalars['String'];
  /** The event type of notification template */
  eventType: Scalars['String'];
  /** The mailboxId applied for notification template */
  mailboxId?: InputMaybe<Scalars['ID']>;
  /** Title of notification template (handlebars) */
  title: Scalars['String'];
};

export type AddTask = {
  buildId: Scalars['ID'];
  createdDateTime: Scalars['DateTime'];
  engineId: Scalars['ID'];
  id: Scalars['ID'];
  jobId: Scalars['ID'];
  parentTaskId?: InputMaybe<Scalars['ID']>;
  payload?: InputMaybe<Scalars['JSONData']>;
  status: TaskStatus;
};

export type AddTaskReplacementEngine = {
  organizationId?: InputMaybe<Scalars['ID']>;
  payloadFunc?: InputMaybe<Scalars['String']>;
  replacementEngineId: Scalars['ID'];
  sourceEngineId: Scalars['ID'];
};

export type AddTasksToJobs = {
  tasks?: InputMaybe<Array<AddTask>>;
};

export type AddTasksToJobsError = {
  __typename?: 'AddTasksToJobsError';
  id?: Maybe<Scalars['ID']>;
  message?: Maybe<Scalars['String']>;
};

export type AddTasksToJobsResponse = {
  __typename?: 'AddTasksToJobsResponse';
  createdTasks?: Maybe<Array<Maybe<Task>>>;
  errors?: Maybe<Array<Maybe<AddTasksToJobsError>>>;
};

/** An application is a set of Veritone functionality that customers can sign up for. */
export type Application = {
  __typename?: 'Application';
  /** The configs associated with this application */
  applicationConfig: ApplicationConfigList;
  /** The headerbar associated with this application */
  applicationHeaderbar?: Maybe<ApplicationHeaderbar>;
  billingDirty?: Maybe<Scalars['Boolean']>;
  /** Billing */
  billingPlanId?: Maybe<Scalars['ID']>;
  category?: Maybe<Scalars['String']>;
  /**
   * OAuth2 client secret. This field is server-generated and is only
   * returned on application creation.
   */
  clientSecret?: Maybe<Scalars['String']>;
  components?: Maybe<ApplicationComponent>;
  contextMenuExtensions?: Maybe<ContextMenuExtensionList>;
  createdDateTime?: Maybe<Scalars['DateTime']>;
  dailyTaskMetrics?: Maybe<DailyTaskMetricsList>;
  deploymentModel?: Maybe<DeploymentModel>;
  description?: Maybe<Scalars['String']>;
  /** The tags associated with the application */
  entityTags?: Maybe<Array<Maybe<EntityTag>>>;
  /**
   * The Application event endpoint.
   * The event is delivered to the application via the Event Routing for Applications mechanism.
   */
  eventEndpoint?: Maybe<Scalars['String']>;
  /** Whether or not the application will be wrapped in aiWare as an iframe */
  headerbarEnabled?: Maybe<Scalars['Boolean']>;
  iconSvg?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isPublic?: Maybe<Scalars['Boolean']>;
  key: Scalars['String'];
  modifiedDateTime?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  nodeModules?: Maybe<Array<Maybe<NodeModule>>>;
  /** OAuth2 redirect URLs */
  oauth2RedirectUrls?: Maybe<Array<Maybe<Scalars['String']>>>;
  organizationId?: Maybe<Scalars['ID']>;
  ownerOrganizationId: Scalars['ID'];
  permissionsRequired?: Maybe<Array<Maybe<Scalars['String']>>>;
  sharedWithOrganizationId?: Maybe<Scalars['ID']>;
  /** The signed URL for the application icon; will fallback to raw iconSvg if unable to sign. */
  signedIconSvg?: Maybe<Scalars['String']>;
  /** The signed URL for the application logo; will fallback to raw iconUrl if unable to sign. */
  signedIconUrl?: Maybe<Scalars['String']>;
  status?: Maybe<ApplicationStatus>;
  url?: Maybe<Scalars['String']>;
  validStateActions?: Maybe<Array<Maybe<ApplicationStateAction>>>;
};


/** An application is a set of Veritone functionality that customers can sign up for. */
export type ApplicationApplicationConfigArgs = {
  configKeyRegexp?: InputMaybe<Scalars['String']>;
  includeDefaults?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orgId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
};


/** An application is a set of Veritone functionality that customers can sign up for. */
export type ApplicationApplicationHeaderbarArgs = {
  orgId?: InputMaybe<Scalars['ID']>;
};


/** An application is a set of Veritone functionality that customers can sign up for. */
export type ApplicationClientSecretArgs = {
  password?: InputMaybe<Scalars['String']>;
};


/** An application is a set of Veritone functionality that customers can sign up for. */
export type ApplicationNodeModulesArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type ApplicationBillingDirty = {
  __typename?: 'ApplicationBillingDirty';
  applicationId: Scalars['ID'];
  billingDirty: Scalars['Boolean'];
  organizationId: Scalars['ID'];
};

export type ApplicationBillingPlanId = {
  __typename?: 'ApplicationBillingPlanId';
  applicationId: Scalars['ID'];
  billingDirty: Scalars['Boolean'];
  billingPlanId: Scalars['String'];
  organizationId: Scalars['ID'];
};

export type ApplicationComponent = {
  __typename?: 'ApplicationComponent';
  contextMenuExtensions?: Maybe<Array<Maybe<ContextMenuExtension>>>;
  dataRegistries?: Maybe<DataRegistryList>;
  engines?: Maybe<EngineList>;
};

export enum ApplicationComponentType {
  DataRegistries = 'dataRegistries',
  Engines = 'engines'
}

export type ApplicationConfig = {
  __typename?: 'ApplicationConfig';
  applicationId?: Maybe<Scalars['ID']>;
  configKey?: Maybe<Scalars['String']>;
  configLevel?: Maybe<ApplicationConfigLevelEnum>;
  configType?: Maybe<ApplicationConfigValueEnum>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<BasicUserInfo>;
  defaultCreatedAt?: Maybe<Scalars['DateTime']>;
  defaultCreatedBy?: Maybe<BasicUserInfo>;
  defaultModifiedAt?: Maybe<Scalars['DateTime']>;
  defaultModifiedBy?: Maybe<BasicUserInfo>;
  /** Default value */
  defaultValue?: Maybe<Scalars['String']>;
  defaultValueJSON?: Maybe<Scalars['JSONData']>;
  description?: Maybe<Scalars['String']>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy?: Maybe<BasicUserInfo>;
  organizationGuid?: Maybe<Scalars['ID']>;
  required?: Maybe<Scalars['Boolean']>;
  secured?: Maybe<Scalars['Boolean']>;
  userId?: Maybe<Scalars['ID']>;
  /** If set, this will contain the value */
  value?: Maybe<Scalars['String']>;
  valueJSON?: Maybe<Scalars['JSONData']>;
};

export type ApplicationConfigDefinition = {
  __typename?: 'ApplicationConfigDefinition';
  applicationId?: Maybe<Scalars['ID']>;
  configKey?: Maybe<Scalars['String']>;
  configLevel?: Maybe<ApplicationConfigLevelEnum>;
  configType?: Maybe<ApplicationConfigValueEnum>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<BasicUserInfo>;
  /** Default value */
  defaultValue?: Maybe<Scalars['String']>;
  defaultValueJSON?: Maybe<Scalars['JSONData']>;
  description?: Maybe<Scalars['String']>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy?: Maybe<BasicUserInfo>;
  organizationGuid?: Maybe<Scalars['ID']>;
  required?: Maybe<Scalars['Boolean']>;
  secured?: Maybe<Scalars['Boolean']>;
};

export type ApplicationConfigDefinitionCreate = {
  appId: Scalars['ID'];
  configKey: Scalars['String'];
  configLevel: ApplicationConfigLevelEnum;
  configType: ApplicationConfigValueEnum;
  /** Default value */
  defaultValue?: InputMaybe<Scalars['String']>;
  defaultValueJSON?: InputMaybe<Scalars['JSONData']>;
  description: Scalars['String'];
  orgId?: InputMaybe<Scalars['ID']>;
  required: Scalars['Boolean'];
  secured: Scalars['Boolean'];
};

export type ApplicationConfigDefinitionDelete = {
  appId: Scalars['ID'];
  configKey: Scalars['String'];
  orgId?: InputMaybe<Scalars['ID']>;
};

export type ApplicationConfigDefinitionFilter = {
  appId: Scalars['ID'];
  configKey: Scalars['String'];
  orgId?: InputMaybe<Scalars['ID']>;
};

export type ApplicationConfigDefinitionList = {
  __typename?: 'ApplicationConfigDefinitionList';
  count?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records: Array<Maybe<ApplicationConfigDefinition>>;
};

export type ApplicationConfigDefinitionUpdate = {
  configKey?: InputMaybe<Scalars['String']>;
  configLevel?: InputMaybe<ApplicationConfigLevelEnum>;
  configType?: InputMaybe<ApplicationConfigValueEnum>;
  /** Default value */
  defaultValue?: InputMaybe<Scalars['String']>;
  defaultValueJSON?: InputMaybe<Scalars['JSONData']>;
  description?: InputMaybe<Scalars['String']>;
  orgId?: InputMaybe<Scalars['ID']>;
  required?: InputMaybe<Scalars['Boolean']>;
  secured?: InputMaybe<Scalars['Boolean']>;
};

export type ApplicationConfigDefinitionUpdateInput = {
  /** A filter indicating which application config definition should be updated. */
  filter?: InputMaybe<ApplicationConfigDefinitionFilter>;
  /** Fields used to update an application config definition. */
  update?: InputMaybe<ApplicationConfigDefinitionUpdate>;
};

export type ApplicationConfigDelete = {
  appId: Scalars['ID'];
  configKey: Scalars['String'];
  orgId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type ApplicationConfigInput = {
  configJSON?: InputMaybe<Scalars['String']>;
  configKey: Scalars['String'];
  configValue?: InputMaybe<Scalars['String']>;
};

export enum ApplicationConfigLevelEnum {
  Organization = 'Organization',
  User = 'User'
}

export type ApplicationConfigList = {
  __typename?: 'ApplicationConfigList';
  count?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records: Array<Maybe<ApplicationConfig>>;
};

export type ApplicationConfigSetConfigInput = {
  appId: Scalars['ID'];
  configs: Array<ApplicationConfigValueInput>;
  orgId?: InputMaybe<Scalars['ID']>;
};

export enum ApplicationConfigValueEnum {
  Boolean = 'Boolean',
  Date = 'Date',
  Float = 'Float',
  Integer = 'Integer',
  Json = 'JSON',
  String = 'String'
}

export type ApplicationConfigValueInput = {
  configJSON?: InputMaybe<Scalars['JSONData']>;
  configKey: Scalars['String'];
  configValue?: InputMaybe<Scalars['String']>;
};

export type ApplicationHeaderbar = {
  __typename?: 'ApplicationHeaderbar';
  config?: Maybe<ApplicationHeaderbarConfig>;
  createdAt: Scalars['DateTime'];
  createdBy: BasicUserInfo;
  elementId?: Maybe<Scalars['String']>;
  modifiedAt: Scalars['DateTime'];
  modifiedBy: BasicUserInfo;
  name?: Maybe<Scalars['String']>;
};

export type ApplicationHeaderbarConfig = {
  __typename?: 'ApplicationHeaderbarConfig';
  backgroundColor?: Maybe<Scalars['String']>;
  displaySupportChat?: Maybe<Scalars['Boolean']>;
  help?: Maybe<Scalars['Boolean']>;
  hidePasswordReset?: Maybe<Scalars['Boolean']>;
  logoSrc?: Maybe<Scalars['String']>;
  notification?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  zIndex?: Maybe<Scalars['Int']>;
};

export type ApplicationHeaderbarConfigInput = {
  backgroundColor?: InputMaybe<Scalars['String']>;
  displaySupportChat?: InputMaybe<Scalars['Boolean']>;
  help?: InputMaybe<Scalars['Boolean']>;
  hidePasswordReset?: InputMaybe<Scalars['Boolean']>;
  logoSrc?: InputMaybe<Scalars['String']>;
  notification?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  zIndex?: InputMaybe<Scalars['Int']>;
};

export type ApplicationHeaderbarInput = {
  config?: InputMaybe<ApplicationHeaderbarConfigInput>;
  elementId: Scalars['String'];
  name: Scalars['String'];
};

export type ApplicationHeaderbarUpdate = {
  config?: InputMaybe<ApplicationHeaderbarConfigInput>;
  elementId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type ApplicationInviteRole = {
  __typename?: 'ApplicationInviteRole';
  /** Application to assign to the invited user */
  application?: Maybe<Application>;
  /** Role to assign to the invited user */
  role?: Maybe<Role>;
};

export type ApplicationInviteRoleInput = {
  /** Id of the application to grant access to */
  applicationId: Scalars['ID'];
  /** Application-specific role to assign to the invited user */
  roleId: Scalars['ID'];
};

export type ApplicationJwtTokenInfo = {
  __typename?: 'ApplicationJWTTokenInfo';
  applicationId: Scalars['ID'];
  organizationId: Scalars['ID'];
  token: Scalars['String'];
};

export type ApplicationList = Page & {
  __typename?: 'ApplicationList';
  /** Number of records returned in this response */
  count?: Maybe<Scalars['Int']>;
  /** Maximum number of results that were retrieved in this query; page size */
  limit: Scalars['Int'];
  /** The starting index for records that were returned in this query. */
  offset: Scalars['Int'];
  records?: Maybe<Array<Maybe<Application>>>;
};

/** TODO */
export type ApplicationPlatform = {
  __typename?: 'ApplicationPlatform';
  /** The application platform ID */
  id?: Maybe<Scalars['ID']>;
  /** Platform type, such as TODO */
  platformType?: Maybe<Scalars['String']>;
  /** The application platform URL. */
  platformUrl?: Maybe<Scalars['String']>;
};

export type ApplicationResourceInput = {
  resourceIds?: InputMaybe<Array<Scalars['ID']>>;
  resourceType: PackageResourceType;
};

export type ApplicationResourceUpdate = {
  action: PackageResourceAction;
  resourceIds?: InputMaybe<Array<Scalars['ID']>>;
  resourceType: PackageResourceType;
};

/**
 * create table if not exists role
 * (
 * role_id           uuid                              not null constraint "_pk_role@role_id" primary key,
 * role_name         text                              not null,
 * role_description  text                              not null,
 * app_name          text,
 * permissions       integer[] default '{}'::integer[] not null,
 * organization_id   integer,
 * is_private        boolean   default false           not null,
 * is_app_event_role boolean   default false,
 * );
 */
export type ApplicationRole = {
  __typename?: 'ApplicationRole';
  application: Application;
  description: Scalars['String'];
  id: Scalars['ID'];
  isApplicationEventRole: Scalars['Boolean'];
  isPrivate: Scalars['Boolean'];
  name: Scalars['String'];
  organization?: Maybe<Organization>;
  permissions?: Maybe<Array<Maybe<AuthPermissionType>>>;
};

export type ApplicationSetting = {
  __typename?: 'ApplicationSetting';
  applicationId: Scalars['ID'];
  description?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  organizationGuid: Scalars['ID'];
  type: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export enum ApplicationStateAction {
  Approve = 'approve',
  Delete = 'delete',
  Deploy = 'deploy',
  Disable = 'disable',
  Edit = 'edit',
  Enable = 'enable',
  Reject = 'reject',
  Submit = 'submit',
  Undelete = 'undelete'
}

/**
 * Set of possible states for a custom application.
 * The application state determines whether or not it is available in production
 * and the actions that can be taken on it.
 */
export enum ApplicationStatus {
  /** The application is active (production state) */
  Active = 'active',
  /** The application has been approved and can now be deployed. */
  Approved = 'approved',
  /** The application has been deleted and is no longer available for any purpose */
  Deleted = 'deleted',
  /** The application has been disabled, but not deleted. */
  Disabled = 'disabled',
  /** The application is in draft state during test and development */
  Draft = 'draft',
  /** The application is awaiting approval. */
  Pending = 'pending',
  /** The application has been rejected and must be modified and re-submitted. */
  Rejected = 'rejected'
}

export type ApplicationWorkflow = {
  action: ApplicationWorkflowAction;
  id: Scalars['ID'];
};

export enum ApplicationWorkflowAction {
  Approve = 'approve',
  Deploy = 'deploy',
  Disable = 'disable',
  Enable = 'enable',
  Reject = 'reject',
  Submit = 'submit',
  Undelete = 'undelete'
}

/**
 * An asset represents a single unit of data, such as a file or URL,
 * and basic metadata about that data. An asset must be contained within
 * a TemporalDataObject.
 */
export type Asset = {
  __typename?: 'Asset';
  /** Size of asset in bytes. */
  assetSize?: Maybe<Scalars['Float']>;
  /**
   * The asset type, such as `media`, `transcript`, or `text`.
   * The asset type determines which engines are able to operate on it.
   * For example, a transcription engine requires a `media` asset.
   * Engines that record their results in an asset typically set the type
   * accordingly, such as `vtn-standard`.
   * See https://docs.veritone.com/#/apis/tutorials/asset-types for supported values.
   */
  assetType?: Maybe<Scalars['String']>;
  /** The TemporalDataObject that contains this asset */
  container?: Maybe<TemporalDataObject>;
  /** The ID of the TemporalDataObject that contains this asset */
  containerId: Scalars['ID'];
  /** Asset content type. Must be a valid MIME type string. */
  contentType?: Maybe<Scalars['String']>;
  createdDateTime?: Maybe<Scalars['DateTime']>;
  /** An optional description of the asset */
  description?: Maybe<Scalars['String']>;
  /**
   * Freeform application-defined metadata. This field may contain information
   * specific to the object type, such as image or video metadata.
   */
  details?: Maybe<Scalars['JSONData']>;
  /**
   * A structured containing metadata about a file. This will be set if the
   * asset was created by uploading a file.
   */
  fileData?: Maybe<AssetFileData>;
  /** The asset ID */
  id: Scalars['ID'];
  /**
   * A Boolean indicating whether or not this asset was created by editing
   * another asset.
   */
  isUserEdited?: Maybe<Scalars['Boolean']>;
  /** Freeform metadata in JSON format. */
  jsondata?: Maybe<Scalars['JSONData']>;
  /** Metadata as raw JSON string */
  jsonstring?: Maybe<Scalars['String']>;
  modifiedDateTime?: Maybe<Scalars['DateTime']>;
  /** Asset name, such as a file name. */
  name?: Maybe<Scalars['String']>;
  /** A signed version of the asset's URI */
  signedUri?: Maybe<Scalars['String']>;
  /**
   * A structure containing metadata about the source engine and task. This will
   * be set if the asset was created by an engine.
   */
  sourceData?: Maybe<AssetSourceData>;
  /**
   * Asset transform. The transformation function to be used with the asset.
   * It can be XML to JSON
   */
  transform?: Maybe<Scalars['String']>;
  /**
   * deprecated - use assetType
   * @deprecated Duplicate, redundant field
   */
  type: Scalars['String'];
  /**
   * The asset's URI. If a file is provided on asset creation, this URI
   * point to the object in Veritone's object storage.
   */
  uri?: Maybe<Scalars['String']>;
};


/**
 * An asset represents a single unit of data, such as a file or URL,
 * and basic metadata about that data. An asset must be contained within
 * a TemporalDataObject.
 */
export type AssetDetailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/**
 * An asset represents a single unit of data, such as a file or URL,
 * and basic metadata about that data. An asset must be contained within
 * a TemporalDataObject.
 */
export type AssetJsonstringArgs = {
  indent?: InputMaybe<Scalars['Int']>;
};


/**
 * An asset represents a single unit of data, such as a file or URL,
 * and basic metadata about that data. An asset must be contained within
 * a TemporalDataObject.
 */
export type AssetTransformArgs = {
  transformFunction: TransformFunction;
};

export enum AssetCreationMode {
  Append = 'append',
  Create = 'create',
  Replace = 'replace'
}

/** A structured containing metadata about an asset file. */
export type AssetFileData = {
  __typename?: 'AssetFileData';
  /** The MD5 checksum of the file */
  md5sum?: Maybe<Scalars['String']>;
  /** Media duration in milliseconds */
  mediaDurationMs?: Maybe<Scalars['Int']>;
  /** Original file URI, if provided on asset creation */
  originalFileUri?: Maybe<Scalars['String']>;
  /** The file size in bytes */
  size?: Maybe<Scalars['BigInt']>;
};

export type AssetList = Page & {
  __typename?: 'AssetList';
  /** Number of records returned in this response */
  count?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
  /** The starting index for records that were returned in this query. */
  offset: Scalars['Int'];
  records?: Maybe<Array<Maybe<Asset>>>;
};

export enum AssetOrderBy {
  AssetType = 'assetType',
  ContentType = 'contentType',
  CreatedDateTime = 'createdDateTime'
}

export type AssetScrollList = {
  __typename?: 'AssetScrollList';
  /** The number of assets in the current result page */
  assets: AssetList;
  /** The reference id to use for the next paging query */
  scrollId: Scalars['String'];
};

/** A structure containing metadata about the source engine and task for an asset. */
export type AssetSourceData = {
  __typename?: 'AssetSourceData';
  /** The engine that created the asset */
  engine?: Maybe<Engine>;
  /** The ID of the engine that created the asset */
  engineId?: Maybe<Scalars['ID']>;
  /** The name of the asset source engine or engine category */
  name?: Maybe<Scalars['String']>;
  /** The schema definition, if there is one */
  schema?: Maybe<Schema>;
  /**
   * ID of the schema describing this asset, if there is one.
   * Typically applies only to assets of type "content-template".
   */
  schemaId?: Maybe<Scalars['ID']>;
  /** The ID of the source from which this asset was generated or stamped. */
  sourceId?: Maybe<Scalars['ID']>;
  /** The specific task that created the asset */
  task?: Maybe<Task>;
  /** ID of the specific task that created the asset */
  taskId?: Maybe<Scalars['ID']>;
};

export type AudienceData = {
  audienceDemographics?: InputMaybe<Scalars['JSONData']>;
  audienceTotal: Scalars['Int'];
  marketCount?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['JSONData']>;
  sourceCount?: InputMaybe<Scalars['Int']>;
};

export enum AuditAction {
  Create = 'Create',
  Delete = 'Delete',
  Update = 'Update'
}

export type AuditDateTimeFilter = {
  fromDateTime?: InputMaybe<Scalars['DateTime']>;
  toDateTime?: InputMaybe<Scalars['DateTime']>;
};

export type AuditEvent = {
  __typename?: 'AuditEvent';
  /** The application that created the audit log */
  application?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  organizationId: Scalars['ID'];
  payload: Scalars['JSONData'];
  userId?: Maybe<Scalars['ID']>;
};

export type AuditEventList = Page & {
  __typename?: 'AuditEventList';
  count?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records?: Maybe<Array<AuditEvent>>;
};

export type AuditLogEntry = {
  __typename?: 'AuditLogEntry';
  /** IP address of the client that generated the audit action. */
  clientIpAddress?: Maybe<Scalars['String']>;
  /** HTTP user agent of the client that generated the audit action. */
  clientUserAgent?: Maybe<Scalars['String']>;
  /** Date/time at which the audit log entry was created. */
  createdDateTime: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  /** The event type, such as `Create`, `Update`, or `Delete`. */
  eventType?: Maybe<Scalars['String']>;
  /** The unique ID of the audit log entry. */
  id: Scalars['ID'];
  /**
   * The ID of the object involved in the audit action. The format of this ID
   * varies by object type.
   */
  objectId?: Maybe<Scalars['ID']>;
  /**
   * The type of the object involved in the audit action, such as `Watchlist`
   * or `TemporalDataObject`.
   */
  objectType?: Maybe<Scalars['String']>;
  /** ID of the organization that generated the audit entry. */
  organizationId?: Maybe<Scalars['ID']>;
  /** Indicates whether or not the attempted action was successful. */
  success?: Maybe<Scalars['Boolean']>;
  /** User name or ID that generated the audit entry. This might be an API key. */
  userName?: Maybe<Scalars['String']>;
};

export type AuditLogEntryList = Page & {
  __typename?: 'AuditLogEntryList';
  /** Count of records in this page. Will be less than or equal to `limit`. */
  count?: Maybe<Scalars['Int']>;
  /**
   * `fromDateTime` value of the query that generated this page.
   * Useful when a default was applied.
   */
  fromDateTime?: Maybe<Scalars['DateTime']>;
  /** Limit used in the query that generated this page. */
  limit: Scalars['Int'];
  /** Offset used in the query that generated this page. */
  offset: Scalars['Int'];
  records: Array<AuditLogEntry>;
  /**
   * `toDateTime` value of the query that generated this page.
   * Useful when a default was applied.
   */
  toDateTime?: Maybe<Scalars['DateTime']>;
};

/** Specifies an "order by" entry in the `auditLog` query */
export type AuditLogOrderBy = {
  direction?: InputMaybe<OrderDirection>;
  field?: InputMaybe<AuditLogOrderByField>;
};

/** Fields that can be set in an `auditLog` `orderBy` parameter */
export enum AuditLogOrderByField {
  ClientIpAddress = 'clientIpAddress',
  ClientUserAgent = 'clientUserAgent',
  CreatedDateTime = 'createdDateTime',
  EventType = 'eventType',
  Id = 'id',
  ObjectId = 'objectId',
  ObjectType = 'objectType',
  Success = 'success',
  UserName = 'userName'
}

/** Access Control Entry */
export type AuthAce = {
  __typename?: 'AuthACE';
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<BasicUserInfo>;
  id: Scalars['ID'];
  /** If protected, this ACE cannot be removed */
  isProtected: Scalars['Boolean'];
  /** Group or User granted the permission set on the object */
  member: AuthGroupMember;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy?: Maybe<BasicUserInfo>;
  /** Object ID */
  objectID: Scalars['ID'];
  /** Type of object referenced by ACE */
  objectType?: Maybe<AuthResourceType>;
  /** Organization */
  organization: OrganizationInfo;
  /** Permission Set */
  permissionSet: AuthPermissionSet;
};

/** Access Control Entry Input for Permissions */
export type AuthAcePermissionInput = {
  /** Member ID */
  member: AuthGroupMemberInput;
  /** Permission Set */
  permissionSetID: Scalars['ID'];
};

/** This is the Auth Access Control List for a particular resource */
export type AuthAcl = Page & {
  __typename?: 'AuthACL';
  count: Scalars['Int'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records: Array<Maybe<AuthAce>>;
};

export type AuthEnforcementEnableInput = {
  /** Turn on or off OLP for Organization. */
  enable: Scalars['Boolean'];
  /**
   * Requires: superadmin
   * Create the authorization group in the specified org
   */
  ownerOrganization?: InputMaybe<Scalars['ID']>;
};

/** Authorization Group */
export type AuthGroup = {
  __typename?: 'AuthGroup';
  /** If this was created from an application role, then this field will be set */
  appRole?: Maybe<Role>;
  authClass?: Maybe<AuthObjectClass>;
  createdAt: Scalars['DateTime'];
  createdBy: BasicUserInfo;
  /** Brief and informative of the group scope and purpose */
  description: Scalars['String'];
  /** Unique id of the group */
  id: Scalars['ID'];
  /** If true, the group is a protected group */
  isProtected: Scalars['Boolean'];
  /**
   * If true, the group is a system group
   * @deprecated Replaced by isProtected field
   */
  isSystem?: Maybe<Scalars['Boolean']>;
  memberCount?: Maybe<Scalars['Int']>;
  /** List of users and groups that are members of the group */
  members: AuthGroupMemberList;
  modifiedAt: Scalars['DateTime'];
  modifiedBy: BasicUserInfo;
  /** Name of the group. limited to 100 characters */
  name: Scalars['String'];
  /**
   * Owner organization. Optional.  This will be the user's organization if not specified.
   * This requires SuperAdmin to set.
   */
  organization: OrganizationInfo;
  organizationACEs?: Maybe<Array<Maybe<AuthAce>>>;
  /** List of authorization groups that this group is direct member of */
  parentGroups?: Maybe<AuthGroupList>;
  /** Permission Set of auth group */
  permissionSet?: Maybe<Array<Maybe<AuthPermissionSet>>>;
  referencedACEs?: Maybe<Array<Maybe<AuthAce>>>;
  /** This returns a list of all folders that use this group as an ACE */
  referencedFolders?: Maybe<FolderList>;
  /** This returns all TDOs that use this group as an ACE */
  referencedTDOs?: Maybe<TdoList>;
  /** Source of the group */
  source: AuthGroupSourceType;
};


/** Authorization Group */
export type AuthGroupMembersArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
  limit?: InputMaybe<Scalars['Int']>;
  memberType?: InputMaybe<AuthGroupMemberType>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** Authorization Group */
export type AuthGroupReferencedFoldersArgs = {
  folderID?: InputMaybe<Scalars['ID']>;
  folderNameRegexp?: InputMaybe<Scalars['String']>;
  parentFolderID?: InputMaybe<Scalars['ID']>;
};

export type AuthGroupCreateInput = {
  /** The designated use type of the auth group */
  authClass?: InputMaybe<AuthObjectClass>;
  description: Scalars['String'];
  /** Optional members */
  members?: InputMaybe<Array<InputMaybe<AuthGroupMemberInput>>>;
  name: Scalars['String'];
  /**
   * Requires: superadmin
   * Create the authorization group in the specified org
   */
  ownerOrganization?: InputMaybe<Scalars['ID']>;
};

export type AuthGroupList = Page & {
  __typename?: 'AuthGroupList';
  count: Scalars['Int'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records: Array<Maybe<AuthGroup>>;
};

export type AuthGroupMember = AuthGroup | User;

export type AuthGroupMemberEntry = {
  __typename?: 'AuthGroupMemberEntry';
  createdAt: Scalars['DateTime'];
  member: AuthGroupMember;
  modifiedAt: Scalars['DateTime'];
};

export type AuthGroupMemberInput = {
  id: Scalars['ID'];
  memberType?: InputMaybe<AuthGroupMemberType>;
};

export type AuthGroupMemberList = Page & {
  __typename?: 'AuthGroupMemberList';
  count: Scalars['Int'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records: Array<Maybe<AuthGroupMemberEntry>>;
};

export enum AuthGroupMemberType {
  Group = 'Group',
  User = 'User'
}

export enum AuthGroupSourceType {
  Api = 'API',
  AppRole = 'AppRole',
  Integration = 'Integration'
}

export type AuthGroupUpdateInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export enum AuthObjectClass {
  Application = 'Application',
  Internal = 'Internal',
  Standard = 'Standard',
  System = 'System'
}

/** legacy used in the @auth directive */
export enum AuthObjectType {
  AuthorizationGroup = 'AuthorizationGroup',
  Folder = 'Folder',
  Job = 'Job',
  Task = 'Task',
  TemporalDataObject = 'TemporalDataObject'
}

export type AuthPermissionCheck = {
  __typename?: 'AuthPermissionCheck';
  /** true if object has permission */
  hasPermission: Scalars['Boolean'];
  /** Object ID */
  id: Scalars['ID'];
  /** Type of object referenced by ACE */
  resourceType?: Maybe<AuthResourceType>;
};

/** Permission Set: set of permission grants, managed as a cohesive entity */
export type AuthPermissionSet = {
  __typename?: 'AuthPermissionSet';
  /** Application that created this Permission Set */
  application?: Maybe<Application>;
  /** This is the approle if this permission set comes from an app role */
  applicationRole?: Maybe<Role>;
  authClass?: Maybe<AuthObjectClass>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<BasicUserInfo>;
  /** Brief description of the Permission Set */
  description?: Maybe<Scalars['String']>;
  hasPermissions: Scalars['Boolean'];
  /** Unique id of the Permission Set */
  id: Scalars['ID'];
  isProtected: Scalars['Boolean'];
  modifiedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy?: Maybe<BasicUserInfo>;
  /** Name of the Permission Set */
  name: Scalars['String'];
  /** Owner organization. */
  organization: OrganizationInfo;
  /**
   * Requires: superadmin
   * List of lib-functional-permissions permissions, ex. recording:read, job:create
   */
  permissions: Array<AuthPermissionType>;
  /**
   * If protected, this permission set cannot be updated or removed
   * @deprecated Replaced by isProtected field
   */
  protected?: Maybe<Scalars['Boolean']>;
  /** This is the set of ACEs that use this permission set */
  referencedACEs?: Maybe<Array<Maybe<AuthAce>>>;
};


/** Permission Set: set of permission grants, managed as a cohesive entity */
export type AuthPermissionSetHasPermissionsArgs = {
  permissions: Array<AuthPermissionType>;
  requireAll?: InputMaybe<Scalars['Boolean']>;
};

/** Authorization Role parameters */
export type AuthPermissionSetInput = {
  /** If this is from an application, the application ID for this permission set */
  applicationID?: InputMaybe<Scalars['ID']>;
  /** The designated use type of the permission set */
  authClass?: InputMaybe<AuthObjectClass>;
  /** Brief description */
  description: Scalars['String'];
  isProtected?: InputMaybe<Scalars['Boolean']>;
  /** Name */
  name: Scalars['String'];
  /** Optional. Requires SuperAdmin to specify a different organization than user */
  organizationID?: InputMaybe<Scalars['ID']>;
  /** List of lib-functional-permissions permissions, ex. recording:read, job:create */
  permissions: Array<AuthPermissionType>;
  /** If this is from an AppRole, the roleID */
  roleID?: InputMaybe<Scalars['ID']>;
};

export type AuthPermissionSetList = Page & {
  __typename?: 'AuthPermissionSetList';
  count: Scalars['Int'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records: Array<Maybe<AuthPermissionSet>>;
};

export type AuthPermissionSetUpdateInput = {
  /** Brief description of the role */
  description?: InputMaybe<Scalars['String']>;
  /** ID */
  id: Scalars['ID'];
  isProtected?: InputMaybe<Scalars['Boolean']>;
  /** Name of the role */
  name?: InputMaybe<Scalars['String']>;
  /** List of lib-functional-permissions permissions, ex. recording:read, job:create */
  permissions?: InputMaybe<Array<AuthPermissionType>>;
};

export enum AuthPermissionType {
  AdminAccess = 'ADMIN_ACCESS',
  AdminCreateApplicationJwt = 'ADMIN_CREATE_APPLICATION_JWT',
  AdminGroupCreate = 'ADMIN_GROUP_CREATE',
  AdminGroupDelete = 'ADMIN_GROUP_DELETE',
  AdminGroupRead = 'ADMIN_GROUP_READ',
  AdminGroupUpdate = 'ADMIN_GROUP_UPDATE',
  AdminOrgCreate = 'ADMIN_ORG_CREATE',
  AdminOrgRead = 'ADMIN_ORG_READ',
  AdminOrgUpdate = 'ADMIN_ORG_UPDATE',
  AdminProfileRead = 'ADMIN_PROFILE_READ',
  AdminProfileUpdate = 'ADMIN_PROFILE_UPDATE',
  AdminRolesCreate = 'ADMIN_ROLES_CREATE',
  AdminRolesDelete = 'ADMIN_ROLES_DELETE',
  AdminRolesRead = 'ADMIN_ROLES_READ',
  AdminRolesUpdate = 'ADMIN_ROLES_UPDATE',
  AdminUiLegacyAccess = 'ADMIN_UI_LEGACY_ACCESS',
  AdminUserCreate = 'ADMIN_USER_CREATE',
  AdminUserDelete = 'ADMIN_USER_DELETE',
  AdminUserRead = 'ADMIN_USER_READ',
  AdminUserUpdate = 'ADMIN_USER_UPDATE',
  AdvertiserAccess = 'ADVERTISER_ACCESS',
  AiwareAdminAdmin = 'AIWARE_ADMIN_ADMIN',
  AiwareAdminCreateApplicationJwt = 'AIWARE_ADMIN_CREATE_APPLICATION_JWT',
  AiwareAdminSuperadmin = 'AIWARE_ADMIN_SUPERADMIN',
  AiwareFlowCreate = 'AIWARE_FLOW_CREATE',
  AiwareFlowDelete = 'AIWARE_FLOW_DELETE',
  AiwareFlowRead = 'AIWARE_FLOW_READ',
  AiwareFlowUpdate = 'AIWARE_FLOW_UPDATE',
  AiwareFolderCreate = 'AIWARE_FOLDER_CREATE',
  AiwareFolderDelete = 'AIWARE_FOLDER_DELETE',
  AiwareFolderFile = 'AIWARE_FOLDER_FILE',
  AiwareFolderRead = 'AIWARE_FOLDER_READ',
  AiwareFolderUpdate = 'AIWARE_FOLDER_UPDATE',
  AiwareGroupCreate = 'AIWARE_GROUP_CREATE',
  AiwareGroupDelete = 'AIWARE_GROUP_DELETE',
  AiwareJobCreate = 'AIWARE_JOB_CREATE',
  AiwareJobDelete = 'AIWARE_JOB_DELETE',
  AiwareJobRead = 'AIWARE_JOB_READ',
  AiwareJobUpdate = 'AIWARE_JOB_UPDATE',
  AiwareScheduledJobCreate = 'AIWARE_SCHEDULED_JOB_CREATE',
  AiwareScheduledJobDelete = 'AIWARE_SCHEDULED_JOB_DELETE',
  AiwareScheduledJobRead = 'AIWARE_SCHEDULED_JOB_READ',
  AiwareScheduledJobUpdate = 'AIWARE_SCHEDULED_JOB_UPDATE',
  AiwareSchemaCreate = 'AIWARE_SCHEMA_CREATE',
  AiwareSchemaDelete = 'AIWARE_SCHEMA_DELETE',
  AiwareSchemaRead = 'AIWARE_SCHEMA_READ',
  AiwareSchemaSearch = 'AIWARE_SCHEMA_SEARCH',
  AiwareSchemaUpdate = 'AIWARE_SCHEMA_UPDATE',
  AiwareSdoCreate = 'AIWARE_SDO_CREATE',
  AiwareSdoDelete = 'AIWARE_SDO_DELETE',
  AiwareSdoRead = 'AIWARE_SDO_READ',
  AiwareSdoUpdate = 'AIWARE_SDO_UPDATE',
  AiwareSourcesCreate = 'AIWARE_SOURCES_CREATE',
  AiwareSourcesDelete = 'AIWARE_SOURCES_DELETE',
  AiwareSourcesRead = 'AIWARE_SOURCES_READ',
  AiwareSourcesUpdate = 'AIWARE_SOURCES_UPDATE',
  AiwareTaskCreate = 'AIWARE_TASK_CREATE',
  AiwareTaskDelete = 'AIWARE_TASK_DELETE',
  AiwareTaskRead = 'AIWARE_TASK_READ',
  AiwareTaskUpdate = 'AIWARE_TASK_UPDATE',
  AiwareTdoCreate = 'AIWARE_TDO_CREATE',
  AiwareTdoDelete = 'AIWARE_TDO_DELETE',
  AiwareTdoRead = 'AIWARE_TDO_READ',
  AiwareTdoSearch = 'AIWARE_TDO_SEARCH',
  AiwareTdoUpdate = 'AIWARE_TDO_UPDATE',
  AiwareUserCreate = 'AIWARE_USER_CREATE',
  AiwareUserDelete = 'AIWARE_USER_DELETE',
  AnalyticsAccess = 'ANALYTICS_ACCESS',
  AnalyticsDashboardUpdate = 'ANALYTICS_DASHBOARD_UPDATE',
  AnalyticsDashboardView = 'ANALYTICS_DASHBOARD_VIEW',
  AssetAll = 'ASSET_ALL',
  AssetUri = 'ASSET_URI',
  BroadcasterAccess = 'BROADCASTER_ACCESS',
  CmsAccess = 'CMS_ACCESS',
  CmsAnalyticsRead = 'CMS_ANALYTICS_READ',
  CmsContenttemplateCreate = 'CMS_CONTENTTEMPLATE_CREATE',
  CmsContenttemplateDelete = 'CMS_CONTENTTEMPLATE_DELETE',
  CmsContenttemplateRead = 'CMS_CONTENTTEMPLATE_READ',
  CmsContenttemplateUpdate = 'CMS_CONTENTTEMPLATE_UPDATE',
  CmsCustomerservice = 'CMS_CUSTOMERSERVICE',
  CmsJobCreate = 'CMS_JOB_CREATE',
  CmsJobDelete = 'CMS_JOB_DELETE',
  CmsJobRead = 'CMS_JOB_READ',
  CmsJobUpdate = 'CMS_JOB_UPDATE',
  CmsMediaCreate = 'CMS_MEDIA_CREATE',
  CmsMediaDelete = 'CMS_MEDIA_DELETE',
  CmsMediaDownload = 'CMS_MEDIA_DOWNLOAD',
  CmsMediaRead = 'CMS_MEDIA_READ',
  CmsMediaShare = 'CMS_MEDIA_SHARE',
  CmsMediaUpdate = 'CMS_MEDIA_UPDATE',
  CmsRecordingCreate = 'CMS_RECORDING_CREATE',
  CmsRecordingDelete = 'CMS_RECORDING_DELETE',
  CmsRecordingRead = 'CMS_RECORDING_READ',
  CmsRecordingUpdate = 'CMS_RECORDING_UPDATE',
  CmsReportCreate = 'CMS_REPORT_CREATE',
  CmsSourcesDelete = 'CMS_SOURCES_DELETE',
  CmsSourcesRead = 'CMS_SOURCES_READ',
  CmsSourcesUpdate = 'CMS_SOURCES_UPDATE',
  CmsTaskCreate = 'CMS_TASK_CREATE',
  CmsTaskDelete = 'CMS_TASK_DELETE',
  CmsTaskRead = 'CMS_TASK_READ',
  CmsTaskUpdate = 'CMS_TASK_UPDATE',
  CmsWorkflowsCreate = 'CMS_WORKFLOWS_CREATE',
  CmsWorkflowsDelete = 'CMS_WORKFLOWS_DELETE',
  CmsWorkflowsRead = 'CMS_WORKFLOWS_READ',
  CmsWorkflowsUpdate = 'CMS_WORKFLOWS_UPDATE',
  CollectionsAccess = 'COLLECTIONS_ACCESS',
  CollectionsCollectionsCreate = 'COLLECTIONS_COLLECTIONS_CREATE',
  CollectionsCollectionsDelete = 'COLLECTIONS_COLLECTIONS_DELETE',
  CollectionsCollectionsRead = 'COLLECTIONS_COLLECTIONS_READ',
  CollectionsCollectionsShare = 'COLLECTIONS_COLLECTIONS_SHARE',
  CollectionsCollectionsUpdate = 'COLLECTIONS_COLLECTIONS_UPDATE',
  CollectionsMentionsCreate = 'COLLECTIONS_MENTIONS_CREATE',
  CollectionsMentionsDelete = 'COLLECTIONS_MENTIONS_DELETE',
  CollectionsMentionsDownload = 'COLLECTIONS_MENTIONS_DOWNLOAD',
  CollectionsMentionsRead = 'COLLECTIONS_MENTIONS_READ',
  CollectionsMentionsShare = 'COLLECTIONS_MENTIONS_SHARE',
  CollectionsMentionsUpdate = 'COLLECTIONS_MENTIONS_UPDATE',
  CollectionsUsersRead = 'COLLECTIONS_USERS_READ',
  DeveloperAccess = 'DEVELOPER_ACCESS',
  DeveloperBuildApprove = 'DEVELOPER_BUILD_APPROVE',
  DeveloperBuildCreate = 'DEVELOPER_BUILD_CREATE',
  DeveloperBuildDelete = 'DEVELOPER_BUILD_DELETE',
  DeveloperBuildDeploy = 'DEVELOPER_BUILD_DEPLOY',
  DeveloperBuildDisapprove = 'DEVELOPER_BUILD_DISAPPROVE',
  DeveloperBuildInvalidate = 'DEVELOPER_BUILD_INVALIDATE',
  DeveloperBuildPause = 'DEVELOPER_BUILD_PAUSE',
  DeveloperBuildRead = 'DEVELOPER_BUILD_READ',
  DeveloperBuildSubmit = 'DEVELOPER_BUILD_SUBMIT',
  DeveloperBuildUnpause = 'DEVELOPER_BUILD_UNPAUSE',
  DeveloperBuildUpdate = 'DEVELOPER_BUILD_UPDATE',
  DeveloperBuildUpload = 'DEVELOPER_BUILD_UPLOAD',
  DeveloperDockerAdmin = 'DEVELOPER_DOCKER_ADMIN',
  DeveloperDockerOrgPull = 'DEVELOPER_DOCKER_ORG_PULL',
  DeveloperDockerOrgPush = 'DEVELOPER_DOCKER_ORG_PUSH',
  DeveloperDockerOrgUserPull = 'DEVELOPER_DOCKER_ORG_USER_PULL',
  DeveloperDockerOrgUserPush = 'DEVELOPER_DOCKER_ORG_USER_PUSH',
  DeveloperEngineCreate = 'DEVELOPER_ENGINE_CREATE',
  DeveloperEngineDelete = 'DEVELOPER_ENGINE_DELETE',
  DeveloperEngineDisable = 'DEVELOPER_ENGINE_DISABLE',
  DeveloperEngineEnable = 'DEVELOPER_ENGINE_ENABLE',
  DeveloperEngineRead = 'DEVELOPER_ENGINE_READ',
  DeveloperEngineUpdate = 'DEVELOPER_ENGINE_UPDATE',
  DeveloperTaskCreate = 'DEVELOPER_TASK_CREATE',
  DeveloperTaskRead = 'DEVELOPER_TASK_READ',
  DeveloperTaskUpdate = 'DEVELOPER_TASK_UPDATE',
  DiscoveryAccess = 'DISCOVERY_ACCESS',
  DiscoveryAnalyticsDownload = 'DISCOVERY_ANALYTICS_DOWNLOAD',
  DiscoveryAnalyticsRead = 'DISCOVERY_ANALYTICS_READ',
  DiscoveryAnalyticsShare = 'DISCOVERY_ANALYTICS_SHARE',
  DiscoveryFolderCreate = 'DISCOVERY_FOLDER_CREATE',
  DiscoveryFolderDelete = 'DISCOVERY_FOLDER_DELETE',
  DiscoveryFolderRead = 'DISCOVERY_FOLDER_READ',
  DiscoveryFolderShare = 'DISCOVERY_FOLDER_SHARE',
  DiscoveryFolderUpdate = 'DISCOVERY_FOLDER_UPDATE',
  DiscoveryMentionsCreate = 'DISCOVERY_MENTIONS_CREATE',
  DiscoveryMentionsDelete = 'DISCOVERY_MENTIONS_DELETE',
  DiscoveryMentionsDownload = 'DISCOVERY_MENTIONS_DOWNLOAD',
  DiscoveryMentionsRead = 'DISCOVERY_MENTIONS_READ',
  DiscoveryMentionsShare = 'DISCOVERY_MENTIONS_SHARE',
  DiscoveryMentionsUpdate = 'DISCOVERY_MENTIONS_UPDATE',
  DiscoveryResultsDownload = 'DISCOVERY_RESULTS_DOWNLOAD',
  DiscoveryResultsRead = 'DISCOVERY_RESULTS_READ',
  DiscoveryResultsShare = 'DISCOVERY_RESULTS_SHARE',
  InternalLoginbyemail = 'INTERNAL_LOGINBYEMAIL',
  JobCreate = 'JOB_CREATE',
  JobDelete = 'JOB_DELETE',
  JobRead = 'JOB_READ',
  JobUpdate = 'JOB_UPDATE',
  MentionsCreate = 'MENTIONS_CREATE',
  MentionsDelete = 'MENTIONS_DELETE',
  MentionsDownload = 'MENTIONS_DOWNLOAD',
  MentionsRead = 'MENTIONS_READ',
  MentionsShare = 'MENTIONS_SHARE',
  MentionsUpdate = 'MENTIONS_UPDATE',
  NoAccess = 'NO_ACCESS',
  PoliticsAccess = 'POLITICS_ACCESS',
  RecordingCreate = 'RECORDING_CREATE',
  RecordingDelete = 'RECORDING_DELETE',
  RecordingRead = 'RECORDING_READ',
  RecordingUpdate = 'RECORDING_UPDATE',
  SourceUpdate = 'SOURCE_UPDATE',
  Superadmin = 'SUPERADMIN',
  TaskCreate = 'TASK_CREATE',
  TaskDelete = 'TASK_DELETE',
  TaskRead = 'TASK_READ',
  TaskUpdate = 'TASK_UPDATE',
  VeritoneFinanceadmin = 'VERITONE_FINANCEADMIN',
  VeritoneSuperadmin = 'VERITONE_SUPERADMIN',
  WorkflowCreate = 'WORKFLOW_CREATE'
}

export type AuthResource = {
  resourceIdFieldPath: Scalars['String'];
  resourceType: AuthResourceType;
};

export type AuthResourceMember = Application | Dataset | Engine | Folder | Library | Organization | Source | StructuredData | TemporalDataObject;

export type AuthResourceMemberInput = {
  id: Scalars['ID'];
  memberType?: InputMaybe<AuthResourceType>;
};

export enum AuthResourceType {
  Application = 'Application',
  Dataset = 'Dataset',
  Engine = 'Engine',
  Folder = 'Folder',
  Library = 'Library',
  None = 'NONE',
  Organization = 'Organization',
  Sdo = 'SDO',
  Source = 'Source',
  Tdo = 'TDO'
}

/** WIP: */
export type AuthRoleRequirement = {
  /**
   * List of one or more permissions required for the operation
   * Currently that's a list of functional permissions, but potentially can be expanded to
   * some sort of policy descriptors
   */
  permissions: Array<AuthPermissionType>;
  /**
   * The name of the field parameter containing id(s) to query for.
   * Object-level authorization will lookup roles set to this resource and assigned to
   * an authorization group in the request authorization context
   */
  resourceIdFieldPath: Scalars['String'];
  /**
   * The type of object that object-level access controls should apply to.
   * Must be set if allowOrgless is true and skipObjectAuthorization is false.
   */
  resourceType: AuthResourceType;
};

export type AutocompleteFieldConfig = {
  __typename?: 'AutocompleteFieldConfig';
  autocompleteField?: Maybe<Scalars['String']>;
  indexField?: Maybe<Scalars['String']>;
};

/** Input fields used to create an automate flow. */
export type AutomateFlowInput = {
  /**
   * Optional application id for linked applications. This will be used to access
   * the default module pallete.
   */
  linkedApplicationId?: InputMaybe<Scalars['ID']>;
  /**
   * Optional automate flow template id. Flow templates can be queried using the flowTemplates call.
   * If left empty will be a blank flow. This must be an actual
   * template id such as '36' for 'Support Call Analytics Reporter'. An engineId will not fail
   * but it will create a blank flow.
   */
  templateId?: InputMaybe<Scalars['ID']>;
};

export type AutomateRunConfig = {
  __typename?: 'AutomateRunConfig';
  build?: Maybe<Build>;
  engineId?: Maybe<Scalars['ID']>;
};

export type BasicUserInfo = {
  __typename?: 'BasicUserInfo';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  imageUrl?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** Type representing a boolean property */
export type BooleanProperty = Property & {
  __typename?: 'BooleanProperty';
  name: Scalars['String'];
  value?: Maybe<Scalars['Boolean']>;
};

export type Build = {
  __typename?: 'Build';
  createdBy?: Maybe<Scalars['String']>;
  /** Date and date build was created */
  createdDateTime?: Maybe<Scalars['DateTime']>;
  /** Data certification */
  dataCertified?: Maybe<Scalars['JSONData']>;
  description?: Maybe<Scalars['String']>;
  /** URL to the Docker image for this engine build, if applicable */
  dockerImage?: Maybe<Scalars['String']>;
  /** The engine this build is for */
  engine?: Maybe<Engine>;
  /** The ID of the engine this build is for */
  engineId: Scalars['ID'];
  executeUri?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /**
   * The entire manifest, supplied by the engine developer, that describes
   * the engine's capabilities and requirements and is used by the platform
   * system to build and execute the engine.
   */
  manifest?: Maybe<Scalars['JSONData']>;
  modifiedBy?: Maybe<Scalars['String']>;
  /** Date and time build was last modified */
  modifiedDateTime?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  outputFormats?: Maybe<Array<Scalars['String']>>;
  preferredInputFormat?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
  /** Used to give a default action choice */
  primaryAction?: Maybe<BuildUpdateAction>;
  /** Release notes for build */
  releaseNotes?: Maybe<Scalars['String']>;
  report?: Maybe<Scalars['JSONData']>;
  runtime?: Maybe<Scalars['JSONData']>;
  /** Used to give secondary action choices */
  secondaryActions?: Maybe<Array<Maybe<BuildUpdateAction>>>;
  /** Engine build status: */
  status?: Maybe<BuildStatus>;
  supportedInputFormats?: Maybe<Array<Scalars['String']>>;
  /**
   * List of IDs of source types that the engine supports.
   * Applies only to adapter engines that ingest data from a source.
   * Will be a list of IDs of SourceType objects.
   */
  supportedSourceTypes?: Maybe<Array<Scalars['String']>>;
  /** Contains all valid action choices */
  validStateActions?: Maybe<Array<Maybe<BuildUpdateAction>>>;
  validateUri?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type BuildList = Page & {
  __typename?: 'BuildList';
  /** Number of records returned in this response */
  count?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
  /** The starting index for records that were returned in this query. */
  offset: Scalars['Int'];
  records?: Maybe<Array<Maybe<Build>>>;
};

/** Valid strings for the `Build.status` field. */
export enum BuildStatus {
  /** The build has been approved and is ready for deployment */
  Approved = 'approved',
  /** The build is available for deployment */
  Available = 'available',
  /** The build has been soft-deleted. */
  Deleted = 'deleted',
  /** Deployment has failed */
  DeployFailed = 'deployFailed',
  /** The build has been deployed. There can be only one deployed build. */
  Deployed = 'deployed',
  /** The build is being deployed. */
  Deploying = 'deploying',
  /** Approval was requested, but denied */
  Disapproved = 'disapproved',
  /** The build files are being fetched from their source. */
  Fetching = 'fetching',
  /** The build failed validation checks. See build report for details. */
  Invalid = 'invalid',
  /**
   * The build is deployed but has been paused. Engine processing will not
   * proceed until the build is un-paused.
   */
  Paused = 'paused',
  /**
   * The build has been created but is still pending approval and other
   * workflow steps.
   */
  Pending = 'pending',
  /** The build has been successfully uploaded to the build repository. */
  Uploaded = 'uploaded'
}

export enum BuildUpdateAction {
  Approve = 'approve',
  Certification = 'certification',
  Delete = 'delete',
  Deploy = 'deploy',
  Disapprove = 'disapprove',
  Invalidate = 'invalidate',
  Pause = 'pause',
  Submit = 'submit',
  Unpause = 'unpause',
  Update = 'update',
  Upload = 'upload'
}

export type BulkCreateWatchlist = {
  watchlists?: InputMaybe<Array<CreateWatchlist>>;
};

export type BulkDeleteContextMenuExtensions = {
  /** List of IDs of context menu extensions to delete */
  ids?: InputMaybe<Array<Scalars['ID']>>;
};

export type BulkPackageGrantInput = {
  packageGrants: Array<InputMaybe<PackageGrantInput>>;
  packageId: Scalars['ID'];
};

export type BulkPackageResourceInput = {
  packageId: Scalars['ID'];
  packageResources?: InputMaybe<Array<InputMaybe<PackageResourceInput>>>;
};

export type BulkUpdateWatchlist = {
  /** Indicates whether or not the watchlist expiration notification should be enable */
  enableExpirationNotification?: InputMaybe<Scalars['Boolean']>;
  /**
   * New stop date for watchlist. Currently, this is the only
   * field that can be updated.
   */
  stopDate?: InputMaybe<Scalars['DateTime']>;
};

export type BulkUpdateWatchlistFilter = {
  /** List of IDs of watchlists to update */
  ids?: InputMaybe<Array<Scalars['ID']>>;
};

export enum BundleCategory {
  Category = 'category',
  Extension = 'extension',
  File = 'file'
}

export type Campaign = {
  __typename?: 'Campaign';
  advertiserId?: Maybe<Scalars['ID']>;
  brandId?: Maybe<Scalars['ID']>;
  budget?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  organizationId: Scalars['ID'];
  startDate?: Maybe<Scalars['DateTime']>;
  stopDate?: Maybe<Scalars['DateTime']>;
};

export type ChangePassword = {
  /**
   * The new password. May be subject to validation rules depending
   * on the organization or environment system policy.
   */
  newPassword: Scalars['String'];
  /**
   * The current user's old password. Must be provided even if the
   * user is otherwise authenticated as an additional security check.
   */
  oldPassword: Scalars['String'];
};

/** Object that represents the mapping of clone assets to its parent's assets. */
export type CloneAssetIdMap = {
  __typename?: 'CloneAssetIdMap';
  /** The new asset ID (within the clone asset container). */
  newAssetId: Scalars['ID'];
  /** The original asset ID (within the cloned asset container). */
  oldAssetId: Scalars['ID'];
};

/** Metadata that represents a clone of a recording. */
export type CloneData = Metadata & {
  __typename?: 'CloneData';
  /** Map of asset IDs from the clone to the parent. */
  assetIdMap?: Maybe<Array<Maybe<CloneAssetIdMap>>>;
  /** Clone blobs flag */
  cloneBlobs?: Maybe<Scalars['Boolean']>;
  /** Timestamp when the recording was cloned */
  date?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** The ID of the asset container this was cloned from */
  originalId: Scalars['String'];
};


/** Metadata that represents a clone of a recording. */
export type CloneDataAssetIdMapArgs = {
  newAssetId?: InputMaybe<Scalars['ID']>;
  oldAssetId?: InputMaybe<Scalars['ID']>;
};

export type CloneRequest = {
  __typename?: 'CloneRequest';
  createdDateTime?: Maybe<Scalars['DateTime']>;
  destinationApplicationId: Scalars['ID'];
  id: Scalars['ID'];
  modifiedDateTime?: Maybe<Scalars['DateTime']>;
  numberOfCompletedRecordings?: Maybe<Scalars['Int']>;
  numberOfRecordings?: Maybe<Scalars['Int']>;
  percentage?: Maybe<Scalars['Int']>;
  sourceApplicationId: Scalars['ID'];
  status?: Maybe<Scalars['String']>;
};

export type CloneRequestList = Page & {
  __typename?: 'CloneRequestList';
  count?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records?: Maybe<Array<Maybe<CloneRequest>>>;
};

export type CloneScheduledJob = {
  id: Scalars['ID'];
  /**
   * Organization ID. Used only by Veritone platform components.
   * Other clients should not attempt to send this field. Any value sent
   * will be ignored.
   */
  organizationId?: InputMaybe<Scalars['ID']>;
};

export type Cluster = {
  __typename?: 'Cluster';
  allowedEngines?: Maybe<Array<Scalars['ID']>>;
  bypassAllowedEngines?: Maybe<Scalars['Boolean']>;
  cachedDateTime?: Maybe<Scalars['DateTime']>;
  /** Cluster configuration overrides */
  clusterConfig?: Maybe<Scalars['JSONData']>;
  /** The GroupId that includes this cluster */
  clusterGroupId?: Maybe<Scalars['ID']>;
  /** Retrieve clusters in group */
  clusters: ClusterList;
  collaborators?: Maybe<ClusterCollaboratorList>;
  containerTag?: Maybe<Scalars['String']>;
  /** Base url controller */
  controllerUrl?: Maybe<Scalars['String']>;
  /** ID for the core that the cluster is pulling jobs from */
  coreId?: Maybe<Scalars['String']>;
  createdDateTime?: Maybe<Scalars['DateTime']>;
  default?: Maybe<Scalars['Boolean']>;
  deletedDateTime?: Maybe<Scalars['DateTime']>;
  /** Edge version. Default is 3. */
  edgeVersion?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  /** Cluster is a group or not */
  isGroup?: Maybe<Scalars['Boolean']>;
  isPublic?: Maybe<Scalars['Boolean']>;
  /** Retrieve jobs */
  jobs: JobList;
  /** ID of the management node. Applies to portable/edge clusters only. */
  managementNodeID?: Maybe<Scalars['ID']>;
  /** media storage option */
  mediaStorage: MediaStorageOption;
  /** media storage path -- applies to edge only */
  mediaStoragePath?: Maybe<Scalars['String']>;
  memorySizeBytes?: Maybe<Scalars['Float']>;
  modifiedDateTime?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  nodes?: Maybe<ClusterNodeList>;
  organizationId?: Maybe<Scalars['ID']>;
  paused?: Maybe<Scalars['Boolean']>;
  /**
   * Optionally, specify a time at which the edge cluster should
   * be restarted daily. Applies only to edge clusters.
   */
  restartTimeUTC?: Maybe<Scalars['Time']>;
  /** Retrieve the cluster's service token */
  serviceToken?: Maybe<Scalars['String']>;
  /** State information about the cluster, conforming to a stable schema. */
  state?: Maybe<Scalars['JSONData']>;
  /** Date and time at which the state was last updated the system. */
  stateLastUpdatedDateTime?: Maybe<Scalars['DateTime']>;
  /** Retrieve the cluster's current status */
  status: ClusterStatus;
  storageSizeBytes?: Maybe<Scalars['Float']>;
  /** Retrieve current subscriptions for events on this cluster. */
  subscriptions: ClusterSubscriptionList;
  /** Retrieve tags for this cluster */
  tags?: Maybe<Array<Scalars['String']>>;
  /** Cluster deployment process status */
  targetStatus?: Maybe<ClusterStatus>;
  tasks: TaskList;
  type?: Maybe<ClusterType>;
};


export type ClusterClustersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ClusterJobsArgs = {
  applicationId?: InputMaybe<Scalars['ID']>;
  applicationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  dateTimeFilter?: InputMaybe<Array<JobDateTimeFilter>>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobSortField>>;
  scheduledJobIds?: InputMaybe<Array<Scalars['ID']>>;
  status?: InputMaybe<Array<JobStatusFilter>>;
  targetId?: InputMaybe<Scalars['ID']>;
};


export type ClusterTasksArgs = {
  dateTimeFilter?: InputMaybe<Array<TaskDateTimeFilter>>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Array<TaskStatus>>;
};

/** A source ACL grants a single organization limited rights to a private clusters */
export type ClusterCollaborator = {
  __typename?: 'ClusterCollaborator';
  /** The organization the cluster was shared with */
  organization?: Maybe<Organization>;
  /** Organization ID the cluster was shared with */
  organizationId: Scalars['ID'];
  /** The permission granted. */
  permission: ClusterPermission;
};

export type ClusterCollaboratorList = Page & {
  __typename?: 'ClusterCollaboratorList';
  count?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records: Array<ClusterCollaborator>;
};

export enum ClusterDateTimeField {
  CreatedDateTime = 'createdDateTime',
  ModifiedDateTime = 'modifiedDateTime',
  StateLastUpdatedDateTime = 'stateLastUpdatedDateTime'
}

export type ClusterDateTimeFilter = {
  field: ClusterDateTimeField;
  fromDateTime?: InputMaybe<Scalars['DateTime']>;
  toDateTime?: InputMaybe<Scalars['DateTime']>;
};

export type ClusterList = Page & {
  __typename?: 'ClusterList';
  count: Scalars['Int'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records: Array<Cluster>;
};

export type ClusterNode = {
  __typename?: 'ClusterNode';
  cluster?: Maybe<Cluster>;
  clusterId?: Maybe<Scalars['ID']>;
  createdDateTime?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  metrics?: Maybe<Scalars['JSONData']>;
  modifiedDateTime?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  /** Cluster configuration overrides */
  nodeConfig?: Maybe<Scalars['JSONData']>;
  paused?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['String']>;
  status?: Maybe<ClusterNodeStatus>;
};

export type ClusterNodeList = Page & {
  __typename?: 'ClusterNodeList';
  count: Scalars['Int'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records?: Maybe<Array<Maybe<ClusterNode>>>;
};

export enum ClusterNodeStatus {
  Anonymous = 'anonymous',
  Decomissioned = 'decomissioned',
  Offline = 'offline',
  Paused = 'paused',
  Running = 'running'
}

export type ClusterNodeUpdate = {
  metrics?: InputMaybe<Scalars['JSONData']>;
  nodeId: Scalars['ID'];
};

export type ClusterOrderBy = {
  direction?: InputMaybe<OrderDirection>;
  field: ClusterOrderByField;
};

export enum ClusterOrderByField {
  CreatedDateTime = 'createdDateTime',
  ModifiedDateTime = 'modifiedDateTime',
  Name = 'name',
  StateLastUpdatedDateTime = 'stateLastUpdatedDateTime'
}

export enum ClusterPermission {
  Owner = 'owner',
  Viewer = 'viewer'
}

export enum ClusterSize {
  Large = 'large',
  Medium = 'medium',
  Small = 'small'
}

export enum ClusterStatus {
  Active = 'active',
  Deploying = 'deploying',
  Failure = 'failure',
  Online = 'online',
  Paused = 'paused',
  Pending = 'pending',
  Terminated = 'terminated'
}

export type ClusterSubscription = {
  __typename?: 'ClusterSubscription';
  createdDateTime: Scalars['DateTime'];
  emailAddress: Scalars['String'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  modifiedDateTime: Scalars['DateTime'];
  userId: Scalars['ID'];
};

export type ClusterSubscriptionList = Page & {
  __typename?: 'ClusterSubscriptionList';
  count: Scalars['Int'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records: Array<ClusterSubscription>;
};

export enum ClusterType {
  /** On Premise */
  OnPrem = 'OnPrem',
  /** Real-Time */
  Rt = 'RT',
  /** Amazon Machine Image */
  Ami = 'ami'
}

export type CognitiveSearch = {
  __typename?: 'CognitiveSearch';
  id: Scalars['ID'];
  /**
   * The mention status to set on each mention generated as a result
   * of a match against this search
   */
  mentionStatus?: Maybe<MentionStatus>;
  /**
   * ID of the mention status to set on each mention generated as a result
   * of a match against this search
   */
  mentionStatusId?: Maybe<Scalars['ID']>;
  /** A recursive tree structure defining the search criteria */
  profile?: Maybe<Scalars['JSONData']>;
  /** The raw query. Read-only and server-generated based on the search profile. */
  query?: Maybe<Scalars['JSONData']>;
};

export type CognitiveSearchCondition = {
  __typename?: 'CognitiveSearchCondition';
  engineCategoryId: Scalars['ID'];
  state: Scalars['JSONData'];
};

export type CognitiveSearchProfile = {
  __typename?: 'CognitiveSearchProfile';
  and?: Maybe<Array<CognitiveSearchProfile>>;
  condition?: Maybe<CognitiveSearchCondition>;
  jsondata?: Maybe<Scalars['JSONData']>;
  or?: Maybe<Array<CognitiveSearchProfile>>;
};

export enum CollaboratorStatus {
  Active = 'active',
  Rejected = 'rejected',
  Revoked = 'revoked'
}

export type Collection = {
  __typename?: 'Collection';
  createdDateTime?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  /**
   * Folders that the collection is filed in.
   * At present, a collection can only be filed in a single folder.
   */
  folder?: Maybe<Array<Folder>>;
  id: Scalars['ID'];
  /** A url to get the collection image */
  imageUrl?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  itemCount?: Maybe<Scalars['Int']>;
  /** Get a list of mentions filed in the collection */
  mentions?: Maybe<CollectionMentionList>;
  modifiedDateTime?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  orgSharing?: Maybe<Scalars['Boolean']>;
  organization?: Maybe<Organization>;
  organizationId: Scalars['ID'];
  ownerId?: Maybe<Scalars['ID']>;
  programCount?: Maybe<Scalars['Int']>;
  /** A signed url to get the collection image. It will only be signed if it is an s3 url. */
  signedImageUrl?: Maybe<Scalars['String']>;
  typeId?: Maybe<Scalars['ID']>;
  /** Folders that the colection is filed in. */
  widgets?: Maybe<WidgetList>;
};


export type CollectionMentionsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type CollectionWidgetsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type CollectionList = Page & {
  __typename?: 'CollectionList';
  /** Number of records returned in this response */
  count?: Maybe<Scalars['Int']>;
  /** Maximum number of results that were retrieved in this query; page size */
  limit: Scalars['Int'];
  /** Provide an offset to skip to a certain element in the result, for paging. */
  offset: Scalars['Int'];
  records?: Maybe<Array<Maybe<Collection>>>;
};

export type CollectionMention = {
  __typename?: 'CollectionMention';
  collection: Collection;
  createdDateTime?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  /** id of the collection */
  folderId: Scalars['ID'];
  mention: Mention;
  /** id of the mention */
  mentionId: Scalars['ID'];
  modifiedDateTime?: Maybe<Scalars['DateTime']>;
  organizationId: Scalars['ID'];
};

export type CollectionMentionInput = {
  /** id of the collection */
  folderId: Scalars['ID'];
  /** id of the mention */
  mentionId: Scalars['ID'];
};

export type CollectionMentionList = Page & {
  __typename?: 'CollectionMentionList';
  /** Number of records returned in this response */
  count: Scalars['Int'];
  /** Maximum number of results that were retrieved in this query; page size */
  limit: Scalars['Int'];
  /** Provide an offset to skip to a certain element in the result, for paging. */
  offset: Scalars['Int'];
  records?: Maybe<Array<CollectionMention>>;
};

export type CollectionMentionOrderBy = {
  direction?: InputMaybe<OrderDirection>;
  field: CollectionMentionOrderField;
};

export enum CollectionMentionOrderField {
  MentionDate = 'mentionDate'
}

export type CompoundProperty = Property & {
  __typename?: 'CompoundProperty';
  name: Scalars['String'];
  value?: Maybe<Kvp>;
};

export type ContextMenuExtension = {
  __typename?: 'ContextMenuExtension';
  /** context menu extension id */
  id?: Maybe<Scalars['ID']>;
  label?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type ContextMenuExtensionList = {
  __typename?: 'ContextMenuExtensionList';
  collections?: Maybe<Array<Maybe<ContextMenuExtension>>>;
  mentions?: Maybe<Array<Maybe<ContextMenuExtension>>>;
  tdos?: Maybe<Array<Maybe<ContextMenuExtension>>>;
  watchlists?: Maybe<Array<Maybe<ContextMenuExtension>>>;
};

export enum ContextMenuExtensionType {
  Collection = 'collection',
  Mention = 'mention',
  Tdo = 'tdo',
  Watchlist = 'watchlist'
}

export type CopyFlow = {
  /** flowId without flowRevisionId will base the copy off the HEAD revision */
  flowId?: InputMaybe<Scalars['ID']>;
  /** flowRevisionId will base the copy off the revision */
  flowRevisionId?: InputMaybe<Scalars['ID']>;
};

export type CreateAllPipelineJobsTargetInfo = {
  endOffsetMs?: InputMaybe<Scalars['Int']>;
  startOffsetMs?: InputMaybe<Scalars['Int']>;
  /**
   * ID of the target object for the job pipeline,
   * typically that of a TemporalDataObject
   */
  targetId: Scalars['ID'];
};

export type CreateApplication = {
  category?: InputMaybe<Scalars['String']>;
  checkPermissions: Scalars['Boolean'];
  contextMenuExtensions?: InputMaybe<CreateContextMenuExtensions>;
  deploymentModel?: InputMaybe<DeploymentModel>;
  description?: InputMaybe<Scalars['String']>;
  /** The tags associated with the application. */
  entityTags?: InputMaybe<Array<InputMaybe<EntityTagInput>>>;
  eventEndpoint?: InputMaybe<Scalars['String']>;
  /** The headerbar configuration to be used with this application */
  headerbar?: InputMaybe<ApplicationHeaderbarInput>;
  headerbarEnabled?: InputMaybe<Scalars['Boolean']>;
  iconSvg?: InputMaybe<Scalars['String']>;
  iconUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  key: Scalars['String'];
  name: Scalars['String'];
  /** The node modules that need to be installed with the application and will be added to the same package as this application. */
  nodeModules?: InputMaybe<Array<InputMaybe<NodeModuleInput>>>;
  oauth2RedirectUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  permissionsRequired?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * The resources (engines, flows, and schemas) which will be added
   * to the new application in the form of components and package resources.
   */
  resources?: InputMaybe<Array<InputMaybe<ApplicationResourceInput>>>;
  /** Allow application to be created with initial status */
  status?: InputMaybe<ApplicationStatus>;
  url?: InputMaybe<Scalars['String']>;
};

export type CreateApplicationRoleInput = {
  applicationId: Scalars['ID'];
  description: Scalars['String'];
  isAppEventRole: Scalars['Boolean'];
  isPrivate: Scalars['Boolean'];
  name: Scalars['String'];
  permissions: Array<InputMaybe<AuthPermissionType>>;
};

export type CreateAsset = {
  /**
   * The asset type. Either this or assetType must be provided.
   * See https://docs.veritone.com/#/apis/tutorials/asset-types for supported values.
   */
  assetType?: InputMaybe<Scalars['String']>;
  /** ID of the parent container, a TemporalDataObject, for the new asset */
  containerId: Scalars['ID'];
  /** A valid MIME type */
  contentType?: InputMaybe<Scalars['String']>;
  /** An optional description for the asset */
  description?: InputMaybe<Scalars['String']>;
  /** Application- or type-specific metadata */
  details?: InputMaybe<Scalars['JSONData']>;
  /** A file to upload. Use multipart form POST to submit this field. */
  file?: InputMaybe<Scalars['UploadedFile']>;
  /** Optionally, set attributes about the file */
  fileData?: InputMaybe<SetAssetFileData>;
  /** Set to true if this asset was created by editing another asset. */
  isUserEdited?: InputMaybe<Scalars['Boolean']>;
  /** Deprecated. Set `fileData`, `sourceData`, or `details` instead. */
  jsondata?: InputMaybe<Scalars['JSONData']>;
  /** Optional expected checksum for the file */
  md5sum?: InputMaybe<Scalars['String']>;
  /** File or other name */
  name?: InputMaybe<Scalars['String']>;
  /**
   * if true, sets the new asset to be the primary asset of its type.
   * Only certain asset types, such as "media" and "transcript",
   * can have primary assets.
   */
  setAsPrimary?: InputMaybe<Scalars['Boolean']>;
  /** Optionally, set attributes about the source engine and task */
  sourceData?: InputMaybe<SetAssetSourceData>;
  /**
   * Set to true if the input asset uri is to be treated as a reference
   * (owned by third-party).  If set to true the source file at uri will
   * not be deleted when deleting asset.
   */
  storeAsReference?: InputMaybe<Scalars['Boolean']>;
  /**
   * Set to true if the container stopDateTime needs to be updated by
   * the duration of the asset
   */
  updateContainerStopDateTime?: InputMaybe<Scalars['Boolean']>;
  /**
   * URI to the asset data. Optional -- if a file is provided, the URI
   * will be computed by the server.
   */
  uri?: InputMaybe<Scalars['String']>;
};

export type CreateAssetInTdo = {
  /**
   * Asset type
   * See https://docs.veritone.com/#/apis/tutorials/asset-types for supported values.
   */
  assetType: Scalars['String'];
  /** A valid MIME type */
  contentType?: InputMaybe<Scalars['String']>;
  /** An optional description for the asset */
  description?: InputMaybe<Scalars['String']>;
  /** Application- or type-specific metadata */
  details?: InputMaybe<Scalars['JSONData']>;
  /** Optionally, set attributes about the file */
  fileData?: InputMaybe<SetAssetFileData>;
  /** File or other name */
  name?: InputMaybe<Scalars['String']>;
  /**
   * If true, sets the new asset to be the primary asset of its type.
   * Only certain asset types, such as "media" and "transcript",
   * can have primary assets.
   */
  setAsPrimary?: InputMaybe<Scalars['Boolean']>;
  /** Optionally, set attributes about the source engine and task */
  sourceData?: InputMaybe<SetAssetSourceData>;
  /**
   * Set to true if the input asset uri is to be treated as a reference
   * (owned by third-party).  If set to true the source file at uri will
   * not be deleted when deleting asset.
   */
  storeAsReference?: InputMaybe<Scalars['Boolean']>;
  /** URI to the asset data. */
  uri: Scalars['String'];
};

export type CreateBuild = {
  dockerImage?: InputMaybe<Scalars['String']>;
  engineId: Scalars['ID'];
  /** Optional given build id */
  id?: InputMaybe<Scalars['ID']>;
  manifest?: InputMaybe<Scalars['JSONData']>;
  releaseNotes?: InputMaybe<Scalars['String']>;
  taskRuntime?: InputMaybe<Scalars['JSONData']>;
};

export type CreateBundle = {
  clusterId: Scalars['ID'];
  externalCredentialId?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  nodeId?: InputMaybe<Scalars['ID']>;
  scheduleDefinition: CreateBundleScheduleDefinition;
  selectCategory: BundleCategory;
  selectDetail: CreateBundleSelectDetail;
  testRun?: InputMaybe<Scalars['Boolean']>;
};

export type CreateBundleScheduleDefinition = {
  recurringEndTime?: InputMaybe<Scalars['DateTime']>;
  recurringStartTime?: InputMaybe<Scalars['DateTime']>;
  repeatDaysOfMonth?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  repeatDaysOfWeek?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  repeatDaysTimeInMinutes?: InputMaybe<Scalars['Int']>;
  repeatMinutes?: InputMaybe<Scalars['Int']>;
};

export type CreateBundleSelectDetail = {
  /** Include items after this time. */
  afterTime?: InputMaybe<Scalars['DateTime']>;
  /** Include items before this time. */
  beforeTime?: InputMaybe<Scalars['DateTime']>;
  category: Scalars['String'];
  /** Array of files to search from. */
  files?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of paths to search from. */
  paths?: InputMaybe<Array<Scalars['String']>>;
  recursiveDescent: Scalars['Boolean'];
  /** Array of file types to include. */
  select?: InputMaybe<Array<Scalars['String']>>;
  service?: InputMaybe<CreateBundleService>;
  /** Array of tasks to run for each job. */
  tasks?: InputMaybe<Array<InputMaybe<CreateBundleSelectDetailTask>>>;
};

export type CreateBundleSelectDetailTask = {
  /** Id of engine. */
  engineId: Scalars['ID'];
};

export type CreateBundleService = {
  bucketName?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  serviceType?: InputMaybe<Scalars['String']>;
};

/**
 * This API creates an edge cluster for this core
 *
 * Example:
 * mutation createCluster {
 * createCluster (input: {
 * name: "YOUR_CLUSTER_NAME",
 * allowedEngines: ["all"],
 * dockerCredentials: {},
 * type: RT,
 * containerTag: "YOUR_CONTAINER_TAG",
 * paused: false,
 * memorySize: "20gb",
 * storageSize: "10gb",
 * bypassAllowedEngines: true,
 * collaborators: [],
 * subscriptions: [],
 * tags: ["aiware-agent"],
 * status: active,
 * mediaStorage: core,
 * mediaStoragePath: "",
 * serviceToken: "fake-token",
 * edgeVersion: 3,
 * }
 * ) {
 * id
 * }
 * }
 */
export type CreateCluster = {
  allowedEngines: Array<InputMaybe<Scalars['String']>>;
  bypassAllowedEngines?: InputMaybe<Scalars['Boolean']>;
  /** Update the cluster config */
  clusterConfig?: InputMaybe<Scalars['JSONData']>;
  /** ID of the cluster group which this cluster belongs */
  clusterGroupId?: InputMaybe<Scalars['ID']>;
  /**
   * Permissions granted to other organizations. Only the cluster owner
   * can view or edit this field.
   */
  collaborators?: InputMaybe<Array<CreateClusterCollaborator>>;
  containerTag?: InputMaybe<Scalars['String']>;
  /** ID of the core that the cluster is pulling jobs from */
  coreId?: InputMaybe<Scalars['String']>;
  dockerCredentials: Scalars['JSONData'];
  edgeVersion?: InputMaybe<Scalars['Int']>;
  /**
   * Indicates if this cluster represents a cluster group or an individual cluster.
   * Default is false - legacy normal cluster
   */
  isGroup?: InputMaybe<Scalars['Boolean']>;
  /** media storage type (edge or core) */
  mediaStorage?: InputMaybe<MediaStorageOption>;
  /** Media storage path. Optional -- use only for edge. */
  mediaStoragePath?: InputMaybe<Scalars['String']>;
  /**
   * Specify memory size in raw bytes or in human-readable
   * format such as 8gb, 1024mb, etc.
   */
  memorySize?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  /** ID of the organization. Only Veritone platform components can set this value. */
  organizationId?: InputMaybe<Scalars['ID']>;
  paused?: InputMaybe<Scalars['Boolean']>;
  /**
   * Optionally, specify a time at which the edge cluster should
   * be restarted daily. Applies only to edge clusters.
   */
  restartTimeUTC?: InputMaybe<Scalars['Time']>;
  /** Optionally, specify an api-token for cluster */
  serviceToken?: InputMaybe<Scalars['String']>;
  /** Status for cluster */
  status?: InputMaybe<ClusterStatus>;
  /**
   * Specify storage size in raw bytes or in human-readable
   * format such as 8gb, 1024mb, etc.
   */
  storageSize?: InputMaybe<Scalars['String']>;
  /** Set subscriptions on the cluster. */
  subscriptions?: InputMaybe<Array<InputMaybe<CreateClusterSubscription>>>;
  /** Tags for cluster */
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<ClusterType>;
};

export type CreateClusterCollaborator = {
  /** ID of the organization to share */
  organizationId: Scalars['ID'];
  /**
   * Permission to grant cluster. Can be `viewer`.
   * Set to `none` to revoke permissions for this organization.
   */
  permission: SetClusterPermission;
};

export type CreateClusterNode = {
  clusterId?: InputMaybe<Scalars['ID']>;
  containerTag?: InputMaybe<Scalars['String']>;
  metrics: Scalars['JSONData'];
  name?: InputMaybe<Scalars['String']>;
  /** Update the cluster node config */
  nodeConfig?: InputMaybe<Scalars['JSONData']>;
  offlineBrowsing?: InputMaybe<Scalars['Boolean']>;
  role?: InputMaybe<Scalars['String']>;
  storagePresent?: InputMaybe<Scalars['Boolean']>;
};

export type CreateClusterSubscription = {
  isActive?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['ID'];
};

export type CreateCognitiveSearch = {
  jsonstring?: InputMaybe<Scalars['String']>;
  mentionStatusId: Scalars['ID'];
  profile?: InputMaybe<Scalars['JSONData']>;
  watchlistId: Scalars['ID'];
};

export type CreateCognitiveSearchCondition = {
  engineCategoryId: Scalars['ID'];
  state: Scalars['JSONData'];
};

export type CreateCognitiveSearchInWatchlist = {
  /** String with JSON containing the cognitive search profiles */
  jsonstring?: InputMaybe<Scalars['String']>;
  mentionStatusId: Scalars['ID'];
  profile?: InputMaybe<Scalars['JSONData']>;
};

export type CreateCognitiveSearchProfile = {
  and?: InputMaybe<Array<InputMaybe<CreateCognitiveSearchProfile>>>;
  condition?: InputMaybe<CreateCognitiveSearchCondition>;
  or?: InputMaybe<Array<InputMaybe<CreateCognitiveSearchProfile>>>;
};

export type CreateCollection = {
  /** description of the collection */
  folderDescription?: InputMaybe<Scalars['String']>;
  /** Collection image */
  image?: InputMaybe<Scalars['String']>;
  /** the name of the collection */
  name: Scalars['String'];
  /** ID for a folder the collection should be filed in */
  parentFolderId: Scalars['ID'];
};

export type CreateCollectionMentions = {
  /** ids of the collections */
  folderIds: Array<Scalars['ID']>;
  /** ids of the mentions */
  mentionIds: Array<Scalars['ID']>;
};

export type CreateContextMenuExtension = {
  /** id of the application to create the context menu extension for */
  id: Scalars['ID'];
  label: Scalars['String'];
  type: ContextMenuExtensionType;
  url?: InputMaybe<Scalars['String']>;
};

export type CreateContextMenuExtensions = {
  collections?: InputMaybe<Array<InputMaybe<CreateContextMenuExtension>>>;
  mentions?: InputMaybe<Array<InputMaybe<CreateContextMenuExtension>>>;
  tdos?: InputMaybe<Array<InputMaybe<CreateContextMenuExtension>>>;
  watchlists?: InputMaybe<Array<InputMaybe<CreateContextMenuExtension>>>;
};

export type CreateCreative = {
  advertiserId?: InputMaybe<Scalars['ID']>;
  brandId?: InputMaybe<Scalars['ID']>;
  keywords?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CreateCustomDashboard = {
  data: Scalars['JSONData'];
  description?: InputMaybe<Scalars['String']>;
  hostAppId: Scalars['ID'];
  name: Scalars['String'];
};

export type CreateDagTemplate = {
  cognitiveCategoryId?: InputMaybe<Scalars['ID']>;
  dag: Scalars['String'];
  dagTemplateLanguage?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  mimeType?: InputMaybe<Scalars['String']>;
  /** Name of the DAG template */
  name: Scalars['String'];
  tags?: InputMaybe<Array<Scalars['String']>>;
  /** ID of the organization. Only superadmin can set this value. */
  targetOrganizationId?: InputMaybe<Scalars['ID']>;
};

export type CreateDataRegistry = {
  /** Provide a description for the new data registry. */
  description: Scalars['String'];
  /** Optionally, provide a forced ID. It must be a valid UUID. */
  id?: InputMaybe<Scalars['ID']>;
  /**
   * Defines a Veritone platform system data registry.
   * Only platform components can set this value.
   */
  isSystem?: InputMaybe<Scalars['Boolean']>;
  /** Provide a name for the new data registry. */
  name: Scalars['String'];
  /**
   * Provide source information. If in doubt, set this
   * field to the same value as name.
   */
  source: Scalars['String'];
};

export type CreateDatasetConfidence = {
  /** allow sources with null confidence values */
  allowNull?: InputMaybe<Scalars['Boolean']>;
  /** Maximum Confidence Filter. Sources with confidence higher than this will be ignore */
  max?: InputMaybe<Scalars['Float']>;
  /** Mininum Confidence Filter. Sources with confidence lower than this will be ignore */
  min?: InputMaybe<Scalars['Float']>;
};

export type CreateDatasetSchema = {
  /** Provide a description of Dataset */
  description?: InputMaybe<Scalars['String']>;
  /** Provide a Name of Dataset */
  name: Scalars['String'];
  /** Provide a JSON defination of schema */
  schema: Scalars['JSONData'];
  /** Tags Asssiocated with the Dataset */
  tags?: InputMaybe<Array<InputMaybe<DatasetTags>>>;
};

/** Input fields used to create a new engine. */
export type CreateEngine = {
  /** The engine category */
  categoryId: Scalars['String'];
  /** CPU Resources required for engine to run, in milli-CPUs */
  cpuResourceMcpu?: InputMaybe<Scalars['Int']>;
  /** Whether or not the engine creates a TDO */
  createsTDO?: InputMaybe<Scalars['Boolean']>;
  /** The engine deployment model. See the DeploymentModel enum for options. */
  deploymentModel: DeploymentModel;
  /** An optional description for the engine. */
  description?: InputMaybe<Scalars['String']>;
  /** In what way can this engine be distributed */
  distributionType?: InputMaybe<EngineDistributionType>;
  /** Edge version. Default is 3. */
  edgeVersion?: InputMaybe<Scalars['Int']>;
  /** The tags associated with the engine */
  entityTags?: InputMaybe<Array<InputMaybe<EntityTagInput>>>;
  /**
   * Optionally, supply custom fields that the user can set when launching
   * the engine. See developer documentation for details.
   */
  fields?: InputMaybe<Array<CreateEngineField>>;
  /** CPU Resources required for engine to run, in milli-CPUs */
  gpuSupported?: InputMaybe<GpuSupported>;
  /** The path for an icon image */
  iconPath?: InputMaybe<Scalars['String']>;
  /** Optional given id */
  id?: InputMaybe<Scalars['ID']>;
  /** List of industries where the capabilities of the engine can be applied */
  industries?: InputMaybe<Array<Scalars['String']>>;
  /**
   * Indicates whether or not the engine should be public -- visible to and
   * usable by users outside the creator's organization.
   * Typically an engine should not be made public until it has been fully
   * configured and tested in production.
   */
  isPublic?: InputMaybe<Scalars['Boolean']>;
  /**
   * JWT rights for engine, which is used for generating jwtToken rights later
   * Limit jwtRights update to private engines only
   */
  jwtRights?: InputMaybe<JwtRightsField>;
  /**
   * Optionally, supply dependency information about this engine.
   * Currently this field cannot be set through the API
   * dependency: CreateEngineDependency
   *
   * Whether or not the engine requires a library.
   */
  libraryRequired?: InputMaybe<Scalars['Boolean']>;
  /** The path for a logo image */
  logoPath?: InputMaybe<Scalars['String']>;
  /** Generic Manifest for the engine based on data supplied during onboarding */
  manifest?: InputMaybe<Scalars['JSONData']>;
  /** Indicates the metadata version number */
  metadataVersion?: InputMaybe<Scalars['Int']>;
  /** Human-readable name for the engine */
  name?: InputMaybe<Scalars['String']>;
  /** An optional price indicator for the engine. */
  price?: InputMaybe<Scalars['Int']>;
  /** Optionally, supply ID's of schemas that this engine will use as input schemas */
  schemas?: InputMaybe<Array<InputMaybe<EngineSchema>>>;
  /** Template Job definitions for standalone engine execution */
  standaloneJobTemplates?: InputMaybe<Array<CreateEngineJobTemplate>>;
  /** Testing detail includes necessary data for engine certification process */
  testingDetails?: InputMaybe<TestingDetailsField>;
  /** List of use cases the engine serves */
  useCases?: InputMaybe<Array<Scalars['String']>>;
  /** Engine or Organization homepage */
  website?: InputMaybe<Scalars['String']>;
};

export type CreateEngineConfiguration = {
  credentialIds?: InputMaybe<Array<Scalars['ID']>>;
  sourceId: Scalars['ID'];
};

export type CreateEngineDependency = {
  /**
   * An optional asset type that the engine will expect to have
   * been created.
   */
  assetType?: InputMaybe<Scalars['String']>;
  /**
   * The category type this engine depends on.
   * Must be a valid categoryType from an existing EngineCategory.
   */
  dependencyType: Scalars['String'];
};

export type CreateEngineField = {
  /**
   * An optional default value for the field. Taken in string format, but
   * applies to all field types.
   */
  defaultValue?: InputMaybe<Scalars['String']>;
  /**
   * Optional default values to apply to a picklist. This field
   * should only be set for a field of type multi-picklist.
   */
  defaultValues?: InputMaybe<Array<Scalars['String']>>;
  /** General information about the field, such as a description. */
  info?: InputMaybe<Scalars['String']>;
  /** A human-readable label for the field. */
  label: Scalars['String'];
  /** Maximum value, in float format. Applies only to fields of type Number. */
  max?: InputMaybe<Scalars['Float']>;
  /** Minimum value, in float format. Applies only to fields of type Number. */
  min?: InputMaybe<Scalars['Float']>;
  /** A machine-readable name, or key, for the field. */
  name: Scalars['String'];
  /**
   * A set of allowed values for the field. Applies only to fields of type
   * picklist or multi-picklist.
   */
  options?: InputMaybe<Array<CreateEngineFieldPicklistOption>>;
  /** specifies whether the field is optional */
  required?: InputMaybe<Scalars['Boolean']>;
  /**
   * Numerical step by which the value should be incremented or decremented in
   * the user interface, in float format. Applies only to fields of type Number.
   */
  step?: InputMaybe<Scalars['Float']>;
  /** The field type. */
  type: EngineFieldType;
};

/** Represents one allowed option in a picklist. */
export type CreateEngineFieldPicklistOption = {
  /** The human-readable label for the option, such as "English-US" for a language selector. */
  key: Scalars['String'];
  /**
   * The machine-readable value that will be sent in the engine payload, such as
   * "en-us" for a language selector.
   */
  value: Scalars['String'];
};

export type CreateEngineJobTemplate = {
  /** Template string */
  template: Scalars['String'];
  /** Templating language */
  templateLanguage?: InputMaybe<TemplateLanguage>;
  /** Job template type */
  type: JobTemplateEnumType;
};

export type CreateEntity = {
  description?: InputMaybe<Scalars['String']>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  /**
   * GraphQL-formatted JSON-like structure containing freeform metadata.
   * If a schema is associated with the entity type, the input will be
   * validated against the schema. Use this field _or_ `jsonstring`, not both.
   */
  jsondata?: InputMaybe<Scalars['JSONData']>;
  /**
   * A string containing valid JSON with freeform metadata.
   * If a schema is associated with the entity type, the input will be
   * validated against the schema. Use this field _or_ `jsondata`, not both.
   */
  jsonstring?: InputMaybe<Scalars['String']>;
  libraryId: Scalars['ID'];
  name: Scalars['String'];
  profileImageUrl?: InputMaybe<Scalars['String']>;
};

export type CreateEntityIdentifier = {
  contentType: Scalars['String'];
  entityId: Scalars['ID'];
  entityType?: InputMaybe<CreateEntityType>;
  file?: InputMaybe<Scalars['UploadedFile']>;
  identifierTypeId: Scalars['ID'];
  isPriority?: InputMaybe<Scalars['Boolean']>;
  /**
   * GraphQL-formatted JSON-like structure containing freeform metadata.
   * If a schema is associated with the entity type, the input will be
   * validated against the schema. Use this field _or_ `jsonstring`, not both.
   */
  jsondata?: InputMaybe<Scalars['JSONData']>;
  /**
   * A string containing valid JSON with freeform metadata.
   * If a schema is associated with the entity type, the input will be
   * validated against the schema. Use this field _or_ `jsondata`, not both.
   */
  jsonstring?: InputMaybe<Scalars['String']>;
  /**
   * If the entity identifier type is image, the new file can automatically
   * be set on the entity as its profile image. This is off by default
   * (the entity profile image is not modified) but can be controlled
   * with this parameter.
   */
  profileUpdateMode?: InputMaybe<SetEntityProfileImage>;
  /**
   * Indicates that the URL should be stored directly as a reference and
   * not uploaded to Veritone platform storage. This option is faster by
   * bypasses content validation and can result in data integrity errors
   * if the file is deleted.
   */
  storeReference?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type CreateEntityIdentifierType = {
  dataType: EntityIdentifierDataType;
  description?: InputMaybe<Scalars['String']>;
  iconClass?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  label: Scalars['String'];
  labelPlural: Scalars['String'];
};

export type CreateEntityType = {
  name: Scalars['String'];
  namePlural: Scalars['String'];
  schema: Scalars['JSONData'];
};

export type CreateEvent = {
  /** Identifier of the app using the event. Using "system" as application will throw error */
  application: Scalars['String'];
  /** General description of the event */
  description?: InputMaybe<Scalars['String']>;
  /** Name of the event to be created */
  eventName: Scalars['String'];
  /** The type of event */
  eventType: Scalars['String'];
  /** Event visibility. Private event is only visible to the app publisher. */
  public?: Scalars['Boolean'];
  /**
   * Optional schema. Accept on Protocol buffer format. If not provided,
   * Custom message schema is inferred
   */
  schemaData?: InputMaybe<Scalars['String']>;
};

export type CreateEventActionTemplate = {
  /** A JSON structure that is compatible with action_type.  For example, if action_type is "webhook", action_attributes contain the mustache compatible template to format the content.  If action_type is "job", then action_attributes need to specify a job template. */
  actionAttributes?: InputMaybe<Scalars['JSONData']>;
  /** dedicated column to specify where/what the action is taking place.  For example, if action is a job, then destination is an engine_id.  For webhook, a uri. */
  actionDestination: Scalars['String'];
  /** Either "job", "webhook", "sms", "email".  Future action_type could be "gql" where action is purely a function call. */
  actionType: EventActionTemplateActionType;
  /** Allows you to specify validation for the action_type.  For example, if action_type is "job", perhaps only whitelist a list of engines that could be called. */
  actionValidation?: InputMaybe<Scalars['JSONData']>;
  /** A JSON structure that is compatible/specific to the input_type.  For example, if input type is "event", then input_attributes simply contain the entire event payload. */
  inputAttributes?: InputMaybe<Scalars['JSONData']>;
  /** use "event" for now.  In the future, we allow additional input_type types.  For example, a schedule or a tweet. */
  inputType: EventActionTemplateInputType;
  /** based on the input_type, input_validation describes additional validations.  For example, if input_type is "event", input_validation could be a list of allowed events. */
  inputValidation?: InputMaybe<Scalars['JSONData']>;
  /** The name of template.  e.g. "Run engine X for every new mention in a watchlist". */
  name: Scalars['String'];
  /** Application this template could be applied to. If application_id is null, then this is an org-wide template. */
  ownerApplicationId?: InputMaybe<Scalars['ID']>;
};

export type CreateEventCustomRule = {
  /** The event action as a mutated copy of EventActionTemplate */
  actions?: InputMaybe<Scalars['JSONData']>;
  /** The description of the custom rule */
  description?: InputMaybe<Scalars['String']>;
  /** The event name that the rule subscribes to */
  eventName: Scalars['String'];
  /** The event type that the rule subscribes to */
  eventType: Scalars['String'];
  /** The name of the custom rule */
  name: Scalars['String'];
  /** The rule params to be used in actions */
  params?: InputMaybe<Scalars['JSONData']>;
  /** The status of the custom rule */
  status?: InputMaybe<EventCustomRuleStatus>;
};

export type CreateExecutionLocation = {
  __typename?: 'CreateExecutionLocation';
  clusterId: Scalars['ID'];
  nodeId?: Maybe<Scalars['ID']>;
};

export type CreateExecutionPreferences = {
  /** Optional. Due date for the task. */
  dueDateTime?: InputMaybe<Scalars['DateTime']>;
  /** Optional. Maximum number of engine instances on the task. */
  maxEngines?: InputMaybe<Scalars['Int']>;
  /** Optional. Maximum retries for the task. */
  maxRetries?: InputMaybe<Scalars['Int']>;
  /** Optional. Defines if the task can be porcessed in parallel. Default value is false. */
  parallelProcessing?: InputMaybe<Scalars['Boolean']>;
  /** Optional. Defines if the oarent task should be completed before starting. Default value is false. */
  parentCompleteBeforeStarting?: InputMaybe<Scalars['Boolean']>;
  /** Optional. Priority of the task. Default value is 0. */
  priority?: InputMaybe<Scalars['Int']>;
};

export type CreateExportRequest = {
  /**
   * Whether or not to include TDO media assets in the export.
   * Setting this option can greatly increase the size of the export file.
   */
  includeMedia?: InputMaybe<Scalars['Boolean']>;
  /** Information on the export output configuration */
  outputConfigurations?: InputMaybe<Array<CreateExportRequestOutputConfig>>;
  /** Information on the TDOs to export data from */
  tdoData: Array<CreateExportRequestForTdo>;
};

export type CreateExportRequestForTdo = {
  /**
   * ID of the mention to export from
   * Either this option _or_ tdoId must be provided.
   */
  mentionId?: InputMaybe<Scalars['ID']>;
  /** optional start date for the exported results. Takes priority over startOffsetMs. */
  startDate?: InputMaybe<Scalars['DateTime']>;
  /** optional start offset in milliseconds for the export, relative to TDO startDateTime */
  startOffsetMs?: InputMaybe<Scalars['Int']>;
  /** optional end date for the exported results. Takes priority over stopOffsetMs. */
  stopDate?: InputMaybe<Scalars['DateTime']>;
  /** optional stop offset in milliseconds for the export, relative to the TDO stopDateTime. */
  stopOffsetMs?: InputMaybe<Scalars['Int']>;
  /**
   * ID of the TDO to export from
   * Either this option _or_ mentionId must be provided.
   * This option must be provided if includeMedia is set to true on CreateExportRequest
   */
  tdoId?: InputMaybe<Scalars['ID']>;
};

export type CreateExportRequestFormatConfig = {
  /**
   * The file extension of the export type, such as "vlf" or "ttml".
   * Must be supported by the requested engine category.
   */
  extension: Scalars['String'];
  /**
   * Optional export options specific to the target engine category.
   * Options vary depending on the extension.
   * See the full list of options available at https://docs.veritone.com/#/apis/tutorials/create-export-request/
   */
  options?: InputMaybe<Scalars['JSONData']>;
};

export type CreateExportRequestOutputConfig = {
  /**
   * ID of an engine category to export results for.
   * Either this option _or_ engineId must be provided.
   */
  categoryId?: InputMaybe<Scalars['ID']>;
  /**
   * ID of an individual engine to export results for.
   * Either this option _or_ categoryId must be provided.
   */
  engineId?: InputMaybe<Scalars['ID']>;
  /** Export output format configuration */
  formats: Array<CreateExportRequestFormatConfig>;
};

export type CreateExternalCredential = {
  dataId?: InputMaybe<Scalars['ID']>;
  sourceTypeId?: InputMaybe<Scalars['ID']>;
};

export type CreateFlow = {
  /** The engine category */
  categoryId?: InputMaybe<Scalars['ID']>;
  /** The engine deployment model. See the DeploymentModel enum for options. */
  deploymentModel?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  /** JWT rights for engine, which is used for generating jwtToken rights later */
  jwtRights?: InputMaybe<Scalars['JSONData']>;
  name?: InputMaybe<Scalars['String']>;
};

export type CreateFlowExecution = {
  /** The id of the execution - user generated */
  flowExecutionId: Scalars['ID'];
  /** The url or string of flow input */
  flowExecutionInput?: InputMaybe<Scalars['String']>;
  /** The url to the log file */
  flowExecutionLog?: InputMaybe<Scalars['String']>;
  /** The url to the result file or single string of text */
  flowExecutionResult?: InputMaybe<Scalars['String']>;
  /** The status of the execution after completion */
  flowExecutionStatus?: InputMaybe<Scalars['String']>;
  /** The id of the associated flow */
  flowId: Scalars['ID'];
  /** The id of the associated revision */
  flowRevisionId?: InputMaybe<Scalars['ID']>;
};

export type CreateFlowFromTemplate = {
  categoryId?: InputMaybe<Scalars['String']>;
  flowTemplateId: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
};

export type CreateFlowRevision = {
  description?: InputMaybe<Scalars['String']>;
  /** The ID of the flow to associate the revision to */
  flowId: Scalars['ID'];
  /** Force creation of revision even if the hash matches an existing revision */
  forceCreate?: InputMaybe<Scalars['Boolean']>;
  /** Set the new revision as the HEAD */
  isHead?: InputMaybe<Scalars['Boolean']>;
  /** The flow array and package that describes the flow and dependencies */
  runtime: Scalars['JSONData'];
};

export type CreateFlowTemplate = {
  author: Scalars['String'];
  categories: Array<InputMaybe<Scalars['String']>>;
  description: Scalars['String'];
  flow: Scalars['String'];
  image: Scalars['String'];
  learnMoreLink?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['String']>;
  package?: InputMaybe<Scalars['String']>;
  public?: InputMaybe<Scalars['Boolean']>;
  screenshots?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtitle: Scalars['String'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title: Scalars['String'];
};

/**
 * Information required to create a new folder.
 * After creation, a folder can be renamed with the `updateFolder` mutation,
 * but no other changes are supported.
 */
export type CreateFolder = {
  /** The folder description */
  description: Scalars['String'];
  /** The folder name */
  name: Scalars['String'];
  /**
   * Order index determining in what order the new folder will be displayed
   * relative to other folders at the same level.
   */
  orderIndex?: InputMaybe<Scalars['Int']>;
  /** ID of the parent folder underneath which the new folder will be placed. */
  parentId: Scalars['ID'];
  /** Root folder type to apply to the new folder */
  rootFolderType?: InputMaybe<RootFolderType>;
  /** Require for API Token and JWT Token */
  userId?: InputMaybe<Scalars['ID']>;
};

export type CreateFolderContentTempate = {
  data?: InputMaybe<Scalars['JSONData']>;
  /** The ID of folder */
  folderId: Scalars['ID'];
  /** The ID of Data Registry */
  schemaId: Scalars['ID'];
  /** The ID of Structure Data Object */
  sdoId: Scalars['ID'];
};

export type CreateIoFolder = {
  mode: IoFolderMode;
  options?: InputMaybe<Scalars['JSONData']>;
  referenceId: Scalars['ID'];
  type: IoFolderType;
};

export type CreateJob = {
  /**
   * Optionally, specify a cluster ID where the job should run.
   * Both the organization and the engine must have access to the cluster.
   */
  clusterId?: InputMaybe<Scalars['ID']>;
  /**
   * Supply a DAG template ID to indicate that this
   * job was created from the given dag template.
   * To create a job _from_ a template, use `launchSingleEngineJob`.
   */
  dagTemplateId?: InputMaybe<Scalars['ID']>;
  /** Optional job description */
  description?: InputMaybe<Scalars['String']>;
  isReprocessJob?: InputMaybe<Scalars['Boolean']>;
  /**
   * Optional job config information. Typically used only by Veritone
   * platform components.
   */
  jobConfig?: InputMaybe<Scalars['JSONData']>;
  /**
   * Supply a job template ID to indicate that this
   * job was created from the given job template.
   * To create a job _from_ a template, use `launchJobTemplates`.
   */
  jobTemplateId?: InputMaybe<Scalars['ID']>;
  /** User-provided job name */
  name?: InputMaybe<Scalars['String']>;
  /** This contains a list of URIs engine toolkit will send completed chunks. */
  notificationUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  retries?: InputMaybe<Scalars['Int']>;
  routes?: InputMaybe<Array<InputMaybe<CreateRoute>>>;
  /**
   * Optionally, specify the scheduled job ID that this job is associated
   * with. Typically it is not necessary for a client to set this; it is
   * handled internally by the API.
   * To create a job _from_ a scheduled job, use `launchScheduledJobs`
   */
  scheduledJobId?: InputMaybe<Scalars['ID']>;
  skipDecider?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
  /**
   * Optionally, provide input needed to create a `TemporalDataObject`.
   * The new `TemporalDataObject` will be the target of this job.
   */
  target?: InputMaybe<CreateTdoInJob>;
  targetId?: InputMaybe<Scalars['ID']>;
  tasks?: InputMaybe<Array<CreateTask>>;
  uploadUrl?: InputMaybe<Scalars['String']>;
};

export type CreateJobTemplate = {
  /**
   * Application ID. Used only by Veritone platform components.
   * Other clients should not attempt to send this field. Any value sent
   * will be ignored.
   */
  applicationId?: InputMaybe<Scalars['ID']>;
  clusterId?: InputMaybe<Scalars['ID']>;
  /**
   * Optional job-level configuration. Typically used only by Veritone
   * platform components.
   */
  jobConfig?: InputMaybe<Scalars['JSONData']>;
  /**
   * This contains a list of URIs engine toolkit will send completed chunks.
   * This is for all tasks in job.
   */
  notificationUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  routes?: InputMaybe<Array<InputMaybe<CreateRoute>>>;
  /** Used only by Veritone platform components. */
  skipDecider?: InputMaybe<Scalars['Boolean']>;
  /** The set of task template definitions for this job template. */
  taskTemplates?: InputMaybe<Array<CreateTaskTemplate>>;
};

export type CreateLibrary = {
  applicationId?: InputMaybe<Scalars['ID']>;
  coverImageUrl?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  libraryTypeId: Scalars['ID'];
  name: Scalars['String'];
  organizationId?: InputMaybe<Scalars['ID']>;
};

export type CreateLibraryCollaborator = {
  /** ID of the library. */
  libraryId: Scalars['ID'];
  /** ID of the collaborator organization. */
  organizationId: Scalars['Int'];
  /** list permissions of collaborator */
  permissions: Array<InputMaybe<Scalars['String']>>;
  /** status of collaborator */
  status?: InputMaybe<CollaboratorStatus>;
};

export type CreateLibraryConfiguration = {
  /**
   * This option is used for Dataset Library Only
   * Dataset TDOs confidence filters
   */
  confidence?: InputMaybe<CreateDatasetConfidence>;
  /** ID of the engine category this config applies to */
  engineCategoryId: Scalars['ID'];
  /** ID of the selected library where this config applies to */
  libraryId: Scalars['ID'];
  /**
   * This option is used for Dataset Library Only
   * List of selected engine where tdos are extracted from for training data
   * TDOs are extracted from higher ranked engines first then fallback to the lower ones if the priors don't have any matching tdo
   */
  rankedSourceEngineIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** List of selected engines for training */
  targetEngineIds: Array<InputMaybe<Scalars['ID']>>;
};

export type CreateLibraryEngineModel = {
  accuracy?: InputMaybe<Scalars['Int']>;
  configurationId?: InputMaybe<Scalars['ID']>;
  /**
   * The URL to a file containing or related to the engine model.
   * Use this field if the data is stored in a separate, internet-accessible
   * location and not managed by Veritone APIs.
   * You may also use `updateLibraryEngineModel` to upload a data file.
   */
  dataUrl?: InputMaybe<Scalars['String']>;
  /** ID of the engine the model is used by */
  engineId: Scalars['ID'];
  /** Optional free-form block containing engine-specific metadata. */
  jsondata?: InputMaybe<Scalars['JSONData']>;
  /** ID fo the library containing this engine model. */
  libraryId: Scalars['ID'];
  /** Id of the train job. */
  trainJobId?: InputMaybe<Scalars['ID']>;
  trainStatus?: InputMaybe<LibraryEngineModelTrainStatus>;
};

export type CreateLibraryType = {
  entityIdentifierTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  entityType: CreateEntityType;
  iconClass?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  label: Scalars['String'];
};

export type CreateMediaShare = {
  expireDateTime?: InputMaybe<Scalars['DateTime']>;
  mediaType: Scalars['String'];
  scheduledJobId?: InputMaybe<Scalars['ID']>;
  /** various settings for diffrent types of media. like audio only for videos */
  settings?: InputMaybe<Scalars['JSONData']>;
  /** sourceId OR tdoId is required */
  sourceId?: InputMaybe<Scalars['ID']>;
  startDateTime?: InputMaybe<Scalars['DateTime']>;
  startOffsetMs?: InputMaybe<Scalars['Int']>;
  stopDateTime?: InputMaybe<Scalars['DateTime']>;
  stopOffsetMs?: InputMaybe<Scalars['Int']>;
  tdoId?: InputMaybe<Scalars['ID']>;
};

export type CreateMention = {
  audience?: InputMaybe<AudienceData>;
  cognitiveEngineResults?: InputMaybe<Scalars['JSONData']>;
  cognitiveEngineResultsString?: InputMaybe<Scalars['String']>;
  hitEndDateTime?: InputMaybe<Scalars['DateTime']>;
  hitStartDateTime?: InputMaybe<Scalars['DateTime']>;
  mediaId: Scalars['ID'];
  mentionDateTime: Scalars['DateTime'];
  mentionEndDateTime?: InputMaybe<Scalars['DateTime']>;
  mentionHitCount: Scalars['Int'];
  mentionStatusId?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['JSONData']>;
  programId: Scalars['ID'];
  queryTerm?: InputMaybe<Scalars['String']>;
  snippets?: InputMaybe<Scalars['JSONData']>;
  snippetsString?: InputMaybe<Scalars['String']>;
  watchlistId?: InputMaybe<Scalars['ID']>;
  /**
   * Optionally, specify the redis watchlist last updated timestamp.
   * If this is set, it will obtain the redLock by watchlistId.
   */
  watchlistUpdatingTimestamp?: InputMaybe<Scalars['Int']>;
};

export type CreateMentionComment = {
  commentText: Scalars['String'];
  mentionId: Scalars['ID'];
};

export type CreateMentionExportRequest = {
  /** Filter information will be received to export data from */
  mentionFilters: CreateMentionExportRequestFilter;
  /** User local timezone */
  userTimeZone?: InputMaybe<Scalars['String']>;
};

export type CreateMentionExportRequestFilter = {
  /** Filter mentionDate from/to */
  date?: InputMaybe<CreateMentionExportRequestFilterDate>;
  /** List optional marketIds will be filtered to export data */
  marketIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** List optional sourceIds will be filtered to export data */
  mediaSourceIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** List optional sourceTypeIds will be filtered to export data */
  mediaSourceTypeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** List optional programIds will be filtered to export data */
  programIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** List optional spotTypeIds will be filtered to export data */
  spotTypeList?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** List optional mentionStatusIds will be filtered to export data */
  statusIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** List optional watchlistIds will be filtered to export data */
  watchlistIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type CreateMentionExportRequestFilterDate = {
  from?: InputMaybe<Scalars['DateTime']>;
  to?: InputMaybe<Scalars['DateTime']>;
};

export type CreateMentionRating = {
  mentionId: Scalars['ID'];
  ratingValue: Scalars['Int'];
};

export type CreateMentions = {
  /**
   * Extensible list of flags to augment mention creation.
   * Possible values:
   * - shouldSyncExistingMentions: emits mention modified event for existing mentions
   * - shouldUpdateAudienceDataForExistingMentions: updates existing mentions with provided audience data
   */
  flags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mentions?: InputMaybe<Array<CreateMention>>;
  /**
   * Optionally, specify the redis watchlist last updated timestamp.
   * If this is set, it will obtain the redLock by watchlistId.
   */
  watchlistUpdatingTimestamp?: InputMaybe<Scalars['Int']>;
};

export type CreateNextPipelineJobsTargetInfo = {
  endOffsetMs?: InputMaybe<Scalars['Int']>;
  startOffsetMs?: InputMaybe<Scalars['Int']>;
  /**
   * ID of the target object for the job pipeline,
   * typically that of a TemporalDataObject
   */
  targetId: Scalars['ID'];
};

export type CreateOpenIdProvider = {
  /** Button color for OpenID Provider on login (e.g.,#FFFFFF,..) */
  btnColor?: InputMaybe<Scalars['String']>;
  /** The link of OpenId Provider Logo */
  btnLogo?: InputMaybe<Scalars['String']>;
  /** Button text for OpenID Provider on login */
  btnText?: InputMaybe<Scalars['String']>;
  /** Button text color for OpenID Provider on login (e.g.,#FFFFFF,..) */
  btnTextColor?: InputMaybe<Scalars['String']>;
  /** The clientId of OpenID Connect, it will be hash as sensitive data */
  clientId: Scalars['String'];
  /** Secret key of OpenID Connect, it will be hash as sensitive data */
  clientSecret: Scalars['String'];
  /** Description of the OpenID Provider */
  description?: InputMaybe<Scalars['String']>;
  /** Flag is set for Global OpenID Provider. Default value is false if not set */
  isGlobal?: InputMaybe<Scalars['Boolean']>;
  /**
   * The issuer URL of the OpenID Connect application.
   * E.g.. (the /.well-known/ URL for Azure AD, or https://accounts.google.com for Google,...)
   */
  issuerUrl: Scalars['String'];
  /** Name of the OpenID Provider will show in Vertione Platform */
  name: Scalars['String'];
  /** Official website url of the Provider */
  websiteUrl?: InputMaybe<Scalars['String']>;
};

export type CreateOrganization = {
  adminSeatLimit?: InputMaybe<Scalars['Int']>;
  applications?: InputMaybe<Scalars['JSONData']>;
  businessUnit: Scalars['String'];
  integrations?: InputMaybe<Scalars['JSONData']>;
  /**
   * Enable/disable the limit enforced for organization
   * Only superadmin can set this value
   */
  isLimitEnforced?: InputMaybe<Scalars['Boolean']>;
  maxAiwareClusters?: InputMaybe<Scalars['Int']>;
  maxAiwareNodes?: InputMaybe<Scalars['Int']>;
  /** Metadata in JSON format. */
  metadata: Scalars['JSONData'];
  name: Scalars['String'];
  /**
   * The budget remaining for organization (cents)
   * Only superadmin can set this value
   */
  remainingBudget?: InputMaybe<Scalars['Int']>;
  seatLimit?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<OrganizationStatus>;
  types?: InputMaybe<Array<InputMaybe<OrganizationType>>>;
};

export type CreateOrganizationInviteInput = {
  /** List of applications and application-specific roles to grant to the user */
  applicationRoles: Array<ApplicationInviteRoleInput>;
  /** Invitee email address */
  email: Scalars['String'];
  /** Message shown to the user and the approver of the invite */
  message?: InputMaybe<Scalars['String']>;
  /** Organization to add the user to */
  organizationId: Scalars['ID'];
};

export type CreatePasswordResetRequest = {
  /** Optionally specify whether we should skip sending the reset email. */
  skipPasswordResetEmail?: InputMaybe<Scalars['Boolean']>;
  /** The user login name. Typically email address. */
  userName: Scalars['String'];
};

export type CreatePasswordResetRequestPayload = {
  __typename?: 'CreatePasswordResetRequestPayload';
  message?: Maybe<Scalars['String']>;
};

export type CreatePasswordUpdateRequest = {
  /** The user's ID */
  id: Scalars['ID'];
  /** Optionally specify whether we should skip sending the reset email. */
  skipPasswordResetEmail?: InputMaybe<Scalars['Boolean']>;
};

export type CreateProcessTemplate = {
  name: Scalars['String'];
  taskList: Scalars['JSONData'];
};

export type CreateProgramAffiliate = {
  scheduledDay: DayOfWeek;
  sourceId: Scalars['ID'];
  startDateTime: Scalars['DateTime'];
  startTime: Scalars['Time'];
  stopDateTime: Scalars['DateTime'];
  stopTime: Scalars['Time'];
};

export type CreateRecurringSchedulePart = {
  durationSeconds?: InputMaybe<Scalars['Int']>;
  repeatInterval: Scalars['Int'];
  repeatIntervalUnit: IntervalUnit;
  /** Time of day, required for repeat interval unit in days. */
  startTime?: InputMaybe<Scalars['Time']>;
};

export type CreateRoute = {
  childIoFolderReferenceId?: InputMaybe<Scalars['ID']>;
  endpoint?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Scalars['JSONData']>;
  parentIoFolderReferenceId?: InputMaybe<Scalars['ID']>;
};

export type CreateSavedSearch = {
  csp: Scalars['JSONData'];
  name: Scalars['String'];
  sharedWithOrganization?: InputMaybe<Scalars['Boolean']>;
};

/**
 * Example to create a scheduleJob:
 * mutation createScheduleJob {
 * createScheduledJob(input:
 * {
 * name: "every5Min"
 *         runMode:Recurring
 * recurringScheduleParts: [
 * {
 * repeatIntervalUnit: Minutes
 * repeatInterval: 5
 * }]
 * jobTemplates:[
 * {
 *
 * #clusterId: "rt-242c1beb-653a-4299-bb33-2d8fb105d70b"
 *             clusterId: "YOUR OWN CLUSTER ID"
 *             taskTemplates : [
 * {
 * engineId: "9e611ad7-2d3b-48f6-a51b-0a1ba40fe255" webstream adapter
 * payload: {
 * url:"https://s3.amazonaws.com/src-veritone-tests/stage/20190505/0_40_Eric%20Knox%20BWC%20Video_40secs.mp4"
 *            }
 * },
 * {
 * engineId: "352556c7-de07-4d55-b33f-74b1cf237f25" playback
 * },
 * {
 * engineId: "8bdb0e3b-ff28-4f6e-a3ba-887bd06e6440" chunk audio
 * payload:{
 * ffmpegTemplate: "audio"
 *             chunkOverlap: 15
 * customFFMPEGProperties:{
 * chunkSizeInSeconds: "30"
 *             }
 * }
 * },
 * {
 * #engine to run
 * engineId: "c0e55cde-340b-44d7-bb42-2e0d65e98255"
 *         }
 * ]
 * }
 * ]
 * }
 * )
 * {
 * id
 * }
 * }
 */
export type CreateScheduledJob = {
  affiliates?: InputMaybe<Array<CreateProgramAffiliate>>;
  /**
   * Application ID. Used only by Veritone platform components.
   * Other clients should not attempt to send this field. Any value sent
   * will be ignored.
   */
  applicationId?: InputMaybe<Scalars['ID']>;
  /** Optionally, associate content templates with the new scheduled job */
  contentTemplates?: InputMaybe<Array<CreateScheduledJobContentTemplateWithScheduledJob>>;
  /** A detailed description. Defaults to name. */
  description?: InputMaybe<Scalars['String']>;
  /**
   * JSON containing metadata details for this scheduled job.
   * If supplied, then the detailsSchemaId must also be set.
   * The supplied data must comply with the schema
   */
  details?: InputMaybe<Scalars['JSONData']>;
  /** Schema ID for detail metadata on this scheduled job */
  detailsSchemaId?: InputMaybe<Scalars['ID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  /**
   * Indicates whether or not the scheduled job is publicly accessible.
   * Only Veritone administrators can create public scheduled jobs.
   * Other users will get an error if they attempt to set this value to true.
   */
  isPublic?: InputMaybe<Scalars['Boolean']>;
  jobTemplateIds?: InputMaybe<Array<Scalars['ID']>>;
  jobTemplates?: InputMaybe<Array<CreateJobTemplate>>;
  name: Scalars['String'];
  /**
   * Organization ID. Used only by Veritone platform components.
   * Other clients should not attempt to send this field. Any value sent
   * will be ignored.
   */
  organizationId?: InputMaybe<Scalars['ID']>;
  recurringScheduleParts?: InputMaybe<Array<CreateRecurringSchedulePart>>;
  runMode?: InputMaybe<RunMode>;
  startDateTime?: InputMaybe<Scalars['DateTime']>;
  stopDateTime?: InputMaybe<Scalars['DateTime']>;
  weeklyScheduleParts?: InputMaybe<Array<CreateWeeklySchedulePart>>;
};

export type CreateScheduledJobCollaborator = {
  /** ID of the organization to share the source with */
  organizationId: Scalars['ID'];
  /**
   * Permission to grant. Can be `editor` or `viewer`.
   * Set to `none` to revoke permissions for this organization.
   */
  permission: SetScheduledJobPermission;
};

export type CreateScheduledJobContentTemplate = {
  /**
   * To create a new structured data object, supply this field with
   * JSON to save in the SDO. The JSON must comply with the schema
   * defined in data registry.
   */
  data?: InputMaybe<Scalars['JSONData']>;
  /** Specify the scheduled job ID that this content template applies to */
  scheduledJobId: Scalars['ID'];
  /**
   * Supply the ID of the data registry that contains the schema
   * for the content template.
   */
  schemaId: Scalars['ID'];
  /**
   * To associate an existing structured data object (SDO) to the
   * source, provide the SDO ID. Either this field or data must be supplied.
   */
  sdoId?: InputMaybe<Scalars['ID']>;
};

export type CreateScheduledJobContentTemplateWithScheduledJob = {
  /**
   * To create a new structured data object, supply this field with
   * JSON to save in the SDO. The JSON must comply with the schema
   * defined in data registry.
   */
  data?: InputMaybe<Scalars['JSONData']>;
  /**
   * Supply the ID of the data registry that contains the schema
   * for the content template.
   */
  schemaId: Scalars['ID'];
  /**
   * To associate an existing structured data object (SDO) to the
   * source, provide the SDO ID. Either this field or data must be supplied.
   */
  sdoId?: InputMaybe<Scalars['ID']>;
};

export type CreateSchema = {
  dataRegistryId: Scalars['ID'];
  definition: Scalars['JSONData'];
  /** Find more details about the fields in the comments of type Schema */
  id: Scalars['ID'];
  majorVersion: Scalars['Int'];
  minorVersion: Scalars['Int'];
  status: SchemaStatus;
};

/** Data used to create a new source */
export type CreateSource = {
  /** Add or modify collaborators on the source. */
  collaborators?: InputMaybe<Array<CreateSourceCollaborator>>;
  /** Optionally, associate content templates with the new source */
  contentTemplates?: InputMaybe<Array<CreateSourceContentTemplateWithSource>>;
  /**
   * Optionally associate a structured data object of the specified correlationSchemaId.
   * Required when correlationSchemaId is specified.
   */
  correlationSDOId?: InputMaybe<Scalars['ID']>;
  /**
   * Optionally associate a schema for correlation.
   * Required when correlationSDOId is specified.
   */
  correlationSchemaId?: InputMaybe<Scalars['ID']>;
  /**
   * Additional metadata to associate with the source. This data may be
   * validated against a schema associated with the source type.
   */
  details?: InputMaybe<Scalars['JSONData']>;
  /**
   * Indicates whether or not the source is public. Default is false (private
   * to owner organization).
   */
  isPublic?: InputMaybe<Scalars['Boolean']>;
  /**
   * The human-readable source name. The value does not have to be unique,
   * but it is strongly recommended to use a name that is unique within
   * the owning organization.
   */
  name: Scalars['String'];
  /** The source type ID */
  sourceTypeId: Scalars['ID'];
  /**
   * Optionally, set an initial state for the source.
   * This is typically not required.
   */
  state?: InputMaybe<Scalars['JSONData']>;
  /** Optional thumbnail image URL for the source */
  thumbnailUrl?: InputMaybe<Scalars['String']>;
};

export type CreateSourceCollaborator = {
  /** ID of the organization to share the source with */
  organizationId: Scalars['ID'];
  /**
   * Permission to grant. Can be `editor` or `viewer`.
   * Set to `none` to revoke permissions for this organization.
   */
  permission: SetSourcePermission;
};

export type CreateSourceContentTemplate = {
  /**
   * To create a new structured data object, supply this field with
   * JSON to save in the SDO. The JSON must comply with the schema
   * defined in data registry.
   */
  data?: InputMaybe<Scalars['JSONData']>;
  /**
   * Supply the ID of the data registry that contains the schema
   * for the content template.
   */
  schemaId: Scalars['ID'];
  /**
   * To associate an existing structured data object (SDO) to the
   * source, provide the SDO ID. Either this field or data must be supplied.
   */
  sdoId?: InputMaybe<Scalars['ID']>;
  /** Specify the source ID that this content template applies to */
  sourceId: Scalars['ID'];
};

export type CreateSourceContentTemplateWithSource = {
  /**
   * To create a new structured data object, supply this field with
   * JSON to save in the SDO. The JSON must comply with the schema
   * defined in data registry.
   */
  data?: InputMaybe<Scalars['JSONData']>;
  /**
   * Supply the ID of the data registry that contains the schema
   * for the content template.
   */
  schemaId: Scalars['ID'];
  /**
   * To associate an existing structured data object (SDO) to the
   * source, provide the SDO ID. Either this field or data must be supplied.
   */
  sdoId?: InputMaybe<Scalars['ID']>;
};

export type CreateSourceType = {
  /** Source type category ID */
  categoryId: Scalars['ID'];
  credentialSchemaId?: InputMaybe<Scalars['ID']>;
  credentialType?: InputMaybe<CredentialType>;
  details?: InputMaybe<Scalars['JSONData']>;
  /**
   * Indicates whether or not the source type is "live", such
   * as a camera feed
   */
  isLive?: InputMaybe<Scalars['Boolean']>;
  /**
   * Indicates that the source type is publicly accessible.
   * If false, is usable only by the owner organization.
   */
  isPublic?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  /**
   * Indicates whether or not the source type requires
   * scan pipeline jobs
   */
  requiresScanPipeline?: InputMaybe<Scalars['Boolean']>;
  sourceSchemaId?: InputMaybe<Scalars['ID']>;
};

export type CreateStructuredData = {
  data?: InputMaybe<Scalars['JSONData']>;
  dataString?: InputMaybe<Scalars['String']>;
  /** Optionally provide a forced ID */
  id?: InputMaybe<Scalars['ID']>;
  /** Id of the schema used to validate this object */
  schemaId: Scalars['ID'];
};

export type CreateSubscription = {
  contact: CreateSubscriptionContact;
  frequency?: InputMaybe<SubscriptionFrequency>;
  objectType?: InputMaybe<SubscriptionObjectType>;
  scheduledDay?: InputMaybe<DayOfWeek>;
  scheduledTime?: InputMaybe<Scalars['Time']>;
  scheduledTimeZone?: InputMaybe<Scalars['String']>;
  /** ID of the object (probably a watchlist) to create a subscription for */
  targetId: Scalars['ID'];
};

export type CreateSubscriptionContact = {
  emailAddress?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  webhookUri?: InputMaybe<Scalars['String']>;
};

/**
 * Used to create a subscription while creating a watchlist.
 * The subscription will be for the new watchlist.
 */
export type CreateSubscriptionInWatchlist = {
  contact: CreateSubscriptionContact;
  frequency?: InputMaybe<SubscriptionFrequency>;
  objectType?: InputMaybe<SubscriptionObjectType>;
  scheduledDay?: InputMaybe<DayOfWeek>;
  scheduledTime?: InputMaybe<Scalars['Time']>;
  scheduledTimeZone?: InputMaybe<Scalars['String']>;
};

/** Payload required to create a temporal data object */
export type CreateTdo = {
  /**
   * Optionally, add the new data to the search index. If the data is not
   * indexed on creation, it can be indexed later by using `updateTDO` or
   * creating a suitable job.
   */
  addToIndex?: InputMaybe<Scalars['Boolean']>;
  /** Only internal systems can set this value */
  applicationId?: InputMaybe<Scalars['ID']>;
  /** Optionally, provide information to create one or more assets. */
  assets?: InputMaybe<Array<CreateAssetInTdo>>;
  /**
   * Optionally, specify one or more structured data objects to apply as
   * content templates to the TDO. They will be stored as assets of type
   * content-template and will contain an immutable copy of the original data.
   */
  contentTemplates?: InputMaybe<Array<CreateTdoContentTemplateWithTdo>>;
  /** A description for the TDO object. */
  description?: InputMaybe<Scalars['String']>;
  details?: InputMaybe<Scalars['JSONData']>;
  /**
   * True if the new TDO should be made public. If true, security.global
   * will be set to true and users from other organizations will be able to
   * view, but not modify, the TDO's metadata and assets.
   */
  isPublic?: InputMaybe<Scalars['Boolean']>;
  /**
   * Optionally, looks up and launch the scheduleJob that associates with
   * media source if it is active
   */
  launchProgram?: InputMaybe<Scalars['Boolean']>;
  /** A name for the TDO object, such as the name of the primary media file. */
  name?: InputMaybe<Scalars['String']>;
  /**
   * An optional parent folder ID for the new TemporalDataObject.
   * The folder can be filed in additional folders later using `fileTemporalDataObject`,
   * or un-filed from this one.
   */
  parentFolderId?: InputMaybe<Scalars['ID']>;
  /** An optional preview asset URL for the TDO */
  previewUrl?: InputMaybe<Scalars['String']>;
  /** Source for the TDO, such as an ingestion type or engine ID. */
  source?: InputMaybe<Scalars['String']>;
  /**
   * Optionally, set source data for this TDO. Source data identifies
   * that task that generated this TDO. If the TDO was not generated as part
   * of engine or adapter execution, this field should not be set.
   * However, it is _strongly_ recommended that engines that create TDOs
   * set this field. Doing so ensures that later tasks in the same job
   * have appropriate access to the new TDO.
   */
  sourceData?: InputMaybe<SetTdoSourceData>;
  /** An optional image representing the TDO source */
  sourceImageUrl?: InputMaybe<Scalars['String']>;
  /**
   * Start date and time. ISO-8601 standard strings
   * and numerical format in either Unix format (seconds
   * since epoch) or milliseconds since epoch are accepted.
   */
  startDateTime: Scalars['DateTime'];
  /**
   * Status, such as "downloaded" or "recording".
   * The server will set a value if one is not provided.
   */
  status?: InputMaybe<Scalars['String']>;
  /**
   * Stop date and time. ISO-8601 standard strings
   * and numerical format in either Unix format (seconds
   * since epoch) or milliseconds since epoch are accepted.
   */
  stopDateTime: Scalars['DateTime'];
  /** An optional thumbnail URL for the TDO */
  thumbnailUrl?: InputMaybe<Scalars['String']>;
};

export type CreateTdoContentTemplateWithTdo = {
  /**
   * To create a new structured data object, supply this field with
   * JSON to save in the SDO. The JSON must comply with the schema
   * defined in data registry.
   */
  data?: InputMaybe<Scalars['JSONData']>;
  /**
   * Supply the ID of the data registry that contains the schema
   * for the content template.
   */
  schemaId: Scalars['ID'];
  /**
   * To associate an existing structured data object (SDO) to the
   * TDO, provide the SDO ID. Either this field or data must be supplied.
   */
  sdoId?: InputMaybe<Scalars['ID']>;
};

export type CreateTdoForJob = {
  /**
   * Optionally, add the new data to the search index. If the data is not
   * indexed on creation, it can be indexed later by using `updateTDO` or
   * creating a suitable job.
   */
  addToIndex?: InputMaybe<Scalars['Boolean']>;
  /** Only internal systems can set this value */
  applicationId?: InputMaybe<Scalars['ID']>;
  /**
   * Optionally, specify one or more structured data objects to apply as
   * content templates to the TDO. They will be stored as assets of type
   * content-template and will contain an immutable copy of the original data.
   */
  contentTemplates?: InputMaybe<Array<CreateTdoContentTemplateWithTdo>>;
  /** A description for the TDO object. */
  description?: InputMaybe<Scalars['String']>;
  /** Detailed metadata about the TDO */
  details?: InputMaybe<Scalars['JSONData']>;
  /**
   * True if the new TDO should be made public. If true, security.global
   * will be set to true and users from other organizations will be able to
   * view, but not modify, the TDO's metadata and assets.
   */
  isPublic?: InputMaybe<Scalars['Boolean']>;
  /**
   * A name for the TDO object, such as the name of the primary media file.
   * If not provided, the TDO will have the name of the scheduled job that
   * created it.
   */
  name?: InputMaybe<Scalars['String']>;
  /**
   * An optional parent folder ID for the new TemporalDataObject.
   * The folder can be filed in additional folders later using `fileTemporalDataObject`,
   * or un-filed from this one.
   */
  parentFolderId?: InputMaybe<Scalars['ID']>;
  /** An optional preview asset URL for the TDO */
  previewUrl?: InputMaybe<Scalars['String']>;
  /** An optional image representing the TDO source */
  sourceImageUrl?: InputMaybe<Scalars['String']>;
  /**
   * Status, such as "downloaded" or "recording".
   * The server will set a value if one is not provided.
   */
  status?: InputMaybe<Scalars['String']>;
  /** An optional thumbnail URL for the TDO */
  thumbnailUrl?: InputMaybe<Scalars['String']>;
};

/** Payload required to create a temporal data object */
export type CreateTdoInJob = {
  /**
   * Optionally, add the new data to the search index. If the data is not
   * indexed on creation, it can be indexed later by using `updateTDO` or
   * creating a suitable job.
   */
  addToIndex?: InputMaybe<Scalars['Boolean']>;
  /** Optionally, provide information to create one or more assets. */
  assets?: InputMaybe<Array<CreateAssetInTdo>>;
  /**
   * Optionally, specify one or more structured data objects to apply as
   * content templates to the TDO. They will be stored as assets of type
   * content-template and will contain an immutable copy of the original data.
   */
  contentTemplates?: InputMaybe<Array<CreateTdoContentTemplateWithTdo>>;
  /** A description for the TDO object. */
  description?: InputMaybe<Scalars['String']>;
  details?: InputMaybe<Scalars['JSONData']>;
  /**
   * True if the new TDO should be made public. If true, security.global
   * will be set to true and users from other organizations will be able to
   * view, but not modify, the TDO's metadata and assets.
   */
  isPublic?: InputMaybe<Scalars['Boolean']>;
  /** A name for the TDO object, such as the name of the primary media file. */
  name?: InputMaybe<Scalars['String']>;
  /**
   * An optional parent folder ID for the new TemporalDataObject.
   * The folder can be filed in additional folders later using `fileTemporalDataObject`,
   * or un-filed from this one.
   */
  parentFolderId?: InputMaybe<Scalars['ID']>;
  /** An optional preview asset URL for the TDO */
  previewUrl?: InputMaybe<Scalars['String']>;
  /**
   * Optionally, set source data for this TDO. Source data identifies
   * that task that generated this TDO. If the TDO was not generated as part
   * of engine or adapter execution, this field should not be set.
   * However, it is _strongly_ recommended that engines that create TDOs
   * set this field. Doing so ensures that later tasks in the same job
   * have appropriate access to the new TDO.
   */
  sourceData?: InputMaybe<SetTdoSourceData>;
  /** An optional image representing the TDO source */
  sourceImageUrl?: InputMaybe<Scalars['String']>;
  /**
   * Start date and time. ISO-8601 standard strings
   * and numerical format in either Unix format (seconds
   * since epoch) or milliseconds since epoch are accepted.
   */
  startDateTime?: InputMaybe<Scalars['DateTime']>;
  /**
   * Status, such as "downloaded" or "recording".
   * The server will set a value if one is not provided.
   */
  status?: InputMaybe<Scalars['String']>;
  /**
   * Stop date and time. ISO-8601 standard strings
   * and numerical format in either Unix format (seconds
   * since epoch) or milliseconds since epoch are accepted.
   */
  stopDateTime?: InputMaybe<Scalars['DateTime']>;
  /** An optional thumbnail URL for the TDO */
  thumbnailUrl?: InputMaybe<Scalars['String']>;
};

export type CreateTdoWithAsset = {
  /**
   * Optionally, add the new data to the search index. If the data is not
   * indexed on creation, it can be indexed later by using `updateTDO` or
   * creating a suitable job.
   */
  addToIndex?: InputMaybe<Scalars['Boolean']>;
  /**
   * Asset type. Default is "media".
   * See https://docs.veritone.com/#/apis/tutorials/asset-types for supported values.
   */
  assetType?: InputMaybe<Scalars['String']>;
  /**
   * Optionally, specify one or more structured data objects to apply as
   * content templates to the TDO. They will be stored as assets of type
   * content-template and will contain an immutable copy of the original data.
   */
  contentTemplates?: InputMaybe<Array<CreateTdoContentTemplateWithTdo>>;
  /**
   * Content type for the file.
   * Default is "video/mp4"
   */
  contentType?: InputMaybe<Scalars['String']>;
  details?: InputMaybe<Scalars['JSONData']>;
  file?: InputMaybe<Scalars['UploadedFile']>;
  /**
   * True if the new TDO should be made public. If true, security.global
   * will be set to true and users from other organizations will be able to
   * view, but not modify, the TDO's metadata and assets.
   */
  isPublic?: InputMaybe<Scalars['Boolean']>;
  /**
   * Optionally, looks up and launch the scheduleJob that associates with
   * media source if it is active
   */
  launchProgram?: InputMaybe<Scalars['Boolean']>;
  /** A name for the TDO object, such as the name of the primary media file. */
  name?: InputMaybe<Scalars['String']>;
  /**
   * An optional parent folder ID for the new TemporalDataObject.
   * The folder can be filed in additional folders later using `fileTemporalDataObject`,
   * or un-filed from this one.
   */
  parentFolderId?: InputMaybe<Scalars['ID']>;
  /** An optional preview asset URL for the TDO */
  previewUrl?: InputMaybe<Scalars['String']>;
  /** The scheduled job ID. */
  scheduledJobId?: InputMaybe<Scalars['ID']>;
  /**
   * Optionally, set source data for this TDO. Source data identifies
   * that task that generated this TDO. If the TDO was not generated as part
   * of engine or adapter execution, this field should not be set.
   * However, it is _strongly_ recommended that engines that create TDOs
   * set this field. Doing so ensures that later tasks in the same job
   * have appropriate access to the new TDO.
   * This source data will be set on both the TDO and the asset.
   */
  sourceData?: InputMaybe<SetTdoSourceData>;
  /** The ingestion source ID for this file */
  sourceId?: InputMaybe<Scalars['ID']>;
  /** An optional image representing the TDO source */
  sourceImageUrl?: InputMaybe<Scalars['String']>;
  /** Start date and time for the file */
  startDateTime: Scalars['DateTime'];
  /** TDO status, such as "recorded" (the default) */
  status?: InputMaybe<Scalars['String']>;
  /**
   * Stop date and time. If not passed, the server
   * will apply a value based on the default
   * chunk size of 15 minutes.
   */
  stopDateTime?: InputMaybe<Scalars['DateTime']>;
  /** An optional thumbnail URL for the TDO */
  thumbnailUrl?: InputMaybe<Scalars['String']>;
  /** determine stopDateTime based on the length of the media asset */
  updateStopDateTimeFromAsset?: InputMaybe<Scalars['Boolean']>;
  /** The file location or URI. */
  uri?: InputMaybe<Scalars['String']>;
};

/** Fields required to create a task. Used when creating a job. */
export type CreateTask = {
  /** Optional. Specifies the build ID of the engine */
  buildId?: InputMaybe<Scalars['String']>;
  /**
   * Engine ID to be used for the task.
   * Either engineId OR taskType is required.
   */
  engineId?: InputMaybe<Scalars['ID']>;
  /** Execution preferences for the current task */
  executionPreferences?: InputMaybe<CreateExecutionPreferences>;
  /** IO folders for the task. */
  ioFolders?: InputMaybe<Array<InputMaybe<CreateIoFolder>>>;
  /** Optional. Specifies whether or not the task target should be cloned. */
  isClone?: InputMaybe<Scalars['Boolean']>;
  /** This contains a list of URIs engine toolkit will send completed chunks. */
  notificationUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Task payload in GraphQL format.
   * Optional. Only one of payloadString and payload is permitted.
   */
  payload?: InputMaybe<Scalars['JSONData']>;
  /**
   * Task payload in raw string form.
   * Optional. Only one of payloadString and payload is permitted.
   */
  payloadString?: InputMaybe<Scalars['String']>;
  /**
   * Optionally, provide a task definition that will be executed if
   * and only if this one fails. Standby tasks can be nested.
   */
  standbyTask?: InputMaybe<CreateTask>;
  /**
   * The task type, which is mapped on the server to an engine ID.
   * Either taskType OR engineId is required.
   */
  taskType?: InputMaybe<Scalars['String']>;
  /** Optional. Specifies whether the task is for testing. */
  testTask?: InputMaybe<Scalars['Boolean']>;
};

export type CreateTaskLog = {
  /** A file to upload. Use multipart form POST to submit this field. */
  file?: InputMaybe<Scalars['UploadedFile']>;
  /** ID of the task which the task long belongs to. */
  taskId: Scalars['ID'];
};

export type CreateTaskTemplate = {
  engineConfigId?: InputMaybe<Scalars['ID']>;
  engineId?: InputMaybe<Scalars['ID']>;
  executionLocationId?: InputMaybe<Scalars['ID']>;
  /** Execution preferences for the current task */
  executionPreferences?: InputMaybe<CreateExecutionPreferences>;
  /** IO folders for the task. */
  ioFolders?: InputMaybe<Array<InputMaybe<CreateIoFolder>>>;
  jobTemplateId?: InputMaybe<Scalars['ID']>;
  /** This contains a list of URIs engine toolkit will send completed chunks. */
  notificationUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  parentTaskId?: InputMaybe<Scalars['ID']>;
  payload?: InputMaybe<Scalars['JSONData']>;
  payloadString?: InputMaybe<Scalars['String']>;
};

export enum CreateTriggerTarget {
  /**
   * Email target should provide the following kvp in the json structure of
   *   TargetType:params
   *
   *  "address":"<your_address>@<your_domain>"
   */
  Email = 'Email',
  /**
   * SMS target should provide the following kvp in the json structure of
   *   TargetType:params
   *
   *   "number": ########
   */
  Sms = 'SMS',
  /**
   * Webhook target should provide the following kvp in the json structure of
   *   TargetType:params
   *
   *   "url":"<protocol>://<your_url>
   */
  Webhook = 'Webhook'
}

export type CreateTriggerType = {
  /**
   * The name of the trigger target. Currently we only support
   * Webhook, SMS, and Email
   */
  name: CreateTriggerTarget;
  /**
   * The parameters for this hook. Must be a JSON payload. See
   * HookTarget docs for supported kvp for each HookTarget type.
   */
  params: Scalars['JSONData'];
};

export type CreateTriggers = {
  /**
   * List of events in csv form. Use "*" to listen to all events. When using a wild card, csv form is no longer valid.
   * Either events or types can be specified at a time. Example:
   * events: "event1,event2,event3" // valid
   * events: "*" // valid
   * events: "*,event1" // invalid
   */
  events?: InputMaybe<Scalars['String']>;
  /** Array of hook targets */
  targets?: InputMaybe<Array<InputMaybe<CreateTriggerType>>>;
  /**
   * List of events in csv form. Use "*" to listen to all types. When using a wild card, csv form is no longer valid.
   * Either events or types can be specified at a time. Example:
   * types: "type1,type2,type3" // valid
   * types: "*" // valid
   * types: "*,type1" // invalid
   */
  types?: InputMaybe<Scalars['String']>;
};

export type CreateUser = {
  acls?: InputMaybe<Array<UserAclInput>>;
  authGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  email?: InputMaybe<Scalars['String']>;
  /** Optionally, specify user's first name */
  firstName?: InputMaybe<Scalars['String']>;
  /**
   * Metadata in JSON format. If a field is provided elsewhere in the
   * payload, it does not need to be saved in jsondata.
   */
  jsondata?: InputMaybe<Scalars['JSONData']>;
  /** Optionally, specify user's last name */
  lastName?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  organizationId: Scalars['ID'];
  /**
   * Password for new user. Optional - if not provided, the user will
   * need to set on first login.
   */
  password?: InputMaybe<Scalars['String']>;
  /** User who requested that the new user be provisioned */
  requestorId?: InputMaybe<Scalars['ID']>;
  roleIds?: InputMaybe<Array<Scalars['ID']>>;
  sendNewUserEmail?: InputMaybe<Scalars['Boolean']>;
};

export type CreateWatchlist = {
  cognitiveSearches?: InputMaybe<Array<CreateCognitiveSearchInWatchlist>>;
  /**
   * Set structured metadata on the watchlist.
   * The data is subject to a set of schemas.
   */
  details?: InputMaybe<Scalars['JSONData']>;
  /**
   * Indicates whether or not the watchlist expiration notification should be enable
   * The default value is false
   */
  enableExpirationNotification?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  /** Optional ID for a folder the watchlist should be filed in */
  parentFolderId?: InputMaybe<Scalars['ID']>;
  searchIndex?: InputMaybe<SearchIndex>;
  sourceIds?: InputMaybe<Array<Scalars['ID']>>;
  sourceTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * Date and time at which the watchlist becomes effective.
   * If not provided, defaults to current time.
   */
  startDateTime?: InputMaybe<Scalars['DateTime']>;
  /** Date and time at which the watchlist expires and is no longer effective. */
  stopDateTime: Scalars['DateTime'];
  subscriptions?: InputMaybe<Array<CreateSubscriptionInWatchlist>>;
  watchlistType?: InputMaybe<Scalars['String']>;
};

export type CreateWeeklySchedulePart = {
  scheduledDay?: InputMaybe<DayOfWeek>;
  startTime?: InputMaybe<Scalars['Time']>;
  stopTime?: InputMaybe<Scalars['Time']>;
};

export type CreateWidget = {
  adScript?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  borderColor?: InputMaybe<Scalars['String']>;
  collectionId: Scalars['ID'];
  displayCollectionDescription?: InputMaybe<Scalars['Boolean']>;
  displayCollectionName?: InputMaybe<Scalars['Boolean']>;
  displayLogo?: InputMaybe<Scalars['Boolean']>;
  displayMentionDescription?: InputMaybe<Scalars['Boolean']>;
  displayMentionIntro?: InputMaybe<Scalars['Boolean']>;
  displayTranscription?: InputMaybe<Scalars['Boolean']>;
  folderId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nextButtonColor?: InputMaybe<Scalars['String']>;
  numberOfMentionsToShow?: InputMaybe<Scalars['Int']>;
  seoTags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  textColor?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};

export type CreateWorkflowRuntimeStorageData = {
  /** Data content - base64 encoded binary, plain string or encoded JSON */
  storageData: Scalars['String'];
  /** Unique lookup id for the workflowRuntimeData */
  storageKey: Scalars['String'];
  /** Optional metadata for the workflowRuntimeData */
  storageMetadata?: InputMaybe<Scalars['String']>;
};

export type CreatedMediaShare = {
  __typename?: 'CreatedMediaShare';
  id: Scalars['String'];
  url: Scalars['String'];
};

export type Creative = {
  __typename?: 'Creative';
  advertiserId?: Maybe<Scalars['ID']>;
  brandId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  keywords?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationId: Scalars['ID'];
};

export enum CredentialType {
  ApiKey = 'APIKey',
  Any = 'Any',
  None = 'None',
  Username = 'Username'
}

export type CustomDashboard = {
  __typename?: 'CustomDashboard';
  createdDateTime: Scalars['DateTime'];
  data: Scalars['JSONData'];
  description?: Maybe<Scalars['String']>;
  hostAppId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  modifiedDateTime: Scalars['DateTime'];
  name: Scalars['String'];
};

export type CustomDashboardList = Page & {
  __typename?: 'CustomDashboardList';
  /** Number of records returned in this response */
  count?: Maybe<Scalars['Int']>;
  /** Maximum number of results that were retrieved in this query; page size */
  limit: Scalars['Int'];
  /** The starting index for records that were returned in this query. */
  offset: Scalars['Int'];
  records?: Maybe<Array<Maybe<CustomDashboard>>>;
};

export type DagTemplate = {
  __typename?: 'DagTemplate';
  cognitiveCategoryId?: Maybe<Scalars['ID']>;
  dag: Scalars['JSONData'];
  dagTemplateLanguage?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mimeType?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  targetOrganizationId: Scalars['ID'];
};

export type DagTemplateList = Page & {
  __typename?: 'DagTemplateList';
  count: Scalars['Int'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records?: Maybe<Array<Maybe<DagTemplate>>>;
};

export type DagTemplateOrganizations = {
  __typename?: 'DagTemplateOrganizations';
  dagTemplateId: Scalars['ID'];
  organizationIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type DailyTaskMetrics = {
  __typename?: 'DailyTaskMetrics';
  /** The date when the tasks run */
  date: Scalars['String'];
  /** The media length in seconds associated with these tasks */
  mediaSecs: Scalars['Int'];
  /** The storage in bytes used by these tasks */
  storageBytes: Scalars['Int'];
  /** The number of tasks created in this date */
  taskCount: Scalars['Int'];
};

export type DailyTaskMetricsList = {
  __typename?: 'DailyTaskMetricsList';
  records: Array<DailyTaskMetrics>;
};

/** Analytics Dashboards */
export type Dashboard = {
  __typename?: 'Dashboard';
  /** The status of the dashboard */
  active?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  /** The filters that can be applied on the dashboard. Typically watchlists. */
  filters?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The order in which to display the dashboard. */
  index?: Maybe<Scalars['Int']>;
  /** Vendor specific identifier for Qlik applications */
  qlikAppId?: Maybe<Scalars['String']>;
  /** Vendor specific identifier for Qlik sheet */
  qlikSheetId?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type DataRegistry = {
  __typename?: 'DataRegistry';
  createdBy?: Maybe<User>;
  createdDateTime?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  ingestionToken?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<User>;
  modifiedDateTime?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  /** The organization that owns this data registry. */
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['ID']>;
  /**
   * The currently published schema version for convenient access.
   * This field will be empty if there is no published schema.
   */
  publishedSchema?: Maybe<Schema>;
  schemas?: Maybe<SchemaList>;
  source?: Maybe<Scalars['String']>;
};


export type DataRegistrySchemasArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  majorVersion?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<SchemaOrder>>>;
  status?: InputMaybe<Array<InputMaybe<SchemaStatus>>>;
};

export type DataRegistryList = Page & {
  __typename?: 'DataRegistryList';
  /** Number of records returned in this response */
  count?: Maybe<Scalars['Int']>;
  /** Maximum number of results that were retrieved in this query; page size */
  limit: Scalars['Int'];
  /** The starting index for records that were returned in this query. */
  offset: Scalars['Int'];
  records?: Maybe<Array<Maybe<DataRegistry>>>;
};

export enum DataRegistryOrderBy {
  CreatedDateTime = 'createdDateTime',
  ModifiedDateTime = 'modifiedDateTime',
  Name = 'name',
  Source = 'source'
}

export type DataRegistryVersion = {
  /** The id of the DataRegistry */
  id: Scalars['ID'];
  /** The major version of the DataRegistry */
  majorVersion?: Scalars['Int'];
};

export enum DataSetFeatureDataTypeEnum {
  GeoPoint = 'geo_point',
  Integer = 'integer',
  IntegerRange = 'integer_range',
  Text = 'text'
}

export type Dataset = {
  __typename?: 'Dataset';
  datasetId: Scalars['ID'];
  description: Scalars['String'];
  metrics?: Maybe<Array<Maybe<DatasetMetric>>>;
  name: Scalars['String'];
  schema?: Maybe<Schema>;
  schemaId: Scalars['ID'];
  tags?: Maybe<Array<Maybe<DatasetSchemaTags>>>;
};

export type DatasetActionInput = {
  /** Action to perform of the Dataset ( avaliable options are ADD,UPDATE and DELETE) */
  action?: InputMaybe<DatasetActionType>;
  /** Data for the Action */
  data?: InputMaybe<Array<DatasetRowInput>>;
};

export enum DatasetActionType {
  Add = 'ADD',
  Delete = 'DELETE',
  Update = 'UPDATE'
}

export enum DatasetClassTypeEnum {
  Audio = 'audio',
  Benchmark = 'benchmark',
  Text = 'text'
}

export type DatasetConfidence = {
  __typename?: 'DatasetConfidence';
  /** allow sources with null confidence values */
  allowNull?: Maybe<Scalars['Boolean']>;
  /** Maximum Confidence Filter. Sources with confidence higher than this will be ignore */
  max?: Maybe<Scalars['Float']>;
  /** Mininum Confidence Filter. Sources with confidence lower than this will be ignore */
  min?: Maybe<Scalars['Float']>;
};

export type DatasetEntry = {
  __typename?: 'DatasetEntry';
  data?: Maybe<Scalars['JSONData']>;
  datasetId?: Maybe<Scalars['ID']>;
  datasetSchemaId?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
};

export type DatasetEntryList = Page & {
  __typename?: 'DatasetEntryList';
  count?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records: Array<DatasetEntry>;
};

export type DatasetFilter = {
  /** Filter logical operation ( AND, OR ) */
  operation?: InputMaybe<FilterCombineOperator>;
  /** Provide a list of tags to filter by */
  tags?: InputMaybe<Array<DatasetTags>>;
};

export type DatasetInput = {
  /** Specify the description of the Dataset */
  description: Scalars['String'];
  /** Specify the name of the Dataset */
  name: Scalars['String'];
  /** Schema ID Asssiocated with the Dataset */
  schemaId: Scalars['ID'];
  /** Tags Asssiocated with the Dataset */
  tags?: InputMaybe<Array<InputMaybe<DatasetTags>>>;
};

export type DatasetList = Page & {
  __typename?: 'DatasetList';
  /** Number of records returned in this response */
  count?: Maybe<Scalars['Int']>;
  /** Maximum number of results that were retrieved in this query; page size */
  limit: Scalars['Int'];
  /** The starting index for records that were returned in this query. */
  offset: Scalars['Int'];
  records?: Maybe<Array<Maybe<Dataset>>>;
};

export type DatasetMetric = {
  __typename?: 'DatasetMetric';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type DatasetQueryCursor = {
  __typename?: 'DatasetQueryCursor';
  /** Cursor Id of the query. */
  cursorId?: Maybe<Scalars['ID']>;
  data?: Maybe<Array<Maybe<DatasetRow>>>;
  /** Dataset Id of the query. */
  datasetId?: Maybe<Scalars['ID']>;
  isDone?: Maybe<Scalars['Boolean']>;
  /** The starting index for records that were returned in this query. */
  offset?: Maybe<Scalars['Int']>;
  /** Total Number of records present in the dataset */
  rowcount?: Maybe<Scalars['Int']>;
};

export type DatasetRow = {
  __typename?: 'DatasetRow';
  /** JSON data of the Dataset Row */
  data?: Maybe<Scalars['JSONData']>;
  /** Id of the Dataset Row */
  id?: Maybe<Scalars['ID']>;
};

export type DatasetRowInput = {
  /** Key value pair of Dataset Row */
  data: Scalars['JSONData'];
  /** Specify the Id of the Dataset Row */
  id: Scalars['ID'];
  /** List of Url's associated with the Dataset Row */
  storeUriContents?: InputMaybe<Array<Scalars['String']>>;
};

export type DatasetSchemaTags = {
  __typename?: 'DatasetSchemaTags';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type DatasetStateInfo = {
  __typename?: 'DatasetStateInfo';
  datasetId: Scalars['ID'];
  structuredDataObjects?: Maybe<Array<StructuredData>>;
};

export type DatasetTags = {
  name: Scalars['String'];
  value: Scalars['String'];
};

export enum DayOfWeek {
  Friday = 'Friday',
  Monday = 'Monday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
  Thursday = 'Thursday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday'
}

export type DeleteBuild = {
  engineId: Scalars['ID'];
  id: Scalars['ID'];
};

export type DeleteContextMenuExtension = {
  /** The ID of the context menu extension to delete */
  id: Scalars['ID'];
};

export type DeleteDatasetPayload = {
  __typename?: 'DeleteDatasetPayload';
  datasetId?: Maybe<Scalars['ID']>;
  message?: Maybe<Scalars['String']>;
};

export type DeleteFlow = {
  flowId: Scalars['ID'];
};

/** Delete a folder */
export type DeleteFolder = {
  /** ID of the folder to delete */
  id: Scalars['ID'];
  orderIndex: Scalars['Int'];
};

export type DeleteIntegrationConfigPayload = {
  __typename?: 'DeleteIntegrationConfigPayload';
  integrationId: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  organizationId: Scalars['ID'];
};

export type DeleteLibraryDataset = {
  /** Id of the selected library */
  libraryId: Scalars['ID'];
  /** List of tdo ids to remove to the selected library */
  tdoIds: Array<InputMaybe<Scalars['ID']>>;
};

export type DeleteLibraryDatasetPayload = {
  __typename?: 'DeleteLibraryDatasetPayload';
  /** Id of the selected library */
  libraryId?: Maybe<Scalars['ID']>;
  /** Delete status */
  message?: Maybe<Scalars['String']>;
  /** List of tdos removed from dataset library */
  tdoIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type DeleteMentionComment = {
  commentId: Scalars['ID'];
  mentionId: Scalars['ID'];
};

/**
 * Input required to delete a mention rating.
 * Both the rating and mention IDs must be provided.
 * Only the rating will be deleted.
 */
export type DeleteMentionRating = {
  /** The mention ID */
  mentionId: Scalars['ID'];
  /** The rating ID */
  ratingId: Scalars['ID'];
};

export type DeleteOrganizationIntegrationConfig = {
  integrationId: Scalars['String'];
  organizationId: Scalars['ID'];
};

/** Payload required to delete an object */
export type DeletePayload = {
  __typename?: 'DeletePayload';
  /** ID of the object that was deleted */
  id: Scalars['ID'];
  /** a message */
  message?: Maybe<Scalars['String']>;
};

export type DeleteStructuredData = {
  id: Scalars['ID'];
  /** Id of the schema used to validate this object */
  schemaId: Scalars['ID'];
};

export type DeployFlowRevision = {
  flowId?: InputMaybe<Scalars['ID']>;
  flowRevisionId?: InputMaybe<Scalars['ID']>;
};

/**
 * Deployment models describe how an engine or application operates on the network
 * and where the data it works with is transmitted. See Veritone's developer
 * documentation at https://steel-ventures.atlassian.net/wiki/spaces/VDH/pages/101364981/Engine+Deployment+Models
 * for a full description.
 */
export enum DeploymentModel {
  /**
   * The engine or application is fully isolated and does not call out to any
   * external endpoints. Numerical code 0.
   */
  FullyNetworkIsolated = 'FullyNetworkIsolated',
  /** Human review of engine results is required. Numerical code 3. */
  HumanReview = 'HumanReview',
  /**
   * The engine or application does not transmit data about its payload over the internet,
   * but may still make external network calls for limited purposes. Numerical code 1.
   */
  MostlyNetworkIsolated = 'MostlyNetworkIsolated',
  /**
   * The engine or application is not network isolated and must call out to external services
   * and transmit data about its payload. Numerical code 2.
   */
  NonNetworkIsolated = 'NonNetworkIsolated'
}

export type DisableOpenIdProviderForOrg = {
  connectId: Scalars['ID'];
  organizationGuid: Scalars['ID'];
};

export type EmitAuditEvent = {
  /** The application that created the audit log */
  application?: InputMaybe<Scalars['String']>;
  /** The contents of the audit log */
  payload: Scalars['JSONData'];
};

export type EmitEvent = {
  /** Identifier of the app using the event */
  application: Scalars['String'];
  /** Event name */
  eventName: Scalars['String'];
  /** Existing event type */
  eventType: Scalars['String'];
  /** Only use for internal/orgless token (optional) */
  orgId?: InputMaybe<Scalars['ID']>;
  /** string payload, it should be serialized Protobuf data with base64 encoding or escaped JSON string */
  payload: Scalars['String'];
};

export type EmitEventResponse = {
  __typename?: 'EmitEventResponse';
  /** the decoder that GQL used to interpret your event before sending */
  decoder: Scalars['String'];
  id: Scalars['ID'];
};

/**
 * Auth required: "task_type.internal", "superadmin", "task_type:org_system"
 *
 * # Example of mention_inserted event
 * {
 *   "type": "mention",
 *   "event": "mention_inserted",
 *   "payload": {
 *     "mentionId": 149703607,
 *     "organizationId": 12345,
 *     "mentionDate": "Mon, 23 Jul 2018 21:03:52 GMT",
 *     "transactionTimestamp": "Mon, 24 Jul 2018 21:03:52 GMT"
 *   }
 * }
 */
export type EmitSystemEvent = {
  /** The event payload */
  payload: Scalars['JSONData'];
  /** A topic */
  topic: Scalars['String'];
};

export type EnableOpenIdProviderForOrg = {
  connectId: Scalars['ID'];
  organizationGuid: Scalars['ID'];
};

export type Engine = {
  __typename?: 'Engine';
  applicationId?: Maybe<Scalars['ID']>;
  asset?: Maybe<Scalars['String']>;
  /**
   * Retrieve builds for the engine.
   * By default, deleted builds are not included.
   * Deleted builds can be retrieved by including the `deleted` status parameter.
   */
  builds?: Maybe<BuildList>;
  /** The engine category */
  category?: Maybe<EngineCategory>;
  categoryId?: Maybe<Scalars['String']>;
  /** CPU Required to run engine, in milli-CPU's */
  cpuResourceMcpu?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdDateTime?: Maybe<Scalars['DateTime']>;
  /**
   * True if the engine creates a TemporalDataObject (TDO) as part of its
   * execution. False otherwise.
   */
  createsTDO?: Maybe<Scalars['Boolean']>;
  /** Dependency information for this engine */
  dependency?: Maybe<EngineDependency>;
  /**
   * Get the deployed build version of this engine. If there is no deployed
   * build, this field will be null.
   */
  deployedVersion?: Maybe<Scalars['Int']>;
  deploymentModel?: Maybe<DeploymentModel>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  /** In what way can this engine be distributed */
  distributionType?: Maybe<EngineDistributionType>;
  edgeVersion?: Maybe<Scalars['Int']>;
  /** The tags associated with the engine */
  entityTags?: Maybe<Array<Maybe<EntityTag>>>;
  executeUri?: Maybe<Scalars['String']>;
  /**
   * The list of custom fields on the engine. Users will be prompted to
   * set or change these values when they run the engine. For example, a
   * translation engine might have a field for the target language.
   */
  fields?: Maybe<Array<EngineField>>;
  /** GPU supported */
  gpuSupported?: Maybe<GpuSupported>;
  /**
   * Get the ingestion flag which determines whether the adapter has a scan phase during ingestion.
   * If there is no deployed build this field cannot be populated.
   */
  hasScanPhase?: Maybe<Scalars['Boolean']>;
  iconPath?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** List of industries where the capabilities of the engine can be applied */
  industries?: Maybe<Array<Scalars['String']>>;
  /**
   * Retrieve input schemas being used by the engine.
   * By default, deleted schemas are not included.
   * Deleted schemas can be retrieved by including the `deleted` status parameter.
   */
  inputSchemas?: Maybe<SchemaList>;
  /**
   * Get engine flag which determines whether the engine is a conductor,
   * this field will be null
   */
  isConductor?: Maybe<Scalars['Boolean']>;
  isPublic?: Maybe<Scalars['Boolean']>;
  /** JWT rights for engine, which is used for generating jwtToken rights later */
  jwtRights?: Maybe<Scalars['JSONData']>;
  /**
   * True if the engine requires a library to run. If so, a library ID must
   * be provided in the engine payload.
   */
  libraryRequired?: Maybe<Scalars['Boolean']>;
  logoPath?: Maybe<Scalars['String']>;
  /** Generic Manifest for the engine based on data supplied during onboarding */
  manifest?: Maybe<Scalars['JSONData']>;
  metadataVersion?: Maybe<Scalars['Int']>;
  /** Specifies the mode in which the engine process input */
  mode?: Maybe<EngineMode>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedDateTime?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  /**
   * Get oauth information based on the deployed build. If there is no deployed
   * build, this field will be null.
   */
  oauth?: Maybe<Scalars['String']>;
  /**
   * Get the engine's output formats, based on the latest deployed build.
   * If there is no deployed build this field cannot be populated.
   */
  outputFormats?: Maybe<Array<Scalars['String']>>;
  /**
   * Retrieve output schemas being used by the engine.
   * By default, deleted schemas are not included.
   * Deleted schemas can be retrieved by including the `deleted` status parameter.
   */
  outputSchemas?: Maybe<SchemaList>;
  ownerOrganization?: Maybe<Organization>;
  ownerOrganizationId: Scalars['ID'];
  /**
   * Get the engine's preferred input format, based on the latest deployed build.
   * If there is no deployed build this field cannot be populated.
   */
  preferredInputFormat?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
  rating?: Maybe<Scalars['Int']>;
  /** Specifies the runtime type, such as "iron" or "edge" */
  runtimeType?: Maybe<Scalars['String']>;
  /** The signed URL for the engine icon; will fallback to raw iconPath if unable to sign. */
  signedIconPath?: Maybe<Scalars['String']>;
  /** The signed URL for the engine logo; will fallback to raw logoPath if unable to sign. */
  signedLogoPath?: Maybe<Scalars['String']>;
  /** Template Job definitions for standalone engine execution */
  standaloneJobTemplates?: Maybe<Array<Maybe<EngineJobTemplate>>>;
  state?: Maybe<EngineState>;
  /**
   * Get the engine's supported input formats, based on the latest deployed build.
   * If there is no deployed build this field cannot be populated.
   */
  supportedInputFormats?: Maybe<Array<Scalars['String']>>;
  /**
   * List of schedule types that the engine supports,
   * based on the latest deployed build.
   * If there is no deployed build, this field cannot be populated.
   */
  supportedScheduleTypes?: Maybe<Array<EngineScheduleType>>;
  /**
   * List of IDs of source types that the engine supports,
   * based on the latest deployed build.
   * If there is no deployed build this field cannot be populated.
   * Applies only to adapter engines that ingest data from a source.
   * Will be a list of IDs of SourceType objects.
   */
  supportedSourceTypes?: Maybe<Array<Scalars['String']>>;
  /** Retrieve task metrics for the engine */
  taskMetrics?: Maybe<EngineTaskMetrics>;
  tasks?: Maybe<TaskList>;
  /** Testing detail includes necessary data for engine certification process */
  testingDetails?: Maybe<TestingDetailsType>;
  /** List of use cases the engine serves */
  useCases?: Maybe<Array<Scalars['String']>>;
  validStateActions?: Maybe<Array<Maybe<EngineStateAction>>>;
  validateUri?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};


export type EngineBuildsArgs = {
  buildStatus?: InputMaybe<Array<BuildStatus>>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EngineBuildOrderBy>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type EngineInputSchemasArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<SchemaOrder>>>;
  schemaStatus?: InputMaybe<Array<SchemaStatus>>;
};


export type EngineOutputSchemasArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<SchemaOrder>>>;
  schemaStatus?: InputMaybe<Array<SchemaStatus>>;
};


export type EngineStandaloneJobTemplatesArgs = {
  type?: InputMaybe<JobTemplateEnumType>;
};


export type EngineTaskMetricsArgs = {
  fromDateTime?: InputMaybe<Scalars['DateTime']>;
  toDateTime?: InputMaybe<Scalars['DateTime']>;
};


export type EngineTasksArgs = {
  dateTimeFilter?: InputMaybe<Array<InputMaybe<TaskDateTimeFilter>>>;
  hasSourceAsset?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type EngineBlacklist = {
  __typename?: 'EngineBlacklist';
  engineCategories?: Maybe<Array<Maybe<EngineCategory>>>;
  engines?: Maybe<Array<Maybe<Engine>>>;
  organizationId: Scalars['ID'];
};

export type EngineBuildOrderBy = {
  direction?: InputMaybe<OrderDirection>;
  field: EngineBuildOrderByField;
};

export enum EngineBuildOrderByField {
  CreatedDateTime = 'createdDateTime',
  ModifiedDateTime = 'modifiedDateTime',
  Version = 'version'
}

export type EngineCategory = {
  __typename?: 'EngineCategory';
  /**
   * An optional key used to identify this engine category's results for
   * search and other purposes.
   * Primarily used by Veritone platform applications.
   */
  categoryMetadataKey?: Maybe<Scalars['String']>;
  /**
   * A type for the engine category. Multiple engine categories with common
   * elements can share a categoryType. This information is used to compute
   * dependencies and format user interface elements.
   */
  categoryType?: Maybe<Scalars['String']>;
  /** The engine class the engine category belongs to */
  class?: Maybe<EngineClass>;
  color?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdDateTime?: Maybe<Scalars['DateTime']>;
  /** A list of categoryTypes on which instances of this engine category depend. */
  dependencies?: Maybe<Array<EngineDependency>>;
  description?: Maybe<Scalars['String']>;
  editable?: Maybe<Scalars['Boolean']>;
  /** The list of IDs of engines in this category */
  engineIds?: Maybe<Array<Scalars['ID']>>;
  /** The list of engines in this category */
  engines?: Maybe<EngineList>;
  /**
   * List of engine result export formats supported by engines in this
   * category. May be empty.
   */
  exportFormats: Array<Maybe<ExportFormat>>;
  iconClass?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /**
   * If the engine category is integrated with libraries, this field contains
   * the list of IDs of entity identifier types that the engine category is compatible
   * with.
   */
  libraryEntityIdentifierTypeIds?: Maybe<Array<Scalars['ID']>>;
  /**
   * If the engine category is integrated with libraries, this field contains
   * the list of entity identifier types that the engine category is compatible
   * with.
   */
  libraryEntityIdentifierTypes?: Maybe<EntityIdentifierTypeList>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedDateTime?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  /**
   * Information about how engine results in this category can be searched
   * in Veritone platform applications.
   * Used primarily by Veritone platform applications.
   */
  searchConfiguration?: Maybe<EngineSearchConfiguration>;
  totalEngines?: Maybe<Scalars['Int']>;
  type?: Maybe<EngineType>;
  videoOnly?: Maybe<Scalars['Boolean']>;
};


export type EngineCategoryEnginesArgs = {
  filter?: InputMaybe<EngineFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<EngineSortField>>>;
};

export type EngineCategoryList = Page & {
  __typename?: 'EngineCategoryList';
  count?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records?: Maybe<Array<EngineCategory>>;
};

export type EngineClass = {
  __typename?: 'EngineClass';
  description?: Maybe<Scalars['String']>;
  iconClass?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type EngineClassList = Page & {
  __typename?: 'EngineClassList';
  count?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records?: Maybe<Array<EngineClass>>;
};

export type EngineConfiguration = {
  __typename?: 'EngineConfiguration';
  credentials?: Maybe<Array<ExternalCredential>>;
  id: Scalars['ID'];
  source?: Maybe<Source>;
  sourceId?: Maybe<Scalars['ID']>;
};

export type EngineConfigurationList = Page & {
  __typename?: 'EngineConfigurationList';
  count: Scalars['Int'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records: Array<EngineConfiguration>;
};

export enum EngineDateTimeField {
  ModifiedDateTime = 'modifiedDateTime'
}

export type EngineDateTimeFilter = {
  field: EngineDateTimeField;
  fromDateTime?: InputMaybe<Scalars['DateTime']>;
  toDateTime?: InputMaybe<Scalars['DateTime']>;
};

export type EngineDependency = {
  __typename?: 'EngineDependency';
  /** Asset type to expect previous engine to produce */
  assetType?: Maybe<Scalars['String']>;
  /** The engine category corresponding to this dependency */
  category?: Maybe<EngineCategory>;
  /**
   * TODO maps to values in engineCategory.data_field?
   * Must be a valid categoryType from an existing EngineCategory.
   */
  dependencyType: Scalars['String'];
};

export enum EngineDistributionType {
  InstanceLocked = 'instance_locked',
  Marketplace = 'marketplace',
  OrgLocked = 'org_locked',
  Private = 'private',
  Public = 'public',
  Sharable = 'sharable'
}

/** Represents a custom input field on an engine. */
export type EngineField = {
  __typename?: 'EngineField';
  /**
   * An optional default value for the field. Taken in string format, but
   * applies to all field types.
   */
  defaultValue?: Maybe<Scalars['String']>;
  /**
   * Optional default values to apply to a picklist. This field
   * should only be set for a field of type multi-picklist.
   */
  defaultValues?: Maybe<Array<Scalars['String']>>;
  /** General information about the field, such as a description. */
  info?: Maybe<Scalars['String']>;
  /** A human-readable label for the field. */
  label?: Maybe<Scalars['String']>;
  /** Maximum value, in float format. Applies only to fields of type Number. */
  max?: Maybe<Scalars['Float']>;
  /** Minimum value, in float format. Applies only to fields of type Number. */
  min?: Maybe<Scalars['Float']>;
  /** A machine-readable name, or key, for the field. */
  name: Scalars['String'];
  /**
   * A set of allowed values for the field. Applies only to fields of type
   * picklist or multi-picklist.
   */
  options?: Maybe<Array<EngineFieldPicklistOption>>;
  /** specifies whether the field is optional */
  required?: Maybe<Scalars['Boolean']>;
  /**
   * Numerical step by which the value should be incremented or decremented in
   * the user interface, in float format. Applies only to fields of type Number.
   */
  step?: Maybe<Scalars['Float']>;
  /** The field type. */
  type: EngineFieldType;
};

/** Represents one allowed option in a picklist. */
export type EngineFieldPicklistOption = {
  __typename?: 'EngineFieldPicklistOption';
  /** The human-readable label for the option, such as "English-US" for a language selector. */
  key: Scalars['String'];
  /**
   * The machine-readable value that will be sent in the engine payload, such as
   * "en-us" for a language selector.
   */
  value: Scalars['String'];
};

/** An enum containing valid custom engine field types. */
export enum EngineFieldType {
  /** A pick list that allows the user to choose any number of a set of allowed values. */
  MultiPicklist = 'MultiPicklist',
  /** A number, in float format */
  Number = 'Number',
  /** A pick list that allows the user to choose one of a set of allowed values. */
  Picklist = 'Picklist',
  /** A dynamic list of schemas that will be populated by the client */
  SchemaSelection = 'SchemaSelection',
  /** A plain text field */
  Text = 'Text'
}

export type EngineFieldValue = {
  fieldName: Scalars['String'];
  fieldValue: Scalars['String'];
};

export type EngineFilter = {
  /** Provide a list of engine category names to filter by */
  category?: InputMaybe<Array<Scalars['String']>>;
  /** Filter by date/time field */
  dateTimeFilter?: InputMaybe<Array<EngineDateTimeFilter>>;
  /** Specify the deployment model of the engine. */
  deploymentModel?: InputMaybe<DeploymentModel>;
  /** Provide a list of deployment models to filter by */
  deploymentModels?: InputMaybe<Array<DeploymentModel>>;
  /** Provide a list of distribution types to filter by */
  distributionTypes?: InputMaybe<Array<EngineDistributionType>>;
  /** Filter logical operation ( AND, OR ) */
  entityTagOperation?: InputMaybe<FilterCombineOperator>;
  /** Filter by tags associated with engines */
  entityTags?: InputMaybe<Array<InputMaybe<EntityTagFilter>>>;
  /** Filter engines that are certified */
  isCertified?: InputMaybe<Scalars['Boolean']>;
  /** Filter engines that are public */
  isPublic?: InputMaybe<Scalars['Boolean']>;
  /** Filter engines that require a library */
  libraryRequired?: InputMaybe<Scalars['Boolean']>;
  /** Provide a list of engine modes to filter by */
  mode?: InputMaybe<Array<EngineMode>>;
  /** Name of engine to filter by */
  name?: InputMaybe<Scalars['String']>;
  /** Specify the maximum price of the engine. */
  priceMax?: InputMaybe<Scalars['Int']>;
  /** Specify the minimum price of the engine. */
  priceMin?: InputMaybe<Scalars['Int']>;
  /** Provide a list of rating from 0 to 5 to filter by. */
  rating?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Provide a list of engine states to filter by */
  state?: InputMaybe<Array<EngineState>>;
  /** Provide a list of supported input formats to filter by */
  supportedInputFormats?: InputMaybe<Array<Scalars['String']>>;
  /** Provide a list of engine type names to filter by */
  type?: InputMaybe<Array<EngineTypeFilter>>;
};

/** Contain resouces of Engine JWT Token */
export type EngineJwtResource = {
  __typename?: 'EngineJWTResource';
  applicationId?: Maybe<Scalars['ID']>;
  jobId?: Maybe<Scalars['ID']>;
  taskId?: Maybe<Scalars['ID']>;
  tdoId?: Maybe<Scalars['ID']>;
  userId?: Maybe<Scalars['ID']>;
};

export type EngineJobTemplate = {
  __typename?: 'EngineJobTemplate';
  /** Template data - json job DAG definition, with handlebar style {{VAR}} parametrization */
  template?: Maybe<Scalars['JSONData']>;
  /** Job template type */
  type?: Maybe<JobTemplateEnumType>;
};

export type EngineList = Page & {
  __typename?: 'EngineList';
  /** Number of records returned in this response */
  count: Scalars['Int'];
  limit: Scalars['Int'];
  /** The starting index for records that were returned in this query. */
  offset: Scalars['Int'];
  records?: Maybe<Array<Maybe<Engine>>>;
};

export enum EngineMode {
  Batch = 'Batch',
  Chunk = 'Chunk',
  Stream = 'Stream'
}

export enum EngineOrderField {
  /** @deprecated Will be ignored if used */
  BuildCreatedDateTime = 'buildCreatedDateTime',
  Category = 'category',
  /** @deprecated Will be ignored if used */
  ClusterSize = 'clusterSize',
  CreatedDateTime = 'createdDateTime',
  DeploymentModel = 'deploymentModel',
  /** @deprecated Will be ignored if used */
  GpuSupported = 'gpuSupported',
  Id = 'id',
  LibraryRequired = 'libraryRequired',
  /** @deprecated Will be ignored if used */
  MaxMediaLengthMs = 'maxMediaLengthMs',
  Mode = 'mode',
  ModifiedDateTime = 'modifiedDateTime',
  Name = 'name',
  Order = 'order',
  Price = 'price',
  Rating = 'rating',
  RuntimeType = 'runtimeType',
  State = 'state',
  Type = 'type'
}

export type EngineOverview = {
  __typename?: 'EngineOverview';
  /** Number of engines in active state */
  active?: Maybe<Scalars['Int']>;
  /** Number of engines in deleted state */
  deleted?: Maybe<Scalars['Int']>;
  /** Number of engines in disabled state */
  disabled?: Maybe<Scalars['Int']>;
  /** Number of engines in draft state */
  draft?: Maybe<Scalars['Int']>;
  /** Number of engines in pending state */
  pending?: Maybe<Scalars['Int']>;
  /** Number of engines in ready state */
  ready?: Maybe<Scalars['Int']>;
};

/** Represents single chunk of engine results for date range */
export type EngineResult = {
  __typename?: 'EngineResult';
  assetId?: Maybe<Scalars['String']>;
  engineId: Scalars['ID'];
  jsondata?: Maybe<Scalars['JSONData']>;
  library?: Maybe<Library>;
  libraryId?: Maybe<Scalars['ID']>;
  startOffsetMs?: Maybe<Scalars['Int']>;
  stopOffsetMs?: Maybe<Scalars['Int']>;
  taskId?: Maybe<Scalars['ID']>;
  tdo?: Maybe<TemporalDataObject>;
  tdoId: Scalars['ID'];
  userEdited?: Maybe<Scalars['Boolean']>;
};

/** Represents a collection of engine results. Not Paged. */
export type EngineResultList = {
  __typename?: 'EngineResultList';
  records?: Maybe<Array<Maybe<EngineResult>>>;
  sourceId?: Maybe<Scalars['ID']>;
};

/** Describes engine run on a TDO with */
export type EngineRun = {
  __typename?: 'EngineRun';
  /** Engine that was run on a TDO */
  engine?: Maybe<Engine>;
  /** Whether or not the engine run has user edits */
  hasUserEdits?: Maybe<Scalars['Boolean']>;
  /** Engine status derived from the written engine output or task status. See TaskStatus enum for details. */
  status?: Maybe<TaskStatus>;
  /** Last run task for this engine and tdo */
  task?: Maybe<Task>;
};

export type EngineRunList = Page & {
  __typename?: 'EngineRunList';
  /** Number of records returned in this response */
  count?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
  /** The starting index for records that were returned in this query. */
  offset: Scalars['Int'];
  records?: Maybe<Array<Maybe<EngineRun>>>;
};

export enum EngineScheduleType {
  Continuous = 'Continuous',
  Now = 'Now',
  OnDemand = 'OnDemand',
  Recurring = 'Recurring'
}

export type EngineSchema = {
  ioType: EngineSchemaIoType;
  schemaId: Scalars['ID'];
};

export enum EngineSchemaIoType {
  Both = 'both',
  Input = 'input',
  Output = 'output'
}

/**
 * Represents configuration on how the results of engines within a given
 * category are indexed and searched.
 * Primarily used by Veritone platform applications.
 */
export type EngineSearchConfiguration = {
  __typename?: 'EngineSearchConfiguration';
  /**
   * Autocomplete field information is used to tell client applications
   * what fields are searchable by autocomplete in the search index and
   * how to search for them.
   */
  autocompleteFields?: Maybe<Array<AutocompleteFieldConfig>>;
  elasticType?: Maybe<Scalars['String']>;
  /**
   * Indicates whether or not search is available for results produced
   * by engines in this category can be searched within the Elasticsearch index.
   */
  isElasticEnabled?: Maybe<Scalars['Boolean']>;
  /**
   * Indicates whether or not search is available for results produced
   * by engines in this category can be searched.
   */
  isSearchEnabled?: Maybe<Scalars['Boolean']>;
  /**
   * Autocomplete field information is used to tell client applications
   * what fields are searchable in the search index and
   * how to search for them.
   */
  searchFields?: Maybe<Array<SearchFieldConfig>>;
  searchMetadataKey?: Maybe<Scalars['String']>;
};

export type EngineSortField = {
  direction?: InputMaybe<OrderDirection>;
  field: EngineOrderField;
};

/** Enumeration containing the set of allowed values for the Engine state field. */
export enum EngineState {
  /** The engine is deployed and active. Set the state to this value to deploy it. */
  Active = 'active',
  /** The engine has been deleted and is no longer available for use. */
  Deleted = 'deleted',
  /** The engine has been disabled. Set this state to disable the engine. */
  Disabled = 'disabled',
  /** The engine is in draft state, suitable for review and internal testing. */
  Draft = 'draft',
  /** The engine is awaiting approval before transitioning to the next state. */
  Pending = 'pending',
  /** The engine is ready for deployment, but has not been deployed yet. */
  Ready = 'ready'
}

export enum EngineStateAction {
  Delete = 'delete',
  Disable = 'disable',
  Edit = 'edit',
  Enable = 'enable',
  Undelete = 'undelete'
}

export type EngineTaskMetrics = {
  __typename?: 'EngineTaskMetrics';
  cancelledCount?: Maybe<Scalars['Int']>;
  completedCount?: Maybe<Scalars['Int']>;
  failedCount?: Maybe<Scalars['Int']>;
  pendingCount?: Maybe<Scalars['Int']>;
  queuedCount?: Maybe<Scalars['Int']>;
  runningCount?: Maybe<Scalars['Int']>;
};

export type EngineType = {
  __typename?: 'EngineType';
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export enum EngineTypeFilter {
  Aggregator = 'Aggregator',
  Cognition = 'Cognition',
  Ingestion = 'Ingestion'
}

export type EngineWhitelist = {
  __typename?: 'EngineWhitelist';
  engineCategories?: Maybe<Array<Maybe<EngineCategory>>>;
  engines?: Maybe<Array<Maybe<Engine>>>;
  organizationId: Scalars['ID'];
};

export type EngineWorkflow = {
  action: EngineWorkflowAction;
  id: Scalars['ID'];
};

export enum EngineWorkflowAction {
  Disable = 'disable',
  Enable = 'enable'
}

export type Entity = {
  __typename?: 'Entity';
  createdBy?: Maybe<Scalars['String']>;
  createdDateTime?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  identifiers?: Maybe<EntityIdentifierList>;
  isPublished?: Maybe<Scalars['Boolean']>;
  jsondata?: Maybe<Scalars['JSONData']>;
  jsonstring?: Maybe<Scalars['String']>;
  library?: Maybe<Library>;
  libraryId?: Maybe<Scalars['ID']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedDateTime?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  profileImageUrl?: Maybe<Scalars['String']>;
  properties?: Maybe<Array<Maybe<Property>>>;
  summary?: Maybe<EntitySummary>;
};


export type EntityIdentifiersArgs = {
  id?: InputMaybe<Scalars['ID']>;
  identifierTypeId?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type EntityIdentifier = {
  __typename?: 'EntityIdentifier';
  contentType: Scalars['String'];
  createdDateTime?: Maybe<Scalars['DateTime']>;
  entity: Entity;
  entityId: Scalars['ID'];
  id: Scalars['ID'];
  identifierType: EntityIdentifierType;
  identifierTypeId: Scalars['ID'];
  isPriority?: Maybe<Scalars['Boolean']>;
  jsondata?: Maybe<Scalars['JSONData']>;
  jsonstring?: Maybe<Scalars['String']>;
  modifiedDateTime?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export enum EntityIdentifierDataType {
  Audio = 'audio',
  Image = 'image',
  Objectbox = 'objectbox',
  Pdf = 'pdf',
  Tdo = 'tdo',
  Text = 'text',
  Video = 'video'
}

export type EntityIdentifierItem = {
  __typename?: 'EntityIdentifierItem';
  entityIdentifierTypeId: Scalars['String'];
  libraryTypeId: Scalars['String'];
  maxItems?: Maybe<Scalars['Int']>;
  minItems?: Maybe<Scalars['Int']>;
};

export type EntityIdentifierItemList = {
  __typename?: 'EntityIdentifierItemList';
  count?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records?: Maybe<Array<Maybe<EntityIdentifierItem>>>;
};

export type EntityIdentifierList = Page & {
  __typename?: 'EntityIdentifierList';
  count?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records?: Maybe<Array<Maybe<EntityIdentifier>>>;
};

export type EntityIdentifierType = {
  __typename?: 'EntityIdentifierType';
  dataType: EntityIdentifierDataType;
  description?: Maybe<Scalars['String']>;
  entityIdentifierItems?: Maybe<Array<Maybe<EntityIdentifierItem>>>;
  iconClass?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  label: Scalars['String'];
  labelPlural: Scalars['String'];
};

export type EntityIdentifierTypeList = Page & {
  __typename?: 'EntityIdentifierTypeList';
  count?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records?: Maybe<Array<EntityIdentifierType>>;
};

export type EntityList = Page & {
  __typename?: 'EntityList';
  /** Number of records returned in this response */
  count?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
  /** The starting index for records that were returned in this query. */
  offset: Scalars['Int'];
  records?: Maybe<Array<Maybe<Entity>>>;
};

export type EntitySummary = {
  __typename?: 'EntitySummary';
  identifierCountsByType?: Maybe<Scalars['JSONData']>;
};

export type EntityTag = {
  __typename?: 'EntityTag';
  tagKey: Scalars['String'];
  tagValue?: Maybe<Scalars['String']>;
};

export type EntityTagFilter = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type EntityTagInput = {
  entityId?: InputMaybe<Scalars['ID']>;
  entityType?: InputMaybe<EntityTagType>;
  organizationId?: InputMaybe<Scalars['ID']>;
  tagKey: Scalars['String'];
  tagValue?: InputMaybe<Scalars['String']>;
};

export enum EntityTagType {
  App = 'app',
  Cluster = 'cluster',
  Engine = 'engine',
  Events = 'events',
  Flow = 'flow',
  Schema = 'schema'
}

export type EntityType = {
  __typename?: 'EntityType';
  name: Scalars['String'];
  namePlural: Scalars['String'];
  schema: Scalars['JSONData'];
};

export type Event = {
  __typename?: 'Event';
  application: Scalars['String'];
  createdBy: Scalars['String'];
  createdDateTime: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  eventName: Scalars['String'];
  eventType: Scalars['String'];
  id: Scalars['ID'];
  public: Scalars['Boolean'];
  schemaData: Scalars['String'];
  schemaHash: Scalars['String'];
};

export type EventActionTemplate = {
  __typename?: 'EventActionTemplate';
  /** A JSON structure that is compatible with action_type.  For example, if action_type is "webhook", action_attributes contain the mustache compatible template to format the content.  If action_type is "job", then action_attributes need to specify a job template. */
  actionAttributes?: Maybe<Scalars['JSONData']>;
  /** dedicated column to specify where/what the action is taking place.  For example, if action is a job, then destination is an engine_id.  For webhook, a uri. */
  actionDestination: Scalars['String'];
  /** Either "job", "webhook", "sms", "email".  Future action_type could be "gql" where action is purely a function call. */
  actionType: EventActionTemplateActionType;
  /** Allows you to specify validation for the action_type.  For example, if action_type is "job", perhaps only whitelist a list of engines that could be called. */
  actionValidation?: Maybe<Scalars['JSONData']>;
  id: Scalars['ID'];
  /** A JSON structure that is compatible/specific to the input_type.  For example, if input type is "event", then input_attributes simply contain the entire event payload. */
  inputAttributes?: Maybe<Scalars['JSONData']>;
  /** use "event" for now.  In the future, we allow additional input_type types.  For example, a schedule or a tweet. */
  inputType: EventActionTemplateInputType;
  /** based on the input_type, input_validation describes additional validations.  For example, if input_type is "event", input_validation could be a list of allowed events. */
  inputValidation?: Maybe<Scalars['JSONData']>;
  /** The name of template.  e.g. "Run engine X for every new mention in a watchlist". */
  name: Scalars['String'];
  /** owner of the template */
  organizationId: Scalars['ID'];
  /** Application this template could be applied to.  If application_id is null, then this is an org-wide template. */
  ownerApplicationId?: Maybe<Scalars['ID']>;
};

export enum EventActionTemplateActionType {
  Email = 'email',
  Gql = 'gql',
  Job = 'job',
  Sms = 'sms',
  Webhook = 'webhook'
}

export enum EventActionTemplateInputType {
  Event = 'event'
}

export type EventActionTemplateList = Page & {
  __typename?: 'EventActionTemplateList';
  count?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records?: Maybe<Array<Maybe<EventActionTemplate>>>;
};

export type EventCustomRule = {
  __typename?: 'EventCustomRule';
  /** The event actions as a mutated copy of EventActionTemplate */
  actions?: Maybe<Scalars['JSONData']>;
  /** The description of the custom rule */
  description?: Maybe<Scalars['String']>;
  /** The event name */
  eventName: Scalars['String'];
  /** The event type */
  eventType: Scalars['String'];
  id: Scalars['ID'];
  /** The name of the custom rule */
  name: Scalars['String'];
  /** The owner org of the custom rule */
  organizationId: Scalars['ID'];
  /** The params to be used in the actions */
  params?: Maybe<Scalars['JSONData']>;
  /** The status of the custom rule */
  status: EventCustomRuleStatus;
};

export type EventCustomRuleList = {
  __typename?: 'EventCustomRuleList';
  count: Scalars['Int'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records?: Maybe<Array<EventCustomRule>>;
};

export enum EventCustomRuleStatus {
  Active = 'active',
  Inactive = 'inactive'
}

export type EventDelivery = {
  name: EventDeliveryType;
  params: Scalars['JSONData'];
};

export enum EventDeliveryType {
  /**
   * Create Job
   * "targetId": ""
   * "engineId":""
   */
  CreateJob = 'CreateJob',
  /**
   * Email protocol should provide the following kvp in the json structure of
   * "address":"<your_address>@<your_domain>"
   */
  Email = 'Email',
  /**
   * SMS protocol should provide the following kvp in the json structure of
   * "number": ##########
   */
  Sms = 'SMS',
  /**
   * Webhook protocol should provide the following kvp in the json structure of
   * "url":"<protocol>://<your_url>"
   * "encoding":"[protobuf|protobuf_base64|json]
   * "template": string
   */
  Webhook = 'Webhook'
}

export type EventFilter = {
  __typename?: 'EventFilter';
  applicationId?: Maybe<Scalars['String']>;
  conditions?: Maybe<Scalars['JSONData']>;
  eventNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  eventType?: Maybe<Scalars['String']>;
};

export type EventFilterInput = {
  applicationId?: InputMaybe<Scalars['String']>;
  conditions?: InputMaybe<Scalars['JSONData']>;
  delivery: NotificationDelivery;
  eventNames: Array<Scalars['String']>;
  eventType: Scalars['String'];
};

export type EventList = Page & {
  __typename?: 'EventList';
  /** Number of records returned in this response */
  count?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
  /** The starting index for records that were returned in this query. */
  offset: Scalars['Int'];
  records?: Maybe<Array<Maybe<Event>>>;
};

export type EventSubscription = {
  __typename?: 'EventSubscription';
  /** The conditions to filter the event */
  conditions?: Maybe<Scalars['JSONData']>;
  /** The params that will be used by the consumer of the event */
  consumerParams: Scalars['JSONData'];
  /** The created date time of the event subscription */
  createdDateTime: Scalars['DateTime'];
  /** The event name such as `MentionGenerated`, `JobCompleted`, etc. */
  eventName: Scalars['String'];
  /** The event type such as `mention`, `job`, etc */
  eventType: Scalars['String'];
  /** The event subscription id */
  id: Scalars['ID'];
  /** The organization id */
  organizationId: Scalars['ID'];
  /** The subscription hash */
  subscriptionHash: Scalars['String'];
  /** The target of the event */
  targetName: Scalars['String'];
};

export type EventSubscriptionList = Page & {
  __typename?: 'EventSubscriptionList';
  /** Number of records returned in this response */
  count?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
  /** The starting index for records that were returned in this query. */
  offset: Scalars['Int'];
  records?: Maybe<Array<Maybe<EventSubscription>>>;
};

export type ExecutionLocation = {
  __typename?: 'ExecutionLocation';
  cluster: Cluster;
  clusterId: Scalars['ID'];
  data: Scalars['JSONData'];
  id: Scalars['ID'];
  node?: Maybe<ClusterNode>;
  nodeId?: Maybe<Scalars['ID']>;
};

export type ExecutionLocationList = Page & {
  __typename?: 'ExecutionLocationList';
  count: Scalars['Int'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records: Array<ExecutionLocation>;
};

export type ExecutionPreferences = {
  __typename?: 'ExecutionPreferences';
  /** Optional. Due date for the task. */
  dueDateTime?: Maybe<Scalars['DateTime']>;
  /** Optional. Maximum number of engine instances on the task. */
  maxEngines?: Maybe<Scalars['Int']>;
  /** Optional. Maximum retries for the task. */
  maxRetries?: Maybe<Scalars['Int']>;
  /** Optional. Defines if the task can be porcessed in parallel. Default value is false. */
  parallelProcessing?: Maybe<Scalars['Boolean']>;
  /** Optional. Defines if the oarent task should be completed before starting. Default value is false. */
  parentCompleteBeforeStarting?: Maybe<Scalars['Boolean']>;
  /** Optional. Priority of the task. Default value is 0. */
  priority?: Maybe<Scalars['Int']>;
};

export type ExportFormat = {
  __typename?: 'ExportFormat';
  /** The file format/extension i.e. ttml, vlf, etc. */
  format: Scalars['String'];
  /** A human readable label for the file format i.e. "Time Text Markup Language" */
  label: Scalars['String'];
  /** A list types to categories the file format by i.e. "subtitle" */
  types: Array<Maybe<Scalars['String']>>;
};

export type ExportRequest = {
  __typename?: 'ExportRequest';
  /**
   * The signed URI to the object that contains, or will contain,
   * export results.
   * An optional file name for the resulting asset object.
   * The extension of the file name may affect how some clients download the file.
   */
  assetUri?: Maybe<Scalars['String']>;
  /** Date/time at which this export request was created */
  createdDateTime: Scalars['DateTime'];
  /** The unique ID of this export request */
  id: Scalars['ID'];
  /** Date/time at which this export request was last modified */
  modifiedDateTime: Scalars['DateTime'];
  /** ID of the organization this export request was issued for */
  organizationId: Scalars['ID'];
  /** ID of the user or API key that created this export request */
  requestorId: Scalars['ID'];
  /** Current status of this export request */
  status: ExportRequestStatus;
};


export type ExportRequestAssetUriArgs = {
  fileName?: InputMaybe<Scalars['String']>;
};

export enum ExportRequestEvent {
  ExportRequest = 'exportRequest',
  MentionExportRequest = 'mentionExportRequest'
}

export type ExportRequestList = Page & {
  __typename?: 'ExportRequestList';
  count?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records: Array<ExportRequest>;
};

export enum ExportRequestStatus {
  Complete = 'complete',
  Downloaded = 'downloaded',
  Failed = 'failed',
  Incomplete = 'incomplete'
}

export type ExternalCredential = {
  __typename?: 'ExternalCredential';
  data?: Maybe<StructuredData>;
  dataId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  sourceType?: Maybe<SourceType>;
  sourceTypeId?: Maybe<Scalars['ID']>;
};

export type ExternalCredentialList = Page & {
  __typename?: 'ExternalCredentialList';
  count: Scalars['Int'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records: Array<ExternalCredential>;
};

export type FileApplication = {
  /** ID of the application to file */
  appId: Scalars['ID'];
  /** ID of the new parent folder */
  folderId: Scalars['ID'];
  /**
   * Order index determining in what order the application will be displayed
   * relative to other objects at the same level
   */
  orderIndex?: InputMaybe<Scalars['Int']>;
};

export type FileData = Metadata & {
  __typename?: 'FileData';
  fileName?: Maybe<Scalars['String']>;
  mimeType?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  size?: Maybe<Scalars['Int']>;
};

export type FileTemporalDataObject = {
  /** ID of the new parent folder */
  folderId: Scalars['ID'];
  /**
   * Order index determining in what order the new TDO will be displayed
   * relative to other TDOs at the same level
   */
  orderIndex?: InputMaybe<Scalars['Int']>;
  /** ID of the TDO to file */
  tdoId: Scalars['ID'];
};

export type FileWatchlist = {
  /** ID of the new parent folder */
  folderId: Scalars['ID'];
  /**
   * Order index determining in what order the watchlist will be displayed
   * relative to other objects at the same level
   */
  orderIndex?: InputMaybe<Scalars['Int']>;
  /** ID of the watchlist to file */
  watchlistId: Scalars['ID'];
};

export type FlowExecution = {
  __typename?: 'FlowExecution';
  /** Auto generated timestamp on creation */
  createdDateTime: Scalars['DateTime'];
  /** The id of the execution */
  flowExecutionId: Scalars['ID'];
  /** The url or string of flow input */
  flowExecutionInput?: Maybe<Scalars['String']>;
  /** The url to the log file */
  flowExecutionLog?: Maybe<Scalars['String']>;
  /** The url to the result file or single string of text */
  flowExecutionResult?: Maybe<Scalars['String']>;
  /** The status of the execution after completion */
  flowExecutionStatus?: Maybe<Scalars['String']>;
  /** The id of the associated flow */
  flowId: Scalars['ID'];
  /** The id of the associated revision */
  flowRevisionId?: Maybe<Scalars['ID']>;
  /** The id of the organization used */
  organizationId: Scalars['String'];
  /** Auto generated timestamp on update */
  updatedDateTime?: Maybe<Scalars['DateTime']>;
  /** The authed user during execution creation */
  userId?: Maybe<Scalars['ID']>;
};

export type FlowExecutionList = Page & {
  __typename?: 'FlowExecutionList';
  count?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records?: Maybe<Array<FlowExecution>>;
};

export type FlowFromTemplate = {
  __typename?: 'FlowFromTemplate';
  buildId: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type FlowRevision = {
  __typename?: 'FlowRevision';
  buildId?: Maybe<Scalars['ID']>;
  createdDateTime: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  engineId: Scalars['ID'];
  flowRevisionId: Scalars['ID'];
  flowRevisionNumb: Scalars['Int'];
  hash?: Maybe<Scalars['String']>;
  isDeployed?: Maybe<Scalars['Boolean']>;
  isHead: Scalars['Boolean'];
  organizationId?: Maybe<Scalars['String']>;
  runtime?: Maybe<Scalars['JSONData']>;
  updatedBy: Scalars['String'];
  updatedDateTime?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['ID']>;
};

export type FlowRevisionList = Page & {
  __typename?: 'FlowRevisionList';
  count?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records?: Maybe<Array<FlowRevision>>;
};

export type FlowTemplate = {
  __typename?: 'FlowTemplate';
  author?: Maybe<Scalars['String']>;
  categories?: Maybe<Array<Maybe<Scalars['String']>>>;
  created?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  flow?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  learnmorelink?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  modified?: Maybe<Scalars['DateTime']>;
  organizationId?: Maybe<Scalars['String']>;
  package?: Maybe<Scalars['String']>;
  public?: Maybe<Scalars['Boolean']>;
  screenshots?: Maybe<Array<Maybe<Scalars['String']>>>;
  subtitle?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  title?: Maybe<Scalars['String']>;
};

export type FlowTemplateList = Page & {
  __typename?: 'FlowTemplateList';
  count?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records?: Maybe<Array<FlowTemplate>>;
};

export type Folder = SecurableObject & {
  __typename?: 'Folder';
  /** Add ACEs to the folder. */
  addACEs?: Maybe<AuthAcl>;
  /** Applications that are filed in this folder */
  childApplications?: Maybe<ApplicationList>;
  /** Collection that are filed in this folder */
  childCollections?: Maybe<CollectionList>;
  /** A paginated list of child folders of this folders */
  childFolders?: Maybe<FolderList>;
  /** TemporalDataObjects that are filed in this folder */
  childTDOs?: Maybe<TdoList>;
  /** Watchlists that are filed in this folder */
  childWatchlists?: Maybe<WatchlistList>;
  contentTemplates: Array<FolderContentTemplate>;
  createdDateTime?: Maybe<Scalars['DateTime']>;
  /** An optional description */
  description?: Maybe<Scalars['String']>;
  /**
   * The ordered path of the folder hierarchy. The first element
   * is always a root folder, and the last is this folder's parent.
   */
  folderPath?: Maybe<Array<Folder>>;
  /** The ID of this folder */
  id: Scalars['ID'];
  /** The maximum depth of child folders allowed */
  maxDepth?: Maybe<Scalars['Int']>;
  modifiedDateTime?: Maybe<Scalars['DateTime']>;
  /** The name of this folder */
  name?: Maybe<Scalars['String']>;
  orderIndex?: Maybe<Scalars['Int']>;
  /** The organization that owns this folder */
  organization?: Maybe<Organization>;
  /** The ID of the organization that owns this folder */
  organizationId?: Maybe<Scalars['ID']>;
  ownerId?: Maybe<Scalars['String']>;
  /** The parent folder */
  parent?: Maybe<Folder>;
  rootFolderTypeId?: Maybe<Scalars['Int']>;
  /** The read/write permissions for a shared folder */
  sharedAccess?: Maybe<Array<Maybe<Scalars['String']>>>;
  sharedWith?: Maybe<SharedWith>;
  /** The folder status */
  status?: Maybe<FolderStatus>;
  /**
   * The subfolders of this folder
   * Deprecated: Use paginated childFolders instead.
   */
  subfolders?: Maybe<Array<Folder>>;
  treeObjectId: Scalars['ID'];
  typeId?: Maybe<Scalars['Int']>;
};


export type FolderAddAcEsArgs = {
  entries: Array<AuthAcePermissionInput>;
};


export type FolderChildApplicationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type FolderChildCollectionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type FolderChildFoldersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  nameMatch?: InputMaybe<StringMatch>;
  names?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FolderOrderBy>>;
};


export type FolderChildTdOsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type FolderChildWatchlistsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  nameMatch?: InputMaybe<StringMatch>;
  names?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type FolderContentTemplate = {
  __typename?: 'FolderContentTemplate';
  createdDateTime?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['JSONData']>;
  folderId: Scalars['ID'];
  id: Scalars['ID'];
  modifiedDateTime?: Maybe<Scalars['DateTime']>;
  schemaId: Scalars['ID'];
  sdo?: Maybe<StructuredData>;
  sdoId: Scalars['ID'];
};

export type FolderList = Page & {
  __typename?: 'FolderList';
  /** Number of records returned in this response */
  count?: Maybe<Scalars['Int']>;
  /** Maximum number of results that were retrieved in this query; page size */
  limit: Scalars['Int'];
  /** Provide an offset to skip to a certain element in the result, for paging. */
  offset: Scalars['Int'];
  records?: Maybe<Array<Maybe<Folder>>>;
};

export type FolderOrderBy = {
  direction?: InputMaybe<OrderDirection>;
  field: FolderOrderByField;
};

export enum FolderOrderByField {
  CreatedDateTime = 'createdDateTime',
  Name = 'name'
}

export type FolderOverview = {
  __typename?: 'FolderOverview';
  childFoldersCount: Scalars['Int'];
  childNonFolderObjectsCount: Scalars['Int'];
  treeObjectIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export enum FolderStatus {
  Active = 'active',
  Inactive = 'inactive'
}

export type FolderSummaryDetail = {
  __typename?: 'FolderSummaryDetail';
  childFoldersCount: Scalars['Int'];
  childNonFolderObjectsCount: Scalars['Int'];
  childWatchlistsIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  createdBy?: Maybe<User>;
  createdDateTime: Scalars['DateTime'];
  depth?: Maybe<Scalars['Int']>;
  fingerprints?: Maybe<Scalars['JSONData']>;
  id: Scalars['ID'];
  marketCount?: Maybe<Scalars['Int']>;
  mediaSourceTypeIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  modifiedDateTime?: Maybe<Scalars['DateTime']>;
  orderIndex?: Maybe<Scalars['Int']>;
  parentTreeObjectId?: Maybe<Scalars['String']>;
  programCount?: Maybe<Scalars['Int']>;
  searchTerms?: Maybe<Array<Maybe<Scalars['String']>>>;
  trackMyPrograms?: Maybe<Scalars['Boolean']>;
  trackingUnitName?: Maybe<Scalars['String']>;
  trackingUnitStartDate?: Maybe<Scalars['DateTime']>;
  trackingUnitStopDate?: Maybe<Scalars['DateTime']>;
  treeObjectId: Scalars['ID'];
  typeId?: Maybe<Scalars['Int']>;
};

/** Enumeration containing the set of allowed values for the Engine state field. */
export enum GpuSupported {
  /** AWS P2 Instance */
  AwsP2 = 'aws_p2',
  /** AWS P3 Instance */
  AwsP3 = 'aws_p3',
  /** No gpu specified. */
  None = 'none'
}

export type GetApplicationJwt = {
  /** ID of the application's token */
  appId: Scalars['ID'];
  /** ID of the Organization scoped. Only use for superadmin. */
  orgId?: InputMaybe<Scalars['ID']>;
  /** The array of roleIds would be assigned to JWT Token */
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type GetCurrentUserPasswordToken = {
  password?: InputMaybe<Scalars['String']>;
};

export type GetEngineJwtResource = {
  jobId?: InputMaybe<Scalars['ID']>;
  taskId?: InputMaybe<Scalars['ID']>;
  tdoId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
};

/**
 * This type represents information about the Veritone GraphQL server
 * instance. Primarily used by Veritone engineering and operations.
 *
 *
 * Example
 *   query graphqlServiceInfo {
 *     graphqlServiceInfo {
 *       buildInfo
 *     }
 *   }
 *
 * returns
 *   {
 *     "data": {
 *       "graphqlServiceInfo": {
 *         "buildInfo": {
 *           "commitHash": "0cb09abc3e30bc825830254c756004749c1979c2",
 *           "branch": "master",
 *           "buildNumber": "1139",
 *           "buildDate": "2020-02-03T22:27:43.000Z",
 *           "environment": "veritone.com",
 *           "commitDate": ""
 *         }
 *       }
 *     }
 *   }
 */
export type GraphQlServiceInfo = {
  __typename?: 'GraphQLServiceInfo';
  /** JSON structure containing build information, such as the build number and date. */
  buildInfo?: Maybe<Scalars['JSONData']>;
  /** This is superadmin only */
  featureFlags?: Maybe<Scalars['JSONData']>;
  /** This is superadmin only */
  heartbeatStats?: Maybe<Scalars['JSONData']>;
};

export type Group = {
  __typename?: 'Group';
  applicationId: Scalars['ID'];
  createdBy?: Maybe<User>;
  createdDateTime?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  /** Freeform metadata in JSON form */
  jsondata?: Maybe<Scalars['JSONData']>;
  modifiedBy?: Maybe<User>;
  modifiedDateTime?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  organizationId: Scalars['ID'];
};

export type GroupList = Page & {
  __typename?: 'GroupList';
  /** Number of records returned in this response */
  count?: Maybe<Scalars['Int']>;
  /** Maximum number of results that were retrieved in this query; page size */
  limit: Scalars['Int'];
  /** The starting index for records that were returned in this query. */
  offset: Scalars['Int'];
  records?: Maybe<Array<Maybe<Group>>>;
};

export enum IngestionStatus {
  Inactive = 'INACTIVE',
  MetricsOnly = 'METRICS_ONLY',
  Record = 'RECORD',
  RecordAndTranscribe = 'RECORD_AND_TRANSCRIBE'
}

/** Type representing an integer property. */
export type IntProperty = Property & {
  __typename?: 'IntProperty';
  name: Scalars['String'];
  value?: Maybe<Scalars['Int']>;
};

export type IntegrationConfig = {
  __typename?: 'IntegrationConfig';
  config: Scalars['JSONData'];
  integrationId: Scalars['String'];
  organizationId: Scalars['ID'];
  userVisible?: Maybe<Scalars['Boolean']>;
};

export enum IntervalUnit {
  Days = 'Days',
  Hours = 'Hours',
  Minutes = 'Minutes',
  Months = 'Months',
  Seconds = 'Seconds',
  Weeks = 'Weeks'
}

export type Invitee = {
  __typename?: 'Invitee';
  email: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type IoFolder = {
  __typename?: 'IoFolder';
  mode: IoFolderMode;
  options?: Maybe<Scalars['JSONData']>;
  referenceId: Scalars['ID'];
  type: IoFolderType;
};

export enum IoFolderMode {
  Chunk = 'chunk',
  Stream = 'stream'
}

export enum IoFolderType {
  Input = 'input',
  Output = 'output'
}

export type JsonObject = Metadata & {
  __typename?: 'JSONObject';
  data?: Maybe<Scalars['JSONData']>;
  name: Scalars['String'];
};

export type JwtRightsField = {
  roles?: InputMaybe<Array<JwtRolesField>>;
};

export type JwtRolesField = {
  assetRights?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  roleName: Scalars['String'];
  taskRights?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Contains information about engineJWTToken context */
export type JwtTokenInfo = {
  __typename?: 'JWTTokenInfo';
  engineId?: Maybe<Scalars['ID']>;
  resource: EngineJwtResource;
  token: Scalars['String'];
};

export type Job = {
  __typename?: 'Job';
  /** Application the job ran under */
  applicationId?: Maybe<Scalars['ID']>;
  /** ID of the cluster where this job will be executed */
  clusterId?: Maybe<Scalars['ID']>;
  createdBy?: Maybe<Scalars['String']>;
  createdDateTime?: Maybe<Scalars['DateTime']>;
  /** Optional job description */
  description?: Maybe<Scalars['String']>;
  /** ID of the job */
  id: Scalars['ID'];
  jobConfig?: Maybe<Scalars['JSONData']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedDateTime?: Maybe<Scalars['DateTime']>;
  /** User-provided job name */
  name?: Maybe<Scalars['String']>;
  /** This contains a list of URIs engine toolkit will send completed chunks. */
  notificationUris?: Maybe<Array<Maybe<Scalars['String']>>>;
  routes?: Maybe<Array<Maybe<Route>>>;
  /** The scheduled job under which this job was created, if applicable. */
  scheduledJob?: Maybe<ScheduledJob>;
  /** ID of the scheduled job under which this job was created, if applicable. */
  scheduledJobId?: Maybe<Scalars['ID']>;
  /** Source asset ID */
  sourceAssetId?: Maybe<Scalars['ID']>;
  /** Overall job status, as computed from the statuses of its component tasks */
  status?: Maybe<TaskStatus>;
  /** Target TemporalDataObject */
  target?: Maybe<TemporalDataObject>;
  /** ID of the target object for the job, such as a container or Recording */
  targetId?: Maybe<Scalars['ID']>;
  /** Tasks the job has or will execute */
  tasks?: Maybe<TaskList>;
  /** The template which this job was created, if applicable. */
  template?: Maybe<JobTemplate>;
  /** ID of the template from which this job was created, if applicable. */
  templateId?: Maybe<Scalars['ID']>;
};


export type JobTasksArgs = {
  hasSourceAsset?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Array<TaskStatus>>;
  targetId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export enum JobDateTimeField {
  CreatedDateTime = 'createdDateTime',
  ModifiedDateTime = 'modifiedDateTime'
}

export type JobDateTimeFilter = {
  field: JobDateTimeField;
  fromDateTime?: InputMaybe<Scalars['DateTime']>;
  toDateTime?: InputMaybe<Scalars['DateTime']>;
};

export type JobList = Page & {
  __typename?: 'JobList';
  /** Number of records returned in this response */
  count?: Maybe<Scalars['Int']>;
  /** Maximum number of results that were retrieved in this query; page size */
  limit: Scalars['Int'];
  /** The starting index for records that were returned in this query. */
  offset: Scalars['Int'];
  /** Jobs retrieved */
  records?: Maybe<Array<Maybe<Job>>>;
};

export enum JobOrderField {
  CreatedDateTime = 'createdDateTime',
  ModifiedDateTime = 'modifiedDateTime'
}

/**
 * deprecated. DO NOT USE.
 * TODO: Remove
 */
export type JobPipeline = {
  __typename?: 'JobPipeline';
  id: Scalars['ID'];
  isPublic: Scalars['Boolean'];
  jobTemplates?: Maybe<JobTemplateList>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['ID']>;
};

/**
 * deprecated. DO NOT USE.
 * TODO: Remove
 */
export type JobPipelineList = Page & {
  __typename?: 'JobPipelineList';
  count: Scalars['Int'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records: Array<JobPipeline>;
};

export type JobSortField = {
  direction?: InputMaybe<OrderDirection>;
  field: JobOrderField;
};

export enum JobStatus {
  Cancelled = 'cancelled',
  Complete = 'complete',
  Failed = 'failed',
  Pending = 'pending',
  Queued = 'queued',
  Running = 'running'
}

export enum JobStatusFilter {
  Cancelled = 'cancelled',
  Complete = 'complete',
  Failed = 'failed',
  Pending = 'pending',
  Queued = 'queued',
  Running = 'running'
}

/** A job template is a reusable template for job creation. */
export type JobTemplate = {
  __typename?: 'JobTemplate';
  /** Target execution cluster ID */
  clusterId?: Maybe<Scalars['ID']>;
  /** Date and time this job template was created */
  createdDateTime?: Maybe<Scalars['DateTime']>;
  /** The object ID */
  id: Scalars['ID'];
  /**
   * Optional configuration data for jobs launched from the template.
   * A schema may be enforced over the data stored here.
   * Used for top-level information about the job that does not fit on
   * a specific task template.
   */
  jobConfig?: Maybe<Scalars['JSONData']>;
  /**
   * deprecated. DO NOT USE.
   * TODO: Remove
   * @deprecated obsolete v2 functionality
   */
  jobPipeline?: Maybe<JobPipeline>;
  /**
   * deprecated. DO NOT USE.
   * TODO: Remove
   * @deprecated obsolete v2 functionality
   */
  jobPipelineId?: Maybe<Scalars['ID']>;
  /** Job pipeline stage. Defined only if this template belongs to a job pipeline. */
  jobPipelineStage?: Maybe<Scalars['Int']>;
  /** Date and time this job template was last modified */
  modifiedDateTime?: Maybe<Scalars['DateTime']>;
  /**
   * This contains a list of URIs engine toolkit will send completed chunks.
   * This is for all tasks in job.
   */
  notificationUris?: Maybe<Array<Maybe<Scalars['String']>>>;
  routes?: Maybe<Array<Maybe<Route>>>;
  skipDecider?: Maybe<Scalars['Boolean']>;
  /** Task templates associated with this job template */
  taskTemplates: TaskTemplateList;
};


/** A job template is a reusable template for job creation. */
export type JobTemplateTaskTemplatesArgs = {
  engineId?: InputMaybe<Scalars['ID']>;
  engineType?: InputMaybe<Array<EngineTypeFilter>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export enum JobTemplateEnumType {
  Reprocess = 'Reprocess',
  Upload = 'Upload'
}

export type JobTemplateList = Page & {
  __typename?: 'JobTemplateList';
  count: Scalars['Int'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records: Array<JobTemplate>;
};

/** Key-value pairs -- a generic way to represent metadata */
export type Kvp = Metadata & {
  __typename?: 'KVP';
  name: Scalars['String'];
  value?: Maybe<Array<Maybe<Property>>>;
};

export type LaunchJobTemplates = {
  /**
   * Optional data used to create a _new_ TDO for the job.
   * Specify this field _or_ `targetInfo`, but not both.
   */
  createTargetInfo?: InputMaybe<CreateTdoForJob>;
  ids: Array<Scalars['ID']>;
  payload?: InputMaybe<Scalars['JSONData']>;
  scheduledJobId?: InputMaybe<Scalars['ID']>;
  targetInfo?: InputMaybe<LaunchJobTemplatesTargetInfo>;
};

export type LaunchJobTemplatesTargetInfo = {
  endOffsetMs?: InputMaybe<Scalars['Int']>;
  startOffsetMs?: InputMaybe<Scalars['Int']>;
  /**
   * ID of the target object for the jobs,
   * typically that of a TemporalDataObject
   */
  targetId: Scalars['ID'];
};

export type LaunchScheduledJobs = {
  /**
   * Optional data used to create a _new_ TDO for the job.
   * Specify this field _or_ `targetInfo`, but not both.
   */
  createTargetInfo?: InputMaybe<CreateTdoForJob>;
  /** Job payload */
  payload?: InputMaybe<Scalars['JSONData']>;
  scheduledJobId?: InputMaybe<Scalars['ID']>;
  /**
   * Optional data about the job target,
   * a TemporalDataObject. If this field is
   * not specified then a suitable
   * object will be created automatically.
   */
  targetInfo?: InputMaybe<CreateAllPipelineJobsTargetInfo>;
};

export type Library = {
  __typename?: 'Library';
  applicationId: Scalars['ID'];
  /** Retrieve collaborators for a library. */
  collaborators?: Maybe<LibraryCollaboratorList>;
  /** Retrieve library model configurations */
  configurations?: Maybe<LibraryConfigurationList>;
  coverImageUrl?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  /** Object creation timestamp. Does not change. */
  createdDateTime?: Maybe<Scalars['DateTime']>;
  /** Retrieve dataset library tdos */
  dataset?: Maybe<LibraryDataset>;
  description?: Maybe<Scalars['String']>;
  /** Retrieve engine models for a library */
  engineModels?: Maybe<LibraryEngineModelList>;
  entities?: Maybe<EntityList>;
  /** The object's unique ID */
  id: Scalars['ID'];
  libraryType?: Maybe<LibraryType>;
  libraryTypeId?: Maybe<Scalars['ID']>;
  modifiedBy?: Maybe<Scalars['String']>;
  /** Object modification timestamp. */
  modifiedDateTime?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['ID']>;
  /** Modular metadata in the form of key-value pairs */
  properties?: Maybe<Array<Maybe<Property>>>;
  /** Security settings for the asset container */
  security?: Maybe<Security>;
  /** Aggregated summary data about the library */
  summary?: Maybe<LibrarySummary>;
  /** Library version */
  version?: Maybe<Scalars['Int']>;
};


export type LibraryCollaboratorsArgs = {
  collaboratorOrgId?: InputMaybe<Scalars['ID']>;
};


export type LibraryConfigurationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type LibraryEngineModelsArgs = {
  currentVersion?: InputMaybe<Scalars['Boolean']>;
  engineId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  lastModified?: InputMaybe<Scalars['Boolean']>;
  libraryVersion?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  trainStatus?: InputMaybe<LibraryEngineModelTrainStatus>;
};


export type LibraryEntitiesArgs = {
  id?: InputMaybe<Scalars['ID']>;
  identifierTypeId?: InputMaybe<Scalars['ID']>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<LibraryEntityOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};

export type LibraryCollaborator = {
  __typename?: 'LibraryCollaborator';
  createdDateTime?: Maybe<Scalars['DateTime']>;
  library?: Maybe<Library>;
  libraryId: Scalars['ID'];
  modifiedDateTime?: Maybe<Scalars['DateTime']>;
  organization?: Maybe<Organization>;
  organizationId: Scalars['ID'];
  permissions?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<Scalars['String']>;
};

export type LibraryCollaboratorList = {
  __typename?: 'LibraryCollaboratorList';
  /** Number of records returned in this response */
  count?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
  /** The starting index for records that were returned in this query. */
  offset: Scalars['Int'];
  records?: Maybe<Array<Maybe<LibraryCollaborator>>>;
};

export type LibraryConfiguration = {
  __typename?: 'LibraryConfiguration';
  /**
   * This option is used for Dataset Library Only
   * Dataset tdos confidence filters
   */
  confidence?: Maybe<DatasetConfidence>;
  /** ID of the engine category this config applies to */
  engineCategoryId?: Maybe<Scalars['ID']>;
  /** library configuration id */
  id?: Maybe<Scalars['ID']>;
  /** ID of the selected library where this config applies to */
  libraryId?: Maybe<Scalars['ID']>;
  /**
   * This option is used for Dataset Library Only
   * List of selected engine where tdos are extracted from for training data
   * TDOs are extracted from higher ranked engines first then fallback to the lower ones if the priors don't have any matching tdo
   */
  rankedSourceEngineIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** List of selected engine ids for training */
  targetEngineIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type LibraryConfigurationList = Page & {
  __typename?: 'LibraryConfigurationList';
  /** Number of records returned in this response */
  count?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
  /** The starting index for records that were returned in this query. */
  offset: Scalars['Int'];
  records?: Maybe<Array<Maybe<LibraryConfiguration>>>;
};

export type LibraryDataset = {
  __typename?: 'LibraryDataset';
  /** Id of the selected library */
  libraryId?: Maybe<Scalars['ID']>;
  /** List of tdo ids in the selected library */
  tdoIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type LibraryEngineModel = {
  __typename?: 'LibraryEngineModel';
  accuracy?: Maybe<Scalars['Int']>;
  configurationId?: Maybe<Scalars['ID']>;
  /**
   * Content type of the data file pointed to by dataUrl.
   * Will be empty if no data file is attached to the engine model.
   */
  contentType?: Maybe<Scalars['String']>;
  createdDateTime?: Maybe<Scalars['DateTime']>;
  dataUrl?: Maybe<Scalars['String']>;
  engine?: Maybe<Engine>;
  engineId: Scalars['ID'];
  id: Scalars['ID'];
  jsondata?: Maybe<Scalars['JSONData']>;
  library?: Maybe<Library>;
  libraryId: Scalars['ID'];
  libraryVersion?: Maybe<Scalars['Int']>;
  modifiedDateTime?: Maybe<Scalars['DateTime']>;
  trainJobId?: Maybe<Scalars['ID']>;
  trainStatus: LibraryEngineModelTrainStatus;
};

export type LibraryEngineModelList = Page & {
  __typename?: 'LibraryEngineModelList';
  count?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records?: Maybe<Array<Maybe<LibraryEngineModel>>>;
};

export enum LibraryEngineModelTrainStatus {
  Complete = 'complete',
  Failed = 'failed',
  Pending = 'pending',
  Queued = 'queued',
  Running = 'running'
}

export enum LibraryEntityOrderBy {
  CreatedDateTime = 'createdDateTime',
  Id = 'id',
  ModifiedDateTime = 'modifiedDateTime',
  Name = 'name'
}

export type LibraryList = Page & {
  __typename?: 'LibraryList';
  /** Number of records returned in this response */
  count?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
  /** The starting index for records that were returned in this query. */
  offset: Scalars['Int'];
  records?: Maybe<Array<Maybe<Library>>>;
};

export enum LibraryOrderBy {
  CreatedDateTime = 'createdDateTime',
  Id = 'id',
  ModifiedDateTime = 'modifiedDateTime',
  Name = 'name',
  Version = 'version'
}

export type LibrarySummary = {
  __typename?: 'LibrarySummary';
  entityCount?: Maybe<Scalars['Int']>;
  lastTrainedDateTime?: Maybe<Scalars['DateTime']>;
  lastTrainedVersion?: Maybe<Scalars['Int']>;
  unpublishedEntityCount?: Maybe<Scalars['Int']>;
};

export type LibraryType = {
  __typename?: 'LibraryType';
  entityIdentifierTypes?: Maybe<Array<Maybe<EntityIdentifierType>>>;
  entityType?: Maybe<EntityType>;
  entityTypeName?: Maybe<Scalars['String']>;
  entityTypeNamePlural?: Maybe<Scalars['String']>;
  iconClass?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
};

export type LibraryTypeList = Page & {
  __typename?: 'LibraryTypeList';
  /** Number of records returned in this response */
  count?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
  /** The starting index for records that were returned in this query. */
  offset: Scalars['Int'];
  records?: Maybe<Array<Maybe<LibraryType>>>;
};

/** Contains information about the user's authentication context. */
export type LoginInfo = {
  __typename?: 'LoginInfo';
  /** API token. This is a persistent organization-level token intended for API access. */
  apiToken?: Maybe<Scalars['String']>;
  applicationPlatforms?: Maybe<Array<Maybe<ApplicationPlatform>>>;
  /**
   * List of Veritone platform applications for which the user is provisioned.
   * Note that these are different than the VDA custom applications referenced
   * in the `Application` type, `applications()` query, and related mutations.
   */
  applications?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** Groups to which the user belongs. */
  groups?: Maybe<Array<Maybe<Group>>>;
  /**
   * True if the user account has a password set. False otherwise.
   * If false, the user will be prompted to set a password on next login.
   */
  hasPassword?: Maybe<Scalars['Boolean']>;
  /** Date and time at which the user last logged in to the Veritone platform */
  lastLoggedIn?: Maybe<Scalars['String']>;
  /** Organization to which the user belongs. */
  organization?: Maybe<Organization>;
  /** True if a password reset will be required on the user's next login. */
  passwordResetRequired?: Maybe<Scalars['Boolean']>;
  /** TODO */
  providerId?: Maybe<Scalars['String']>;
  /** TODO */
  providerScreenName?: Maybe<Scalars['String']>;
  /** TODO */
  providerUserId?: Maybe<Scalars['String']>;
  /**
   * Session-scoped user token. This token is tied to the user's session and will expire
   * when that session ends.
   */
  token?: Maybe<Scalars['String']>;
  /** Date and time when the token will expire. */
  tokenExpiration?: Maybe<Scalars['DateTime']>;
  /** User object */
  user?: Maybe<User>;
};

/** Type that holds multi-factor authentication for a user */
export type MfaInfo = {
  __typename?: 'MFAInfo';
  defaultOption?: Maybe<Scalars['String']>;
  gaVerifiedDateTime?: Maybe<Scalars['DateTime']>;
  pendingRegistration?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  smsVoiceVerifiedDateTime?: Maybe<Scalars['DateTime']>;
};

export type MatchEntityTagInput = {
  entityType?: InputMaybe<EntityTagType>;
  tagKey: Scalars['String'];
};

export type MatchedEntityTagsList = Page & {
  __typename?: 'MatchedEntityTagsList';
  count?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records?: Maybe<Array<EntityTag>>;
};

export type MediaShare = {
  __typename?: 'MediaShare';
  mediaType: Scalars['String'];
  scheduledJobId?: Maybe<Scalars['ID']>;
  serviceName: Scalars['String'];
  /** various settings for diffrent types of media. like audio only for videos */
  settings?: Maybe<Scalars['JSONData']>;
  /** sourceId OR tdoId is required */
  sourceId?: Maybe<Scalars['ID']>;
  startDateTime?: Maybe<Scalars['DateTime']>;
  startOffsetMs?: Maybe<Scalars['Int']>;
  stopDateTime?: Maybe<Scalars['DateTime']>;
  stopOffsetMs?: Maybe<Scalars['Int']>;
  tdoId?: Maybe<Scalars['ID']>;
};

export type MediaShareInfo = {
  __typename?: 'MediaShareInfo';
  accessToken: Scalars['String'];
  isSegmented?: Maybe<Scalars['Boolean']>;
  token: Scalars['String'];
};

export enum MediaStorageOption {
  Core = 'core',
  Edge = 'edge'
}

export type Mention = {
  __typename?: 'Mention';
  adCreative?: Maybe<Scalars['JSONData']>;
  advertiser?: Maybe<Scalars['JSONData']>;
  advertiserId?: Maybe<Scalars['ID']>;
  audience?: Maybe<Scalars['Int']>;
  audienceAffiliateCount?: Maybe<Scalars['Int']>;
  audienceMarketCount?: Maybe<Scalars['Int']>;
  brand?: Maybe<Scalars['JSONData']>;
  brandId?: Maybe<Scalars['ID']>;
  campaign?: Maybe<Campaign>;
  campaignId?: Maybe<Scalars['ID']>;
  cognitiveEngineResults?: Maybe<Scalars['JSONData']>;
  comments?: Maybe<MentionCommentList>;
  complianceStatusId?: Maybe<Scalars['ID']>;
  createdDateTime?: Maybe<Scalars['DateTime']>;
  endDateTime?: Maybe<Scalars['DateTime']>;
  fingerprint?: Maybe<Scalars['JSONData']>;
  hash?: Maybe<Scalars['ID']>;
  hitEndDateTime?: Maybe<Scalars['DateTime']>;
  hitStartDateTime?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isMatch?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['ID']>;
  mentionDate?: Maybe<Scalars['DateTime']>;
  mentionHitCount?: Maybe<Scalars['Int']>;
  mentionRating?: Maybe<Scalars['Float']>;
  mentionSnippets?: Maybe<Array<Maybe<MentionSnippets>>>;
  metadata?: Maybe<Scalars['JSONData']>;
  modifiedDateTime?: Maybe<Scalars['DateTime']>;
  organization: Organization;
  organizationId: Scalars['ID'];
  privateNote?: Maybe<Scalars['String']>;
  publicNote?: Maybe<Scalars['String']>;
  queryTerm?: Maybe<Scalars['String']>;
  ratings?: Maybe<MentionRatingList>;
  scheduleId?: Maybe<Scalars['ID']>;
  scheduledJob?: Maybe<ScheduledJob>;
  sourceId?: Maybe<Scalars['ID']>;
  sourceTypeId?: Maybe<Scalars['ID']>;
  spotTypeId?: Maybe<Scalars['ID']>;
  statusId?: Maybe<Scalars['ID']>;
  temporalDataObject?: Maybe<TemporalDataObject>;
  userSnippets?: Maybe<Array<Maybe<MentionUserSnippets>>>;
  watchlist?: Maybe<Watchlist>;
  watchlistId?: Maybe<Scalars['ID']>;
};


export type MentionRatingsArgs = {
  userId?: InputMaybe<Scalars['ID']>;
};

export type MentionComment = {
  __typename?: 'MentionComment';
  commentId: Scalars['ID'];
  commentText?: Maybe<Scalars['String']>;
  createdDateTime?: Maybe<Scalars['DateTime']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  mentionId?: Maybe<Scalars['ID']>;
  modifiedDateTime?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['ID']>;
  userImage?: Maybe<Scalars['String']>;
};

export type MentionCommentList = Page & {
  __typename?: 'MentionCommentList';
  count?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records?: Maybe<Array<Maybe<MentionComment>>>;
};

export enum MentionDateTimeField {
  EndDateTime = 'endDateTime',
  HitStartDateTime = 'hitStartDateTime',
  HitStopDateTime = 'hitStopDateTime',
  MentionDate = 'mentionDate'
}

export type MentionDateTimeFilter = {
  field: MentionDateTimeField;
  fromDateTime?: InputMaybe<Scalars['DateTime']>;
  toDateTime?: InputMaybe<Scalars['DateTime']>;
};

export type MentionHit = {
  __typename?: 'MentionHit';
  endTime?: Maybe<Scalars['Float']>;
  queryTerm?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['Float']>;
};

export type MentionList = Page & {
  __typename?: 'MentionList';
  count?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records?: Maybe<Array<Mention>>;
};

export type MentionOrderBy = {
  direction?: InputMaybe<OrderDirection>;
  field: MentionOrderByField;
};

export enum MentionOrderByField {
  EndDateTime = 'endDateTime',
  HitEndDateTime = 'hitEndDateTime',
  HitStartDateTime = 'hitStartDateTime',
  Id = 'id',
  MentionDate = 'mentionDate'
}

export type MentionRating = {
  __typename?: 'MentionRating';
  createdDateTime?: Maybe<Scalars['DateTime']>;
  mentionId?: Maybe<Scalars['ID']>;
  modifiedDateTime?: Maybe<Scalars['DateTime']>;
  ratingId: Scalars['ID'];
  ratingValue?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['ID']>;
};

export type MentionRatingList = Page & {
  __typename?: 'MentionRatingList';
  count?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records?: Maybe<Array<Maybe<MentionRating>>>;
};

export type MentionSnippets = {
  __typename?: 'MentionSnippets';
  endTime?: Maybe<Scalars['Float']>;
  hits?: Maybe<Array<Maybe<MentionHit>>>;
  startTime?: Maybe<Scalars['Float']>;
  text?: Maybe<Scalars['String']>;
};

export type MentionStatus = {
  __typename?: 'MentionStatus';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type MentionUserSnippets = {
  __typename?: 'MentionUserSnippets';
  endTime?: Maybe<Scalars['Float']>;
  snippets?: Maybe<Array<Maybe<MentionSnippets>>>;
  startTime?: Maybe<Scalars['Float']>;
  text?: Maybe<Scalars['String']>;
  transcriptEndDate?: Maybe<Scalars['DateTime']>;
  transcriptStartDate?: Maybe<Scalars['DateTime']>;
};

export type Metadata = {
  name: Scalars['String'];
};

export enum ModuleRepo {
  Github = 'github',
  Npm = 'npm'
}

/** Move a folder into a new parent folder. */
export type MoveFolder = {
  newOrderIndex: Scalars['Int'];
  newParentTreeObjectId: Scalars['ID'];
  prevOrderIndex: Scalars['Int'];
  prevParentTreeObjectId: Scalars['ID'];
  rootFolderType?: InputMaybe<RootFolderType>;
  treeObjectId: Scalars['ID'];
};

export type MoveTemporalDataObject = {
  /** ID of the new parent folder. The TDO will be added to this folder. */
  newFolderId: Scalars['ID'];
  /** ID of the original parent folder. The TDO will be removed from this folder. */
  oldFolderId: Scalars['ID'];
  /** ID of the TDO to move */
  tdoId: Scalars['ID'];
};

/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type Mutation = {
  __typename?: 'Mutation';
  /**
   * This will add ACEs to the specified object(s).
   *
   * Applies the partial ACEs to the specified objects
   */
  addACEsToResources: AuthAcl;
  /** add a DAG template to organization */
  addDagTemplateToOrganization: DagTemplateOrganizations;
  /**
   * Add recordings to a dataset library
   * Example:
   * Request:
   * mutation {
   *   addLibraryDataset(input: {
   *     libraryId: "e0a6e5ad-dec8-49a1-ad33-3f1194c2e599",
   *     tdoIds: ["1570899328"]}) {
   *     	tdoIds
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "addLibraryDataset": {
   *       "tdoIds": [
   *         "1570899328"
   *       ]
   *     }
   *   }
   * }
   */
  addLibraryDataset?: Maybe<LibraryDataset>;
  /**
   * Add a single media segment to a TemporalDataObject.
   * This mutation will update the manifest asset (`media-mdp`)
   * for the TemporalDataObject.
   * Example:
   * Request:
   * mutation {
   *   addMediaSegment(input: {
   *     containerId: "1570705980",
   *     details: [],
   *     url: "https://edit.co.uk/uploads/2016/12/Image-1-Alternatives-to-stock-photography-Thinkstock.jpg",
   *     segmentGroupId: "123"}) {
   *     id
   *     name
   *     createdBy
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "addMediaSegment": {
   *       "id": "1570705980",
   *       "name": "example",
   *       "createdBy": null
   *     }
   *   }
   * }
   */
  addMediaSegment: TemporalDataObject;
  /**
   * Add a media segments to a TemporalDataObject.
   * This mutation will update the manifest asset (`media-mdp`)
   * for the TemporalDataObject.
   * Example:
   * Request:
   * mutation {
   *  addMediaSegments(
   *    containerId: "1570705980",
   *    segments: [
   *      {
   *    	details: [],
   *    	url: "https://edit.co.uk/uploads/2016/12/Image-1-Alternatives-to-stock-photography-Thinkstock.jpg",
   *    },
   *      {
   *    	details: [],
   *    	url: "https://edit.co.uk/uploads/2016/12/Image-1-Alternatives-to-stock-photography-Thinkstock.jpg"
   *      }
   *    ]
   *    segmentGroupId: "123") {
   *    id
   *    name
   *
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "addMediaSegments": {
   *       "id": "1570705980",
   *       "name": "example"
   *     }
   *   }
   * }
   */
  addMediaSegments: TemporalDataObject;
  /**
   * Add a new notification action by eventName, eventType, application
   * Example:
   * Request:
   * mutation {
   *   addNotificationAction(input: {
   *     eventName: "example",
   *   	eventType: "example"
   *   	actionName: "example"
   *   	icon: "https://edit.co.uk/uploads/2016/12/Image-1-Alternatives-to-stock-photography-Thinkstock.jpg"
   *   	urlTemplate: "www.veritone.com"
   *   	application: "80354999-d633-4595-9578-d82f59a5134f"
   *   	mailboxId: "0415f525-813d-4fd4-9dea-9428382b05b9"}) {
   *     	id
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "addNotificationAction": {
   *       "id": "27dab45b-d825-4f20-b758-4b089d610903"
   *     }
   *   }
   * }
   */
  addNotificationAction?: Maybe<NotificationAction>;
  /**
   * Add a new notification template by eventName, eventType, application
   * Example:
   * Request:
   * mutation {
   *   addNotificationTemplate(input: {
   *   eventName: "example"
   *   eventType: "example"
   *   title: "example"
   *   body: "example"
   *   application: "80354999-d633-4595-9578-d82f59a5134f"
   *   mailboxId: "0415f525-813d-4fd4-9dea-9428382b05b9"}) {
   *     	id
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "addNotificationTemplate": {
   *       "id": "1dbf3d28-bc7a-434f-ba65-455da0169323"
   *     }
   *   }
   * }
   */
  addNotificationTemplate?: Maybe<NotificationTemplate>;
  /**
   * Replace a source engine to replacement engine
   * Example:
   * Request:
   * mutation {
   *   addTaskReplacementEngine(input: {
   *     sourceEngineId: "1"
   *   	replacementEngineId: "2"
   *   	organizationId: "35521"
   *   	payloadFunc: null}) {
   *     	replacementEngineId
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "addTaskReplacementEngine": {
   *       "replacementEngineId": "2"
   *     }
   *   }
   * }
   */
  addTaskReplacementEngine?: Maybe<TaskEngineReplacement>;
  addTasksToJobs?: Maybe<AddTasksToJobsResponse>;
  addToEngineBlacklist?: Maybe<EngineBlacklist>;
  addToEngineWhitelist?: Maybe<EngineWhitelist>;
  /**
   * Add an existing user to an organization.
   * One of the user identifiers (userId or userName) has to be specified.
   */
  addUserToOrganization?: Maybe<User>;
  appendWarningToTask?: Maybe<Scalars['ID']>;
  /** This adds an application to an organization. */
  applicationAddToOrg: Application;
  /** This creates a config definition for an application */
  applicationConfigDefinitionCreate?: Maybe<ApplicationConfigDefinitionList>;
  /** This removes an existing config definition from an application */
  applicationConfigDefinitionDelete?: Maybe<OperationResult>;
  /** This updates an existing config definition for an application */
  applicationConfigDefinitionUpdate?: Maybe<ApplicationConfigDefinitionList>;
  /** This removes configs for an app/org/user */
  applicationConfigDelete?: Maybe<OperationResult>;
  /** This sets configs for an app/org/user */
  applicationConfigSet?: Maybe<ApplicationConfigList>;
  /** This removes an application from an organization */
  applicationRemoveFromOrg?: Maybe<OperationResult>;
  /**
   * Apply an application workflow step, such as "submit" or "approve"
   * Example:
   * Request:
   * mutation {
   *   applicationWorkflow(input: {
   *     id: "dcc6a08e-1114-43e9-b74a-2b469a32f437",
   *     action: submit}) {
   *     	id
   *     	name
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "applicationWorkflow": {
   *       "id": "dcc6a08e-1114-43e9-b74a-2b469a32f437",
   *       "name": "appexamplebill2"
   *     }
   *   }
   * }
   */
  applicationWorkflow?: Maybe<Application>;
  /**
   * Create default authorization group for initialize new org or current org OLP onboarding
   * This will create two default auth group, orgAdmin + orgAllAccess
   */
  authEnforcementEnable?: Maybe<Array<AuthGroup>>;
  /** Add members to authorization group */
  authGroupAddMembers: AuthGroup;
  /** Create new authorization group */
  authGroupCreate: AuthGroup;
  /** Delete existing authorization group */
  authGroupDelete: DeletePayload;
  /** Remove members from authorization group */
  authGroupRemoveMembers?: Maybe<AuthGroup>;
  /** Update existing authorization group */
  authGroupUpdate: AuthGroup;
  /** Create new authorization role */
  authPermissionSetCreate: AuthPermissionSet;
  /**
   * Delete Permission Set
   * !!! Warning: this will delete the permission set.  This will fail if referenced in an ACE
   */
  authPermissionSetDelete: DeletePayload;
  /**
   * Update existing authorization role
   * !!! Warning: this will update all permissions given to authorization groups
   * on resources and organization-wide, granted by this authorization role.
   *
   * Note: Deletion of authorization roles is not supported; use this mutation to assign
   * an empty permission set to effectively disable a role.
   */
  authPermissionSetUpdate: AuthPermissionSet;
  bulkCreateWatchlist?: Maybe<WatchlistList>;
  bulkDeleteContextMenuExtensions?: Maybe<ContextMenuExtensionList>;
  /**
   * Apply bulk updates to watchlists.
   * This mutation is currently available only to Veritone operations.
   */
  bulkUpdateWatchlist?: Maybe<WatchlistList>;
  /**
   * Cancel a job. This action effectively deletes the job,
   * although a records of job and task execution remains in
   * Veritone's database.
   */
  cancelJob?: Maybe<DeletePayload>;
  /** Change the current authenticated user's password */
  changePassword?: Maybe<User>;
  /**
   * Delete partial information from a temporal data object.
   * Use the delete options to control exactly which data is deleted.
   * The default is to delete objects from storage and the search index,
   * while leaving TDO-level metadata and task engine results intact.
   * To permanently delete the TDO, use delete TDO.
   * Example:
   * Request:
   * mutation {
   *   cleanupTDO(
   *     id: "1570705980") {
   *     id
   *     message
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "cleanupTDO": {
   *       "id": "1570705980",
   *       "message": null
   *     }
   *   }
   * }
   */
  cleanupTDO?: Maybe<DeletePayload>;
  cloneScheduledJob: ScheduledJob;
  copyFlow?: Maybe<Engine>;
  /**
   * Create a new application. An application must
   * go through a sequence of workflow steps before
   * it is available in production. See the VDA documentation
   * for details.
   * Example:
   * Request:
   * mutation {
   *   createApplication(input: {
   *     name: "example123",
   *     key: "example123",
   *     category: "example",
   *     url: "www.veritone.com",
   *     checkPermissions: true}) {
   *     	id
   *     	name
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "createApplication": {
   *       "id": "7e863365-94de-4ac9-8826-df1a398c9a21",
   *       "name": "example123"
   *     }
   *   }
   * }
   */
  createApplication?: Maybe<Application>;
  /** This creates headerbar information for an application/organization */
  createApplicationHeaderbar?: Maybe<ApplicationHeaderbar>;
  /** Create an application role */
  createApplicationRole: ApplicationRole;
  /**
   * Create a media asset. Optionally, upload content using
   * multipart form POST.
   * example:
   * Request:
   * mutation {
   *   createAsset(input: {
   *     containerId: "1570654874",
   *     contentType: "application/json",
   *     description: "example",
   *     file: null,
   *     assetType: "text",
   *     uri: "example"
   * 	  name: "example"}) {
   *   id
   *     name
   *     description
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "createAsset": {
   *       "id": "1570654874_4hJtNKSUXD",
   *       "name": "example",
   *       "description": "example"
   *     }
   *   }
   * }
   */
  createAsset?: Maybe<Asset>;
  /**
   * Create a new automate flow. An automate flow is an engine
   * with extra metadata to work in the automate environment.
   * This endpoint will return an engineId that can be used to open
   * the flow in automate.
   * Example:
   * Request:
   * mutation {
   *   createAutomateFlow(input: {
   *     linkedApplicationId: "123",
   *     templateId: "36"
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "createAutomateFlow": {
   *       "engineId": "567",
   *       "build": {
   *         "engineId": 567
   *       }
   *     }
   *   }
   * }
   */
  createAutomateFlow?: Maybe<AutomateRunConfig>;
  createCluster?: Maybe<Cluster>;
  createClusterNode?: Maybe<ClusterNode>;
  createCognitiveSearch?: Maybe<CognitiveSearch>;
  /**
   * Create (ingest) a structured data object
   * Example:
   * Request:
   * mutation {
   *   createCollection(input: {
   * 		name: "example",
   *   	folderDescription: "example",
   *   	image:"",
   *   	parentFolderId: "d551fbd6-7354-4b0e-abfb-654ab8583be2"}) {
   *     id
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "createCollection": {
   *       "id": "242361"
   *     }
   *   }
   * }
   */
  createCollection?: Maybe<Collection>;
  /** Add a mention to a collection */
  createCollectionMention?: Maybe<CollectionMention>;
  createCollectionMentions: Array<CollectionMention>;
  /**
   * Create a context menu extension
   * Example:
   * Request:
   *   mutation {
   *   createContextMenuExtension(input: {
   *     id: "80354999-d633-4595-9578-d82f59a5134f"
   *   	label: "example"
   *  		url: "www.veritone.com"
   *   	type: tdo}) {
   *     	id
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "createContextMenuExtension": {
   *       "id": "cdf19d46-4d89-4b5b-a6bf-ae12c17f2746"
   *     }
   *   }
   * }
   */
  createContextMenuExtension: ContextMenuExtension;
  /**
   * Create a creative
   * Example:
   * Request:
   * mutation {
   *   createCreative(input: {
   *     name: "example"
   *   	keywords: "example keywords"
   *   	brandId: null
   *   	advertiserId: null}) {
   *     	id
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "createCreative": {
   *       "id": "25208"
   *     }
   *   }
   * }
   */
  createCreative: Creative;
  /**
   * Create a custom dashboard
   * Example:
   * Request:
   * mutation {
   *   createCustomDashboard(input: {
   *     hostAppId: "80354999-d633-4595-9578-d82f59a5134f",
   *     name: "example",
   *     description: "example",
   *     data: {
   *       example: "example jsondata"}}) {
   *     	id
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "createCustomDashboard": {
   *       "id": "60141fc5-8d31-487d-9847-c47f990e4537"
   *     }
   *   }
   * }
   */
  createCustomDashboard?: Maybe<CustomDashboard>;
  /** Creates a DAG template */
  createDagTemplate: DagTemplate;
  /**
   * Create a structured data registry schema metadata.
   * Example:
   * Request:
   * mutation {
   *   createDataRegistry(input: {
   *     name: "example",
   *     description: "example"
   *     source: "example"}) {
   *     	id
   *     	organizationId
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "createDataRegistry": {
   *       "id": "230f95e4-95c9-47c4-a845-61ca67ad6ba6",
   *       "organizationId": "35521"
   *     }
   *   }
   * }
   */
  createDataRegistry?: Maybe<DataRegistry>;
  /**
   * Create a Dataset
   * Example:
   * Request:
   * mutation {
   *   createDataset(input: {
   *     name: "example",
   *     description: "example",
   *     schemaId: "acab8bd9-a4d4-44de-ad4b-cc949d696cf9",
   *     tags: {
   *       name: "example",
   *       value: "example value"}}) {
   *     datasetId
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "createDataset": {
   *       "datasetId": "47c831ea-f4f6-4eeb-9e39-8c1cd0a1eb95"
   *     }
   *   }
   * }
   */
  createDataset?: Maybe<Dataset>;
  /**
   * Create a Dataset Schema
   * Example:
   * Request:
   * mutation {
   *   createDatasetSchema(input: {
   *   name: "example"
   *   description: "example"
   *   schema: {
   *     example: "example value"
   *   }
   *    tags: {
   *       name: "example",
   *       value: "example value"}}) {
   *     	schema{
   *         id
   *       }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "createDatasetSchema": null
   *   }
   * }
   */
  createDatasetSchema?: Maybe<Dataset>;
  /**
   * Create a new engine. The engine will need to go
   * through a sequence of workflow steps before
   * use in production. See VDA documentation for details.
   * Example:
   * Request:
   * mutation {
   *   createEngine(input: {
   *     id: "123",
   *     name: "example",
   *     categoryId: "581dbb32-ea5b-4458-bd15-8094942345e3",
   *     deploymentModel: FullyNetworkIsolated
   *     useCases: [],
   *     industries: []}) {
   *     id
   *     ownerOrganizationId
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "createEngine": {
   *       "id": "123",
   *       "ownerOrganizationId": "35521"
   *     }
   *   }
   * }
   */
  createEngine?: Maybe<Engine>;
  /**
   * Create an engine build.
   * Example:
   * Request:
   *   mutation {
   *     createEngineBuild(input: {
   *       engineId: "1",
   *       taskRuntime: [],
   *       dockerImage: "build",
   *       manifest: [] }) {
   *         id
   *         name
   *         engineId
   *       }
   *       realeaseNotes: "Includes feature x..."
   *     }
   *   }
   * Response:
   * {
   *   "data": {
   *     "createEngineBuild": {
   *       "id": "2a1a1b58-6983-4002-b9ed-7b7f325f621a",
   *       "name": "example Version 1",
   *       "engineId": "1",
   *       "releaseNotes": "Includes feature x..."
   *     }
   *   }
   * }
   */
  createEngineBuild?: Maybe<Build>;
  /**
   * Create a new entity.
   * Example:
   * Request:
   * mutation {
   *   createEntity(input: {
   *     name: "example",
   *     description: "example",
   *     libraryId: "e0a6e5ad-dec8-49a1-ad33-3f1194c2e599",
   *     jsondata: {
   *       example: "new example" }}) {
   *     		id
   *     		name
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "createEntity": {
   *       "id": "85b700fa-f327-4fea-b94b-ed83054170db",
   *       "name": "example"
   *     }
   *   }
   * }
   */
  createEntity?: Maybe<Entity>;
  /**
   * Create an entity identifier.
   * This mutation accepts file uploads. To use this mutation and upload a file,
   * send a multipart form POST containing two parameters:  `query`, with the
   * GraphQL query, and `file` containing the file itself.
   * For more information see the documentation at https://veritone-developer.atlassian.net/wiki/spaces/DOC/pages/13893791/GraphQL.
   * Example:
   * Request:
   * mutation {
   *   createEntityIdentifier(input: {
   *     entityId: "85b700fa-f327-4fea-b94b-ed83054170db",
   *   	identifierTypeId: "123",
   *     title: "example",
   *   	isPriority: false,
   *     contentType: "example",
   *   	url: "https://edit.co.uk/uploads/2016/12/Image-1-Alternatives-to-stock-photography-Thinkstock.jpg"}) {
   *     	id
   *     	isPriority
   *   }
   * }
   * Result:
   * {
   *   "data": {
   *     "createEntityIdentifier": {
   *       "id": "bf67e595-3666-4a0c-9f4b-0ad99a1770fe",
   *       "isPriority": false,
   *     }
   *   }
   * }
   */
  createEntityIdentifier?: Maybe<EntityIdentifier>;
  /**
   * Create an entity identifier type, such as "face" or "image".
   * Entity identifier types are typically created or modified
   * only by Veritone engineering. Most libraries and
   * entities will use existing entity identifier types.
   * Example:
   * Request:
   * mutation {
   *   createEntityIdentifierType(input: {
   *     label: "example"
   *   	labelPlural: "example"
   *   	iconClass: null
   *   	description: "example"
   *   	dataType: text
   *   	id: "123"}) {
   *     	id
   *     	description
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "createEntityIdentifierType": {
   *       "id": "123",
   *       "description": null
   *     }
   *   }
   * }
   */
  createEntityIdentifierType?: Maybe<EntityIdentifierType>;
  /**
   *   Create a new event
   *   Example:
   *   Request:
   *   mutation {
   *   createEvent(input: {
   *     eventName: "example",
   *   	eventType: "example",
   *   	application: ""
   *   	description: "example"}) {
   *     	id
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "createEvent": {
   *       "id": "55fc7c51-1521-4043-902f-f0f3a357da6d"
   *     }
   *   }
   * }
   */
  createEvent: Event;
  /**
   * Create a new event trigger template
   * Example:
   * Request:
   * mutation {
   *   createEventActionTemplate(input: {
   *   	name: "example"
   *   	inputType: event
   *   	inputValidation: {
   *       example: "example"
   *     }
   *   	inputAttributes:  {
   *       example: "example"
   *     }
   *   	actionType: job
   *   	actionValidation: {
   *       example: "example"
   *     }
   *   	actionDestination: "1"
   *   	actionAttributes: {
   *       example: "example"
   *     }}) {
   *     	id
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "createEventActionTemplate": {
   *       "id": "d02522d7-ef5f-448f-981a-d2cfc7603d92"
   *     }
   *   }
   * }
   */
  createEventActionTemplate: EventActionTemplate;
  /**
   * Create a new event custom rule
   * Example:
   * Request:
   * mutation {
   *   createEventCustomRule(input: {
   *   name: "example"
   *   eventType: "example"
   *   eventName: "example"
   *   description: "example description"
   *   actions:[]
   *   params: {
   *       example: "example"
   *   }}) {
   *     id
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "createEventCustomRule": {
   *       "id": "0a0d3ec8-b4fb-48fc-bd39-c47a22b2173b"
   *     }
   *   }
   * }
   */
  createEventCustomRule: EventCustomRule;
  /**
   * Create an export request. The requested TDO data, possibly including
   * TDO media and engine results, will be exported offline.
   * Example:
   * Request:
   * mutation {
   *   createExportRequest(input: {
   *     tdoData: {
   *       tdoId: "1580388995",
   *     }}) {
   *     id
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "createExportRequest": {
   *       "id": "938b2d64-6df1-486b-b6ea-29d33dee49ad"
   *     }
   *   }
   * }
   */
  createExportRequest: ExportRequest;
  createFlow?: Maybe<Engine>;
  createFlowExecution?: Maybe<FlowExecution>;
  createFlowFromTemplate?: Maybe<FlowFromTemplate>;
  createFlowRevision?: Maybe<FlowRevision>;
  createFlowTemplate?: Maybe<FlowTemplate>;
  /**
   * Create a new folder
   * Example:
   * Request:
   * mutation {
   *   createFolder(input: {
   *     name: "example",
   *     description: "example",
   *     parentId: "2ac28573-917a-4c4b-be91-a0ac64cbc982",
   *   	rootFolderType:watchlist}) {
   *     	id
   *     	name
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "createFolder": {
   *       "id": "d551fbd6-7354-4b0e-abfb-654ab8583be2",
   *       "name": "example"
   *     }
   *   }
   * }
   */
  createFolder?: Maybe<Folder>;
  /** Create new content template into a folder */
  createFolderContentTempate: FolderContentTemplate;
  /** Create a job */
  createJob?: Maybe<Job>;
  createJobTemplate: JobTemplate;
  /**
   * Create a new library.
   * Once the library is created, the client can add
   * entities and entity identifiers. Note that the
   * library type determines what types of entity identifiers
   * can be used within the library.
   * Example:
   * Request:
   * mutation {
   *   createLibrary(input: {
   *   	name: "example"
   *   	applicationId: "32babe30-fb42-11e4-89bc-27b69865858a"
   *   	organizationId: "35521"
   *   	libraryTypeId: "123"
   *   	coverImageUrl: "https://edit.co.uk/uploads/2016/12/Image-1-Alternatives-to-stock-photography-Thinkstock.jpg"
   *   	description: "example"}) {
   *     	id
   *     	name
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "createLibrary": {
   *       "id": "e0a6e5ad-dec8-49a1-ad33-3f1194c2e599",
   *       "name": "example"
   *     }
   *   }
   * }
   */
  createLibrary?: Maybe<Library>;
  /**
   * Create a library collaborator.
   * Example:
   * Request:
   * mutation {
   *   createLibraryCollaborator(input: {
   *     libraryId: "e0a6e5ad-dec8-49a1-ad33-3f1194c2e599",
   *     organizationId: 35521,
   *     permissions: ["job.create"]}) {
   *     	organizationId
   *     	status
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "createLibraryCollaborator": {
   *       "organizationId": "35521",
   *       "status": "active"
   *     }
   *   }
   * }
   */
  createLibraryCollaborator?: Maybe<LibraryCollaborator>;
  /**
   * Create Dataset Library Configuration
   * Example
   * Request:
   * mutation {
   *   createLibraryConfiguration(input: {
   *     libraryId: "e0a6e5ad-dec8-49a1-ad33-3f1194c2e599",
   *     engineCategoryId: "c1e5f177-ca10-433a-a155-bb5e4872cf9a",
   *     targetEngineIds: ["1"],
   *   	confidence: {}}) {
   *     	id
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "createLibraryConfiguration": {
   *       "id": "7396e71b-db5a-4c4c-bf6f-4fc66a5a07f7"
   *     }
   *   }
   * }
   */
  createLibraryConfiguration?: Maybe<LibraryConfiguration>;
  /**
   * Create a library engine model.
   * Example:
   * Request:
   * mutation {
   *   createLibraryEngineModel(input: {
   *     engineId: "1",
   *     libraryId: "e0a6e5ad-dec8-49a1-ad33-3f1194c2e599",
   *     trainJobId: "123",
   *     dataUrl: "https://edit.co.uk/uploads/2016/12/Image-1-Alternatives-to-stock-photography-Thinkstock.jpg"}) {
   *     	id
   *     	engineId
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "createLibraryEngineModel": {
   *       "id": "0e9c25f7-d994-4363-af41-c00b37de9a1b",
   *       "engineId": "1"
   *     }
   *   }
   * }
   */
  createLibraryEngineModel?: Maybe<LibraryEngineModel>;
  /**
   * Create a library type, such as "ad" or "people".
   * Entity identifier types are typically created or modified
   * only by Veritone engineering. Most libraries
   * will use existing entity identifier types.
   * Example:
   * Request:
   * mutation {
   *   createLibraryType(input: {
   *     id: "123",
   *     label: "example",
   *     entityIdentifierTypeIds: ["123"],
   *     entityType: {
   *       name: "example",
   *       namePlural: "example",
   *       schema: {
   *       example: "example" }}}) {
   *     		id
   *     		label
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "createLibraryType": {
   *       "id": "123",
   *       "label": "example"
   *     }
   *   }
   * }
   */
  createLibraryType?: Maybe<LibraryType>;
  /** Create Media Share. Returning the url of the share */
  createMediaShare: CreatedMediaShare;
  /** Create a mention object */
  createMention?: Maybe<Mention>;
  /** Create a mention comment */
  createMentionComment?: Maybe<MentionComment>;
  /**
   * Create a mention export request. The requested mentionFilters including
   * The mention export file csv will be exported offline.
   * Example:
   * Request:
   * mutation {
   *   createMentionExportRequest(input: {
   *     mentionFilters: {
   *       watchlistIds: ["123"]}}) {
   *     	id
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "createMentionExportRequest": {
   *       "id": "400c98c2-faa8-44e4-b5d8-daf2fb43445e"
   *     }
   *   }
   * }
   */
  createMentionExportRequest: ExportRequest;
  /** Create a mention rating */
  createMentionRating?: Maybe<MentionRating>;
  /** Create Mention in bulk. The input should be an array of createMentions */
  createMentions?: Maybe<MentionList>;
  /** Create an OpenID Provider */
  createOpenIdProvider?: Maybe<OpenIdProvider>;
  /** Create a new organization. */
  createOrganization?: Maybe<Organization>;
  /** Multi Organization Invitation */
  createOrganizationInvite: OrganizationInvite;
  /**
   * Create a password reset request. This mutation is used on behalf
   * of a user who needs to reset their password. It operates only on
   * the currently authenicated user (based on the authentication token provided).
   * Example:
   * Request:
   * mutation {
   *   createPasswordResetRequest(input: {
   *     userName: "example",
   *     skipPasswordResetEmail:true}) {
   *     	message
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "createPasswordResetRequest": {
   *       "message": "Reset request issued for example. Email will not be sent."
   *     }
   *   }
   * }
   */
  createPasswordResetRequest?: Maybe<CreatePasswordResetRequestPayload>;
  /**
   * Force a user to update password on next login.
   * This mutation is used by administrators.
   * Example:
   * Request:
   * mutation {
   *   createPasswordUpdateRequest(input: {
   *     id: "267de7e1-efb2-444a-a524-210328b78503",
   *     skipPasswordResetEmail: true}) {
   * 			id
   *     	name
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "createPasswordUpdateRequest": {
   *       "id": "267de7e1-efb2-444a-a524-210328b78503",
   *       "name": "example"
   *     }
   *   }
   * }
   */
  createPasswordUpdateRequest?: Maybe<User>;
  /**
   * Create a processTemplate in CMS
   * Example:
   * Request:
   * mutation {
   *   createProcessTemplate(input: {
   *     name: "example",
   *     taskList: {
   *       example: "task"
   *     }}) {
   *     	id
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "createProcessTemplate": {
   *       "id": "746"
   *     }
   *   }
   * }
   */
  createProcessTemplate: ProcessTemplate;
  /**
   * Create root folder for an organization
   * Example:
   * Request:
   * mutation {
   *   createRootFolders {
   *     id
   *     treeObjectId
   *     rootFolderTypeId
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "createRootFolders": [
   *       {
   *         "id": "2ac28573-917a-4c4b-be91-a0ac64cbc982",
   *         "treeObjectId": "3104f61f-4bd1-4175-9fe6-27436d591c54",
   *         "rootFolderTypeId": 1
   *       },
   *       {
   *         "id": "d3e27eb3-7d4a-47ab-af64-bf1529390f4e",
   *         "treeObjectId": "4c9f1c95-f6a3-4355-8831-c77719850eaa",
   *         "rootFolderTypeId": 1
   *       }
   *     ]
   *   }
   * }
   */
  createRootFolders?: Maybe<Array<Maybe<Folder>>>;
  /**
   * Create a new Saved Search
   * Example:
   * Request:
   * mutation {
   *   createSavedSearch(input: {
   *     name: "example",
   *     csp: {
   *       example: "example"}}) {
   *     		id
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "createSavedSearch": {
   *       "id": "a29f2255-e509-4454-89ec-e425390ca4ca"
   *     }
   *   }
   * }
   */
  createSavedSearch: SavedSearch;
  /**
   * This creates a scheduled job that will run on a schedule.  Once a scheduled job is created, it can be launched with
   * `launchScheduledJob`
   */
  createScheduledJob: ScheduledJob;
  /** Create a new content template on a scheduled job */
  createScheduledJobContentTemplate: ScheduledJobContentTemplate;
  /**
   * Create a schema record.
   * Example:
   * Request:
   * mutation {
   *   createSchema(input: {
   *       id: "450f95e4-95c9-47c4-a845-62ca67ad6ea6",
   *       dataRegistryId: "230f95e4-95c9-47c4-a845-61ca67ad6ba6",
   *       status: published,
   *       definition: {
   *         example: "example"
   *       },
   *       majorVersion: 1,
   *       minorVersion: 2
   *     }) {
   *     	id
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "createSchema": {
   *       "id": "230f95e4-95c9-47c4-a845-61ca67ad6ba6",
   *     }
   *   }
   * }
   */
  createSchema?: Maybe<Schema>;
  /** Create a new source */
  createSource?: Maybe<Source>;
  /** Create a new source content template on a source */
  createSourceContentTemplate: SourceContentTemplate;
  createSourceType?: Maybe<SourceType>;
  /**
   * Create (ingest) a structured data object
   * Example:
   * Request:
   * mutation {
   *   createStructuredData(input: {
   *     schemaId: "b79b7ff3-0b80-4d7c-ac51-d5f3459d13fa",
   *     data: {
   *       example: "example"
   *     }}) {
   *     	id
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "createStructuredData": {
   *       "id": "e180f94f-866e-4454-92f9-7ee20d6448fa"
   *     }
   *   }
   * }
   */
  createStructuredData?: Maybe<StructuredData>;
  /**
   * Create a subscription
   * Example:
   * Request:
   * mutation {
   *   createSubscription(input: {
   *     targetId: "325791",
   *   	contact: {
   *       emailAddress: "example email"},
   *   	scheduledDay: Friday}) {
   *     	id
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "createSubscription": {
   *       "id": "274939"
   *     }
   *   }
   * }
   */
  createSubscription?: Maybe<Subscription>;
  /**
   *   Create a new temporal data object
   * Example:
   * Request:
   * mutation {
   *   createTDO(input: {
   *     startDateTime: 1623253937,
   *     stopDateTime: 1623259000,
   *     source: "123",
   *     name: "example",
   *     description: "example",
   *     isPublic: false,
   *     applicationId: "123"}) {
   *     id
   *     name
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "createTDO": {
   *       "id": "1570654874",
   *       "name": "example"
   *     }
   *   }
   * }
   */
  createTDO?: Maybe<TemporalDataObject>;
  /**
   * Create a TDO and an asset with a single call
   * Example:
   * Request:
   * mutation {
   *   createTDOWithAsset(input: {
   *       startDateTime: 1623841655,
   *       stopDateTime: 1623851655,
   *       contentType: "video/mp4",
   *       assetType: "media",
   *       addToIndex: false,
   *       uri: "https://s3.amazonaws.com/hold4fisher/s3Test.mp4"}) {
   *     		id
   *     		status
   *     		assets {
   *       		records {
   *         		id
   *         		assetType
   *         		contentType
   *         		signedUri
   *       			}
   *     		}
   *   		}
   * }
   * Response:
   * {
   *   "data": {
   *     "createTDOWithAsset": {
   *       "id": "1580507556",
   *       "status": "recorded",
   *       "assets": {
   *         "records": [
   *           {
   *             "id": "1580507556_DQ2nU8cTDh",
   *             "assetType": "media",
   *             "contentType": "video/mp4",
   *             "signedUri": "https://s3.amazonaws.com/hold4fisher/s3Test.mp4"
   *           }
   *         ]
   *       }
   *     }
   *   }
   * }
   */
  createTDOWithAsset?: Maybe<TemporalDataObject>;
  /**
   * Create a task log by using
   * multipart form POST.
   */
  createTaskLog?: Maybe<TaskLog>;
  createTaskTemplate: TaskTemplate;
  /**
   * Create trigger for events or types.
   * Example:
   * Request:
   * mutation {
   *   createTriggers(input: {
   *     events: "*",
   *     targets: {
   *       name: Email,
   *       params: {
   *       address: "example@veritone.com"}}}) {
   *     	id
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "createTriggers": [
   *       {
   *         "id": "2936"
   *       }
   *     ]
   *   }
   * }
   */
  createTriggers?: Maybe<Array<Maybe<Trigger>>>;
  /**
   * Create a new user within an organization.
   * Example:
   * Request:
   * mutation {
   *   createUser(input: {
   *     name: "example",
   *     password: "example",
   *     organizationId: "35521"}) {
   *     	id
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "createUser": {
   *       "id": "267de7e1-efb2-444a-a524-210328b78503"
   *     }
   *   }
   * }
   */
  createUser?: Maybe<User>;
  /**
   * Create the default user setting definition for application by current organization
   * Example:
   * Request:
   * mutation {
   *   createUserSettingDefinition(
   *     application: "80354999-d633-4595-9578-d82f59a5134f",
   *     key: "example",
   *     type: "example",
   *     defaultValue: "example") {
   *     	applicationId
   *     	organizationGuid
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "createUserSettingDefinition": {
   *       "applicationId": "80354999-d633-4595-9578-d82f59a5134f",
   *       "organizationGuid": "49a4cbbc-5e83-4c42-b9a3-be6ec0732f09"
   *     }
   *   }
   * }
   */
  createUserSettingDefinition?: Maybe<ApplicationSetting>;
  /**
   * Create a watchlist
   * Example:
   * Request:
   * mutation {
   *   createWatchlist(input: {
   *     stopDateTime: 1623851655,
   *     name: "example",
   *     searchIndex: mine,
   *     parentFolderId: "9d639f1b-a0d4-47b0-8149-3568f048f320",
   *     cognitiveSearches: [],
   *     subscriptions: [],
   *     details: {
   *       example: "example"}}) {
   *     	id
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "createWatchlist": {
   *       "id": "325783"
   *     }
   *   }
   * }
   */
  createWatchlist?: Maybe<Watchlist>;
  /**
   * Creates a widget associated with a collection
   * Example:
   * Request:
   * mutation {
   *   createWidget(input:{
   *     collectionId: "242361",
   *     name: "example",
   *     nextButtonColor: "000000"}) {
   *     id
   *     name
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "createWidget": {
   *       "id": "fwSwWdRWTm2fdFMoPQDKkg",
   *       "name": ""
   *     }
   *   }
   * }
   */
  createWidget?: Maybe<Widget>;
  /** Perform Dataset Operations */
  datasetDataOperation?: Maybe<DatasetStateInfo>;
  /**
   * Delete an application
   * Example:
   * Request:
   * mutation {
   *   deleteApplication(
   *     id: "7e863365-94de-4ac9-8826-df1a398c9a21") {
   *     	id
   *     	message
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "deleteApplication": {
   *       "id": "7e863365-94de-4ac9-8826-df1a398c9a21",
   *       "message": null
   *     }
   *   }
   * }
   */
  deleteApplication?: Maybe<DeletePayload>;
  /** Delete an application role */
  deleteApplicationRole: DeletePayload;
  /**
   * Delete an asset
   * Example:
   * Request:
   * mutation {
   *   deleteAsset(
   *     id: "1570705980_w4ZLCPU7Dk") {
   *     	id
   *     	message
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "deleteAsset": {
   *       "id": "1570705980_w4ZLCPU7Dk",
   *       "message": "No storage objects deleted for example"
   *     }
   *   }
   * }
   */
  deleteAsset?: Maybe<DeletePayload>;
  deleteCluster?: Maybe<DeletePayload>;
  deleteClusterNode?: Maybe<DeletePayload>;
  deleteCognitiveSearch?: Maybe<DeletePayload>;
  /**
   * Delete Collection
   * Example:
   * Request:
   * mutation {
   *   deleteCollection(
   *     id: "242361") {
   *     	message
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "deleteCollection": {
   *       "message": "Deleted Successfully"
   *     }
   *   }
   * }
   */
  deleteCollection?: Maybe<DeletePayload>;
  /** Remove a mention from a collection */
  deleteCollectionMention?: Maybe<CollectionMention>;
  /**
   *   Delete a context menu extension
   *   Example:
   *   Request:
   *   mutation {
   *   deleteContextMenuExtension(input: {
   *     id: "cdf19d46-4d89-4b5b-a6bf-ae12c17f2746"}) {
   *     	message
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "deleteContextMenuExtension": {
   *       "message": null
   *     }
   *   }
   * }
   */
  deleteContextMenuExtension: DeletePayload;
  /**
   * Delete a creative
   * Example:
   * Request:
   * mutation {
   *   deleteCreative(
   *     id: "25208") {
   *     	message
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "deleteCreative": {
   *       "message": null
   *     }
   *   }
   * }
   */
  deleteCreative: DeletePayload;
  /**
   * Delete a custom dashboard
   * Example:
   * Request:
   * mutation {
   *   deleteCustomDashboard(
   *     id: "60141fc5-8d31-487d-9847-c47f990e4537") {
   *     	message
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "deleteCustomDashboard": {
   *       "message": "Custom dashboard deleted"
   *     }
   *   }
   * }
   */
  deleteCustomDashboard?: Maybe<DeletePayload>;
  /** delete a DAG template */
  deleteDagTemplate?: Maybe<DeletePayload>;
  /** Delete a Dataset */
  deleteDataset: DeleteDatasetPayload;
  /**
   * Delete an engine
   * Example:
   * Request:
   * mutation {
   *   deleteEngine(
   *     id: "123") {
   *     id
   *     message
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "deleteEngine": {
   *       "id": "123",
   *       "message": "engine 123 deleted"
   *     }
   *   }
   * }
   */
  deleteEngine?: Maybe<DeletePayload>;
  /**
   * Delete an engine build
   * Example:
   * Request:
   * mutation {
   *   deleteEngineBuild(input: {
   *     id: "6f766576-03a9-42c4-8a96-f4cd932e7c6c",
   *     engineId: "1"}) {
   *     	id
   *     	message
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "deleteEngineBuild": {
   *       "id": "6f766576-03a9-42c4-8a96-f4cd932e7c6c",
   *       "message": "Engine build 6f766576-03a9-42c4-8a96-f4cd932e7c6c deleted"
   *     }
   *   }
   * }
   */
  deleteEngineBuild?: Maybe<DeletePayload>;
  /**
   * Delete an entity. This mutation will also delete all associated
   * entity identifiers and associated objects.
   * Example:
   * Request:
   * mutation {
   *   deleteEntity(id: "522bc6cf-5b7c-47bd-bd30-10cd77016a49") {
   *     message
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "deleteEntity": {
   *       "message": "Entity 522bc6cf-5b7c-47bd-bd30-10cd77016a49 deleted."
   *     }
   *   }
   * }
   */
  deleteEntity?: Maybe<DeletePayload>;
  /**
   * Delete an entity identifier
   * Example:
   * Request:
   * mutation {
   *   deleteEntityIdentifier(id: "0bda9fa6-9fad-4025-8f03-07cc73321050") {
   *     	message
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "deleteEntityIdentifier": {
   *       "message": "Entity identifier0bda9fa6-9fad-4025-8f03-07cc73321050 deleted."
   *     }
   *   }
   * }
   */
  deleteEntityIdentifier?: Maybe<DeletePayload>;
  /**
   * Delete an event custom rule
   * Example:
   * Request:
   * mutation {
   *   deleteEventCustomRule(
   *     id: "0a0d3ec8-b4fb-48fc-bd39-c47a22b2173b") {
   *     	message
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "deleteEventCustomRule": {
   *       "message": "Deleted event custom rule"
   *     }
   *   }
   * }
   */
  deleteEventCustomRule: DeletePayload;
  deleteFlow?: Maybe<Engine>;
  deleteFlowTemplate?: Maybe<FlowTemplate>;
  /**
   * Delete a folder
   * Example:
   * Request:
   * mutation {
   *   deleteFolder(input: {
   *     id:"d551fbd6-7354-4b0e-abfb-654ab8583be2",
   *     orderIndex: 1}) {
   *     	message
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "deleteFolder": {
   *       "message": null
   *     }
   *   }
   * }
   */
  deleteFolder?: Maybe<DeletePayload>;
  /** Delete existing folder content template by folderContentTemplateId */
  deleteFolderContentTempate: DeletePayload;
  deleteFromEngineBlacklist?: Maybe<EngineBlacklist>;
  deleteFromEngineWhitelist?: Maybe<EngineWhitelist>;
  deleteJobTemplate?: Maybe<DeletePayload>;
  /**
   * Delete a library. This mutation will also delete all entities,
   * entity identifiers, library engine models, and associated objects.
   * Example:
   * Request:
   * mutation {
   *   deleteLibrary(id:"d232c90f-ae47-4125-b884-0d35fbed7e5f") {
   *     message
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "deleteLibrary": {
   *       "message": "d232c90f-ae47-4125-b884-0d35fbed7e5f deleted"
   *     }
   *   }
   * }
   */
  deleteLibrary?: Maybe<DeletePayload>;
  /**
   * Delete a library collaborator
   * Example:
   * Request:
   * mutation {
   *   deleteLibraryCollaborator(
   *     libraryId: "e0a6e5ad-dec8-49a1-ad33-3f1194c2e599",
   *   	organizationId: "35521") {
   *     	id
   *     	message
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "deleteLibraryCollaborator": {
   *       "id": "e0a6e5ad-dec8-49a1-ad33-3f1194c2e599 - 35521",
   *       "message": "library collaborator model libraryId: e0a6e5ad-dec8-49a1-ad33-3f1194c2e599, organizationId: 35521 deleted."
   *     }
   *   }
   * }
   */
  deleteLibraryCollaborator?: Maybe<DeletePayload>;
  /** Delete Dataset Library Configuration */
  deleteLibraryConfiguration?: Maybe<DeletePayload>;
  /**
   * Remove recordings from a dataset library
   * Example:
   * Request:
   * mutation {
   *   deleteLibraryDataset(input: {
   *     libraryId: "e0a6e5ad-dec8-49a1-ad33-3f1194c2e599",
   *     tdoIds: ["1570899328"]}) {
   *     	tdoIds
   *     	message
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "deleteLibraryDataset": {
   *       "tdoIds": [
   *         "1570899328"
   *       ],
   *       "message": "[1570899328] are removed from e0a6e5ad-dec8-49a1-ad33-3f1194c2e599"
   *     }
   *   }
   * }
   */
  deleteLibraryDataset?: Maybe<DeleteLibraryDatasetPayload>;
  /**
   * Delete a library engine model
   * Example:
   * Request:
   * mutation {
   *   deleteLibraryEngineModel(
   *     id: "0e9c25f7-d994-4363-af41-c00b37de9a1b") {
   *     	id
   *     	message
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "deleteLibraryEngineModel": {
   *       "id": "0e9c25f7-d994-4363-af41-c00b37de9a1b",
   *       "message": "library engine model 0e9c25f7-d994-4363-af41-c00b37de9a1b deleted."
   *     }
   *   }
   * }
   */
  deleteLibraryEngineModel?: Maybe<DeletePayload>;
  /** Delete a mention comment */
  deleteMentionComment?: Maybe<DeletePayload>;
  /** Delete a mention rating */
  deleteMentionRating?: Maybe<DeletePayload>;
  /** Delete OpenID Provider */
  deleteOpenIdProvider?: Maybe<DeletePayload>;
  /** Delete an integration config. Requires superadmin. */
  deleteOrganizationIntegrationConfig: DeleteIntegrationConfigPayload;
  /**
   * delete organization invitation
   * This deletion is hard-delete process. It will remove invitation completely from the database.
   */
  deleteOrganizationInvite?: Maybe<DeletePayload>;
  /**
   * Delete a processTemplate by ID in CMS
   * Example:
   * Request:
   * mutation {
   *   deleteProcessTemplate(
   *     id: "746") {
   *     message
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "deleteProcessTemplate": {
   *       "message": null
   *     }
   *   }
   * }
   */
  deleteProcessTemplate: DeletePayload;
  /**
   * Delete a saved search
   * Example:
   * Request:
   * mutation {
   *   deleteSavedSearch(
   *     id:"a29f2255-e509-4454-89ec-e425390ca4ca") {
   *     	message
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "deleteSavedSearch": {
   *       "message": null
   *     }
   *   }
   * }
   */
  deleteSavedSearch: DeletePayload;
  deleteScheduledJob?: Maybe<DeletePayload>;
  deleteScheduledJobContentTemplate?: Maybe<DeletePayload>;
  deleteSource?: Maybe<DeletePayload>;
  deleteSourceContentTemplate?: Maybe<DeletePayload>;
  deleteSourceType?: Maybe<DeletePayload>;
  /**
   * Delete a structured data object
   * Example:
   * Request:
   * mutation {
   *   deleteStructuredData(input:{
   *     id: "e180f94f-866e-4454-92f9-7ee20d6448fa",
   *     schemaId: "b79b7ff3-0b80-4d7c-ac51-d5f3459d13fa"}) {
   *     	message
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "deleteStructuredData": {
   *       "message": null
   *     }
   *   }
   * }
   */
  deleteStructuredData?: Maybe<DeletePayload>;
  /**
   * Delete a subscription
   * Example:
   * Request:
   * mutation {
   *   deleteSubscription(
   *     id: "274939") {
   *     	message
   *   }
   * }
   * Response:
   * mutation {
   *   deleteSubscription(
   *     id: "274939") {
   *     	message
   *   }
   * }
   */
  deleteSubscription?: Maybe<DeletePayload>;
  /**
   * Delete a temporal data object. The TDO metadata, its assets and
   * all storage objects, and search index data are deleted.
   * Engine results stored in related task objects are not.
   * cleanupTDO can be used to selectively delete certain data on the TDO.
   * Example:
   * Request:
   * mutation {
   *   deleteTDO(
   *     id: "1570654874") {
   *     id
   *     message
   *   }
   * }
   * Response:
   *   {
   *   "data": {
   *     "deleteTDO": {
   *       "id": "1570654874",
   *       "message": "TemporalDataObject 1570654874 and all associated asset content was deleted."
   *     }
   *   }
   * }
   */
  deleteTDO?: Maybe<DeletePayload>;
  deleteTaskTemplate?: Maybe<DeletePayload>;
  /**
   * Delete a registed trigger by ID.
   * Example:
   * Request:
   * mutation {
   *   deleteTrigger(
   *   id: "2936") {
   *     message
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "deleteTrigger": {
   *       "message": "Trigger 2936 has been removed from organization 35521"
   *     }
   *   }
   * }
   */
  deleteTrigger?: Maybe<DeletePayload>;
  /**
   * Delete a user
   * Example:
   * Request:
   * mutation {
   *   deleteUser(
   *     id: "267de7e1-efb2-444a-a524-210328b78503") {
   *     	message
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "deleteUser": {
   *       "message": null
   *     }
   *   }
   * }
   */
  deleteUser?: Maybe<DeletePayload>;
  /**
   * Delete the default user setting definition for application and org
   * Example:
   * Request:
   * mutation {
   *   deleteUserSettingDefinition(
   *     application: "80354999-d633-4595-9578-d82f59a5134f",
   *     key:"example") {
   *     	message
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "deleteUserSettingDefinition": {
   *       "message": "Application setting (application: 80354999-d633-4595-9578-d82f59a5134f, organizationGuid: 49a4cbbc-5e83-4c42-b9a3-be6ec0732f09, key: example) has been deleted"
   *     }
   *   }
   * }
   */
  deleteUserSettingDefinition: DeletePayload;
  /**
   * Delete a watchlist
   * Example:
   * Request:
   * mutation {
   *   deleteWatchlist(
   *     id:"325783") {
   *     	message
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "deleteWatchlist": {
   *       "message": "Watchlist deleted along with 0 subscriptions, 0 cognitive search profiles, 0 mention comments, and 0 mention ratings."
   *     }
   *   }
   * }
   */
  deleteWatchlist?: Maybe<DeletePayload>;
  deployFlowRevision?: Maybe<FlowRevision>;
  /** Disable Global OpenID Provider for Organization */
  disableOpenIdProviderForOrg?: Maybe<UpdatePayload>;
  /**
   * Creates an immutable audit log event with the given payload
   * Example:
   * Request:
   * mutation {
   *   emitAuditEvent(input: {
   *     application: ""
   *     payload: {
   *       example: "example"
   *     }}) {
   *     	id
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "emitAuditEvent": {
   *       "id": "fdc7b3a3-ab23-4866-a330-c0ad910cd64f"
   *     }
   *   }
   * }
   */
  emitAuditEvent: AuditEvent;
  /**
   * Emit an event
   * Example:
   * Request:
   * mutation {
   *   emitEvent(input: {
   *     eventName: "example",
   *     eventType: "example",
   *     application: "",
   *     payload: ""}) {
   *     	id
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "emitEvent": {
   *       "id": "0952fe68-5652-4804-857d-26e21ef3d7e8"
   *     }
   *   }
   * }
   */
  emitEvent: EmitEventResponse;
  /**
   * Emit a system-level emit. This mutation is used only by
   * Veritone platform components.
   */
  emitSystemEvent: SystemEventInfo;
  /** Enable Global OpenID Provider for Organization */
  enableOpenIdProviderForOrg?: Maybe<UpdatePayload>;
  /** Apply an engine workflow step, such as "submit" or "approve" */
  engineWorkflow?: Maybe<Engine>;
  /**
   * Refresh a user token, returning a fresh token so that the client
   * can continue to authenticate to the API.\
   * Example:
   * Request:
   * mutation {
   *   extendToken(
   *     token: "32abe146-4e07-4f5e-8e1e-f7f2e0142cf7") {
   *     	hasPassword
   *     	user{id}
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "extendToken": {
   *       "hasPassword": true,
   *       "user": {
   *         "id": "d8304ba1-0d4c-4268-a82c-8c62fd455066"
   *       }
   *     }
   *   }
   * }
   */
  extendToken?: Maybe<LoginInfo>;
  /**
   * Bulk delete context menu extensions.
   * Example:
   * Request:
   * mutation {
   *   bulkDeleteContextMenuExtensions(input: {
   *     ids: []}) {
   *     	mentions{
   *         id
   *       }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "bulkDeleteContextMenuExtensions": {
   *       "mentions": []
   *     }
   *   }
   * }
   */
  fileApplication?: Maybe<Application>;
  /**
   * File a TemporalDataObject in a folder. A given TemporalDataObject can
   * be filed in any number of folders, or none. Filing causes the TemporalDataObject
   * and its assets to be visible within the folder.
   * Example:
   * Request:
   * mutation {
   *   fileTemporalDataObject(input:{
   *     tdoId: "1580388995",
   *     folderId: "9d639f1b-a0d4-47b0-8149-3568f048f320"}) {
   *     	id
   *     	folders{
   *         id
   *       }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "fileTemporalDataObject": {
   *       "id": "1580388995",
   *       "folders": [
   *         {
   *           "id": "9d639f1b-a0d4-47b0-8149-3568f048f320"
   *         }
   *       ]
   *     }
   *   }
   * }
   */
  fileTemporalDataObject?: Maybe<TemporalDataObject>;
  fileWatchlist?: Maybe<Watchlist>;
  /** Get Organization scoped application JWT token */
  getApplicationJWT?: Maybe<ApplicationJwtTokenInfo>;
  /**
   * Get password token info for current user
   * Example:
   * Request:
   * mutation {
   *   getCurrentUserPasswordToken(input: {
   *     password: "Example password"}) {
   *     	passwordToken
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "getCurrentUserPasswordToken": {
   *       "passwordToken": "e4cb86c7-34a4-4a52-b458-3ebbb2cca9c3"
   *     }
   *   }
   * }
   */
  getCurrentUserPasswordToken: PasswordTokenInfo;
  /**
   * JWT tokens with a more limited scoped token to specific
   * resources to the recording, task, and job
   * and also has no organization association.
   * Example:
   * Request:
   * mutation {
   *   getEngineJWT(input: {
   *     engineId: "1",
   *     resource:{
   *       tdoId: "1580701928"
   *     }}) {
   *    	token
   *   }
   * }
   *   Response:
   * {
   *   "data": {
   *     "getEngineJWT": {
   *       "token": "eyJh...Tw_z3BKRA"
   *     }
   *   }
   * }
   */
  getEngineJWT: JwtTokenInfo;
  /** Creates one or more jobs based on the supplied job templates. */
  launchJobTemplates?: Maybe<Array<Maybe<Job>>>;
  /** Creates one or more jobs based on the supplied scheduled job. */
  launchScheduledJobs?: Maybe<Array<Maybe<Job>>>;
  /**
   * Create and launch a job executing a single engine,
   * using the default engine DAG definition modified with the
   * supplied field values
   */
  launchSingleEngineJob?: Maybe<Job>;
  /**
   * Mark all notification as read for mailboxIds
   * Example:
   * Request:
   * mutation {
   *   markAllNotificationsRead(
   *     mailboxIds: ["0415f525-813d-4fd4-9dea-9428382b05b9"]) {
   *     	id
   *   }
   * }
   * Response:
   * "data": {
   *   "markAllNotificationsRead": {
   *       "id": "0415f525-813d-4fd4-9dea-9428382b05b9",
   *       "notifications": {
   *         "records": {
   *             "flags": [
   *               "unseen",
   *               "read"
   *             ]
   *           }
   *       }
   *   }
   * }
   */
  markAllNotificationsRead?: Maybe<Array<Maybe<NotificationMailbox>>>;
  /**
   * Mark all notification as read for mailboxIds
   * Example:
   * Request:
   * mutation {
   *   markAllNotificationsSeen(
   *     mailboxIds: ["0415f525-813d-4fd4-9dea-9428382b05b9"]) {
   *     	id
   *     	notifications{
   *         records{
   *           flags
   *         }
   *       }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "markAllNotificationsSeen":
   *       {
   *         "id": "0415f525-813d-4fd4-9dea-9428382b05b9",
   *         "notifications": {
   *           "records":
   *             {
   *               "flags": [
   *                 "read",
   *                 "seen"
   *               ]
   *             }
   *             }
   *         }
   *       }
   *   }
   * }
   */
  markAllNotificationsSeen?: Maybe<Array<Maybe<NotificationMailbox>>>;
  /**
   * Move a folder from one parent folder to another.
   * Example:
   * Request:
   * mutation {
   *   moveFolder(input: {
   *     treeObjectId: "68a5833a-f573-41fe-840a-adb5f6888e2d",
   *     prevParentTreeObjectId: "3104f61f-4bd1-4175-9fe6-27436d591c54",
   *     newParentTreeObjectId: "ad7839a7-d088-4202-9db1-5ed4992f915d",
   *     prevOrderIndex: 1,
   *     newOrderIndex: 1}) {
   *     	id
   *     	name
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "moveFolder": {
   *       "id": "d551fbd6-7354-4b0e-abfb-654ab8583be2",
   *       "name": "new name"
   *     }
   *   }
   * }
   */
  moveFolder?: Maybe<Folder>;
  /**
   * Moves a TemporalDataObject from one parent folder to another.
   * Any other folders the TemporalDataObject is filed in are unaffected.
   * Example:
   * Request:
   * mutation {
   *   moveTemporalDataObject(input: {
   *     tdoId: "1580388995",
   *     oldFolderId: "9d639f1b-a0d4-47b0-8149-3568f048f320",
   *     newFolderId: "2ac28573-917a-4c4b-be91-a0ac64cbc982"}) {
   *     	id
   *     	folders{
   *         folderPath{id}
   *       }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "moveTemporalDataObject": {
   *       "id": "1580388995",
   *       "folders": [
   *         {
   *           "folderPath": [
   *             {
   *               "id": "2ac28573-917a-4c4b-be91-a0ac64cbc982"
   *             }
   *           ]
   *         }
   *       ]
   *     }
   *   }
   * }
   */
  moveTemporalDataObject?: Maybe<TemporalDataObject>;
  /**
   * Create a custom notification mailbox
   * Example:
   * Request:
   * mutation {
   *   notificationMailboxCreate(input: {
   *     name: "example",
   *     eventFilter: {
   *     	eventNames: "example",
   *    		eventType: "example",,
   *     	delivery: {
   *       	params: {
   *         	example: "example params"
   *       	}
   *     	}
   *     },
   *     notificationTemplate: "",
   *     limit: 10}) {
   *     	id
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "notificationMailboxCreate": [
   *       {
   *         "id": "0415f525-813d-4fd4-9dea-9428382b05b9"
   *   }
   * }     }
   */
  notificationMailboxCreate?: Maybe<NotificationMailbox>;
  /**
   * Delete a notification mailbox
   * Example:
   * Request:
   * mutation {
   *   notificationMailboxDelete(id:"0415f525-813d-4fd4-9dea-9428382b05b9") {
   *     message
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "notificationMailboxDelete": {
   *       "message": "Notification mailbox has been removed"
   *     }
   *   }
   * }
   */
  notificationMailboxDelete: DeletePayload;
  /**
   * Pause a notification mailbox
   * Example:
   * Request:
   * mutation {
   *   notificationMailboxPause(
   *     id: "0415f525-813d-4fd4-9dea-9428382b05b9") {
   *     	id
   *     	paused
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "notificationMailboxPause": {
   *       "id": "0415f525-813d-4fd4-9dea-9428382b05b9",
   *       "paused": true
   *     }
   *   }
   * }
   */
  notificationMailboxPause?: Maybe<NotificationMailbox>;
  /**
   * Unpause/resume a notification mailbox
   * Example:
   * Request:
   * mutation {
   *   notificationMailboxUnpause(
   *     id: "0415f525-813d-4fd4-9dea-9428382b05b9") {
   *     	id
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "notificationMailboxUnpause": {
   *       "id": "0415f525-813d-4fd4-9dea-9428382b05b9"
   *     }
   *   }
   * }
   */
  notificationMailboxUnpause?: Maybe<NotificationMailbox>;
  /**
   * Post a notification to some mailboxes
   * Example:
   * Request:
   * mutation {
   *   notificationPost(input: {
   *     mailboxIds: ["0415f525-813d-4fd4-9dea-9428382b05b9"],
   *     title: "example title",
   *     body: "example body",
   *     contentType: "type",
   *     flags: unread}) {
   *     	id
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "notificationPost": {
   *       "id": "iDDfG3oB3LnZSYqhRv7-"
   *     }
   *   }
   * }
   */
  notificationPost?: Maybe<Notification>;
  /** Create a package */
  packageCreate?: Maybe<Package>;
  /** Delete a package */
  packageDelete?: Maybe<PackageDeleteResult>;
  /** Update a package */
  packageUpdate?: Maybe<Package>;
  /** Add or remove Grants to a package and organization */
  packageUpdateGrants?: Maybe<Package>;
  /** Add Resources to a package */
  packageUpdateResources?: Maybe<Package>;
  /** Pairs a node with a cluster. */
  pairClusterNode?: Maybe<ClusterNode>;
  pauseCluster?: Maybe<Cluster>;
  /** Pause for a node */
  pauseClusterNode?: Maybe<ClusterNode>;
  pauseFlow?: Maybe<Engine>;
  /** Pings the server to update the node's last ping. */
  pingClusterNode?: Maybe<ClusterNode>;
  /**
   * Publish a new version of a library.
   * Increments library version by one and trains compatible engines.
   * Example:
   * Request:
   * mutation {
   *   publishLibrary(
   *     id: "e0a6e5ad-dec8-49a1-ad33-3f1194c2e599") {
   *     	name
   *     	description
   *     	version
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "publishLibrary": {
   *       "name": "example",
   *       "description": "new description",
   *       "version": 2
   *     }
   *   }
   * }
   */
  publishLibrary?: Maybe<Library>;
  /**
   * Refreshes the session user from database to reflect the latest changes. It does not extend session timeout.\
   * Example:
   * Request:
   * mutation {
   *   refreshToken(
   *     token: "32abe146-4e07-4f5e-8e1e-f7f2e0142cf7") {
   *     	hasPassword
   *     	user{id}
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "refreshToken": {
   *       "hasPassword": true,
   *       "user": {
   *         "id": "d8304ba1-0d4c-4268-a82c-8c62fd455066"
   *       }
   *     }
   *   }
   * }
   */
  refreshToken?: Maybe<LoginInfo>;
  /** Remove ACE from ACL.  The ACE Ids specified must be for same object type */
  removeACEsFromResource: AuthAcl;
  /** Remove an application event endpoint */
  removeApplicationEventEndpoint?: Maybe<DeletePayload>;
  /** remove a DAG template from organization */
  removeDagTemplateFromOrganization: DagTemplateOrganizations;
  /**
   * Remove a notification action by id
   * Example
   * Request:
   * mutation {
   *   removeNotificationAction(
   *     id:"27dab45b-d825-4f20-b758-4b089d610903") {
   *     	message
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "removeNotificationAction": {
   *       "message": "Notification Action has been removed"
   *     }
   *   }
   * }
   */
  removeNotificationAction: DeletePayload;
  /**
   * Remove a notification template by id
   * Example:
   * Request:
   * mutation {
   *   removeNotificationTemplate(id: "1dbf3d28-bc7a-434f-ba65-455da0169323") {
   *     message
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "removeNotificationTemplate": {
   *       "message": "Notification Template has been removed"
   *     }
   *   }
   * }
   */
  removeNotificationTemplate: DeletePayload;
  /**
   * Remove an engine replacement
   * Example:
   * Request:
   * mutation {
   *   removeTaskReplacementEngine(input: {
   *     sourceEngineId: "1",
   *   	replacementEngineId: "2",
   *   	organizationId: "35521"}) {
   *     	message
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "removeTaskReplacementEngine": {
   *       "message": "Engine replacement has been removed"
   *     }
   *   }
   * }
   */
  removeTaskReplacementEngine?: Maybe<DeletePayload>;
  /**
   * Remove an existing user for organization.
   * One of the user identifiers (userId or userName) has to be specified.
   * The operation fails if the organization is the last one to which user belongs.
   */
  removeUserFromOrganization?: Maybe<User>;
  /**
   * Mark existing saved search profile as deleted
   * Create new saved search profile
   * Example:
   * Request:
   * mutation {
   *   replaceSavedSearch(input: {
   *     id: "3d4f04c5-7855-4b9c-ba65-9bd6c2932a7e",
   *     name: "example",
   *     csp: {
   *       example: "new csp"}}) {
   *     		id
   *   }
   * }
   * Response:
   * mutation {
   *   replaceSavedSearch(input: {
   *     id: "3d4f04c5-7855-4b9c-ba65-9bd6c2932a7e",
   *     name: "example",
   *     csp: {
   *       example: "new csp"}}) {
   *     		id
   *   }
   * }
   */
  replaceSavedSearch: SavedSearch;
  /**
   * Start a clone job. A clone creates a new TDO
   * that links back to an existing TDO's assets
   * instead of creating new ones and is used
   * primarily to handle sample media.
   * Only for internal platform components.
   * Example:
   * Request:
   * mutation {
   *   requestClone(input: {
   *     sourceApplicationId: "47bd3e25-f4ea-435f-b69b-13cb4f9dd60a",
   *     destinationApplicationId:"5908703b-51b4-4291-9787-b54bada73b0a",
   *   cloneBlobs: true}) {
   *     	id
   *     	status
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "requestClone": null
   *   }
   * }
   */
  requestClone?: Maybe<CloneRequest>;
  /**
   * Retry a job. This action applies only to jobs
   * that are in a failure state. The task sequence
   * for the job will be restarted in its original
   * configuration.
   */
  retryJob?: Maybe<Job>;
  revertScheduledJob: ScheduledJob;
  /**
   * Send a basic email. Mutation returns true for a success message.
   * The email from field will be automatically set the default platform email address
   * Example:
   * Request:
   * mutation {
   *   sendEmail(input: {
   *   	to: "example@veritone.com"
   *   	subject: "example"
   *   	message: "email body"
   *   	replyTo: "example@veritone.com"
   *   })
   * }
   * Response:
   * {
   *   "data": {
   *     "sendEmail": true
   *   }
   * }
   */
  sendEmail: Scalars['Boolean'];
  /**
   * Set and unset the notification flags
   * Example:
   * Request:
   * mutation {
   *   setNotificationFlag(input: {
   *     notificationId: "iDDfG3oB3LnZSYqhRv7-",
   *     setFlags: read}) {
   *     	id
   *     	flags
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "setNotificationFlag": {
   *       "id": "iDDfG3oB3LnZSYqhRv7-",
   *       "flags": [
   *         "unread",
   *         "read"
   *       ]
   *     }
   *   }
   * }
   */
  setNotificationFlag?: Maybe<Notification>;
  /**
   * Add or update an organization integration config by
   * organization id and integration id. Requires superadmin.
   */
  setOrganizationIntegrationConfig: IntegrationConfig;
  setUserDefaultOrganization?: Maybe<OrganizationInfo>;
  /** Create or Update Workflow data. */
  setWorkflowRuntimeStorageData: WorkflowRuntimeStorageData;
  /**
   * Share a collection, allowing other organizations to view the data
   * it contains.
   * Example:
   * Request:
   * mutation {
   *   shareCollection(input: {
   *     folderId: "242599",
   *     shareMessage: "example",
   *     recipients: [] }) {
   *     	id
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "shareCollection": {
   *       "id": "FhQrlAwfRMaTy0blR_eHRw"
   *     }
   *   }
   * }
   */
  shareCollection?: Maybe<Share>;
  /**
   * Share a folder with other organizations
   * Requires superadmin
   */
  shareFolder?: Maybe<Folder>;
  /** Share mention */
  shareMention?: Maybe<Share>;
  /** Share a mention from a collection */
  shareMentionFromCollection?: Maybe<Share>;
  /** Share mentions in bulk */
  shareMentionInBulk?: Maybe<Array<Maybe<Share>>>;
  /** Start a Veritone Workflow instance */
  startWorkflowRuntime: WorkflowRuntimeResponse;
  /** Shutdown Veritone Workflow instance */
  stopWorkflowRuntime: WorkflowRuntimeResponse;
  /**
   * Subscribe to an event
   * Example:
   * Request:
   * mutation {
   *   subscribeEvent(input: {
   *     eventName: "example",
   *     eventType: "example",
   *     application: "",
   *     delivery: {
   *       name: CreateJob,
   *       params: {
   *         targetId: "1580701928"
   *   			engineId: "1"
   *       }
   *     }
   *   })
   * }
   * Response:
   * {
   *   "data": {
   *     "subscribeEvent": "a0d04eeb-c32d-4852-9273-bb0acda970b9"
   *   }
   * }
   */
  subscribeEvent: Scalars['ID'];
  /** #Switch user to organization */
  switchUserToOrganization?: Maybe<LoginInfo>;
  unfileApplication?: Maybe<Application>;
  /**
   * Unfile a TemporalDataObject from a folder. This causes the TemporalDataObject
   * and its assets to disappear from the folder, but does not otherwise affect
   * either the TDO or the folder and does not change access controls.
   * Example:
   * Request:
   * mutation {
   *   unfileTemporalDataObject(input: {
   *     tdoId: "1580388995",
   *     folderId: "9d639f1b-a0d4-47b0-8149-3568f048f320"}) {
   *     	id
   *     	description
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "unfileTemporalDataObject": {
   *       "id": "1580388995",
   *       "description": null
   *     }
   *   }
   * }
   */
  unfileTemporalDataObject?: Maybe<TemporalDataObject>;
  /**
   * Unfile a watchlist from a folder
   * Example:
   * Request:
   * mutation {
   *   unfileWatchlist(input: {
   *    watchlistId:"325786",
   *     folderId: "9d639f1b-a0d4-47b0-8149-3568f048f320"}) {
   *     	id
   *     	folders{
   *         folderPath{
   *           id
   *         }
   *       }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "unfileWatchlist": {
   *       "id": "325786",
   *       "folders": []
   *     }
   *   }
   * }
   */
  unfileWatchlist?: Maybe<Watchlist>;
  /** Unpairs a node with a cluster. */
  unpairClusterNode?: Maybe<ClusterNode>;
  unpauseCluster?: Maybe<Cluster>;
  /** Unpause for a node */
  unpauseClusterNode?: Maybe<ClusterNode>;
  unpauseFlow?: Maybe<Engine>;
  /**
   * Unsubscribe to an event
   * Example:
   * Request:
   * mutation {
   *   unsubscribeEvent(
   *     id: "a0d04eeb-c32d-4852-9273-bb0acda970b9") {
   *     	id
   *     	message
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "unsubscribeEvent": {
   *       "id": "a0d04eeb-c32d-4852-9273-bb0acda970b9",
   *       "message": "Unsubscribed from event"
   *     }
   *   }
   * }
   */
  unsubscribeEvent: UnsubscribeEvent;
  /**
   * Update a custom application. Applications are subject to
   * specific workflows. The current application state determines
   * what updates can be made to it. See VDA documentation for details.
   * Example:
   * Request:
   * mutation {
   *   updateApplication(input: {
   *     name: "example123",
   *     id: "7e863365-94de-4ac9-8826-df1a398c9a21"
   *     category: "example",
   *     url: "www.veritone.com",
   *     checkPermissions: true,
   *     oauth2RedirectUrls: [],
   *     permissionsRequired: []}) {
   *     	id
   *     	name
   *     	url
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "updateApplication": {
   *       "id": "7e863365-94de-4ac9-8826-df1a398c9a21",
   *       "name": "example123",
   *       "url": "www.veritone.com"
   *     }
   *   }
   * }
   */
  updateApplication?: Maybe<Application>;
  /**
   * Update an application's billing dirty for an organization.
   * Example:
   * Request:
   * mutation {
   *   updateApplicationBillingDirty(
   *     applicationId: "32babe30-fb42-11e4-89bc-27b69865858a",
   *     organizationId: "35521",
   *     billingDirty: false) {
   *     	applicationId
   *     	billingDirty
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "updateApplicationBillingDirty": {
   *       "applicationId": "32babe30-fb42-11e4-89bc-27b69865858a",
   *       "billingDirty": false
   *     }
   *   }
   * }
   */
  updateApplicationBillingDirty: ApplicationBillingDirty;
  /**
   * Update an application's billing plan id for an organization.
   * Example:
   * Request:
   * mutation {
   *   updateApplicationBillingPlanId(
   *   	applicationId:"32babe30-fb42-11e4-89bc-27b69865858a",
   *     organizationId: "35521",
   *     billingPlanId: "123") {
   *     	applicationId
   *     	billingDirty
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "updateApplicationBillingPlanId": {
   *       "applicationId": "32babe30-fb42-11e4-89bc-27b69865858a",
   *       "billingDirty": true
   *     }
   *   }
   * }
   */
  updateApplicationBillingPlanId: ApplicationBillingPlanId;
  /**
   * Update an application by adding or removing components
   * Example:
   * Request:
   * mutation {
   *   updateApplicationComponent(input: {
   *     id: "5908703b-51b4-4291-9787-b54bada73b0a",
   *     componentIds: ["1"],
   *     type: engines,
   *     action: add}) {
   *     	engines{
   *         records{
   *           id
   *         }
   *       }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "updateApplicationComponent": {
   *       "engines": {
   *         "records": [
   *           {
   *             "id": "1"
   *           }
   *         ]
   *       }
   *     }
   *   }
   * }
   */
  updateApplicationComponent: ApplicationComponent;
  /** Update event endpoint for an application */
  updateApplicationEventEndpoint?: Maybe<Application>;
  /** This updates headerbar information for an application/organization */
  updateApplicationHeaderbar?: Maybe<ApplicationHeaderbar>;
  /** Update a specified application role */
  updateApplicationRole: ApplicationRole;
  /**
   * Update an asset
   * Example:
   * Request:
   * mutation {
   *  updateAsset(input: {
   *    id: "1570705980_w4ZLCPU7Dk",
   *    description: "example",
   *    name: "example",
   *    fileData: null,
   *    sourceData: null,
   *    details: null}) {
   *    id
   *    name
   *    contentType
   *  }
   * }
   * Result:
   * {
   *   "data": {
   *     "updateAsset": {
   *       "id": "1570705980_w4ZLCPU7Dk",
   *       "name": "example",
   *       "contentType": "application/json"
   *     }
   *   }
   * }
   */
  updateAsset?: Maybe<Asset>;
  updateCluster?: Maybe<Cluster>;
  updateClusterNode?: Maybe<ClusterNode>;
  /** Update the cluster's runtime state. Used only by infrastructure elements. */
  updateClusterState?: Maybe<Cluster>;
  updateCognitiveSearch?: Maybe<CognitiveSearch>;
  /**
   * Update a collection
   * Example:
   * Request:
   * mutation {
   *   updateCollection(input: {
   *     folderId: "242361"
   *   	name: "new name"
   *   	folderDescription: "new description"}) {
   *     	id
   *     	name
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "updateCollection": {
   *       "id": "242361",
   *       "name": "new name"
   *     }
   *   }
   * }
   */
  updateCollection?: Maybe<Collection>;
  /** Update a mention in a collection */
  updateCollectionMention: CollectionMention;
  /**
   * Update a context menu extension
   * Example:
   * Request:
   *   mutation {
   *   updateContextMenuExtension(input: {
   *     id: "cdf19d46-4d89-4b5b-a6bf-ae12c17f2746",
   *     label: "new label",
   *   	url: "www.veritone.com"}) {
   *     	label
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "updateContextMenuExtension": {
   *       "label": "new label"
   *     }
   *   }
   * }
   */
  updateContextMenuExtension: ContextMenuExtension;
  /**
   * Update a creative
   * Example:
   * Request:
   * mutation {
   *   updateCreative(input: {
   *     id: "25208",
   *     name: "example",
   *   	keywords: "new keywords",
   *   	brandId: null,
   *   	advertiserId: null}) {
   *     	id
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "updateCreative": {
   *       "id": "25208"
   *     }
   *   }
   * }
   */
  updateCreative: Creative;
  /**
   * Update the current authenticated user
   * Example:
   * Request:
   * mutation {
   *   updateCurrentUser(input: {
   *     title: "undefined"}) {
   *     	id
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "updateCurrentUser": {
   *       "id": "59cb4e74-7c31-4267-b91e-d4600bc08008"
   *     }
   *   }
   * }
   */
  updateCurrentUser: User;
  /**
   * Update a custom dashboard
   * Example:
   * Request:
   * mutation {
   *   updateCustomDashboard(input: {
   *     id: "60141fc5-8d31-487d-9847-c47f990e4537",
   *     name: "new name"}) {
   *     	name
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "updateCustomDashboard": {
   *       "name": "new name"
   *     }
   *   }
   * }
   */
  updateCustomDashboard?: Maybe<CustomDashboard>;
  /** Update a DAG template */
  updateDagTemplate: DagTemplate;
  /**
   * Update a structured data registry schema metadata.
   * Example:
   * Request:
   * mutation {
   *   updateDataRegistry(input: {
   *     id: "230f95e4-95c9-47c4-a845-61ca67ad6ba6"
   *   	name: "example"
   *   	description: "example"
   *   	source: "new source"}) {
   *     	id
   *     	source
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "updateDataRegistry": {
   *       "id": "230f95e4-95c9-47c4-a845-61ca67ad6ba6",
   *       "source": "new source"
   *     }
   *   }
   * }
   */
  updateDataRegistry?: Maybe<DataRegistry>;
  /** Update a Dataset */
  updateDataset?: Maybe<Dataset>;
  /**
   * Update an engine. Engines are subject to specific
   * workflow steps. An engine's state determines what
   * updates can be made to it. See VDA documentation for
   * details.
   * Example:
   * Request:
   * mutation {
   *   updateEngine(input: {
   *     id:"123",
   *     isPublic: false,
   *     name: "example",
   *     deploymentModel: FullyNetworkIsolated,
   *     price: 1}) {
   *     id
   *     ownerOrganizationId
   *     name
   *     price
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "updateEngine": {
   *       "id": "123",
   *       "ownerOrganizationId": "35521",
   *       "name": "example",
   *       "price": 1
   *     }
   *  }
   * }
   */
  updateEngine?: Maybe<Engine>;
  /**
   * Update an engine build. Engine builds are subject to
   * specific workflow steps. A build's state determines what
   * updates can be made to it. See VDA documentation for details.
   * Example:
   * Request:
   * mutation {
   *   updateEngineBuild(input: {
   *   	id: "6f766576-03a9-42c4-8a96-f4cd932e7c6c",
   *     engineId: "1",
   *     action: update,
   *     taskRuntime: []}) {
   *       id
   *       name
   *     }
   *     releaseNotes: "Includes feature x..."
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "updateEngineBuild": {
   *       "id": "6f766576-03a9-42c4-8a96-f4cd932e7c6c",
   *       "name": "example Version 3"
   *       "releaseNotes": "Includes feature x..."
   *     }
   *   }
   * }
   */
  updateEngineBuild?: Maybe<Build>;
  /**
   * Update an entity.
   * Example:
   * Request:
   * mutation {
   *   updateEntity(input: {
   *   	id: "85b700fa-f327-4fea-b94b-ed83054170db",
   *     name: "example",
   *     description: "example",
   *     jsondata: {
   *       example: "updated example" }}) {
   *     		id
   *     		name
   *     		jsondata
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "updateEntity": {
   *       "id": "85b700fa-f327-4fea-b94b-ed83054170db",
   *       "name": "example",
   *       "jsondata": {
   *         "example": "updated example"
   *       }
   *     }
   *   }
   * }
   */
  updateEntity?: Maybe<Entity>;
  /**
   * Updates an entity identifier.
   * Example:
   * Request:
   * mutation {
   *   updateEntityIdentifier(input: {
   *     id: "bf67e595-3666-4a0c-9f4b-0ad99a1770fe",
   *     title: "example",
   *   	isPriority: true,
   *   	url: "https://edit.co.uk/uploads/2016/12/Image-1-Alternatives-to-stock-photography-Thinkstock.jpg"}) {
   *     		id
   *     		isPriority
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "updateEntityIdentifier": {
   *       "id": "bf67e595-3666-4a0c-9f4b-0ad99a1770fe",
   *       "isPriority": true
   *     }
   *   }
   * }
   */
  updateEntityIdentifier?: Maybe<EntityIdentifier>;
  /**
   * Update an entity identifier type.
   * Example:
   * Request:
   * mutation {
   *   updateEntityIdentifierType(input: {
   *     id: "123",
   *     label: "example",
   *     labelPlural: "example"
   *     description: "new description",
   *   	dataType: image}) {
   *     	id
   *     	description
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "updateEntityIdentifierType": null
   *   }
   * }
   */
  updateEntityIdentifierType?: Maybe<EntityIdentifierType>;
  /**
   * Update an event
   * Example:
   * Request:
   * mutation {
   *   updateEvent(input: {
   *     id: "55fc7c51-1521-4043-902f-f0f3a357da6d",
   *     description: "new example description"}) {
   *     	id
   *     	description
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "updateEvent": {
   *       "id": "55fc7c51-1521-4043-902f-f0f3a357da6d",
   *       "description": "new example description"
   *     }
   *   }
   * }
   */
  updateEvent: Event;
  /**
   * Update an event trigger template
   * Example:
   * Request:
   * mutation {
   *   updateEventActionTemplate(input: {
   *     id: "d02522d7-ef5f-448f-981a-d2cfc7603d92",
   *     name: "example",
   *     actionValidation: {
   *       example: "new validation"}}) {
   *     id
   *     actionValidation
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "updateEventActionTemplate": {
   *       "id": "d02522d7-ef5f-448f-981a-d2cfc7603d92",
   *       "actionValidation": {
   *         "example": "new validation"
   *       }
   *     }
   *   }
   * }
   */
  updateEventActionTemplate: EventActionTemplate;
  /**
   * Update an event custom rule
   * Example:
   * Request:
   *   mutation {
   *   updateEventCustomRule(input: {
   *     id: "0a0d3ec8-b4fb-48fc-bd39-c47a22b2173b",
   *     name: "example",
   *     status: inactive,
   *     description: "new description"}) {
   *     	id
   *     	description
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "updateEventCustomRule": {
   *       "id": "0a0d3ec8-b4fb-48fc-bd39-c47a22b2173b",
   *       "description": "new description"
   *     }
   *   }
   * }
   */
  updateEventCustomRule: EventCustomRule;
  /**
   * Update an export request
   * Example:
   * Request:
   * mutation {
   *   updateExportRequest(input: {
   *     id: "938b2d64-6df1-486b-b6ea-29d33dee49ad",
   *     status: complete}) {
   *     	id
   *     	status
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "updateExportRequest": {
   *       "id": "938b2d64-6df1-486b-b6ea-29d33dee49ad",
   *       "status": "complete"
   *     }
   *   }
   * }
   */
  updateExportRequest: ExportRequest;
  updateFlow?: Maybe<Engine>;
  updateFlowExecution?: Maybe<FlowExecution>;
  updateFlowRevision?: Maybe<FlowRevision>;
  updateFlowRevisionHead?: Maybe<FlowRevision>;
  updateFlowTemplate?: Maybe<FlowTemplate>;
  /**
   * Update an existing folder
   * Example:
   * Request:
   * mutation {
   *   updateFolder(input: {
   *     id: "d551fbd6-7354-4b0e-abfb-654ab8583be2",
   *     name: "new name"}) {
   *     	name
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "updateFolder": {
   *       "name": "new name"
   *     }
   *   }
   * }
   */
  updateFolder?: Maybe<Folder>;
  /** Update existing content template by folderContentTemplateId */
  updateFolderContentTempate: FolderContentTemplate;
  updateJobTemplate: JobTemplate;
  updateJobs?: Maybe<JobList>;
  /**
   * Update an existing library.
   * Example:
   * Request:
   * mutation {
   *   updateLibrary(input: {
   *     	id: "e0a6e5ad-dec8-49a1-ad33-3f1194c2e599",
   *   	name: "example"
   *   	coverImageUrl: "https://edit.co.uk/uploads/2016/12/Image-1-Alternatives-to-stock-photography-Thinkstock.jpg"
   *   	description: "new description"
   *   	libraryTypeId: "123"
   *   	version: 2}) {
   *     	id
   *     	name
   *     	description
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "updateLibrary": {
   *       "id": "e0a6e5ad-dec8-49a1-ad33-3f1194c2e599",
   *       "name": "example",
   *       "description": "new description"
   *     }
   *   }
   * }
   */
  updateLibrary?: Maybe<Library>;
  /**
   * Update a library collaborator
   * Example:
   * Request:
   * mutation {
   *   updateLibraryCollaborator(input: {
   *     libraryId: "e0a6e5ad-dec8-49a1-ad33-3f1194c2e599",
   *     organizationId: 35521,
   *     permissions: ["job.create", "job.read"]}) {
   *    		 status
   *     	 permissions
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "updateLibraryCollaborator": {
   *       "status": "active",
   *       "permissions": [
   *         "job.create"
   *       ]
   *     }
   *   }
   * }
   */
  updateLibraryCollaborator?: Maybe<LibraryCollaborator>;
  /** Update Dataset Library Configuration */
  updateLibraryConfiguration?: Maybe<LibraryConfiguration>;
  /**
   * Update a library engine model
   * Example:
   * Request:
   * mutation {
   *   updateLibraryEngineModel(input: {
   *     id: "0e9c25f7-d994-4363-af41-c00b37de9a1b",
   *     trainJobId: "1234"}) {
   *     	trainJobId
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "updateLibraryEngineModel": {
   *       "trainJobId": "1234"
   *     }
   *   }
   * }
   */
  updateLibraryEngineModel?: Maybe<LibraryEngineModel>;
  /**
   * Update a library type.
   * Example:
   * Request:
   * mutation {
   *   updateLibraryType(input: {
   *     id: "123",
   *     label: "example",
   *     entityIdentifierTypeIds: ["123"],
   *     entityType: {
   *       name: "example",
   *       namePlural: "example",
   *       schema: {
   *       example: "new example" }}}) {
   *     		id
   *     		label
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "updateLibraryType": null
   *   }
   * }
   */
  updateLibraryType?: Maybe<LibraryType>;
  /** Update a mention object */
  updateMention?: Maybe<Mention>;
  /** Update a mention comment */
  updateMentionComment?: Maybe<MentionComment>;
  /**
   * Update status or assetURI of a mentionExportRequest
   * Often use when the file export was completed or downloaded
   * Example:
   * Request:
   * mutation {
   *   updateMentionExportRequest(input: {
   *     id: "400c98c2-faa8-44e4-b5d8-daf2fb43445e"
   *     status: incomplete,
   *     assetUri: "www.veritone.com",
   *   	sqlQueries:""}) {
   *     	id
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "updateMentionExportRequest": {
   *       "id": "400c98c2-faa8-44e4-b5d8-daf2fb43445e"
   *     }
   *   }
   * }
   */
  updateMentionExportRequest: ExportRequest;
  /** Update a mention rating */
  updateMentionRating?: Maybe<MentionRating>;
  /** Update a set of mentions */
  updateMentions?: Maybe<Array<Maybe<Mention>>>;
  /** Update an OpenId Provider by ID */
  updateOpenIdProvider?: Maybe<OpenIdProvider>;
  /**
   * Update an organization
   * Example:
   * Request:
   * mutation {
   *   updateOrganization(input: {
   *     id: "35521",
   *     indexTDOsByDefault: true}) {
   *     	id
   *     	status
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "updateOrganization": {
   *       "id": "35521",
   *       "status": "active"
   *     }
   *   }
   * }
   */
  updateOrganization?: Maybe<Organization>;
  /** Update organization billing policy. Requires superadmin */
  updateOrganizationBilling?: Maybe<OrganizationBilling>;
  /** Set the default/alwaysUse Cluster for organization */
  updateOrganizationCluster: OrganizationCluster;
  updateOrganizationInvite: OrganizationInvite;
  /**
   * Update a processTemplate by ID in CMS
   * Example:
   * Request:
   * mutation {
   *   updateProcessTemplate(input: {
   *     id: "746",
   *     taskList: {
   *       example: "task",
   *       new: "new task"
   *     }}) {
   *     id
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "updateProcessTemplate": {
   *       "id": "746"
   *     }
   *   }
   * }
   */
  updateProcessTemplate: ProcessTemplate;
  updateScheduledJob: ScheduledJob;
  /**
   * Update the state of a schema
   * Example:
   * Request:
   * mutation {
   *   updateSchemaState(input: {
   *     id: "0bd05e43-ddac-4b1a-9238-f3b177439b91",
   *     status: deleted}) {
   *     	id
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "updateSchemaState": {
   *       "id": "0bd05e43-ddac-4b1a-9238-f3b177439b91"
   *     }
   *   }
   * }
   */
  updateSchemaState?: Maybe<Schema>;
  updateSharedCollectionHistory?: Maybe<SharedCollectionHistory>;
  updateSharedCollectionMentions?: Maybe<Share>;
  updateSource?: Maybe<Source>;
  updateSourceType?: Maybe<SourceType>;
  /**
   * Update a subscription
   * Example:
   * Request:
   * mutation {
   *   updateSubscription(input: {
   *     id: "274939"}) {
   *     	id
   *   }
   * }
   * Response:
   * mutation {
   *   updateSubscription(input: {
   *     id: "274939"}) {
   *     	id
   *   }
   * }
   */
  updateSubscription?: Maybe<Subscription>;
  /**
   * Update a temporal data object
   * Example:
   * Request:
   * mutation {
   *  updateTDO(input:{
   *    id: "1570654874",
   *    status: "example",
   *    name: "example"}) {
   *    id
   *    name
   *    description
   *   }
   * }
   * Result:
   * {
   *   "data": {
   *     "updateTDO": {
   *       "id": "1570654874",
   *       "name": "example",
   *       "description": null
   *     }
   *   }
   * }
   */
  updateTDO?: Maybe<TemporalDataObject>;
  /** Update a task */
  updateTask?: Maybe<Task>;
  updateTaskTemplate: TaskTemplate;
  /**
   * Update an existing user'
   * Example:
   * Request:
   * mutation {
   *   updateUser(input: {
   *     id: "267de7e1-efb2-444a-a524-210328b78503",
   *     firstName: "example",
   *   	lastName: "example"}) {
   *   		firstName
   *     	lastName
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "updateUser": {
   *       "firstName": "example",
   *       "lastName": "example"
   *     }
   *   }
   * }
   */
  updateUser?: Maybe<User>;
  /**
   * Update setting for user (add/update/remove settings)
   * Example:
   * Request:
   * mutation {
   *   updateUserSetting(input: {
   *     application: "80354999-d633-4595-9578-d82f59a5134f",
   *   	key: "example12",
   *   	value: "example value"}) {
   *     	userId
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "updateUserSetting": {
   *       "userId": "59cb4e74-7c31-4267-b91e-d4600bc08008"
   *     }
   *   }
   * }
   */
  updateUserSetting?: Maybe<UserSetting>;
  /**
   * Update the status of a user
   * Example:
   * Request:
   * mutation {
   *   updateUserStatus(input: {
   *     id: "9728eeef-4ccc-423c-8c98-ffa37313a98d",
   *     status: deleted}) {
   *     	status
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "updateUserStatus": {
   *       "status": "deleted"
   *     }
   *   }
   * }
   */
  updateUserStatus: User;
  /**
   * Update a watchlist
   * Example:
   * Request:
   * mutation {
   *   updateWatchlist(input: {
   *     id: "325783"
   *     name: "new name"
   *     details: {
   *       example: "new details"}}) {
   *     	id
   *     	name
   *   }
   * }
   * Response:
   *   {
   *   "data": {
   *     "updateWatchlist": {
   *       "id": "325783",
   *       "name": "new name"
   *     }
   *   }
   * }
   */
  updateWatchlist?: Maybe<Watchlist>;
  /**
   * Updates a widget
   * Example:
   * Request:
   * mutation {
   *   updateWidget(input: {
   *     id: "fwSwWdRWTm2fdFMoPQDKkg",
   *     name: "new example name"}) {
   *     	id
   *     	name
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "updateWidget": {
   *       "id": "fwSwWdRWTm2fdFMoPQDKkg",
   *       "name": "new example name"
   *     }
   *   }
   * }
   */
  updateWidget?: Maybe<Widget>;
  /**
   * Upload and store an engine result. The result will be stored as an
   * asset associated with the target TemporalDataObject and the
   * task will be updated accordingly.
   * Use a multipart form POST to all this mutation.
   */
  uploadEngineResult?: Maybe<Asset>;
  /**
   * Update a structured data registry schema.
   * Example:
   * Request:
   * mutation {
   *   upsertSchemaDraft(input: {
   *     dataRegistryId: "230f95e4-95c9-47c4-a845-61ca67ad6ba6",
   *     schema: {
   *       example: "example"
   *     }}) {
   *     	id
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "upsertSchemaDraft": {
   *       "id": "0bd05e43-ddac-4b1a-9238-f3b177439b91"
   *     }
   *   }
   * }
   */
  upsertSchemaDraft?: Maybe<Schema>;
  /**
   * Login as a user. This mutation does not require an existing authentication
   * context (via `Authorization` header with bearer token, cookie, etc.).
   * Instead, the client supplies credentials to this mutation, which then
   * authenticates the user and sets up the authentication context.
   * The returned tokens can be used to authenticate future requests.
   * Example:
   * Request:
   * mutation {
   *   userLogin(input: {
   *     userName: "example1",
   *     password: "example1"}) {
   *     	apiToken
   *     	lastLoggedIn
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "userLogin": {
   *       "apiToken": null,
   *       "lastLoggedIn": "2021-06-15T02:04:52.000Z",
   *       "token": "a0bbdb23-058c-4b44-901f-aa3efc056a3a"
   *     }
   *   }
   * }
   */
  userLogin?: Maybe<LoginInfo>;
  /**
   * Logout user and invalidate user token
   * Example:
   * Request:
   * mutation {
   *   userLogout(
   *     token: "a5610058-260d-46ac-aa3e-ee529c4feaab")
   * }
   * Response:
   * {
   *   "data": {
   *     "userLogout": null
   *   }
   * }
   */
  userLogout?: Maybe<Scalars['Boolean']>;
  /**
   * Validates if an engine output conforms to the engine output guidelines
   * Example:
   * Request:
   * mutation {
   *   validateEngineOutput(input:
   *   {
   *   	schemaId: "https://docs.veritone.com/schemas/vtn-standard/master.json",
   *   	validationContracts: [
   *     	"structured-data"
   *   	],
   *   	series: [
   *     	{
   *       	startTimeMs: 0,
   *       	stopTimeMs: 10000,
   *       	structuredData: {
   *         	exampleschemaid: {
   *           	key: "value",
   *           	any: "data you'd like",
   *           	as_long: "as it conforms to the schema"
   *         	}
   *       	}
   *     	}
   *   	]
   * 	}
   *  )
   * }
   * Response:
   * {
   *   "data": {
   *     "validateEngineOutput": true
   *   }
   * }
   */
  validateEngineOutput: Scalars['Boolean'];
  /**
   * Validate a user token. This mutation is used by services to determine
   * if the token provided by a given client is valid.
   * Example:
   * Request:
   * mutation {
   *   validateToken(
   *     token: "32abe146-4e07-4f5e-8e1e-f7f2e0142cf7") {
   *     	hasPassword
   *     	user{id}
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "validateToken": {
   *       "hasPassword": true,
   *       "user": {
   *         "id": "d8304ba1-0d4c-4268-a82c-8c62fd455066"
   *       }
   *     }
   *   }
   * }
   */
  validateToken?: Maybe<LoginInfo>;
  /**
   * Verify JWT token
   * Example:
   * Request:
   * mutation {
   *   verifyJWT(jwtToken:"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjb250ZW
   *   50QXBwbGljYXRpb25JZCI6IjQ5YTRjYmJjLTVlODMtNGM0Mi1iOWEzLWJlNmVjMDczMmY
   *   wOSIsImNvbnRlbnRPcmdhbml6YXRpb25JZCI6MzU1MjEsImVuZ2luZUlkIjoiMSIsInVzZ
   *   XJJZCI6IjU5Y2I0ZTc0LTdjMzEtNDI2Ny1iOTFlLWQ0NjAwYmMwODAwOCIsInNjb3BlIjpb
   *   eyJhY3Rpb25zIjpbImFzc2V0OnVyaSIsImFzc2V0OmFsbCIsInJlY29yZGluZzpyZWFkIiw
   *   icmVjb3JkaW5nOnVwZGF0ZSJdLCJyZXNvdXJjZXMiOnsicmVjb3JkaW5nSWRzIjpbIjE1OD
   *   A3MDE5MjgiXX19LHsiYWN0aW9ucyI6WyJ0YXNrOnVwZGF0ZSJdLCJyZXNvdXJjZXMiOnsia
   *   m9iSWRzIjpbXSwidGFza0lkcyI6W10sInNvdXJjZUlkcyI6W119fV0sImlhdCI6MTYyNDAz
   *   NjEyMiwiZXhwIjoxNjI0NjQwOTIyLCJzdWIiOiJlbmdpbmUtcnVuIiwianRpIjoiMTViYjI
   *   3YzAtNGI1Yy00NjNhLWFkMTgtOWFkNDI0ODFiMTMzIn0.R7qYdPkA1wjJUiTdb1ryvTnZASPN9FEuGATw_z3BKRA") {
   *     payload
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "verifyJWT": {
   *       "payload": {
   *         "contentApplicationId": "49a4cbbc-5e83-4c42-b9a3-be6ec0732f09",
   *         "contentOrganizationId": 35521,
   *         "engineId": "1",
   *         "userId": "59cb4e74-7c31-4267-b91e-d4600bc08008",
   *         "scope": [
   *           {
   *             "actions": [
   *               "asset:uri",
   *               "asset:all",
   *               "recording:read",
   *               "recording:update"
   *             ],
   *             "resources": {
   *               "recordingIds": [
   *                 "1580701928"
   *               ]
   *             }
   *           },
   *           {
   *             "actions": [
   *               "task:update"
   *             ],
   *             "resources": {
   *               "jobIds": [],
   *               "taskIds": [],
   *               "sourceIds": []
   *             }
   *           }
   *         ],
   *         "iat": 1624036122,
   *         "exp": 1624640922,
   *         "sub": "engine-run",
   *         "jti": "15bb27c0-4b5c-463a-ad18-9ad42481b133"
   *       }
   *     }
   *   }
   * }
   */
  verifyJWT?: Maybe<VerifyJwtPayload>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationAddAcEsToResourcesArgs = {
  entries: Array<AuthAcePermissionInput>;
  ids: Array<Scalars['ID']>;
  resourceType?: InputMaybe<AuthResourceType>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationAddDagTemplateToOrganizationArgs = {
  input: AddDagTemplateToOrganization;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationAddLibraryDatasetArgs = {
  input: AddLibraryDataset;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationAddMediaSegmentArgs = {
  input: AddMediaSegment;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationAddMediaSegmentsArgs = {
  containerId: Scalars['ID'];
  segmentGroupId?: InputMaybe<Scalars['ID']>;
  segments: Array<InputMaybe<AddMediaSegments>>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationAddNotificationActionArgs = {
  input?: InputMaybe<AddNotificationAction>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationAddNotificationTemplateArgs = {
  input?: InputMaybe<AddNotificationTemplate>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationAddTaskReplacementEngineArgs = {
  input?: InputMaybe<AddTaskReplacementEngine>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationAddTasksToJobsArgs = {
  input?: InputMaybe<AddTasksToJobs>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationAddToEngineBlacklistArgs = {
  toAdd: SetEngineBlacklist;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationAddToEngineWhitelistArgs = {
  toAdd: SetEngineWhitelist;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationAddUserToOrganizationArgs = {
  organizationGuid: Scalars['ID'];
  priority?: InputMaybe<Scalars['Int']>;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  userId?: InputMaybe<Scalars['ID']>;
  userName?: InputMaybe<Scalars['String']>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationAppendWarningToTaskArgs = {
  message?: InputMaybe<Scalars['String']>;
  reason: Scalars['String'];
  referenceId?: InputMaybe<Scalars['ID']>;
  taskId?: InputMaybe<Scalars['ID']>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationApplicationAddToOrgArgs = {
  appId: Scalars['ID'];
  configs?: InputMaybe<Array<ApplicationConfigInput>>;
  orgId: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationApplicationConfigDefinitionCreateArgs = {
  input?: InputMaybe<Array<InputMaybe<ApplicationConfigDefinitionCreate>>>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationApplicationConfigDefinitionDeleteArgs = {
  input?: InputMaybe<ApplicationConfigDefinitionDelete>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationApplicationConfigDefinitionUpdateArgs = {
  input?: InputMaybe<Array<InputMaybe<ApplicationConfigDefinitionUpdateInput>>>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationApplicationConfigDeleteArgs = {
  input?: InputMaybe<ApplicationConfigDelete>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationApplicationConfigSetArgs = {
  input?: InputMaybe<ApplicationConfigSetConfigInput>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationApplicationRemoveFromOrgArgs = {
  appId: Scalars['ID'];
  clearConfigs?: InputMaybe<Scalars['Boolean']>;
  orgId: Scalars['ID'];
  userId?: InputMaybe<Scalars['ID']>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationApplicationWorkflowArgs = {
  input?: InputMaybe<ApplicationWorkflow>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationAuthEnforcementEnableArgs = {
  input: AuthEnforcementEnableInput;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationAuthGroupAddMembersArgs = {
  id: Scalars['ID'];
  members: Array<AuthGroupMemberInput>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationAuthGroupCreateArgs = {
  input: AuthGroupCreateInput;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationAuthGroupDeleteArgs = {
  id: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationAuthGroupRemoveMembersArgs = {
  id: Scalars['ID'];
  memberIds: Array<Scalars['ID']>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationAuthGroupUpdateArgs = {
  input: AuthGroupUpdateInput;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationAuthPermissionSetCreateArgs = {
  input: AuthPermissionSetInput;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationAuthPermissionSetDeleteArgs = {
  id: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationAuthPermissionSetUpdateArgs = {
  input: AuthPermissionSetUpdateInput;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationBulkCreateWatchlistArgs = {
  input: BulkCreateWatchlist;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationBulkDeleteContextMenuExtensionsArgs = {
  input?: InputMaybe<BulkDeleteContextMenuExtensions>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationBulkUpdateWatchlistArgs = {
  filter: BulkUpdateWatchlistFilter;
  input?: InputMaybe<BulkUpdateWatchlist>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCancelJobArgs = {
  id: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationChangePasswordArgs = {
  input: ChangePassword;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCleanupTdoArgs = {
  id: Scalars['ID'];
  options?: InputMaybe<Array<TdoCleanupOption>>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCloneScheduledJobArgs = {
  input: CloneScheduledJob;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCopyFlowArgs = {
  input?: InputMaybe<CopyFlow>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateApplicationArgs = {
  input?: InputMaybe<CreateApplication>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateApplicationHeaderbarArgs = {
  appId: Scalars['ID'];
  input?: InputMaybe<ApplicationHeaderbarInput>;
  orgId?: InputMaybe<Scalars['ID']>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateApplicationRoleArgs = {
  input?: InputMaybe<CreateApplicationRoleInput>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateAssetArgs = {
  input: CreateAsset;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateAutomateFlowArgs = {
  input?: InputMaybe<AutomateFlowInput>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateClusterArgs = {
  input: CreateCluster;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateClusterNodeArgs = {
  input: CreateClusterNode;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateCognitiveSearchArgs = {
  input?: InputMaybe<CreateCognitiveSearch>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateCollectionArgs = {
  input?: InputMaybe<CreateCollection>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateCollectionMentionArgs = {
  input?: InputMaybe<CollectionMentionInput>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateCollectionMentionsArgs = {
  input?: InputMaybe<CreateCollectionMentions>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateContextMenuExtensionArgs = {
  input: CreateContextMenuExtension;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateCreativeArgs = {
  input: CreateCreative;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateCustomDashboardArgs = {
  input?: InputMaybe<CreateCustomDashboard>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateDagTemplateArgs = {
  input: CreateDagTemplate;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateDataRegistryArgs = {
  input: CreateDataRegistry;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateDatasetArgs = {
  input: DatasetInput;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateDatasetSchemaArgs = {
  input: CreateDatasetSchema;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateEngineArgs = {
  input?: InputMaybe<CreateEngine>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateEngineBuildArgs = {
  input: CreateBuild;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateEntityArgs = {
  input: CreateEntity;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateEntityIdentifierArgs = {
  input: CreateEntityIdentifier;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateEntityIdentifierTypeArgs = {
  input: CreateEntityIdentifierType;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateEventArgs = {
  input: CreateEvent;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateEventActionTemplateArgs = {
  input: CreateEventActionTemplate;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateEventCustomRuleArgs = {
  input: CreateEventCustomRule;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateExportRequestArgs = {
  input: CreateExportRequest;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateFlowArgs = {
  input?: InputMaybe<CreateFlow>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateFlowExecutionArgs = {
  input?: InputMaybe<CreateFlowExecution>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateFlowFromTemplateArgs = {
  input?: InputMaybe<CreateFlowFromTemplate>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateFlowRevisionArgs = {
  input?: InputMaybe<CreateFlowRevision>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateFlowTemplateArgs = {
  input?: InputMaybe<CreateFlowTemplate>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateFolderArgs = {
  input?: InputMaybe<CreateFolder>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateFolderContentTempateArgs = {
  input: CreateFolderContentTempate;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateJobArgs = {
  input?: InputMaybe<CreateJob>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateJobTemplateArgs = {
  input: CreateJobTemplate;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateLibraryArgs = {
  input: CreateLibrary;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateLibraryCollaboratorArgs = {
  input: CreateLibraryCollaborator;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateLibraryConfigurationArgs = {
  input: CreateLibraryConfiguration;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateLibraryEngineModelArgs = {
  input: CreateLibraryEngineModel;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateLibraryTypeArgs = {
  input: CreateLibraryType;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateMediaShareArgs = {
  input: CreateMediaShare;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateMentionArgs = {
  input: CreateMention;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateMentionCommentArgs = {
  input?: InputMaybe<CreateMentionComment>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateMentionExportRequestArgs = {
  input: CreateMentionExportRequest;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateMentionRatingArgs = {
  input?: InputMaybe<CreateMentionRating>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateMentionsArgs = {
  input: CreateMentions;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateOpenIdProviderArgs = {
  input?: InputMaybe<CreateOpenIdProvider>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateOrganizationArgs = {
  input: CreateOrganization;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateOrganizationInviteArgs = {
  input: CreateOrganizationInviteInput;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreatePasswordResetRequestArgs = {
  input?: InputMaybe<CreatePasswordResetRequest>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreatePasswordUpdateRequestArgs = {
  input?: InputMaybe<CreatePasswordUpdateRequest>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateProcessTemplateArgs = {
  input: CreateProcessTemplate;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateRootFoldersArgs = {
  rootFolderType?: InputMaybe<RootFolderType>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateSavedSearchArgs = {
  input: CreateSavedSearch;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateScheduledJobArgs = {
  input: CreateScheduledJob;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateScheduledJobContentTemplateArgs = {
  input: CreateScheduledJobContentTemplate;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateSchemaArgs = {
  input: CreateSchema;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateSourceArgs = {
  input: CreateSource;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateSourceContentTemplateArgs = {
  input: CreateSourceContentTemplate;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateSourceTypeArgs = {
  input: CreateSourceType;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateStructuredDataArgs = {
  input: CreateStructuredData;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateSubscriptionArgs = {
  input: CreateSubscription;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateTdoArgs = {
  input?: InputMaybe<CreateTdo>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateTdoWithAssetArgs = {
  input?: InputMaybe<CreateTdoWithAsset>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateTaskLogArgs = {
  input: CreateTaskLog;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateTaskTemplateArgs = {
  input: CreateTaskTemplate;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateTriggersArgs = {
  input: CreateTriggers;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateUserArgs = {
  input?: InputMaybe<CreateUser>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateUserSettingDefinitionArgs = {
  application: Scalars['ID'];
  defaultValue: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
  organizationGuid?: InputMaybe<Scalars['ID']>;
  type: Scalars['String'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateWatchlistArgs = {
  input: CreateWatchlist;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationCreateWidgetArgs = {
  input?: InputMaybe<CreateWidget>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDatasetDataOperationArgs = {
  actions?: InputMaybe<Array<DatasetActionInput>>;
  async?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  updateMetrics?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDeleteApplicationArgs = {
  id: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDeleteApplicationRoleArgs = {
  id: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDeleteAssetArgs = {
  id: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDeleteClusterArgs = {
  id: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDeleteClusterNodeArgs = {
  id: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDeleteCognitiveSearchArgs = {
  id: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDeleteCollectionArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDeleteCollectionMentionArgs = {
  input?: InputMaybe<CollectionMentionInput>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDeleteContextMenuExtensionArgs = {
  input: DeleteContextMenuExtension;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDeleteCreativeArgs = {
  id: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDeleteCustomDashboardArgs = {
  id: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDeleteDagTemplateArgs = {
  id: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDeleteDatasetArgs = {
  id: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDeleteEngineArgs = {
  id: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDeleteEngineBuildArgs = {
  input: DeleteBuild;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDeleteEntityArgs = {
  id: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDeleteEntityIdentifierArgs = {
  id: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDeleteEventCustomRuleArgs = {
  id: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDeleteFlowArgs = {
  input?: InputMaybe<DeleteFlow>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDeleteFlowTemplateArgs = {
  id: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDeleteFolderArgs = {
  input?: InputMaybe<DeleteFolder>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDeleteFolderContentTempateArgs = {
  id: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDeleteFromEngineBlacklistArgs = {
  toDelete: SetEngineBlacklist;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDeleteFromEngineWhitelistArgs = {
  toDelete: SetEngineBlacklist;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDeleteJobTemplateArgs = {
  id: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDeleteLibraryArgs = {
  id: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDeleteLibraryCollaboratorArgs = {
  libraryId: Scalars['ID'];
  organizationId: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDeleteLibraryConfigurationArgs = {
  id: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDeleteLibraryDatasetArgs = {
  input: DeleteLibraryDataset;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDeleteLibraryEngineModelArgs = {
  id: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDeleteMentionCommentArgs = {
  input?: InputMaybe<DeleteMentionComment>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDeleteMentionRatingArgs = {
  input?: InputMaybe<DeleteMentionRating>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDeleteOpenIdProviderArgs = {
  id: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDeleteOrganizationIntegrationConfigArgs = {
  input: DeleteOrganizationIntegrationConfig;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDeleteOrganizationInviteArgs = {
  organizationInviteId: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDeleteProcessTemplateArgs = {
  id: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDeleteSavedSearchArgs = {
  id: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDeleteScheduledJobArgs = {
  id: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDeleteScheduledJobContentTemplateArgs = {
  id: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDeleteSourceArgs = {
  id: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDeleteSourceContentTemplateArgs = {
  id: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDeleteSourceTypeArgs = {
  id: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDeleteStructuredDataArgs = {
  input: DeleteStructuredData;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDeleteSubscriptionArgs = {
  id: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDeleteTdoArgs = {
  id: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDeleteTaskTemplateArgs = {
  id: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDeleteTriggerArgs = {
  id: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDeleteUserArgs = {
  id: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDeleteUserSettingDefinitionArgs = {
  application: Scalars['ID'];
  key: Scalars['String'];
  organizationGuid?: InputMaybe<Scalars['ID']>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDeleteWatchlistArgs = {
  id: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDeployFlowRevisionArgs = {
  input?: InputMaybe<DeployFlowRevision>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationDisableOpenIdProviderForOrgArgs = {
  input?: InputMaybe<DisableOpenIdProviderForOrg>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationEmitAuditEventArgs = {
  input: EmitAuditEvent;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationEmitEventArgs = {
  input: EmitEvent;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationEmitSystemEventArgs = {
  input: EmitSystemEvent;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationEnableOpenIdProviderForOrgArgs = {
  input?: InputMaybe<EnableOpenIdProviderForOrg>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationEngineWorkflowArgs = {
  input?: InputMaybe<EngineWorkflow>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationExtendTokenArgs = {
  token: Scalars['String'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationFileApplicationArgs = {
  input: FileApplication;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationFileTemporalDataObjectArgs = {
  input: FileTemporalDataObject;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationFileWatchlistArgs = {
  input: FileWatchlist;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationGetApplicationJwtArgs = {
  input?: InputMaybe<GetApplicationJwt>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationGetCurrentUserPasswordTokenArgs = {
  input: GetCurrentUserPasswordToken;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationGetEngineJwtArgs = {
  input: GetEngineJwt;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationLaunchJobTemplatesArgs = {
  input: LaunchJobTemplates;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationLaunchScheduledJobsArgs = {
  input: LaunchScheduledJobs;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationLaunchSingleEngineJobArgs = {
  input: SingleEngineJobInput;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationMarkAllNotificationsReadArgs = {
  mailboxIds: Array<InputMaybe<Scalars['ID']>>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationMarkAllNotificationsSeenArgs = {
  mailboxIds: Array<InputMaybe<Scalars['ID']>>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationMoveFolderArgs = {
  input?: InputMaybe<MoveFolder>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationMoveTemporalDataObjectArgs = {
  input: MoveTemporalDataObject;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationNotificationMailboxCreateArgs = {
  input?: InputMaybe<NotificationMailboxInput>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationNotificationMailboxDeleteArgs = {
  id: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationNotificationMailboxPauseArgs = {
  id: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationNotificationMailboxUnpauseArgs = {
  id: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationNotificationPostArgs = {
  input?: InputMaybe<NotificaionPostInput>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationPackageCreateArgs = {
  input?: InputMaybe<PackageCreateInput>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationPackageDeleteArgs = {
  id: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationPackageUpdateArgs = {
  input?: InputMaybe<PackageUpdateInput>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationPackageUpdateGrantsArgs = {
  input: BulkPackageGrantInput;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationPackageUpdateResourcesArgs = {
  input?: InputMaybe<BulkPackageResourceInput>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationPairClusterNodeArgs = {
  input: PairClusterNode;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationPauseClusterArgs = {
  input: PauseCluster;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationPauseClusterNodeArgs = {
  input: PauseClusterNode;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationPauseFlowArgs = {
  input?: InputMaybe<PauseFlow>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationPingClusterNodeArgs = {
  input: PingClusterNode;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationPublishLibraryArgs = {
  id: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationRefreshTokenArgs = {
  token: Scalars['String'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationRemoveAcEsFromResourceArgs = {
  ids: Array<Scalars['ID']>;
  resourceType: AuthResourceType;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationRemoveApplicationEventEndpointArgs = {
  id: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationRemoveDagTemplateFromOrganizationArgs = {
  input?: InputMaybe<RemoveDagFromOrganization>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationRemoveNotificationActionArgs = {
  id: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationRemoveNotificationTemplateArgs = {
  id: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationRemoveTaskReplacementEngineArgs = {
  input?: InputMaybe<RemoveTaskReplacementEngine>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationRemoveUserFromOrganizationArgs = {
  organizationGuid: Scalars['ID'];
  userId?: InputMaybe<Scalars['ID']>;
  userName?: InputMaybe<Scalars['String']>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationReplaceSavedSearchArgs = {
  input: ReplaceSavedSearch;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationRequestCloneArgs = {
  input?: InputMaybe<RequestClone>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationRetryJobArgs = {
  id: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationRevertScheduledJobArgs = {
  input: RevertScheduledJob;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationSendEmailArgs = {
  input: SendEmail;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationSetNotificationFlagArgs = {
  input?: InputMaybe<SetNotificationFlag>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationSetOrganizationIntegrationConfigArgs = {
  input: SetOrganizationIntegrationConfig;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationSetUserDefaultOrganizationArgs = {
  defaultOrganizationId: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationSetWorkflowRuntimeStorageDataArgs = {
  input: CreateWorkflowRuntimeStorageData;
  workflowRuntimeId: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationShareCollectionArgs = {
  input?: InputMaybe<ShareCollection>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationShareFolderArgs = {
  input?: InputMaybe<ShareFolderInput>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationShareMentionArgs = {
  input?: InputMaybe<ShareMention>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationShareMentionFromCollectionArgs = {
  input?: InputMaybe<ShareMentionFromCollection>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationShareMentionInBulkArgs = {
  input?: InputMaybe<ShareMentionInBulk>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationStartWorkflowRuntimeArgs = {
  generateAuthToken?: InputMaybe<Scalars['Boolean']>;
  orgId: Scalars['ID'];
  workflowRuntimeId: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationStopWorkflowRuntimeArgs = {
  workflowRuntimeId: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationSubscribeEventArgs = {
  input: SubscribeEvent;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationSwitchUserToOrganizationArgs = {
  organizationGuid: Scalars['ID'];
  token: Scalars['String'];
  userName: Scalars['String'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUnfileApplicationArgs = {
  input: UnfileApplication;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUnfileTemporalDataObjectArgs = {
  input: UnfileTemporalDataObject;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUnfileWatchlistArgs = {
  input: UnfileWatchlist;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUnpairClusterNodeArgs = {
  id: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUnpauseClusterArgs = {
  input: UnpauseCluster;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUnpauseClusterNodeArgs = {
  input: UnpauseClusterNode;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUnpauseFlowArgs = {
  input?: InputMaybe<PauseFlow>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUnsubscribeEventArgs = {
  id: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateApplicationArgs = {
  input?: InputMaybe<UpdateApplication>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateApplicationBillingDirtyArgs = {
  applicationId: Scalars['ID'];
  billingDirty: Scalars['Boolean'];
  organizationId: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateApplicationBillingPlanIdArgs = {
  applicationId: Scalars['ID'];
  billingPlanId: Scalars['String'];
  organizationId: Scalars['ID'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateApplicationComponentArgs = {
  input: UpdateApplicationComponent;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateApplicationEventEndpointArgs = {
  input?: InputMaybe<UpdateApplicationEventEndpoint>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateApplicationHeaderbarArgs = {
  appId: Scalars['ID'];
  input?: InputMaybe<ApplicationHeaderbarUpdate>;
  orgId?: InputMaybe<Scalars['ID']>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateApplicationRoleArgs = {
  input?: InputMaybe<UpdateApplicationRoleInput>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateAssetArgs = {
  input: UpdateAsset;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateClusterArgs = {
  input: UpdateCluster;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateClusterNodeArgs = {
  input: UpdateClusterNode;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateClusterStateArgs = {
  input: UpdateClusterState;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateCognitiveSearchArgs = {
  input?: InputMaybe<UpdateCognitiveSearch>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateCollectionArgs = {
  input?: InputMaybe<UpdateCollection>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateCollectionMentionArgs = {
  input: UpdateCollectionMention;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateContextMenuExtensionArgs = {
  input: UpdateContextMenuExtension;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateCreativeArgs = {
  input: UpdateCreative;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateCurrentUserArgs = {
  input: UpdateCurrentUser;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateCustomDashboardArgs = {
  input?: InputMaybe<UpdateCustomDashboard>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateDagTemplateArgs = {
  input: UpdateDagTemplate;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateDataRegistryArgs = {
  input: UpdateDataRegistry;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateDatasetArgs = {
  id: Scalars['ID'];
  input?: InputMaybe<DatasetInput>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateEngineArgs = {
  input?: InputMaybe<UpdateEngine>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateEngineBuildArgs = {
  input: UpdateBuild;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateEntityArgs = {
  input: UpdateEntity;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateEntityIdentifierArgs = {
  input: UpdateEntityIdentifier;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateEntityIdentifierTypeArgs = {
  input: UpdateEntityIdentifierType;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateEventArgs = {
  input: UpdateEvent;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateEventActionTemplateArgs = {
  input: UpdateEventActionTemplate;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateEventCustomRuleArgs = {
  input: UpdateEventCustomRule;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateExportRequestArgs = {
  input: UpdateExportRequest;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateFlowArgs = {
  input?: InputMaybe<CreateEngine>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateFlowExecutionArgs = {
  input?: InputMaybe<UpdateFlowExecution>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateFlowRevisionArgs = {
  input?: InputMaybe<UpdateFlowRevision>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateFlowRevisionHeadArgs = {
  input?: InputMaybe<UpdateFlowRevisionHead>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateFlowTemplateArgs = {
  input?: InputMaybe<UpdateFlowTemplate>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateFolderArgs = {
  input?: InputMaybe<UpdateFolder>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateFolderContentTempateArgs = {
  input: UpdateFolderContentTempate;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateJobTemplateArgs = {
  input: UpdateJobTemplate;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateJobsArgs = {
  input: UpdateJobs;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateLibraryArgs = {
  input: UpdateLibrary;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateLibraryCollaboratorArgs = {
  input: UpdateLibraryCollaborator;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateLibraryConfigurationArgs = {
  input: UpdateLibraryConfiguration;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateLibraryEngineModelArgs = {
  input: UpdateLibraryEngineModel;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateLibraryTypeArgs = {
  input: UpdateLibraryType;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateMentionArgs = {
  input: UpdateMention;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateMentionCommentArgs = {
  input?: InputMaybe<UpdateMentionComment>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateMentionExportRequestArgs = {
  input: UpdateMentionExportRequest;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateMentionRatingArgs = {
  input?: InputMaybe<UpdateMentionRating>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateMentionsArgs = {
  input: UpdateMentions;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateOpenIdProviderArgs = {
  input?: InputMaybe<UpdateOpenIdProvider>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateOrganizationArgs = {
  input: UpdateOrganization;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateOrganizationBillingArgs = {
  planId: Scalars['String'];
  targetOrganizationId?: InputMaybe<Scalars['ID']>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateOrganizationClusterArgs = {
  input?: InputMaybe<UpdateOrganizationCluster>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateOrganizationInviteArgs = {
  input: UpdateOrganizationInviteInput;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateProcessTemplateArgs = {
  input: UpdateProcessTemplate;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateScheduledJobArgs = {
  input: UpdateScheduledJob;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateSchemaStateArgs = {
  input: UpdateSchemaState;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateSharedCollectionHistoryArgs = {
  input?: InputMaybe<UpdateSharedCollectionHistory>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateSharedCollectionMentionsArgs = {
  mentionIds?: InputMaybe<Array<Scalars['ID']>>;
  shareId: Scalars['String'];
  type: SharedCollectionUpdateType;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateSourceArgs = {
  input: UpdateSource;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateSourceTypeArgs = {
  input: UpdateSourceType;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateSubscriptionArgs = {
  input: UpdateSubscription;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateTdoArgs = {
  input?: InputMaybe<UpdateTdo>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateTaskArgs = {
  input?: InputMaybe<UpdateTask>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateTaskTemplateArgs = {
  input: UpdateTaskTemplate;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateUserArgs = {
  input?: InputMaybe<UpdateUser>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateUserSettingArgs = {
  input?: InputMaybe<UpdateUserSetting>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateUserStatusArgs = {
  input: UpdateUserStatus;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateWatchlistArgs = {
  input: UpdateWatchlist;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpdateWidgetArgs = {
  input?: InputMaybe<UpdateWidget>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUploadEngineResultArgs = {
  input: UploadEngineResult;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUpsertSchemaDraftArgs = {
  input: UpsertSchemaDraft;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUserLoginArgs = {
  input?: InputMaybe<UserLogin>;
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationUserLogoutArgs = {
  token: Scalars['String'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationValidateEngineOutputArgs = {
  input: Scalars['JSONData'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationValidateTokenArgs = {
  token: Scalars['String'];
};


/**
 * Mutations are used to modify data. Each mutation takes an input
 * that contains the data necessary to create or update the data
 * in question.
 */
export type MutationVerifyJwtArgs = {
  jwtToken: Scalars['String'];
};

export type NodeModule = {
  __typename?: 'NodeModule';
  accessToken?: Maybe<Scalars['String']>;
  isPrivateRegistry?: Maybe<Scalars['Boolean']>;
  isPrivateRepo?: Maybe<Scalars['Boolean']>;
  moduleId?: Maybe<Scalars['ID']>;
  moduleName?: Maybe<Scalars['String']>;
  moduleRepo: ModuleRepo;
  moduleVersion?: Maybe<Scalars['String']>;
  registryUrl?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  sshUrl?: Maybe<Scalars['String']>;
  status: NodeModuleStatus;
};

export type NodeModuleInput = {
  accessToken?: InputMaybe<Scalars['String']>;
  isPrivateRegistry?: InputMaybe<Scalars['Boolean']>;
  isPrivateRepo?: InputMaybe<Scalars['Boolean']>;
  moduleId?: InputMaybe<Scalars['ID']>;
  moduleName?: InputMaybe<Scalars['String']>;
  moduleRepo: ModuleRepo;
  moduleVersion?: InputMaybe<Scalars['String']>;
  registryUrl?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Scalars['String']>;
  sshUrl?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<NodeModuleStatus>;
};

export enum NodeModuleStatus {
  Active = 'active',
  Deleted = 'deleted'
}

export type NodePair = {
  clusterId: Scalars['ID'];
  displayName: Scalars['String'];
  offlineBrowsing: Scalars['Boolean'];
  role: Scalars['String'];
};

export type NotificaionPostInput = {
  /** The applicationId of notification */
  application?: InputMaybe<Scalars['String']>;
  /** This can be encrypted string, json, html */
  body: Scalars['String'];
  /** Hint what/how the body is encoded */
  contentType: Scalars['String'];
  /** This flag indicates whether the notification is persistent or not. */
  ephemeral?: InputMaybe<Scalars['Boolean']>;
  /** Event name of notification (optional) */
  eventName?: InputMaybe<Scalars['String']>;
  /** Event type of notification (optional) */
  eventType?: InputMaybe<Scalars['String']>;
  flags?: InputMaybe<Array<NotificationFlag>>;
  /** Recepient mailbox/user/organization ids */
  mailboxIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** The title of notification */
  title?: InputMaybe<Scalars['String']>;
};

export type Notification = {
  __typename?: 'Notification';
  /** The applicationId of notification */
  applicationId?: Maybe<Scalars['String']>;
  /** This can be encrypted string, json, html */
  body?: Maybe<Scalars['String']>;
  /** Hint what/how the body is encoded */
  contentType?: Maybe<Scalars['String']>;
  /** Dates tracked internally */
  createdDateTime?: Maybe<Scalars['DateTime']>;
  /** Event name of notification */
  eventName?: Maybe<Scalars['String']>;
  /** Event type of notification */
  eventType?: Maybe<Scalars['String']>;
  /** If states are exclusive then this can be just NotificationState */
  flags?: Maybe<Array<NotificationFlag>>;
  id: Scalars['ID'];
  readDateTime?: Maybe<Scalars['DateTime']>;
  /** The title of notification */
  title?: Maybe<Scalars['String']>;
  updatedDateTime?: Maybe<Scalars['DateTime']>;
};

export type NotificationAction = {
  __typename?: 'NotificationAction';
  actionName?: Maybe<Scalars['String']>;
  applicationId?: Maybe<Scalars['String']>;
  createdDateTime?: Maybe<Scalars['DateTime']>;
  eventName: Scalars['String'];
  eventType: Scalars['String'];
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mailboxId?: Maybe<Scalars['ID']>;
  ownerApplicationId: Scalars['String'];
  ownerOrganizationId: Scalars['ID'];
  updatedDateTime?: Maybe<Scalars['DateTime']>;
  urlTemplate: Scalars['String'];
};

export type NotificationActionList = Page & {
  __typename?: 'NotificationActionList';
  count?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records?: Maybe<Array<Maybe<NotificationAction>>>;
};

export enum NotificationDateTimeField {
  ActionDateTime = 'actionDateTime',
  CreatedDateTime = 'createdDateTime',
  ReadDateTime = 'readDateTime'
}

export type NotificationDateTimeFilter = {
  field: NotificationDateTimeField;
  fromDateTime?: InputMaybe<Scalars['DateTime']>;
  toDateTime?: InputMaybe<Scalars['DateTime']>;
};

export enum NotificationDeliveryType {
  NotificationMailbox = 'NotificationMailbox'
}

export enum NotificationFlag {
  ActionDone = 'actionDone',
  ActionPending = 'actionPending',
  Read = 'read',
  Seen = 'seen',
  Starred = 'starred',
  Unread = 'unread',
  Unseen = 'unseen'
}

export type NotificationList = Page & {
  __typename?: 'NotificationList';
  count?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records?: Maybe<Array<Notification>>;
};

export type NotificationMailbox = {
  __typename?: 'NotificationMailbox';
  details?: Maybe<Scalars['JSONData']>;
  eventFilter?: Maybe<EventFilter>;
  /**
   * Special mailboxes like the default user and org mailbox have
   * ids matching the userId/applicationId
   */
  id: Scalars['ID'];
  /**
   * Some frequently queried statistics from the Notifications field
   * so the clients don't have to page through to get that information
   */
  lastReceiptDateTime?: Maybe<Scalars['DateTime']>;
  latestUpdateDate?: Maybe<Scalars['DateTime']>;
  limit?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  notificationTemplate?: Maybe<Scalars['String']>;
  notifications?: Maybe<NotificationList>;
  /**
   * The mailboxes can be paused and no new notification would be
   * posted until they are unpaused. This is different for silencing
   * the notifications from the UI
   */
  paused?: Maybe<Scalars['Boolean']>;
  totalCount?: Maybe<Scalars['Int']>;
  unreadCount?: Maybe<Scalars['Int']>;
  unseenCount?: Maybe<Scalars['Int']>;
};


export type NotificationMailboxNotificationsArgs = {
  dateTimeFilter?: InputMaybe<Array<NotificationDateTimeFilter>>;
  flags?: InputMaybe<Array<NotificationFlag>>;
  flagsMode?: InputMaybe<FilterCombineOperator>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<NotificationDateTimeField>;
  orderDirection?: InputMaybe<OrderDirection>;
};

export type NotificationMailboxInput = {
  /** Mailbox details with optional json data */
  details?: InputMaybe<Scalars['JSONData']>;
  /** The conditions to filter the event - same structure as subcribeEvent mutation */
  eventFilter: EventFilterInput;
  /** Set maximum number of notifications the mailbox can contain */
  limit?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  /**
   * Handlebar template for transforming the event to a
   * notification
   */
  notificationTemplate: Scalars['String'];
};

export type NotificationTemplate = {
  __typename?: 'NotificationTemplate';
  applicationId?: Maybe<Scalars['String']>;
  body: Scalars['String'];
  createdDateTime?: Maybe<Scalars['DateTime']>;
  eventName: Scalars['String'];
  eventType: Scalars['String'];
  id: Scalars['ID'];
  mailboxId?: Maybe<Scalars['ID']>;
  ownerApplicationId: Scalars['String'];
  ownerOrganizationId: Scalars['ID'];
  title: Scalars['String'];
  updatedDateTime?: Maybe<Scalars['DateTime']>;
};

export type NotificationTemplateList = Page & {
  __typename?: 'NotificationTemplateList';
  count?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records?: Maybe<Array<Maybe<NotificationTemplate>>>;
};

export type OktaConfiguration = {
  __typename?: 'OktaConfiguration';
  /** The organization's Okta client ID. */
  clientId?: Maybe<Scalars['String']>;
  /**
   * An optional login alias for the organization. If provided, the organization's users
   * will have a dedicated Veritone login endpoint.
   */
  loginAlias?: Maybe<Scalars['String']>;
  /**
   * Indicates whether or not authentication with Okta is enabled
   * for the organization. If enabled, this applies to all users # within the organization.
   */
  oktaAuthenticationEnabled?: Maybe<Scalars['Boolean']>;
  /** The organization's Okta domain. */
  oktaDomain?: Maybe<Scalars['String']>;
};

export type OpResult = {
  __typename?: 'OpResult';
  code?: Maybe<Scalars['String']>;
  msg?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type OpenIdProvider = {
  __typename?: 'OpenIdProvider';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isGlobal?: Maybe<Scalars['Boolean']>;
  loginButtonStyle?: Maybe<OpenIdProviderLoginButtonStyle>;
  loginUrl: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  websiteUrl?: Maybe<Scalars['String']>;
};

export type OpenIdProviderList = Page & {
  __typename?: 'OpenIdProviderList';
  count?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records?: Maybe<Array<Maybe<OpenIdProvider>>>;
};

export type OpenIdProviderLoginButtonStyle = {
  __typename?: 'OpenIdProviderLoginButtonStyle';
  btnColor?: Maybe<Scalars['String']>;
  btnLogo?: Maybe<Scalars['String']>;
  btnText?: Maybe<Scalars['String']>;
  btnTextColor?: Maybe<Scalars['String']>;
};

export type OperationResult = {
  __typename?: 'OperationResult';
  code?: Maybe<Scalars['String']>;
  msg?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export enum OrderDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type Organization = {
  __typename?: 'Organization';
  /** Applications belonging to the organization */
  applications?: Maybe<ApplicationList>;
  /** If TRUE, billing+plan_id has been updated */
  billingDirty?: Maybe<Scalars['Boolean']>;
  /** Billing plan id */
  billingPlanId?: Maybe<Scalars['String']>;
  /** Last time billing was updated */
  billingUpdatedDatetime?: Maybe<Scalars['DateTime']>;
  /** List of engines forbidden to this organization. */
  blacklist?: Maybe<EngineBlacklist>;
  /** Business unit */
  businessUnit?: Maybe<Scalars['String']>;
  /** Collections for this organization */
  collections?: Maybe<CollectionList>;
  createdDateTime?: Maybe<Scalars['DateTime']>;
  /** Storage for the month in bytes */
  currentStorageBytes?: Maybe<Scalars['Float']>;
  /** Dashboards */
  dashboards?: Maybe<Array<Maybe<Dashboard>>>;
  /** Retrieve default cluster of organization */
  defaultCluster?: Maybe<Cluster>;
  /** The organization GUID */
  guid?: Maybe<Scalars['ID']>;
  /** The organization ID */
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  /** Retrieve integration config of organization by integration id */
  integrationConfig?: Maybe<IntegrationConfig>;
  /**
   * An ID corresponding to the organization used internally for some
   * provisioning elements. `applicationId` on `TemporalDataObject`, `Job`,
   * and some other types uses this value instead of the organization `id`.
   */
  internalApplicationId?: Maybe<Scalars['ID']>;
  /** Enable/disable the limit enforced for organization */
  isLimitEnforced?: Maybe<Scalars['Boolean']>;
  /** The email got an invitation and waiting to complete the invitation */
  isUserPendingMember?: Maybe<Scalars['Boolean']>;
  /** Freeform metadata in JSON format */
  jsondata?: Maybe<Scalars['JSONData']>;
  /** Storage for last month in ByteHrs */
  lastMonthBytehrsTotal?: Maybe<Scalars['Float']>;
  /** Storage for last month in GB-HR */
  lastMonthGbhrTotal?: Maybe<Scalars['Float']>;
  /** The amount of media uploaded by this org in milliseconds */
  mediaUsageMs?: Maybe<Scalars['Int']>;
  modifiedDateTime?: Maybe<Scalars['DateTime']>;
  /** Storage for the month in ByteHrs */
  monthlyBytehrsTotal?: Maybe<Scalars['Float']>;
  /** Current Charge */
  monthlyCurrentCharge?: Maybe<Scalars['Float']>;
  /** Storage for the month in GB-HR */
  monthlyGbhrTotal?: Maybe<Scalars['Float']>;
  /** How many bytes processed per month */
  monthlyProcessingBytesTotal?: Maybe<Scalars['Float']>;
  /** How many hours processed per month */
  monthlyProcessingHoursTotal?: Maybe<Scalars['Float']>;
  /** Processing last ran at this time */
  monthlyProcessingLastran?: Maybe<Scalars['DateTime']>;
  /** Storage last ran */
  monthyStorageLastran?: Maybe<Scalars['DateTime']>;
  /** The organization's name */
  name?: Maybe<Scalars['String']>;
  /** Retrive notifications of org default mailbox */
  notifications?: Maybe<NotificationList>;
  /**
   * Configuration for authentication and directory integration
   * using Okta. By default, this feature is not used.
   */
  oktaConfiguration: OktaConfiguration;
  /** Multi Organization Invite */
  organizationInvites?: Maybe<Array<Maybe<OrganizationInvite>>>;
  /** Display the package grants */
  packageGrants?: Maybe<PackageGrantList>;
  /** The pending cost of organization */
  pendingCost?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Int']>;
  /** The budget remaining for organization (cents) */
  remainingBudget?: Maybe<Scalars['Float']>;
  /** The flag to specify organization which require OpenId Connect */
  requireOpenId?: Maybe<Scalars['Boolean']>;
  /** Roles allowed within the organization */
  roles?: Maybe<Array<Maybe<Role>>>;
  /** Folder tree for this organization */
  rootFolder?: Maybe<Folder>;
  /**
   * Custom schemas defined by this organization.
   * This field is not fully implemented!
   */
  schemas?: Maybe<SchemaList>;
  seatLimit?: Maybe<Scalars['Int']>;
  /** The number of active seats */
  seats?: Maybe<Scalars['Int']>;
  /** Organization's current status */
  status?: Maybe<OrganizationStatus>;
  /** Test */
  testOrgField?: Maybe<Scalars['Boolean']>;
  /**
   * A list of types applied to the organization, such
   * as `Broadcaster` or `Agency`.
   */
  type?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Users belonging to the organization */
  users?: Maybe<UserList>;
  /**
   * Watchlists for this organization.
   * This field is not fully implemented!
   */
  watchlists?: Maybe<WatchlistList>;
  /**
   * List of engines allowed for this organization.
   * Takes precedence of the blacklist. That is, if a whitelist
   * is defined, then only engines in the whitelist are permitted
   * regardless of what is in the blacklist.
   * This field is not fully implemented!
   */
  whitelist?: Maybe<EngineWhitelist>;
};


export type OrganizationApplicationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type OrganizationCollectionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type OrganizationIntegrationConfigArgs = {
  id: Scalars['ID'];
};


export type OrganizationIsUserPendingMemberArgs = {
  email?: InputMaybe<Scalars['String']>;
};


export type OrganizationNotificationsArgs = {
  dateTimeFilter?: InputMaybe<Array<NotificationDateTimeFilter>>;
  flags?: InputMaybe<Array<NotificationFlag>>;
  flagsMode?: InputMaybe<FilterCombineOperator>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<NotificationDateTimeField>;
  orderDirection?: InputMaybe<OrderDirection>;
};


export type OrganizationOrganizationInvitesArgs = {
  email?: InputMaybe<Scalars['String']>;
  organizationInviteId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<OrganizationInviteStatus>;
  statuses?: InputMaybe<Array<InputMaybe<OrganizationInviteStatus>>>;
};


export type OrganizationRolesArgs = {
  isAppEventRole?: InputMaybe<Scalars['Boolean']>;
};


export type OrganizationRootFolderArgs = {
  type?: InputMaybe<RootFolderType>;
};


export type OrganizationUsersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type OrganizationBasicInfo = {
  __typename?: 'OrganizationBasicInfo';
  guid: Scalars['ID'];
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type OrganizationBilling = {
  __typename?: 'OrganizationBilling';
  organizationId: Scalars['ID'];
  planId: Scalars['String'];
};

export type OrganizationCluster = {
  __typename?: 'OrganizationCluster';
  clusterId: Scalars['ID'];
  isAlwaysUse?: Maybe<Scalars['Boolean']>;
  organizationId: Scalars['ID'];
};

export type OrganizationInfo = {
  __typename?: 'OrganizationInfo';
  /** The organization GUID */
  guid?: Maybe<Scalars['ID']>;
  /** The organization ID */
  id: Scalars['ID'];
  /** Organization avatar/logo */
  imageUrl?: Maybe<Scalars['String']>;
  /** The email got an invitation and waiting to complete the invitation */
  isUserPendingMember?: Maybe<Scalars['Boolean']>;
  /** The organization's name */
  name?: Maybe<Scalars['String']>;
  /** Relative priority in the user org list */
  priority?: Maybe<Scalars['Int']>;
};


export type OrganizationInfoIsUserPendingMemberArgs = {
  email?: InputMaybe<Scalars['String']>;
};

export type OrganizationInfoList = Page & {
  __typename?: 'OrganizationInfoList';
  /** Number of records returned in this response */
  count?: Maybe<Scalars['Int']>;
  /** Maximum number of results that were retrieved in this query; page size */
  limit: Scalars['Int'];
  /** Provide an offset to skip to a certain element in the result, for paging. */
  offset: Scalars['Int'];
  records?: Maybe<Array<Maybe<OrganizationInfo>>>;
};

export type OrganizationInvite = {
  __typename?: 'OrganizationInvite';
  /** List of applications and application-specific roles to grant to the user */
  applicationRoles: Array<ApplicationInviteRole>;
  /** Audit history of the actions performed */
  audit: Array<OrganizationInviteActionAudit>;
  /** createdBy provide info of the invitation creator */
  createdBy: BasicUserInfo;
  /** User email */
  email?: Maybe<Scalars['String']>;
  /** Date the invitation becomes invalid. Default is 7 days after creation */
  expirationDate: Scalars['DateTime'];
  /** Unique invitation id */
  id: Scalars['ID'];
  /** Invitee */
  invitee?: Maybe<Invitee>;
  /** Message shown to the user and the approver of the invite */
  message?: Maybe<Scalars['String']>;
  /** Organization to add the user to */
  organization: OrganizationBasicInfo;
  /** Status of the invite */
  status: OrganizationInviteStatus;
};

/** Multi Organization Invitation */
export enum OrganizationInviteAction {
  Approve = 'approve',
  Complete = 'complete',
  Reject = 'reject',
  Request = 'request',
  Submit = 'submit'
}

export type OrganizationInviteActionAudit = {
  __typename?: 'OrganizationInviteActionAudit';
  /** Type of action performed on the invite */
  action: OrganizationInviteAction;
  /** UserId or orgId used to perform the action */
  actor: Scalars['String'];
  /** Status at the time of the action */
  priorStatus: OrganizationInviteStatus;
  /** Timestamp of the action */
  timestamp: Scalars['DateTime'];
};

export enum OrganizationInviteStatus {
  Approved = 'approved',
  Completed = 'completed',
  Deleted = 'deleted',
  Expired = 'expired',
  Rejected = 'rejected',
  Submitted = 'submitted'
}

export type OrganizationList = Page & {
  __typename?: 'OrganizationList';
  /** Number of records returned in this response */
  count?: Maybe<Scalars['Int']>;
  /** Maximum number of results that were retrieved in this query; page size */
  limit: Scalars['Int'];
  /** Provide an offset to skip to a certain element in the result, for paging. */
  offset: Scalars['Int'];
  records?: Maybe<Array<Maybe<Organization>>>;
};

export enum OrganizationStatus {
  Active = 'active',
  Deleted = 'deleted'
}

export enum OrganizationType {
  Agency = 'agency',
  Broadcaster = 'broadcaster'
}

export type Package = {
  __typename?: 'Package';
  aiwareVersion?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy: BasicUserInfo;
  deleted?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  distributionType?: Maybe<EngineDistributionType>;
  id: Scalars['ID'];
  modifiedAt: Scalars['DateTime'];
  modifiedBy: BasicUserInfo;
  name: Scalars['String'];
  organization?: Maybe<OrganizationInfo>;
  primaryResourceId?: Maybe<Scalars['ID']>;
  resources?: Maybe<PackageResourceList>;
  sourceOriginId?: Maybe<Scalars['ID']>;
  version: Scalars['String'];
};


export type PackageResourcesArgs = {
  type?: InputMaybe<PackageResourceType>;
};

export type PackageCreateInput = {
  aiwareVersion?: InputMaybe<Scalars['String']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  distributionType?: InputMaybe<EngineDistributionType>;
  name: Scalars['String'];
  organizationId?: InputMaybe<Scalars['ID']>;
  primaryResourceId?: InputMaybe<Scalars['ID']>;
  resources?: InputMaybe<Array<InputMaybe<PackageResourceInput>>>;
  sourceOriginId?: InputMaybe<Scalars['ID']>;
  version: Scalars['String'];
};

export type PackageDeleteResult = {
  __typename?: 'PackageDeleteResult';
  code?: Maybe<Scalars['String']>;
  msg?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type PackageGrant = {
  __typename?: 'PackageGrant';
  createdAt: Scalars['DateTime'];
  createdBy: BasicUserInfo;
  grantType: PackageGrantType;
  modifiedAt: Scalars['DateTime'];
  modifiedBy: BasicUserInfo;
  organization: OrganizationInfo;
  package: Package;
};

export enum PackageGrantAction {
  Add = 'ADD',
  Remove = 'REMOVE'
}

export type PackageGrantInput = {
  action?: InputMaybe<PackageGrantAction>;
  grantType: PackageGrantType;
  organizationId: Scalars['ID'];
};

export type PackageGrantList = {
  __typename?: 'PackageGrantList';
  count: Scalars['Int'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records: Array<Maybe<PackageGrant>>;
};

export enum PackageGrantType {
  Deny = 'DENY',
  Grant = 'GRANT'
}

export type PackageList = {
  __typename?: 'PackageList';
  count: Scalars['Int'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records: Array<Maybe<Package>>;
};

export type PackageOpResult = {
  __typename?: 'PackageOpResult';
  code?: Maybe<Scalars['String']>;
  msg?: Maybe<Scalars['String']>;
  record?: Maybe<Package>;
  success: Scalars['Boolean'];
};

export type PackageResource = {
  __typename?: 'PackageResource';
  createdAt: Scalars['DateTime'];
  createdBy: BasicUserInfo;
  id: Scalars['ID'];
  modifiedAt: Scalars['DateTime'];
  modifiedBy: BasicUserInfo;
  packageId: Scalars['ID'];
  resourceId: Scalars['ID'];
  resourceType: PackageResourceType;
};

export enum PackageResourceAction {
  Add = 'ADD',
  Remove = 'REMOVE'
}

export type PackageResourceInput = {
  action: PackageResourceAction;
  resourceId: Scalars['ID'];
  resourceType: PackageResourceType;
};

export type PackageResourceList = {
  __typename?: 'PackageResourceList';
  count: Scalars['Int'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records: Array<Maybe<PackageResource>>;
};

export enum PackageResourceType {
  Application = 'application',
  ApplicationContentMenuExtension = 'applicationContentMenuExtension',
  ApplicationViewer = 'applicationViewer',
  DagTemplate = 'dagTemplate',
  Dataset = 'dataset',
  Engine = 'engine',
  EngineBuild = 'engineBuild',
  EventDefinition = 'eventDefinition',
  EventListener = 'eventListener',
  EventListenerMapping = 'eventListenerMapping',
  Flow = 'flow',
  Folder = 'folder',
  Library = 'library',
  LibraryType = 'libraryType',
  NodeRedPalette = 'nodeRedPalette',
  Package = 'package',
  ScheduledJob = 'scheduledJob',
  Schema = 'schema',
  Sdo = 'sdo',
  Service = 'service',
  Tdo = 'tdo'
}

export type PackageUpdateInput = {
  aiwareVersion?: InputMaybe<Scalars['String']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  distributionType?: InputMaybe<EngineDistributionType>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  primaryResourceId?: InputMaybe<Scalars['ID']>;
  resources?: InputMaybe<Array<InputMaybe<PackageResourceInput>>>;
  sourceOriginId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['String']>;
};

/**
 * Common fields used by queries and fields that support paging to represent
 * a single page of results.
 */
export type Page = {
  /** Number of records returned in this response */
  count?: Maybe<Scalars['Int']>;
  /** Maximum number of results that were retrieved in this query; page size */
  limit: Scalars['Int'];
  /** Provide an offset to skip to a certain element in the result, for paging. */
  offset: Scalars['Int'];
};

export type PairClusterNode = {
  id: Scalars['ID'];
  nodePair: NodePair;
};

export type PasswordTokenInfo = {
  __typename?: 'PasswordTokenInfo';
  passwordToken?: Maybe<Scalars['String']>;
};

export type PauseCluster = {
  id: Scalars['ID'];
};

export type PauseClusterNode = {
  /** Node ID */
  id: Scalars['ID'];
};

export type Permission = {
  __typename?: 'Permission';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type PermissionList = Page & {
  __typename?: 'PermissionList';
  /** Number of records returned in this response */
  count?: Maybe<Scalars['Int']>;
  /** Maximum number of results that were retrieved in this query; page size */
  limit: Scalars['Int'];
  /** The starting index for records that were returned in this query. */
  offset: Scalars['Int'];
  records?: Maybe<Array<Maybe<Permission>>>;
};

export type PingClusterNode = {
  /** Id of the node. */
  nodeId: Scalars['ID'];
  nodeMetrics?: InputMaybe<Scalars['JSONData']>;
};

export type PollTask = {
  id: Scalars['ID'];
  jobId: Scalars['ID'];
  pollPayload?: InputMaybe<Scalars['JSONData']>;
};

export type ProcessTemplate = {
  __typename?: 'ProcessTemplate';
  id: Scalars['ID'];
  name: Scalars['String'];
  organizationId: Scalars['ID'];
  taskList: Scalars['JSONData'];
};

export type ProcessTemplateList = Page & {
  __typename?: 'ProcessTemplateList';
  count?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records?: Maybe<Array<ProcessTemplate>>;
};

/** Metadata that represents a program. */
export type Program = Metadata & {
  __typename?: 'Program';
  id?: Maybe<Scalars['ID']>;
  image?: Maybe<Scalars['String']>;
  liveImage?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type ProgramAffiliate = {
  __typename?: 'ProgramAffiliate';
  scheduledDay?: Maybe<DayOfWeek>;
  /** The day of week adjusted to source live timezone */
  scheduledDayLocal?: Maybe<DayOfWeek>;
  scheduledJob?: Maybe<ScheduledJob>;
  scheduledJobId: Scalars['ID'];
  source?: Maybe<Source>;
  sourceId: Scalars['ID'];
  startDateTime?: Maybe<Scalars['DateTime']>;
  startTime?: Maybe<Scalars['Time']>;
  status?: Maybe<Scalars['String']>;
  stopDateTime?: Maybe<Scalars['DateTime']>;
  stopTime?: Maybe<Scalars['Time']>;
};

export type ProgramAffiliateList = Page & {
  __typename?: 'ProgramAffiliateList';
  count?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records?: Maybe<Array<ProgramAffiliate>>;
};

/** A property is a name-value pair. This is the base interface for properties. */
export type Property = {
  name: Scalars['String'];
};

/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type Query = {
  __typename?: 'Query';
  /**
   * Retrieve a single application
   * Example:
   * Request:
   * query {
   *  	application(id: "47bd3e25-f4ea-435f-b69b-13cb4f9dd60a") {
   *     name
   *     key
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "application": {
   *       "name": "appexamplebill",
   *       "key": "appexamplebill"
   *     }
   *   }
   * }
   */
  application?: Maybe<Application>;
  /**
   * Retrieve configs for a given application
   * Example:
   * Request:
   * query {
   *   applicationConfig(applicationId: "47bd3e25-f4ea-435f-b69b-13cb4f9dd60a") {
   *     records: {
   *       configType
   *       configLevel
   *     }
   *     offset: 0
   *     limit: 1
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "applicationConfig": {
   *       "records": {
   *         "configType": "String",
   *         "configLevel": "Organization"
   *       }
   *     }
   *   }
   * }
   */
  applicationConfig: ApplicationConfigList;
  /**
   * Retrieve config definitions for a given application
   * Example:
   * Request:
   * query {
   *   applicationConfigDefinition(applicationId: "47bd3e25-f4ea-435f-b69b-13cb4f9dd60a", configKey: 'dark mode') {
   *     records: {
   *       configType
   *       defaultValue
   *     }
   *     offset: 0
   *     limit: 1
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "applicationConfigDefinition": {
   *       "records": [{
   *         "configType": Boolean,
   *         "defaultValue": true,
   *       }]
   *     }
   *   }
   * }
   */
  applicationConfigDefinition: ApplicationConfigDefinitionList;
  /**
   * Retrieve headerbar information for an application
   * Example:
   * Request:
   * query {
   *   applicationHeaderbar(id: "47bd3e25-f4ea-435f-b69b-13cb4f9dd60a") {
   *     name
   *     config {
   *       title
   *     }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "applicationHeaderbar": {
   *       "name": "APP_BAR",
   *       "config": {
   *         "title": "Library"
   *       }
   *     }
   *   }
   * }
   */
  applicationHeaderbar?: Maybe<ApplicationHeaderbar>;
  /** This returns the specified application role */
  applicationRole?: Maybe<ApplicationRole>;
  /**
   * Get App Roles
   *
   * If no args, return visible appRoles to Org.
   * If args, filter approles visible to user an org by criteria
   * If organization is specified, the user must be a SuperAdmin.  If so, then approles will be visible to that org instead of caller's org.
   * If SuperAdmin and organization is not specified, this behaves as if a normal user in an org called it.
   */
  applicationRoles: Array<Maybe<ApplicationRole>>;
  /**
   * Retrieve applications. These are custom applications integrated into
   * the Veritone platform using the VDA framework.
   * Example:
   * Request:
   * query {
   *   applications(limit:2) {
   *     records {
   *       id
   *       name
   *     }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "applications": {
   *       "records": [
   *         {
   *           "id": "47bd3e25-f4ea-435f-b69b-13cb4f9dd60a",
   *           "name": "appexamplebill"
   *         },
   *         {
   *           "id": "5908703b-51b4-4291-9787-b54bada73b0a",
   *           "name": "appexample2"
   *         }
   *       ]
   *     }
   *   }
   * }
   */
  applications?: Maybe<ApplicationList>;
  /**
   * Retrieve a single Asset
   * Example:
   * Request:
   * query {
   *   asset(
   *     id: "1570654874_4hJtNKSUXD") {
   *     id
   *     name
   *     description
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "asset": {
   *       "id": "1570654874_4hJtNKSUXD",
   *       "name": "example",
   *       "description": "example"
   *     }
   *   }
   * }
   */
  asset?: Maybe<Asset>;
  /**
   * Retrieve multiple assets
   * Example:
   * Request:
   * query {
   *   assets(
   *    ids:["1570654874_4hJtNKSUXD"],
   *     contentTypes:[],
   *     assetTypes:["text"],
   * 	  sourceEngineIds:[],
   * 	  createdDateFilter:null,
   * 	  scrollId: null){
   *     assets{
   *       records{id}
   *       count
   *     }
   *     scrollId
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "assets": {
   *       "assets": {
   *         "records": [],
   *         "count": 0
   *       },
   *       "scrollId": ""
   *     }
   *   }
   * }
   */
  assets?: Maybe<AssetScrollList>;
  /**
   * Example:
   * Request:
   * query {
   *  	auditEvents(limit: 2) {
   *     records {
   *       id
   *       application
   *     }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "auditEvents": {
   *       "records": [
   *         {
   *           "id": "fdc7b3a3-ab23-4866-a330-c0ad910cd64f",
   *           "application": ""
   *         }
   *       ]
   *     }
   *   }
   * }
   */
  auditEvents: AuditEventList;
  /**
   * Examine entries from the audit log. All operations that modify data are
   * written to the audit log. Only entries for the user's own organization
   * can be queried.
   * All queries are bracketed by a time window. A default time window is applied
   * if the `toDateTime` and/or `fromDateTime` parameters are not provided.
   * The maximum time window length is 30 days.
   * Only Veritone and organization administrators can use this query.
   * Example:
   * Request:
   * query {
   *   auditLog(limit: 2) {
   *     records {
   *       id
   *       objectId
   *       description
   *     }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "auditLog": {
   *       "records": [
   *         {
   *           "id": "735915311",
   *           "objectId": "*********",
   *           "description": "Changed password"
   *         },
   *         {
   *           "id": "735915307",
   *           "objectId": "********",
   *           "description": "Changed password"
   *         }
   *       ]
   *     }
   *   }
   * }
   */
  auditLog: AuditLogEntryList;
  /** Get authorization group by id */
  authGroup: AuthGroup;
  /** Get the list of authorization groups */
  authGroups: AuthGroupList;
  /**
   * Requires: superadmin
   * Get authorization role by id
   */
  authPermissionSet: AuthPermissionSet;
  /**
   * Requires: superadmin
   * Get the list of authorization roles in the platform
   */
  authPermissionSets: AuthPermissionSetList;
  /**
   * Retrieve the basic user information.
   * The caller and the queried user are required to be members of the same organization,
   * unless the caller is superadmin user.
   * Example:
   * Request:
   * query {
   *   basicUserInfo(id: "267de7e1-efb2-444a-a524-210328b78503") {
   *     id
   *     name
   *     firstName
   *     lastName
   *     email
   *     imageUrl
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "basicUserInfo": {
   *       "id": "267de7e1-efb2-444a-a524-210328b78503",
   *       "name": "username",
   *       "firstName": "first",
   *       "lastName": "last",
   *       "email": "email@test.com",
   *       "imageUrl": null
   *     }
   *   }
   * }
   */
  basicUserInfo?: Maybe<BasicUserInfo>;
  /**
   * Retrieve clone job entries
   * Example:
   * Request:
   * query {
   *   cloneRequests {
   *     records{
   *       id
   *     }
   *   }
   * }
   *   Response:
   *   {
   *   "data": {
   *     "cloneRequests": {
   *       "records": []
   *     }
   *   }
   * }
   */
  cloneRequests?: Maybe<CloneRequestList>;
  /** Retrieve a single cluster */
  cluster: Cluster;
  /** Retrieve a single node */
  clusterNode: ClusterNode;
  /** Retrieve a list of nodes */
  clusterNodes: ClusterNodeList;
  /** matching cluster tags in use by this organization */
  clusterTags: Array<Scalars['String']>;
  /** Retrieve a list of clusters */
  clusters: ClusterList;
  cognitiveSearch: CognitiveSearch;
  /**
   * Retrieve a collection by id
   * Example:
   * Request:
   * query {
   *   collection(id: "241121") {
   *     name
   *     isActive
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "collection": {
   *       "name": "example",
   *       "isActive": true
   *     }
   *   }
   * }
   */
  collection: Collection;
  collectionMention: CollectionMention;
  /**
   * Retrieve a list of collection mentions
   * Specify at least one of folderId or mentionId
   */
  collectionMentions: CollectionMentionList;
  /**
   * Retrieve multiple collections
   * Example:
   * Request:
   * query {
   *   collections {
   *     records {
   *       id
   *       name
   *     }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "collections": {
   *       "records": [
   *         {
   *           "id": "241121",
   *           "name": "example"
   *         },
   *         {
   *           "id": "242599",
   *           "name": "example"
   *         },
   *         {
   *           "id": "243625",
   *           "name": "example"
   *         }
   *       ]
   *     }
   *   }
   * }
   */
  collections: CollectionList;
  /**
   * Get creative by id with current organizationId
   * Example:
   * Request:
   * query {
   *   creative(id: "25209") {
   *     organizationId
   *     brandId
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "creative": {
   *       "organizationId": "35521",
   *       "brandId": null
   *     }
   *   }
   * }
   */
  creative: Creative;
  /**
   * Returns custom dashboard by id
   * Example:
   * Request:
   * query {
   *   customDashboard(id: "a20ae938-e827-4b0b-a62a-6c9af0b98cc9") {
   *     hostAppId
   *     name
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "customDashboard": {
   *       "hostAppId": "80354999-d633-4595-9578-d82f59a5134f",
   *       "name": "example"
   *     }
   *   }
   * }
   */
  customDashboard?: Maybe<CustomDashboard>;
  /**
   * Returns all custom dashboards created by user
   * Example:
   * Request:
   * query {
   *   customDashboards {
   *     records {
   *       id
   *       description
   *       hostAppId
   *     }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "customDashboards": {
   *       "records": [
   *         {
   *           "id": "a20ae938-e827-4b0b-a62a-6c9af0b98cc9",
   *           "description": "example",
   *           "hostAppId": "80354999-d633-4595-9578-d82f59a5134f"
   *         }
   *       ]
   *     }
   *   }
   * }
   */
  customDashboards?: Maybe<CustomDashboardList>;
  /** Gets a DAG Template by ID. */
  dagTemplate: DagTemplate;
  /** Retriveve a list of DAG templates */
  dagTemplates?: Maybe<DagTemplateList>;
  dailyTaskMetrics: DailyTaskMetricsList;
  /**
   * Retrieve multiple data registries
   * Example:
   * Request:
   * query {
   *   dataRegistries(limit: 2) {
   *     records {
   *       id
   *       name
   *     }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "dataRegistries": {
   *       "records": [
   *         {
   *           "id": "532ef261-d3a4-4c09-8fc7-0653a5131577",
   *           "name": "example"
   *         },
   *         {
   *           "id": "317c941d-30d0-455e-882b-34a26e513364",
   *           "name": "example"
   *         }
   *       ]
   *     }
   *   }
   * }
   */
  dataRegistries?: Maybe<DataRegistryList>;
  /**
   * Retrieve a single data registry
   * Example:
   * Request:
   * query {
   *   dataRegistry(id: "532ef261-d3a4-4c09-8fc7-0653a5131577") {
   *     name
   *     organizationId
   *     source
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "dataRegistry": {
   *       "name": "example",
   *       "organizationId": "35521",
   *       "source": "veritone-35521.datasets"
   *     }
   *   }
   * }
   */
  dataRegistry?: Maybe<DataRegistry>;
  /** Retrives the specific Dataset */
  dataset?: Maybe<Dataset>;
  datasetDataQuery: DatasetEntryList;
  /**
   * Retrieve list of Datasets
   * Example:
   * Request:
   * query {
   *   datasets(limit:2, filter: {operation:OR}) {
   *     records {
   *       datasetId
   *       name
   *     }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "datasets": {
   *       "records": []
   *     }
   *   }
   * }
   */
  datasets?: Maybe<DatasetList>;
  /**
   * Retrieve a single engine by ID
   * Example:
   * Request:
   * query {
   *   engine(id:1) {
   *     name
   *     state
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "engine": {
   *       "name": "example",
   *       "state": "pending"
   *     }
   *   }
   * }
   */
  engine?: Maybe<Engine>;
  /**
   * Retrieve an engine build
   * Example:
   * Request:
   * query {
   *   engineBuild(id: "2a1a1b58-6983-4002-b9ed-7b7f325f621a"){
   *     name
   *     engineId
   *   }
   * }
   *   Response:
   * {
   *   "data": {
   *     "engineBuild": {
   *       "name": "example Version 1",
   *       "engineId": "1"
   *     }
   *   }
   * }
   */
  engineBuild?: Maybe<Build>;
  /**
   * Retrieve engine categories
   * Example:
   * Request:
   * query {
   *   engineCategories(limit:2) {
   *     records {
   *       id
   *       type {
   *         name
   *       }
   *       name
   *     }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "engineCategories": {
   *       "records": [
   *         {
   *           "id": "581dbb32-ea5b-4458-bd15-8094942345e3",
   *           "type": {
   *             "name": "Cognition"
   *           },
   *           "name": "Transcode"
   *         },
   *         {
   *           "id": "67cd4dd0-2f75-445d-a6f0-2f297d6cd182",
   *           "type": {
   *             "name": "Cognition"
   *           },
   *           "name": "Transcription"
   *         }
   *       ]
   *     }
   *   }
   * }
   */
  engineCategories?: Maybe<EngineCategoryList>;
  /**
   * Retrieve a specific engine category\
   * Example:
   * Request:
   * query {
   *   engineCategory(id: "581dbb32-ea5b-4458-bd15-8094942345e3") {
   *     name
   *     type{
   *       name
   *     }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "engineCategory": {
   *       "name": "Transcode",
   *       "type": {
   *         "name": "Cognition"
   *       }
   *     }
   *   }
   * }
   */
  engineCategory?: Maybe<EngineCategory>;
  /**
   * Retrieve a specific engine class
   * Example:
   * Request:
   * query {
   *   engineClass(id: "e0283fdf-7f85-472e-b367-59cc8d205ba7") {
   *     id
   *     name
   *     description
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "engineClass": {
   *       "id": "e0283fdf-7f85-472e-b367-59cc8d205ba7",
   *       "name": "audio",
   *       "description": "The input to engines in the Audio class is an audio or video file or stream. If your engine processes human speech or voice, it likely belongs in the Speech class instead. Audio engines may recognize a specific audio segment, such as an advertisement, identify sounds like that of a crying baby or detect the presence of audio or music in an audio or video file, for example."
   *     }
   *   }
   * }
   */
  engineClass?: Maybe<EngineClass>;
  /**
   * Retrieve list of engine classes
   * Example:
   * Request:
   * query {
   *   engineClasses(limit: 2) {
   *     records {
   *       id
   *       name
   *       description
   *     }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "engineClasses": {
   *       "records": [
   *         {
   *           "id": "e0283fdf-7f85-472e-b367-59cc8d205ba7",
   *           "name": "audio",
   *           "description": "The input to engines in the Audio class is an audio or video file or stream. If your engine processes human speech or voice, it likely belongs in the Speech class instead. Audio engines may recognize a specific audio segment, such as an advertisement, identify sounds like that of a crying baby or detect the presence of audio or music in an audio or video file, for example."
   *         },
   *         {
   *           "id": "1bcfdd35-1e9b-4694-8273-00b19510d164",
   *           "name": "biometrics",
   *           "description": "The input to engines in the Biometrics class may be an image, speech or other audio or video file or stream. By definition, the Biometrics class covers cognitive analysis related to data points from the human body. Biometrics engines may detect or recognize faces, identify face attributes to estimate a person's age or ethnicity or verify a person based on their unique iris, for example."
   *         }
   *       ]
   *     }
   *   }
   * }
   */
  engineClasses?: Maybe<EngineClassList>;
  /** Retrieve a single engine configuration */
  engineConfiguration?: Maybe<EngineConfiguration>;
  /** Retrieve all engine configurations */
  engineConfigurations?: Maybe<EngineConfigurationList>;
  /**
   * Retrieve engine overview
   * Example:
   * Request:
   * query {
   *   engineOverview {
   *     ready
   *   }
   * }
   *   Response:
   *   {
   *   "data": {
   *     "engineOverview": {
   *       "ready": 7
   *     }
   *   }
   * }
   */
  engineOverview?: Maybe<EngineOverview>;
  /**
   * Retrieves engine results by TDO and engine ID or by job ID.
   * Example:
   * Request:
   * query {
   *   engineResults(
   *     tdoId: "1580507556",
   *   	engineIds: "4") {
   *     	sourceId
   *     	records {
   *         tdoId
   *       }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "engineResults": {
   *       "sourceId": null,
   *       "records": []
   *     }
   *   }
   * }
   */
  engineResults?: Maybe<EngineResultList>;
  /**
   * Retrieve engines
   * Example:
   * Request:
   * query {
   *   engines(limit:2) {
   *     records{
   *       id
   *       state
   *     }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "engines": {
   *       "records": [
   *         {
   *           "id": "2",
   *           "state": "pending"
   *         },
   *         {
   *           "id": "1",
   *           "state": "pending"
   *         }
   *       ]
   *     }
   *   }
   * }
   */
  engines?: Maybe<EngineList>;
  /**
   * Retrieve a list of entities across libraries
   * Example:
   * Request:
   * query {
   *  	entities(libraryIds: "e0a6e5ad-dec8-49a1-ad33-3f1194c2e599") {
   *     records {
   *       id
   *       name
   *       isPublished
   *     }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "entities": {
   *       "records": [
   *         {
   *           "id": "85b700fa-f327-4fea-b94b-ed83054170db",
   *           "name": "example",
   *           "isPublished": false
   *         }
   *       ]
   *     }
   *   }
   * }
   */
  entities?: Maybe<EntityList>;
  /**
   * Retrieve a specific entity
   * Example:
   * Request:
   * query {
   *  	entity(id: "85b700fa-f327-4fea-b94b-ed83054170db") {
   *     name
   *     libraryId
   *     isPublished
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "entity": {
   *       "name": "example",
   *       "libraryId": "e0a6e5ad-dec8-49a1-ad33-3f1194c2e599",
   *       "isPublished": false
   *     }
   *   }
   * }
   */
  entity?: Maybe<Entity>;
  /**
   * Retrieve an entity identifier type
   * Example:
   * Request:
   * query {
   *   entityIdentifierType(id:"face") {
   *     label
   *     entityIdentifierItems {
   *       libraryTypeId
   *     }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "entityIdentifierType": {
   *       "label": "Face",
   *       "entityIdentifierItems": [
   *         {
   *           "libraryTypeId": "people"
   *         },
   *         {
   *           "libraryTypeId": "suspect"
   *         },
   *         {
   *           "libraryTypeId": "people-known-offender"
   *         },
   *         {
   *           "libraryTypeId": "people-of-interest"
   *         }
   *       ]
   *     }
   *   }
   * }
   */
  entityIdentifierType?: Maybe<EntityIdentifierType>;
  /**
   * Retrieve entity identifier types
   * Example:
   * Request:
   * query {
   *     entityIdentifierTypes(limit:2) {
   *     records{
   *       id
   *       label
   *     }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "entityIdentifierTypes": {
   *       "records": [
   *         {
   *           "id": "face",
   *           "label": "Face"
   *         },
   *         {
   *           "id": "audio-recording",
   *           "label": "audio file"
   *         }
   *       ]
   *     }
   *   }
   * }
   */
  entityIdentifierTypes?: Maybe<EntityIdentifierTypeList>;
  /**
   * Retrieve a event by id
   * Example:
   * Request:
   * query {
   *   event(id: "55fc7c51-1521-4043-902f-f0f3a357da6d") {
   *     eventName
   *     eventType
   * 		description
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "event": {
   *       "eventName": "example",
   *       "eventType": "example",
   *       "description": "new example description"
   *     }
   *   }
   * }
   */
  event: Event;
  /**
   * Example:
   * Request:
   * query {
   *   eventActionTemplate(id: "d02522d7-ef5f-448f-981a-d2cfc7603d92") {
   *     organizationId
   *     actionType
   *     name
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "eventActionTemplate": {
   *       "organizationId": "35521",
   *       "actionType": "job",
   *       "name": "example"
   *     }
   *   }
   * }
   */
  eventActionTemplate?: Maybe<EventActionTemplate>;
  /**
   * Example:
   * Request:
   * query {
   *   eventActionTemplates(
   *     inputType: event,
   *     actionType: job
   *     limit:2) {
   *     	records {
   *         id
   *         name
   *       }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "eventActionTemplates": {
   *       "records": [
   *         {
   *           "id": "d02522d7-ef5f-448f-981a-d2cfc7603d92",
   *           "name": "example"
   *         },
   *         {
   *           "id": "49d28375-b6b2-418e-b965-8e939d1189ae",
   *           "name": "example"
   *         }
   *       ]
   *     }
   *   }
   * }
   */
  eventActionTemplates: EventActionTemplateList;
  /**
   * Example:
   * Request:
   * query {
   *   eventCustomRule(id: "c2c1ee13-37d2-4f92-9156-5cb1a3c59ed5") {
   *     name
   *     eventName
   *     description
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "eventCustomRule": {
   *       "name": "example",
   *       "eventName": "example",
   *       "description": "example description"
   *     }
   *   }
   * }
   */
  eventCustomRule?: Maybe<EventCustomRule>;
  /**
   * Example:
   * Request:
   * query {
   *   eventCustomRules(limit: 2) {
   *     records {
   *       id
   *       name
   *     }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "eventCustomRules": {
   *       "records": [
   *         {
   *           "id": "c2c1ee13-37d2-4f92-9156-5cb1a3c59ed5",
   *           "name": "example"
   *         }
   *       ]
   *     }
   *   }
   * }
   */
  eventCustomRules: EventCustomRuleList;
  /**
   * Retrieve a subscription by id
   * Example:
   * Request:
   * query {
   *   eventSubscription(id: "4a81cdf7-e85b-4dc4-85ce-7c2d300cd194") {
   *     id
   *     organizationId
   *     eventName
   *     targetName
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "eventSubscription": {
   *       "id": "4a81cdf7-e85b-4dc4-85ce-7c2d300cd194",
   *       "organizationId": "35521",
   *       "eventName": "LibraryTrainingComplete",
   *       "targetName": "NotificationMailbox"
   *     }
   *   }
   * }
   */
  eventSubscription: EventSubscription;
  /**
   * Retrieve a list of subscriptions by organization
   * Example:
   * Request:
   * query {
   *   eventSubscriptions(limit: 2) {
   *     records {
   *       id
   *       eventName
   *     }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "eventSubscriptions": {
   *       "records": [
   *         {
   *           "id": "4a81cdf7-e85b-4dc4-85ce-7c2d300cd194",
   *           "eventName": "LibraryTrainingComplete"
   *         },
   *         {
   *           "id": "c7c4a969-4500-4d7b-b77f-81b1e64bf112",
   *           "eventName": "LibraryTrainingComplete"
   *         }
   *       ]
   *     }
   *   }
   * }
   */
  eventSubscriptions: EventSubscriptionList;
  /**
   * Retrieve a list of events by application
   * Example:
   * Request:
   * query {
   *   events(
   *     application: "system",
   *     limit: 2) {
   *     	records {
   *         id
   *         eventName
   *       }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "events": {
   *       "records": [
   *         {
   *           "id": "8876aa2f-1068-411d-b746-28c867c151cc",
   *           "eventName": "ActionTokenForbidden"
   *         },
   *         {
   *           "id": "d5082d0e-3c96-4c71-9f27-c679650f2adf",
   *           "eventName": "ActionUserForbidden"
   *         }
   *       ]
   *     }
   *   }
   * }
   */
  events: EventList;
  /** Retrieve a single execution location */
  executionLocation?: Maybe<ExecutionLocation>;
  /** Retrieve a list of execution locations */
  executionLocations: ExecutionLocationList;
  /**
   * Retrieve a single export request by id
   * Example:
   * Request:
   * query {
   *   exportRequest(id: "938b2d64-6df1-486b-b6ea-29d33dee49ad") {
   *     id
   *     organizationId
   *     requestorId
   *     status
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "exportRequest": {
   *       "id": "938b2d64-6df1-486b-b6ea-29d33dee49ad",
   *       "organizationId": "35521",
   *       "requestorId": "59cb4e74-7c31-4267-b91e-d4600bc08008",
   *       "status": "complete"
   *     }
   *   }
   * }
   */
  exportRequest: ExportRequest;
  /**
   * Retrieve a list of export requests
   * Example:
   * Request:
   * query {
   *   exportRequests(limit: 2) {
   *     records {
   *       id
   *       organizationId
   *     }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "exportRequests": {
   *       "records": [
   *         {
   *           "id": "938b2d64-6df1-486b-b6ea-29d33dee49ad",
   *           "organizationId": "35521"
   *         }
   *       ]
   *     }
   *   }
   * }
   */
  exportRequests: ExportRequestList;
  /** Retrieve a single external credential */
  externalCredential: ExternalCredential;
  /** Retrieve a list of external credentials */
  externalCredentials: ExternalCredentialList;
  /** flow */
  flow?: Maybe<Engine>;
  /** flowExecution */
  flowExecution?: Maybe<FlowExecution>;
  /** flowExecutions */
  flowExecutions?: Maybe<FlowExecutionList>;
  /** flowRevision */
  flowRevision?: Maybe<FlowRevision>;
  /** flowRevisions */
  flowRevisions?: Maybe<FlowRevisionList>;
  /** flowTemplates */
  flowTemplates?: Maybe<FlowTemplateList>;
  /** flows */
  flows?: Maybe<EngineList>;
  /**
   * Retrieve a single folder. Used to navigate the folder tree structure.
   * Example:
   * Request:
   * query {
   *  	folder(id: "2ac28573-917a-4c4b-be91-a0ac64cbc982") {
   *     	typeId
   *     	treeObjectId
   *     	childFolders{
   *         records{
   *           id
   *         }
   *       }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "folder": {
   *       "typeId": 4,
   *       "treeObjectId": "3104f61f-4bd1-4175-9fe6-27436d591c54",
   *       "childFolders": {
   *         "records": [
   *           {
   *             "id": "9d639f1b-a0d4-47b0-8149-3568f048f320"
   *           },
   *           {
   *             "id": "a347319d-72da-43a2-93fc-e677876aca80"
   *           }
   *         ]
   *       }
   *     }
   *   }
   * }
   */
  folder?: Maybe<Folder>;
  /**
   * Retrieve a folder overview
   * Example:
   * Request:
   * query {
   *  	folderOverview(ids:"3104f61f-4bd1-4175-9fe6-27436d591c54") {
   *     childFoldersCount
   *     childNonFolderObjectsCount
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "folderOverview": {
   *       "childFoldersCount": 3,
   *       "childNonFolderObjectsCount": 0
   *     }
   *   }
   * }
   */
  folderOverview?: Maybe<FolderOverview>;
  /**
   * Example:
   * Request:
   * query {
   *  	folderSummaryDetails(ids: "3104f61f-4bd1-4175-9fe6-27436d591c54") {
   *     id
   *     typeId
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "folderSummaryDetails": [
   *       {
   *         "id": "1580701928",
   *         "typeId": 5
   *       },
   *       {
   *         "id": "1580388995",
   *         "typeId": 5
   *       },
   *       {
   *         "id": "2ac28573-917a-4c4b-be91-a0ac64cbc982",
   *         "typeId": 4
   *       },
   *       {
   *         "id": "243625",
   *         "typeId": 3
   *       },
   *       {
   *         "id": "242599",
   *         "typeId": 3
   *       },
   *       {
   *         "id": "d551fbd6-7354-4b0e-abfb-654ab8583be2",
   *         "typeId": 1
   *       },
   *       {
   *         "id": "a347319d-72da-43a2-93fc-e677876aca80",
   *         "typeId": 1
   *       },
   *       {
   *         "id": "9d639f1b-a0d4-47b0-8149-3568f048f320",
   *         "typeId": 1
   *       }
   *     ]
   *   }
   * }
   */
  folderSummaryDetails?: Maybe<Array<Maybe<FolderSummaryDetail>>>;
  /** Returns the ACL for the specified object */
  getACLForResources?: Maybe<AuthAcl>;
  /**
   * Returns a signed writable S3 URL. A client can then
   * upload to this URL with an HTTP PUT without providing
   * any additional authorization (_note_: it must be a PUT.
   * A POST will fail.)
   * Example:
   * Request:
   * query {
   *  	getSignedWritableUrl(type: "preview") {
   *     bucket
   *     key
   *     url
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "getSignedWritableUrl": {
   *       "bucket": "prod-api.veritone.com",
   *       "key": "35521/preview/2021/5/5/_/19-50-374_ed2c10a7-6f96-4d7c-a498-7bedeb383c7e",
   *       "url": "https://s3.amazonaws.com/prod-api.veritone.com/35521/preview/2021/5/5/_/19-50-374_ed2c10a7-6f96-4d7c-a498-7bedeb383c7e?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAQMR5VATUHU3MEGOA%2F20210618%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20210618T194850Z&X-Amz-Expires=86400&X-Amz-Signature=44857350a7f0b7311d4b911b557f4171a6ffe126c76e3d26f6e5cd532f645e53&X-Amz-SignedHeaders=host"
   *     }
   *   }
   * }
   */
  getSignedWritableUrl?: Maybe<WritableUrlInfo>;
  /**
   * Return writable storage URLs in bulk.
   * A maximum of 1000 can be created in one call.
   * See `getSignedWritableUrl` for details on usage of the
   * response contents.
   * Example:
   * Request:
   * query {
   *  getSignedWritableUrls(number: 2) {
   *   	bucket
   *   	key
   *   	url
   * 	}
   * }
   * Response:
   * {
   *   "data": {
   *     "getSignedWritableUrls": [
   *       {
   *         "bucket": "prod-api.veritone.com",
   *         "key": "35521/other/2021/5/5/_/19-19-384_723ca284-cee6-4883-af16-edcbfed86433",
   *         "url": "https://s3.amazonaws.com/prod-api.veritone.com/35521/other/2021/5/5/_/19-19-384_723ca284-cee6-4883-af16-edcbfed86433?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAQMR5VATUHU3MEGOA%2F20210618%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20210618T194919Z&X-Amz-Expires=86400&X-Amz-Signature=57c8d9046297e6d6839d19e7d22552618e9ff89dd4855ca7f7aceb26e89d3de4&X-Amz-SignedHeaders=host"
   *       },
   *       {
   *         "bucket": "prod-api.veritone.com",
   *         "key": "35521/other/2021/5/6/_/19-19-384_76af4aeb-5d9b-4bc4-b1d0-251e3f57b651",
   *         "url": "https://s3.amazonaws.com/prod-api.veritone.com/35521/other/2021/5/6/_/19-19-384_76af4aeb-5d9b-4bc4-b1d0-251e3f57b651?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAQMR5VATUHU3MEGOA%2F20210618%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20210618T194919Z&X-Amz-Expires=86400&X-Amz-Signature=9e139df517ca85fa0b969f0d3ff55b890b8a5e199c4fa7b3a26ea2f12a65bfec&X-Amz-SignedHeaders=host"
   *       }
   *     ]
   *   }
   * }
   */
  getSignedWritableUrls: Array<WritableUrlInfo>;
  /**
   * Gets engine usage for an organization based on their billing type.
   * Example:
   * Request:
   * query {
   *   getUsageByTaskType {
   *     totalDuration
   *     totalCost
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "getUsageByTaskType": {
   *       "totalDuration": 0,
   *       "totalCost": "0"
   *     }
   *   }
   * }
   */
  getUsageByTaskType: UsageByTaskType;
  /**
   * Retrieve Application user setting definitions
   * Example:
   * Request:
   * query {
   *   getUserSettingDefinitions(application: "80354999-d633-4595-9578-d82f59a5134f") {
   *     key
   *     value
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "getUserSettingDefinitions": [
   *       {
   *         "key": "example",
   *         "value": "example"
   *       }
   *     ]
   *   }
   * }
   */
  getUserSettingDefinitions?: Maybe<Array<Maybe<ApplicationSetting>>>;
  /**
   * Retrive User setting
   * Example:
   * Request:
   * query {
   *   getUserSettings {
   *     key
   *     applicationId
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "getUserSettings": [
   *       {
   *         "key": "example12",
   *         "applicationId": "80354999-d633-4595-9578-d82f59a5134f"
   *       }
   *     ]
   *   }
   * }
   */
  getUserSettings?: Maybe<Array<Maybe<UserSetting>>>;
  /**
   * Returns information about the GraphQL server, useful
   * for diagnostics. This data is primarily used by Veritone
   * development, and some fields may be restricted to Veritone administrators.
   */
  graphqlServiceInfo?: Maybe<GraphQlServiceInfo>;
  /**
   * Retrieve groups
   * Example:
   * Request:
   * query {
   *  	groups {
   *     records {
   *       id
   *       name
   *     }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "groups": {
   *       "records": [
   *         {
   *           "id": "8db639c1-c926-4f83-90de-d86c2ae5973d",
   *           "name": "WTS API Docs Org"
   *         }
   *       ]
   *     }
   *   }
   * }
   */
  groups?: Maybe<GroupList>;
  /** See if the specified objects have the specified permissions */
  hasPermissions: Array<Maybe<AuthPermissionCheck>>;
  /** Retrieve a single job by ID */
  job?: Maybe<Job>;
  /** Retrieve a single job template */
  jobTemplate: JobTemplate;
  /** Retrieve a list of job templates for a given job pipelineId */
  jobTemplates: JobTemplateList;
  /**
   * Retrieve jobs
   * Example:
   * Request:
   * query {
   *   jobs(limit:2) {
   *     records{
   *       id
   *       name
   *     }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "jobs": {
   *       "records": []
   *     }
   *   }
   * }
   */
  jobs?: Maybe<JobList>;
  /**
   * Retrieve libraries and entities
   * Example:
   * Request:
   * query {
   *   libraries(limit:2) {
   *     records {
   *       id
   *       name
   *       libraryTypeId
   *     }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "libraries": {
   *       "records": [
   *         {
   *           "id": "e0a6e5ad-dec8-49a1-ad33-3f1194c2e599",
   *           "name": "example",
   *           "libraryTypeId": "123"
   *         }
   *       ]
   *     }
   *   }
   * }
   */
  libraries?: Maybe<LibraryList>;
  /**
   * Retrieve a specific library
   * Example:
   * Request:
   * query {
   *   library(id: "e0a6e5ad-dec8-49a1-ad33-3f1194c2e599") {
   *     name
   *     organizationId
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "library": {
   *       "name": "example",
   *       "organizationId": "35521"
   *     }
   *   }
   * }
   */
  library?: Maybe<Library>;
  /**
   * Retrieve library configuration
   * Example:
   * Request:
   * query {
   *   libraryConfiguration(id:"7396e71b-db5a-4c4c-bf6f-4fc66a5a07f7") {
   *     confidence{
   *       min
   *       max
   *     }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "libraryConfiguration": {
   *       "confidence": {
   *         "min": 0,
   *         "max": 100
   *       }
   *     }
   *   }
   * }
   */
  libraryConfiguration?: Maybe<LibraryConfiguration>;
  /**
   * Retrieve a specific library engine model
   * Example:
   * Request:
   * query {
   *   libraryEngineModel(id: "87714ca6-8dbd-4da0-9dc0-d9233927b00d") {
   *     trainStatus
   *     engineId
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "libraryEngineModel": {
   *       "trainStatus": "pending",
   *       "engineId": "1"
   *     }
   *   }
   * }
   */
  libraryEngineModel?: Maybe<LibraryEngineModel>;
  /**
   * Retrieve a single library type
   * Example:
   * Request:
   * query {
   *   libraryType(id: "people-known-offender") {
   *     entityTypeName
   *     label
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "libraryType": {
   *       "entityTypeName": "known offender",
   *       "label": "IDentify - Known Offender"
   *     }
   *   }
   * }
   */
  libraryType?: Maybe<LibraryType>;
  /**
   * Retrieve all library types
   * Example:
   * Request:
   * query {
   *   libraryTypes(limit:2) {
   *     records{
   *       id
   *       entityTypeName
   *     }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "libraryTypes": {
   *       "records": [
   *         {
   *           "id": "people-known-offender",
   *           "entityTypeName": "known offender"
   *         },
   *         {
   *           "id": "dataset",
   *           "entityTypeName": "dataset"
   *         }
   *       ]
   *     }
   *   }
   * }
   */
  libraryTypes?: Maybe<LibraryTypeList>;
  /**
   * Retrieve list entity tags where tag key contains user input
   * Example:
   * Request:
   * query {
   *   matchEntityTags(input: { tagKey: "test}) {
   *     records {
   *       tagKey
   *       tagValue
   *     }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "matchEntityTags": {
   *       "records": [
   *         {
   *           "tagKey": "test-tag",
   *           "tagValue": "test-value"
   *         },
   *         {
   *           "tagKey": "another-testtag",
   *           "tagValue": ""
   *         },
   *       ]
   *     }
   *   }
   * }
   */
  matchEntityTags?: Maybe<MatchedEntityTagsList>;
  /**
   * Retrieve information for the current logged-in user
   * Example:
   * Request:
   * query {
   *  	me {
   *     id
   *     organizationId
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "me": {
   *       "id": "59cb4e74-7c31-4267-b91e-d4600bc08008",
   *       "organizationId": "35521"
   *     }
   *   }
   * }
   */
  me?: Maybe<User>;
  /** Get the media share by media shareId */
  mediaShare: MediaShare;
  /** Retrieve a single mention */
  mention?: Maybe<Mention>;
  /**
   * Example:
   * Request:
   * query {
   *  	mentionStatusOptions {
   *     id
   *     name
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "mentionStatusOptions": [
   *       {
   *         "id": "7",
   *         "name": "Auto Verified"
   *       },
   *       {
   *         "id": "5",
   *         "name": "Invalid"
   *       },
   *       {
   *         "id": "3",
   *         "name": "Needs Review"
   *       },
   *       {
   *         "id": "1",
   *         "name": "Pending Verification"
   *       },
   *       {
   *         "id": "6",
   *         "name": "Processing Verification"
   *       },
   *       {
   *         "id": "4",
   *         "name": "Request Bonus"
   *       },
   *       {
   *         "id": "2",
   *         "name": "Verified"
   *       }
   *     ]
   *   }
   * }
   */
  mentionStatusOptions: Array<MentionStatus>;
  /**
   * Retrieve multiple mentions
   * Example:
   * Request:
   * query {
   *   mentions {
   *     records {
   *       id
   *     }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "mentions": {
   *       "records": []
   *     }
   *   }
   * }
   */
  mentions?: Maybe<MentionList>;
  /**
   * Retrieve basic organization info about the organizations to which the user belongs
   * Example:
   * Request:
   * query {
   *  	myOrganizations {
   *     records {
   *       id
   *       name
   *     }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "myOrganizations": {
   *       "records": [
   *         {
   *           "id": "35521",
   *           "name": "WTS API Docs Org"
   *         }
   *       ]
   *     }
   *   }
   * }
   */
  myOrganizations?: Maybe<OrganizationInfoList>;
  /**
   * Retrieve the rights of the current user
   * Example:
   * Request:
   * query {
   *  	myRights {
   *     resources
   *     operations
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "myRights": {
   *       "resources": {},
   *       "operations": [
   *         "admin.access",
   *         "admin.org.read",
   *         "admin.org.update",
   *         "admin.user.create",
   *         "admin.user.read",
   *         "admin.user.update",
   *         "admin.user.delete",
   *         ...
   *       ]
   *     }
   *   }
   * }
   */
  myRights?: Maybe<RightsListing>;
  /**
   * Retrieve Notification Actions
   * Example:
   * Request:
   * query {
   *   notificationActions {
   *     records {
   *     	id
   *       actionName
   *     }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "notificationActions": {
   *       "records": [
   *         {
   *           "id": "866aad9c-9e68-4c33-b523-373bb332aea2",
   *           "actionName": "example"
   *         }
   *       ]
   *     }
   *   }
   * }
   */
  notificationActions?: Maybe<NotificationActionList>;
  /**
   * Retrive Notification Mailboxes by list of mailboxIds
   * Example:
   * Request:
   * query {
   *   notificationMailboxes {
   *     id
   *     name
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "notificationMailboxes": [
   *       {
   *         "id": "6fda80b5-3d1a-4eb8-bd32-277be5104149",
   *         "name": "example"
   *       },
   *       {
   *         "id": "d20e9f37-a887-41bb-aed0-3268884ecebc",
   *         "name": "Library training mailbox"
   *       },
   *       {
   *         "id": "2d29533b-560e-4354-b794-84f823d33205",
   *         "name": "Library training mailbox"
   *       }
   *     ]
   *   }
   * }
   */
  notificationMailboxes?: Maybe<Array<NotificationMailbox>>;
  /**
   * Retrive Notification Templates
   * Example:
   * Request:
   * query {
   *   notificationTemplates(limit: 2) {
   *     records {
   *       id
   *       eventName
   *     }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "notificationTemplates": {
   *       "records": [
   *         {
   *           "id": "3947b833-2be4-4415-8272-2cee62fbca23",
   *           "eventName": "example"
   *         }
   *       ]
   *     }
   *   }
   * }
   */
  notificationTemplates?: Maybe<NotificationTemplateList>;
  /** Get OpenID Provider by id */
  openIdProvider: OpenIdProvider;
  /**
   * Get OpenID Provides
   * Example:
   * Request:
   * query {
   *   openIdProviders {
   *     records {
   *       id
   *       isGlobal
   *       websiteUrl
   *     }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "openIdProviders": {
   *       "records": []
   *     }
   *   }
   * }
   */
  openIdProviders?: Maybe<OpenIdProviderList>;
  /**
   * Retrieve a single organization
   * Example:
   * Request:
   * query {
   *   organization(id: "35521") {
   *     status
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "organization": {
   *       "status": "active"
   *     }
   *   }
   * }
   */
  organization?: Maybe<Organization>;
  /**
   * Retrieve organizations
   * Example:
   * Request:
   * query {
   *   organizations(limit:2) {
   *     records {
   *       id
   *       name
   *     }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "organizations": {
   *       "records": [
   *         {
   *           "id": "35521",
   *           "name": "WTS API Docs Org"
   *         }
   *       ]
   *     }
   *   }
   * }
   */
  organizations?: Maybe<OrganizationList>;
  /**
   * List existing package grants.
   * Either packageId or organizationId must be specified
   * packageGrants(id: 123) - Show grants for package 123
   * packageGrants(organizationId: 12) - Show grants for all packages to org 12
   * packageGrants(id: 123, organizationId: 12) Show grants for package 123 to org 12.
   */
  packageGrants?: Maybe<PackageGrantList>;
  packages?: Maybe<PackageList>;
  /**
   * Retrieve permissions
   * Example:
   * Request:
   * query {
   *  	permissions(limit:5) {
   *     records {
   *       id
   *       name
   *     }
   *   }
   * }
   *   Response:
   * {
   *   "data": {
   *     "permissions": {
   *       "records": [
   *         {
   *           "id": "2",
   *           "name": "admin.access"
   *         },
   *         {
   *           "id": "9",
   *           "name": "admin.group.create"
   *         },
   *         {
   *           "id": "12",
   *           "name": "admin.group.delete"
   *         },
   *         {
   *           "id": "10",
   *           "name": "admin.group.read"
   *         },
   *         {
   *           "id": "11",
   *           "name": "admin.group.update"
   *         }
   *       ]
   *     }
   *   }
   * }
   */
  permissions?: Maybe<PermissionList>;
  /**
   * Get process templates by id
   * Example:
   * Request:
   * query {
   *   processTemplate(id: "762") {
   *     name
   *     organizationId
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "processTemplate": {
   *       "name": "example",
   *       "organizationId": "35521"
   *     }
   *   }
   * }
   */
  processTemplate: ProcessTemplate;
  /**
   * Get list process templates by id or current organizationId
   * Example:
   * Request:
   * query {
   *   processTemplates(limit: 2) {
   *     records {
   *       id
   *       organizationId
   *       name
   *     }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "processTemplates": {
   *       "records": [
   *         {
   *           "id": "762",
   *           "organizationId": "35521",
   *           "name": "example"
   *         }
   *       ]
   *     }
   *   }
   * }
   */
  processTemplates: ProcessTemplateList;
  /**
   * Retrieve most recent builds
   * Example:
   * Request:
   * query {
   *   recentBuilds(limit:2) {
   *     records{
   *       id
   *       name
   *     }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "recentBuilds": {
   *       "records": [
   *         {
   *           "id": "44193f81-57b4-47dd-9fe0-be95000776d9",
   *           "name": "example Version 5"
   *         },
   *         {
   *           "id": "bae12129-2724-40c3-abd2-6bb4021f21ae",
   *           "name": "example Version 4"
   *         }
   *       ]
   *     }
   *   }
   * }
   */
  recentBuilds?: Maybe<BuildList>;
  /**
   * Retrieve the root folders for an organization
   * Example:
   * Request:
   * query {
   *  	rootFolders {
   *     id
   *     typeId
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "rootFolders": [
   *       {
   *         "id": "2ac28573-917a-4c4b-be91-a0ac64cbc982",
   *         "typeId": 4
   *       },
   *       {
   *         "id": "d3e27eb3-7d4a-47ab-af64-bf1529390f4e",
   *         "typeId": 4
   *       }
   *     ]
   *   }
   * }
   */
  rootFolders?: Maybe<Array<Maybe<Folder>>>;
  /**
   * Fetch all saved searches that the current user has made
   * Fetch all saved searches that have been shared with
   * the current users organization
   * Include any saved searches that the user has created
   * Example:
   * Request:
   * query {
   *   savedSearches {
   *     records {
   *       id
   *       name
   *     }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "savedSearches": {
   *       "records": [
   *         {
   *           "id": "3aa9fecb-d3cb-4fa5-a11b-20e02ae494b9",
   *           "name": "example"
   *         }
   *       ]
   *     }
   *   }
   * }
   */
  savedSearches: SavedSearchList;
  /** Retrieve a single schedule */
  scheduledJob?: Maybe<ScheduledJob>;
  /** Retrieve or search for schedules */
  scheduledJobs?: Maybe<ScheduledJobList>;
  /**
   * Retrieve a schema for structured data ingestions
   * Example:
   * Request:
   * query {
   *  	schema(id: "21a08123-45dc-497e-b329-360d9f3fcaac") {
   *     definition
   *     status
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "schema": {
   *       "definition": {
   *         "example": "example value"
   *       },
   *       "status": "draft"
   *     }
   *   }
   * }
   */
  schema?: Maybe<Schema>;
  /**
   * Example:
   * Request:
   * query {
   *  	schemaProperties(limit: 2) {
   *     records {
   *       type
   *       dataRegistryId
   *     }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "schemaProperties": {
   *       "records": [
   *         {
   *           "type": "string",
   *           "dataRegistryId": "c3c9fa66-15b2-4bc4-b37f-c790e3ea0db6"
   *         },
   *         {
   *           "type": "string",
   *           "dataRegistryId": "dbfa78af-f935-4ace-8a70-f70ca36ce49c"
   *         }
   *       ]
   *     }
   *   }
   * }
   */
  schemaProperties?: Maybe<SchemaPropertyList>;
  /**
   * Retrieve a list of schemas for structured data ingestions\
   * Example:
   * Request:
   * query {
   *   schemas(limit: 2) {
   *     records {
   *       id
   *       organizationId
   *     }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "schemas": {
   *       "records": [
   *         {
   *           "id": "21a08123-45dc-497e-b329-360d9f3fcaac",
   *           "organizationId": "35521"
   *         },
   *         {
   *           "id": "57aa1618-344d-4d35-9980-5fe1ec6c3112",
   *           "organizationId": "35521"
   *         }
   *       ]
   *     }
   *   }
   * }
   */
  schemas?: Maybe<SchemaList>;
  /**
   * Search for media across an index.
   * This query requires a user token.
   * Example:
   * Request:
   * query{
   *   searchMedia(search:{
   *     offset: 0
   *     limit: 1
   *     index: ["mine"]
   *     query:{
   *         operator: "query_string"
   *         field: "transcript.transcript"
   *         value: "paris NOT \"las vegas\""
   *         }
   *   }) {
   *     jsondata
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "searchMedia": {
   *       "jsondata": {
   *         "results": [
   *           {
   *             "recording": {
   *               "recordingId": "43033727",
   *               "fileLocation": "https://inspirent.s3.amazonaws.com/assets/43033727/ea9d9845-775b-48cd-aada-16fa56894ba0.mp4?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAI7L6G7PCOOOLA7MQ%2F20171215%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20171215T181255Z&X-Amz-Expires=604800&X-Amz-Signature=2fd918d5ac20979bd27d365bfa455904cf1726307fddbd362a28a8bd9a0a81a8&X-Amz-SignedHeaders=host",
   *               "fileType": "video/mp4",
   *               "programId": "-1",
   *               "programName": "Weekly Talkshow",
   *               "programLiveImage": "https://inspirent.s3.amazonaws.com/assets/43033727/fe693b30-18ae-47c7-984f-530eab61d7.jpeg",
   *               "mediaSourceId": "-1",
   *               "mediaSourceTypeId": "5",
   *               "sliceTime": 1512682022,
   *               "mediaStartTime": 1512681992,
   *               "aibDuration": 90,
   *               "isOwn": true,
   *               "hitStartTime": 1512682022,
   *               "hitEndTime": 1512682082
   *             },
   *             "startDateTime": 1512682022,
   *             "stopDateTime": 1512682082,
   *             "hits": [
   *               {
   *                 "veritone-file": {
   *                   "filename": "Veritone_v06.mp4",
   *                   "mimetype": "video/mp4",
   *                   "size": 162533502
   *                 }
   *               }
   *             ]
   *           }
   *         ],
   *         "totalResults": 733275,
   *         "limit": 1,
   *         "from": 0,
   *         "to": 0,
   *         "searchToken": "930f0960-e1c3-11e7-9e94-eba5f6b5faf7",
   *         "timestamp": 1513361576
   *       }
   *     }
   *   }
   * }
   */
  searchMedia?: Maybe<SearchResult>;
  /**
   * Search for mentions across an index.
   * This query requires a user token.
   * Known Issues:
   * - Offset can not go past 10,000.  To get around this, the best practice is to keep updating the start time of the query based on the last mention you have processed.
   * Example:
   * Request:
   * query{
   *   searchMentions(search:{
   *     offset: 0
   *     limit: 1
   *     index: ["mine"]
   *     query:{
   *         operator: "and"
   *         conditions: [{
   *             operator: "term"
   *             field: "trackingUnitName"
   *             value: "Dallas Cowboys Super Bowl"
   *             },
   *             {
   *             operator: "term"
   *             field: "mentionStatusId"
   *             value: "1"
   *         }]
   *     }
   *   }) {
   *     jsondata
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "searchMentions": {
   *       "jsondata": {
   *         "results": [
   *           {
   *             "id": 47569938,
   *             "programFormatName": "Information and News",
   *             "mentionDate": "2017-01-31T07:59:18.000Z",
   *             "mediaStartTime": "2017-01-31T07:45:01.000Z",
   *             "mediaId": 20017455,
   *             "metadata": {
   *               "filename": "AM-RADIO",
   *               "veritone-file": {
   *                 "size": 0,
   *                 "filename": "AM-RADIO",
   *                 "mimetype": "audio/mpeg"
   *               },
   *               "veritone-media-source": {
   *                  "mediaSourceId": "14326",
   *                 "mediaSourceTypeId": "1"
   *               },
   *               "veritone-program": {
   *                 "programId": "3828",
   *                 "programName": "AM-RADIO Morning Talk",
   *                 "programImage": "https://s3.amazonaws.com/veritone-ugc/cb5e59d4-a986-4e2b-b525-482319df3350%2FbrdProgram%2F2uGsLVKsQeiKN3UuHufC_941478_10151455644772706_951533539_n.jpg",
   *                 "programLiveImage": "https://s3.amazonaws.com/prod-veritone-ugc/cb5e59d4-a986-4e2b-b525-482319df3350%2FbrdProgram%2FwwEn3Ya9RgmMQwUEGoD1_LUkKlgZQS36ncUbY8Iz7_2520to%2520live2.JPG"
   *               }
   *             },
   *             "fileLocation": "https://inspirent.s3.amazonaws.com/recordings/9605ea97-87df-428e-6740-720df8b8691c_original.mp3?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAI7L6G7PCOOOLA7MQ%2F20171215%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20171215T205111Z&X-Amz-Expires=604800&X-Amz-Signature=00f62a6e2367c109320c98b9aea190cd28d82ac347eeeca030f42810b7ab75e3&X-Amz-SignedHeaders=host",
   *             "fileType": "audio/mpeg",
   *             "snippets": [
   *               {
   *                 "startTime": 857.62,
   *                 "endTime": 887.33,
   *                 "text": "eighty first women's Australian Open final Monica Seles beat Steffi Graf four six six three six two in one thousand nine hundred twenty eight the Dallas Cowboys beat the Buffalo Bills thirty to thirteen in Atlanta running back Emmitt Smith wins the M.V.P. and fourth consecutive Super Bowl game loss to the Cowboys twenty sixteen at the one hundred fourth women's Australian Open final six three six six four that time capsule your",
   *                 "hits": [
   *                   {
   *                     "startTime": 865.7,
   *                     "endTime": 865.929,
   *                     "queryTerm": "Dallas"
   *                   },
   *                   {
   *                     "startTime": 865.93,
   *                     "endTime": 866.07,
   *                     "queryTerm": "Cowboys"
   *                   },
   *                   {
   *                     "startTime": 872.74,
   *                       "endTime": 873.31,
   *                     "queryTerm": "Super"
   *                   },
   *                   {
   *                     "startTime": 873.31,
   *                     "endTime": 873.43,
   *                     "queryTerm": "Bowl"
   *                   }
   *                 ]
   *               }
   *             ],
   *             "userSnippets": null,
   *             "advertiserId": 0,
   *             "advertiserName": "",
   *             "brandId": 0,
   *             "brandImage": "",
   *             "brandName": "",
   *             "campaignId": 0,
   *             "campaignName": "",
   *             "organizationId": 7295,
   *                "organizationName": "Demo Organization",
   *             "trackingUnitId": 10032,
   *             "trackingUnitName": "Dallas Cowboys Super Bowl",
   *             "mentionStatusId": 1,
   *             "mediaSourceTypeId": 1,
   *             "mediaSourceTypeName": "Audio",
   *             "mediaSourceId": 14326,
   *             "mediaSourceName": "AM-RADIO Morning Talk",
   *             "isNational": true,
   *             "spotTypeId": null,
   *             "spotTypeName": null,
   *             "programId": 3828,
   *             "programName": "AM-RADIO",
   *             "programImage": "https://s3.amazonaws.com/prod-veritone-ugc/cb5e59d4-a986-4e2b-b525-482319df3350%2FbrdProgram%2F2uGsLVKsQeiKN3UuHufC_941478_10151455644772706_951533539_n.jpg",
   *             "programLiveImage": "https://s3.amazonaws.com/veritone-ugc/cb5e52b4-a986-4e2b-b525-482319df3350%2FbrdProgram%2FwwEn3Ya9RgmMQwUEGoD1_LUkKlgZQS36ncUbY8Iz7_2520to%2520live2.JPG",
   *             "impressions": 1894,
   *             "audience": [
   *               {
   *                 "gender": "men",
   *                 "age_group": "35-44",
   *                 "audience": 11,
   *                 "isTargetMatch": true
   *               },
   *               {
   *                 "gender": "men",
   *                 "age_group": "45-49",
   *                 "audience": 121,
   *                 "isTargetMatch": true
   *               },
   *               {
   *                 "gender": "men",
   *                 "age_group": "50-54",
   *                 "audience": 474,
   *                 "isTargetMatch": true
   *               },
   *               {
   *                 "gender": "men",
   *                 "age_group": "65+",
   *                 "audience": 95,
   *                 "isTargetMatch": true
   *               },
   *               {
   *                 "gender": "women",
   *                 "age_group": "50-54",
   *                 "audience": 19,
   *                 "isTargetMatch": false
   *               },
   *               {
   *                 "gender": "women",
   *                 "age_group": "65+",
   *                 "audience": 693,
   *                 "isTargetMatch": false
   *               },
   *               {
   *                 "gender": "men",
   *                 "age_group": "55-64",
   *                 "audience": 481,
   *                 "isTargetMatch": true
   *               }
   *             ],
   *             "targetAudience": {
   *               "gender": 1,
   *               "genderName": "M",
   *               "ageGroup": [
   *                 0,
   *                 5
   *               ],
   *               "ageGroupMin": 18,
   *               "ageGroupMax": 0,
   *                 "impressions": 1182
   *             },
   *             "audienceMarketCount": 3,
   *             "audienceAffiliateCount": 1,
   *             "rating": null,
   *             "ratings": null,
   *             "comments": null,
   *             "markets": [
   *               {
   *                 "marketId": 54,
   *                 "marketName": "Des Moines-Ames, IA"
   *               }
   *             ],
   *             "marketId": null,
   *             "marketName": null,
   *             "hourOfDay": 7,
   *             "dayOfWeek": 2,
   *             "dayOfMonth": 31,
   *             "month": 1,
   *             "year": 2017,
   *             "isMatch": true,
   *             "mentionStatusName": "Pending Verification",
   *             "complianceStatusId": null,
   *             "cognitiveEngineResults": null,
   *             "hits": 4
   *           }
   *         ],
   *         "totalResults": 579,
   *         "limit": 1,
   *         "from": 0,
   *         "to": 0,
   *         "searchToken": "ae882400-e1d9-11e7-947b-339cddca931e",
   *         "timestamp": 1513371071
   *       }
   *     }
   *   }
   * }
   */
  searchMentions?: Maybe<SearchResult>;
  /** Retrieve a shared collection */
  sharedCollection?: Maybe<SharedCollection>;
  /**
   * Retrieve shared collection history records
   * Example:
   * Request:
   * query {
   *   sharedCollectionHistory(limit: 2,
   *   folderId: "d551fbd6-7354-4b0e-abfb-654ab8583be2") {
   *     records {
   *       id
   *       status
   *       shareId
   *     }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "sharedCollectionHistory": {
   *       "records": []
   *     }
   *   }
   * }
   */
  sharedCollectionHistory: SharedCollectionHistoryList;
  /**
   * Retrieve the shared folders for an organization
   * Example:
   * Request:
   * query {
   *  	sharedFolders {
   *     id
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "sharedFolders": []
   *   }
   * }
   */
  sharedFolders?: Maybe<Array<Maybe<Folder>>>;
  /** Retrieve a shared mention */
  sharedMention?: Maybe<SharedMention>;
  /** Retrieve a single source */
  source: Source;
  /** Retrieve a single source type */
  sourceType: SourceType;
  /** Retrieve all source type categories */
  sourceTypeCategories: SourceTypeCategoryList;
  /** Retrieve a single source type category */
  sourceTypeCategory: SourceTypeCategory;
  /** Retrieve a list of source types */
  sourceTypes: SourceTypeList;
  /** Retrieve a list of sources */
  sources: SourceList;
  /**
   * Example:
   * Request:
   * query {
   *   staticAppConfig {
   *     loginUrl
   *     apiRoot
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "staticAppConfig": {
   *       "loginUrl": "https://login.veritone.com",
   *       "apiRoot": "https://api.veritone.com"
   *     }
   *   }
   * }
   */
  staticAppConfig: StaticAppConfig;
  /**
   * Retrieve a structured data object
   * Example:
   * Request:
   * query {
   *  	structuredData(
   *     id: "bbc0d388-b7ed-4073-9760-cb7701130eaf",
   *   	schemaId: "acab8bd9-a4d4-44de-ad4b-cc949d696cf9") {
   *     	data
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "structuredData": {
   *       "data": {
   *         "example": "example"
   *       }
   *     }
   *   }
   * }
   */
  structuredData?: Maybe<StructuredData>;
  /**
   * Retrieve a structured data object
   * Example:
   * Request:
   * query {
   *  	structuredDataObject(
   *     id: "bbc0d388-b7ed-4073-9760-cb7701130eaf",
   *   	schemaId: "acab8bd9-a4d4-44de-ad4b-cc949d696cf9") {
   *     	data
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "structuredDataObject": {
   *       "data": {
   *         "example": "example"
   *       }
   *     }
   *   }
   * }
   */
  structuredDataObject?: Maybe<StructuredData>;
  /**
   * Retrieve a paginated list of structured data object
   * Example:
   * Request:
   * query {
   *  	structuredDataObjects(schemaId: "acab8bd9-a4d4-44de-ad4b-cc949d696cf9") {
   *     records {
   *       id
   *       data
   *     }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "structuredDataObjects": {
   *       "records": [
   *         {
   *           "id": "bbc0d388-b7ed-4073-9760-cb7701130eaf",
   *           "data": {
   *             "example": "example"
   *           }
   *         },
   *         {
   *           "id": "f914eafe-ed9b-46b1-a48d-effd5575764a",
   *           "data": {
   *             "example": "example"
   *           }
   *         }
   *       ]
   *     }
   *   }
   * }
   */
  structuredDataObjects?: Maybe<StructuredDataList>;
  /**
   * Retrieve a subscription by id
   * Example:
   * Request:
   * query {
   *   subscription(id: "275818") {
   *     isActive
   *     jsondata
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "subscription": {
   *       "isActive": true,
   *       "jsondata": {
   *         "tracking_unit_id": "325791",
   *         "creator_email": "example email",
   *         "unsubscribe_hash": "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0cmFja2luZ1VuaXQiOiJ0cmFja2luZ191bml0X2lkIiwiZW1haWxBZGRyZXNzIjoiZW1haWxfYWRkcmVzcyIsInRyYWNraW5nX3VuaXRfaWQiOiIzMjU3OTEiLCJlbWFpbF9hZGRyZXNzIjoiZXhhbXBsZSBlbWFpbCIsImlhdCI6MTYyNDAyMjY4OCwiaXNzIjoidmVyaXRvbmU6ZGlzY292ZXJ5Iiwic3ViIjoidW5zdWJzY3JpYmUifQ.stYGS_goXaEhwLbKtYRohPirUT-q6vuY5hMHt74BWMUuEWYhwAQBxMItoFjZSXc3lHolQutxsl_BDiMOWNS4snRvcn-jI-5HG_4A3gEjQc6sYbgtyeVGxuDAg4urtj5sSBz0AU0xXZwLp2NI0Q39dqQSi1v1ZFANFE-jGULHreE3h617hLKf6CvegaOyrn_wqNONsB6VKDbXoLxdWoYJu3k7UztbvD1SC_bYHc7ltd1Ua2blUXSH0eBlk7pSv1vWdpw9KwMeuPJdC3R3qOB3-0xtp7KzTs0f5TelSZbk-6keVJz4LQt2mDxs6uivd8wb6GJ6Ikw-uKUYuo3T-vL0p-hFA5DkwiToomqTIqXvF5DGJxx762bKLLEKALAC55LdJ7eCZc6DmrnRbYLYNVfc2jK9YBDKeZxUAjNmYvlRsQTpLIrLoxWWmCbOJznfEjrzp_gI24rUh5qZ_-KUHr0pEYd5DuURy_geCmwSedq-nHV8tlE7op1bX8k9fwWFjIS7JIjYquUJq9T2wqIORO0WN6DGhgqkL7texbx9IYSWRkAY26KQxUF08jm5Vh_jrkmRyXsS9r5kVn_AGXbMA_HqtFo2jvXw5OXDcuaRjYwJpf8YtMvjNuDl8t9gbSmKwbeG1FsErPX0ne5K2TRWIqolohIvdHTTfsZLVvWdwmASnYw"
   *       }
   *     }
   *   }
   * }
   */
  subscription: Subscription;
  /** Retrieve a single task by ID */
  task?: Maybe<Task>;
  /**
   * Retrive list of Engine Replacement
   * Example:
   * Request:
   * query {
   *   taskReplacementEngines {
   *     records {
   *       sourceEngineId
   *       replacementEngineId
   *     }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "taskReplacementEngines": {
   *       "records": [
   *         {
   *           "sourceEngineId": "1",
   *           "replacementEngineId": "2"
   *         }
   *       ]
   *     }
   *   }
   * }
   */
  taskReplacementEngines?: Maybe<TaskReplacementEngineList>;
  /** Retrieve a single task template */
  taskTemplate: TaskTemplate;
  tasks?: Maybe<TaskList>;
  /**
   * Retrieve a single temporal data object
   * Example:
   * Request:
   * query {
   *   temporalDataObject(
   *     id: 1570654874) {
   *     id
   *     name
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "temporalDataObject": {
   *     "id": "1570654874",
   *     "name": "example"
   *     }
   *   }
   * }
   */
  temporalDataObject?: Maybe<TemporalDataObject>;
  /**
   * Retrieve a list of temporal data objects.
   * Example:
   * Request:
   * query {
   *   temporalDataObjects(
   *     organizationId: "35521"){
   *     records{name}
   *     offset
   *     limit
   *     count
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "temporalDataObjects": {
   *       "records": [
   *         {
   *           "name": "example"
   *         },
   *         {
   *           "name": "example"
   *         },
   *       ],
   *       "offset": 0,
   *       "limit": 30,
   *       "count": 8
   *     }
   *   }
   * }
   */
  temporalDataObjects?: Maybe<TdoList>;
  /**
   *   This query returns information about time zones recognized by this
   *   server. The information is static and does not change.
   *   Example:
   *   Request:
   *   query {
   *   timeZones {
   *     name
   *     abbreviations{
   *       name
   *     }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "timeZones": [
   *       {
   *         "name": "Africa/Abidjan",
   *         "abbreviations": [
   *           {
   *             "name": "GMT"
   *           }
   *         ]
   *       },
   *       {
   *         "name": "Africa/Accra",
   *         "abbreviations": [
   *           {
   *             "name": "GMT"
   *           },
   *           {
   *             "name": "+0020"
   *           }
   *         ]
   *       },
   *       {
   *         "name": "Africa/Lagos",
   *         "abbreviations": [
   *           {
   *             "name": "WAT"
   *           }
   *         ]
   *       },
   *       ...
   *       ...
   *         ]
   *       }
   *     ]
   *   }
   * }
   */
  timeZones: Array<TimeZone>;
  /**
   * Retrieve user's organization API tokens
   * Example:
   * Request:
   * query {
   *  	tokens {
   *     id
   *     applicationId
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "tokens": []
   *   }
   * }
   */
  tokens?: Maybe<Array<Maybe<Token>>>;
  /**
   * Retrieve a trigger by id
   * Example:
   * Request:
   * query {
   *   trigger(id: "2998") {
   *     target
   *     createdDateTime
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "trigger": {
   *       "target": "Email",
   *       "createdDateTime": "2021-06-18T13:35:08.631Z"
   *     }
   *   }
   * }
   */
  trigger?: Maybe<Trigger>;
  /**
   * Retrieve triggers
   * Example:
   * Request:
   * query {
   *   triggers {
   *     id
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "triggers": [
   *       {
   *         "id": "2998"
   *       }
   *     ]
   *   }
   * }
   */
  triggers?: Maybe<Array<Maybe<Trigger>>>;
  /**
   * Retrieve an individual user
   * Example:
   * Request:
   * query {
   *   user(id: "267de7e1-efb2-444a-a524-210328b78503") {
   *     name
   *     status
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "user": {
   *       "name": "example",
   *       "status": "deleted"
   *     }
   *   }
   * }
   */
  user?: Maybe<User>;
  /**
   * Retrieve users
   * Example:
   * Request:
   * query {
   *   users(
   *     organizationIds:"35521",
   *     limit: 2) {
   *     	records {
   *       	id
   *       	name
   *     	}
   *   	}
   * }
   * Response:
   * {
   *   "data": {
   *     "users": {
   *       "records": [
   *         {
   *           "id": "267de7e1-efb2-444a-a524-210328b78503",
   *           "name": "example"
   *         },
   *         {
   *           "id": "d8304ba1-0d4c-4268-a82c-8c62fd455066",
   *           "name": "example1"
   *         }
   *       ]
   *     }
   *   }
   * }
   */
  users?: Maybe<UserList>;
  /**
   * Retrieve a single watchlist by id
   * Example:
   * Request:
   * query {
   *   watchlist(id: "325791") {
   *     name
   *     watchlistType
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "watchlist": {
   *       "name": "example",
   *       "watchlistType": "tracking"
   *     }
   *   }
   * }
   */
  watchlist?: Maybe<Watchlist>;
  /**
   * Retrieve multiple watchlists
   * Example:
   * Request:
   * query {
   *   watchlists(limit: 2) {
   *     records {
   *       id
   *       name
   *     }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "watchlists": {
   *       "records": [
   *         {
   *           "id": "326916",
   *           "name": "example"
   *         },
   *         {
   *           "id": "325791",
   *           "name": "example"
   *         }
   *       ]
   *     }
   *   }
   * }
   */
  watchlists?: Maybe<WatchlistList>;
  /**
   * Retrieve a single Widget
   * Example:
   * Request:
   * query {
   *   widget(
   *     id: "KOIFUT_rT_Oy3Ev9zfKT6A") {
   *     	collection{
   *         id
   *       }
   *   }
   * }
   * Response:
   * {
   *   "data": {
   *     "widget": {
   *       "collection": {
   *         "id": "243625"
   *       }
   *     }
   *   }
   * }
   */
  widget?: Maybe<Widget>;
  /** Retrieve Workflow Metric of the current user's organization */
  workflowMetric: WorkflowMetric;
  /** Retrieve Veritone Workflow instance status by id */
  workflowRuntime: WorkflowRuntimeResponse;
  /** Get a specific workflowRuntimeData based on dataKey */
  workflowRuntimeStorageData: WorkflowRuntimeStorageDataList;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryApplicationArgs = {
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryApplicationConfigArgs = {
  appId: Scalars['ID'];
  configKeyRegexp?: InputMaybe<Scalars['String']>;
  includeDefaults?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orgId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryApplicationConfigDefinitionArgs = {
  appId: Scalars['ID'];
  configKey?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryApplicationHeaderbarArgs = {
  appId: Scalars['ID'];
  orgId?: InputMaybe<Scalars['ID']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryApplicationRoleArgs = {
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryApplicationRolesArgs = {
  applicationId?: InputMaybe<Scalars['ID']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  nameRegex?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['ID']>;
  public?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryApplicationsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orgId?: InputMaybe<Scalars['ID']>;
  owned?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<ApplicationStatus>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryAssetArgs = {
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryAssetsArgs = {
  assetTypes?: InputMaybe<Array<Scalars['String']>>;
  contentTypes?: InputMaybe<Array<Scalars['String']>>;
  createdDateFilter?: InputMaybe<TemporalDataObjectDateTimeFilter>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  scrollId?: InputMaybe<Scalars['String']>;
  sourceEngineIds?: InputMaybe<Array<Scalars['String']>>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryAuditEventsArgs = {
  application?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderDirection?: InputMaybe<OrderDirection>;
  query?: InputMaybe<Scalars['JSONData']>;
  terms?: InputMaybe<Array<Scalars['JSONData']>>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryAuditLogArgs = {
  clientIpAddress?: InputMaybe<Scalars['String']>;
  clientUserAgent?: InputMaybe<Scalars['String']>;
  eventType?: InputMaybe<Scalars['String']>;
  fromDateTime?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  limit?: InputMaybe<Scalars['Int']>;
  objectId?: InputMaybe<Scalars['ID']>;
  objectType?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AuditLogOrderBy>>;
  organizationId?: InputMaybe<Scalars['ID']>;
  success?: InputMaybe<Scalars['Boolean']>;
  toDateTime?: InputMaybe<Scalars['DateTime']>;
  userName?: InputMaybe<Scalars['String']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryAuthGroupArgs = {
  groupName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryAuthGroupsArgs = {
  appRoleID?: InputMaybe<Scalars['ID']>;
  authClass?: InputMaybe<Array<InputMaybe<AuthObjectClass>>>;
  createdDateTime?: InputMaybe<AuditDateTimeFilter>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  member?: InputMaybe<AuthGroupMemberInput>;
  modifiedDateTime?: InputMaybe<AuditDateTimeFilter>;
  nameRegex?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  ownerOrganization?: InputMaybe<Scalars['ID']>;
  source?: InputMaybe<AuthGroupSourceType>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryAuthPermissionSetArgs = {
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryAuthPermissionSetsArgs = {
  applicationID?: InputMaybe<Scalars['ID']>;
  authClass?: InputMaybe<Array<InputMaybe<AuthObjectClass>>>;
  createdDateTime?: InputMaybe<Scalars['DateTime']>;
  hasPermissions?: InputMaybe<Array<AuthPermissionType>>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  limit?: InputMaybe<Scalars['Int']>;
  modifiedDateTime?: InputMaybe<Scalars['DateTime']>;
  nameRegex?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  ownerOrganization?: InputMaybe<Scalars['ID']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryBasicUserInfoArgs = {
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryCloneRequestsArgs = {
  applicationId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryClusterArgs = {
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryClusterNodeArgs = {
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryClusterNodesArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryClusterTagsArgs = {
  match: Scalars['String'];
  matchType?: InputMaybe<StringMatch>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryClustersArgs = {
  allowedEngines?: InputMaybe<Array<Scalars['ID']>>;
  clusterGroupId?: InputMaybe<Scalars['ID']>;
  clusterGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  dateTimeFilter?: InputMaybe<Array<ClusterDateTimeFilter>>;
  edgeVersion?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  isGroup?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  nameMatch?: InputMaybe<StringMatch>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ClusterOrderBy>>;
  organizationId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<ClusterStatus>;
  tagMatch?: InputMaybe<StringMatch>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  type?: InputMaybe<ClusterType>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryCognitiveSearchArgs = {
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryCollectionArgs = {
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryCollectionMentionArgs = {
  folderId: Scalars['ID'];
  mentionId: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryCollectionMentionsArgs = {
  folderId?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  mentionId?: InputMaybe<Scalars['ID']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<CollectionMentionOrderBy>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryCollectionsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  mentionId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryCreativeArgs = {
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryCustomDashboardArgs = {
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryCustomDashboardsArgs = {
  hostAppId?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryDagTemplateArgs = {
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryDagTemplatesArgs = {
  cognitiveCategoryId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  mimeType?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  tagMatch?: InputMaybe<StringMatch>;
  tags?: InputMaybe<Array<Scalars['String']>>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryDataRegistriesArgs = {
  filterByOwnership?: InputMaybe<SchemaOwnership>;
  id?: InputMaybe<Scalars['ID']>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  nameMatch?: InputMaybe<StringMatch>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<DataRegistryOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryDataRegistryArgs = {
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryDatasetArgs = {
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryDatasetDataQueryArgs = {
  datasetId: Scalars['ID'];
  filter?: InputMaybe<Scalars['JSONData']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StructuredDataOrderBy>>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryDatasetsArgs = {
  filter?: InputMaybe<DatasetFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryEngineArgs = {
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryEngineBuildArgs = {
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryEngineCategoriesArgs = {
  id?: InputMaybe<Scalars['ID']>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryEngineCategoryArgs = {
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryEngineClassArgs = {
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryEngineClassesArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryEngineConfigurationArgs = {
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryEngineConfigurationsArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryEngineResultsArgs = {
  engineCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  engineIds?: InputMaybe<Array<Scalars['ID']>>;
  fallbackTdoId?: InputMaybe<Scalars['ID']>;
  ignoreUserEdited?: InputMaybe<Scalars['Boolean']>;
  jobId?: InputMaybe<Scalars['ID']>;
  mentionId?: InputMaybe<Scalars['ID']>;
  sourceId?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  startOffsetMs?: InputMaybe<Scalars['Int']>;
  stopDate?: InputMaybe<Scalars['DateTime']>;
  stopOffsetMs?: InputMaybe<Scalars['Int']>;
  tdoId?: InputMaybe<Scalars['ID']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryEnginesArgs = {
  category?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['String']>;
  createsTDO?: InputMaybe<Scalars['Boolean']>;
  edgeVersion?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<EngineFilter>;
  id?: InputMaybe<Scalars['ID']>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  libraryRequired?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<EngineSortField>>>;
  owned?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<Array<InputMaybe<EngineState>>>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryEntitiesArgs = {
  identifierTypeId?: InputMaybe<Scalars['ID']>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  libraryIds?: InputMaybe<Array<Scalars['ID']>>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<LibraryEntityOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryEntityArgs = {
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryEntityIdentifierTypeArgs = {
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryEntityIdentifierTypesArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryEventArgs = {
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryEventActionTemplateArgs = {
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryEventActionTemplatesArgs = {
  actionType?: InputMaybe<EventActionTemplateActionType>;
  inputType?: InputMaybe<EventActionTemplateInputType>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  ownerApplicationId?: InputMaybe<Scalars['ID']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryEventCustomRuleArgs = {
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryEventCustomRulesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryEventSubscriptionArgs = {
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryEventSubscriptionsArgs = {
  eventName?: InputMaybe<Scalars['String']>;
  eventType?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryEventsArgs = {
  application: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryExecutionLocationArgs = {
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryExecutionLocationsArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryExportRequestArgs = {
  event?: InputMaybe<ExportRequestEvent>;
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryExportRequestsArgs = {
  event?: InputMaybe<ExportRequestEvent>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Array<ExportRequestStatus>>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryExternalCredentialArgs = {
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryExternalCredentialsArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryFlowArgs = {
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryFlowExecutionArgs = {
  flowExecutionId: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryFlowExecutionsArgs = {
  flowExecutionId?: InputMaybe<Scalars['ID']>;
  flowId: Scalars['ID'];
  flowRevisionId?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryFlowRevisionArgs = {
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryFlowRevisionsArgs = {
  buildId?: InputMaybe<Scalars['ID']>;
  createOnEmpty?: InputMaybe<Scalars['Boolean']>;
  engineId?: InputMaybe<Scalars['ID']>;
  flowId?: InputMaybe<Scalars['ID']>;
  hasBuilds?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  isDeployed?: InputMaybe<Scalars['Boolean']>;
  isHead?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['ID']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryFlowTemplatesArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryFlowsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryFolderArgs = {
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryFolderOverviewArgs = {
  ids: Array<Scalars['ID']>;
  rootFolderType?: InputMaybe<RootFolderType>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryFolderSummaryDetailsArgs = {
  ids: Array<Scalars['ID']>;
  rootFolderType?: InputMaybe<RootFolderType>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryGetAclForResourcesArgs = {
  ids: Array<InputMaybe<Scalars['ID']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  permissions?: InputMaybe<Array<AuthPermissionType>>;
  requireAll?: InputMaybe<Scalars['Boolean']>;
  resourceType: AuthResourceType;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryGetSignedWritableUrlArgs = {
  expiresInSeconds?: InputMaybe<Scalars['Int']>;
  key?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['ID']>;
  path?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryGetSignedWritableUrlsArgs = {
  number: Scalars['Int'];
  organizationId?: InputMaybe<Scalars['ID']>;
  path?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryGetUserSettingDefinitionsArgs = {
  application: Scalars['ID'];
  key?: InputMaybe<Scalars['String']>;
  organizationGuid?: InputMaybe<Scalars['ID']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryGetUserSettingsArgs = {
  application?: InputMaybe<Scalars['ID']>;
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['ID']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryGroupsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  organizationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryHasPermissionsArgs = {
  ids: Array<Scalars['ID']>;
  permissions: Array<AuthPermissionType>;
  requireAll?: InputMaybe<Scalars['Boolean']>;
  resourceType: AuthResourceType;
  userID?: InputMaybe<Scalars['ID']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryJobArgs = {
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryJobTemplateArgs = {
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryJobTemplatesArgs = {
  engineId?: InputMaybe<Scalars['ID']>;
  engineType?: InputMaybe<Array<EngineTypeFilter>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  scheduledJobId?: InputMaybe<Scalars['ID']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryJobsArgs = {
  applicationId?: InputMaybe<Scalars['ID']>;
  applicationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  applicationStatus?: InputMaybe<Scalars['String']>;
  clusterId?: InputMaybe<Scalars['ID']>;
  dateTimeFilter?: InputMaybe<Array<JobDateTimeFilter>>;
  engineCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  engineIds?: InputMaybe<Array<Scalars['ID']>>;
  hasScheduledJobId?: InputMaybe<Scalars['Boolean']>;
  hasTargetTDO?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobSortField>>;
  scheduledJobIds?: InputMaybe<Array<Scalars['ID']>>;
  status?: InputMaybe<Array<JobStatusFilter>>;
  targetId?: InputMaybe<Scalars['ID']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryLibrariesArgs = {
  entityIdentifierTypeIds?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['ID']>;
  includeOwnedOnly?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<LibraryOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  type?: InputMaybe<Scalars['String']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryLibraryArgs = {
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryLibraryConfigurationArgs = {
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryLibraryEngineModelArgs = {
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryLibraryTypeArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryLibraryTypesArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryMatchEntityTagsArgs = {
  input: MatchEntityTagInput;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryMediaShareArgs = {
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryMentionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  mentionId: Scalars['ID'];
  offset?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['String']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryMentionsArgs = {
  dateTimeFilter?: InputMaybe<Array<MentionDateTimeFilter>>;
  folderId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MentionOrderBy>>;
  sourceId?: InputMaybe<Scalars['ID']>;
  sourceTypeId?: InputMaybe<Scalars['ID']>;
  tdoId?: InputMaybe<Scalars['ID']>;
  watchlistId?: InputMaybe<Scalars['ID']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryMyOrganizationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryNotificationActionsArgs = {
  application?: InputMaybe<Scalars['String']>;
  eventName?: InputMaybe<Scalars['String']>;
  eventType?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  mailboxId?: InputMaybe<Scalars['ID']>;
  offset?: InputMaybe<Scalars['Int']>;
  ownerOrganizationId?: InputMaybe<Scalars['ID']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryNotificationMailboxesArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryNotificationTemplatesArgs = {
  application?: InputMaybe<Scalars['String']>;
  eventName?: InputMaybe<Scalars['String']>;
  eventType?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  mailboxId?: InputMaybe<Scalars['ID']>;
  offset?: InputMaybe<Scalars['Int']>;
  ownerOrganizationId?: InputMaybe<Scalars['ID']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryOpenIdProviderArgs = {
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryOpenIdProvidersArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  isGlobal?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orgId?: InputMaybe<Scalars['ID']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryOrganizationArgs = {
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryOrganizationsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  kvpProperty?: InputMaybe<Scalars['String']>;
  kvpValue?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  nameMatch?: InputMaybe<StringMatch>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryPackageGrantsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  organizationId?: InputMaybe<Scalars['ID']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryPackagesArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  nameRegexp?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['ID']>;
  owned?: InputMaybe<Scalars['Boolean']>;
  primaryResourceId?: InputMaybe<Scalars['ID']>;
  resourceId?: InputMaybe<Scalars['ID']>;
  sourceOriginId?: InputMaybe<Scalars['ID']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryPermissionsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryProcessTemplateArgs = {
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryProcessTemplatesArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryRecentBuildsArgs = {
  buildStatus?: InputMaybe<Array<BuildStatus>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EngineBuildOrderBy>>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryRootFoldersArgs = {
  type?: InputMaybe<RootFolderType>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QuerySavedSearchesArgs = {
  filterByName?: InputMaybe<Scalars['String']>;
  includeShared?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<SavedSearchOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryScheduledJobArgs = {
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryScheduledJobsArgs = {
  clusterId?: InputMaybe<Scalars['ID']>;
  createdBy?: InputMaybe<Scalars['ID']>;
  dateTimeFilter?: InputMaybe<Array<ScheduledJobDateTimeFilter>>;
  engineCategoryId?: InputMaybe<Scalars['ID']>;
  engineId?: InputMaybe<Scalars['ID']>;
  engineType?: InputMaybe<Array<EngineTypeFilter>>;
  hasJobTemplate?: InputMaybe<Scalars['Boolean']>;
  hasRunningJobs?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  includeOwnedOnly?: InputMaybe<Scalars['Boolean']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScheduledJobOrderBy>>;
  partTimeFilter?: InputMaybe<Array<ScheduledJobPartTimeFilter>>;
  permission?: InputMaybe<ScheduledJobPermission>;
  primarySourceId?: InputMaybe<Array<Scalars['ID']>>;
  primarySourceTypeId?: InputMaybe<Array<Scalars['ID']>>;
  runMode?: InputMaybe<RunMode>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QuerySchemaArgs = {
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QuerySchemaPropertiesArgs = {
  dataRegistryVersion?: InputMaybe<Array<DataRegistryVersion>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QuerySchemasArgs = {
  dataRegistryId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  limit?: InputMaybe<Scalars['Int']>;
  majorVersion?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  nameMatch?: InputMaybe<StringMatch>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<SchemaOrder>>>;
  status?: InputMaybe<Array<SchemaStatus>>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QuerySearchMediaArgs = {
  search: Scalars['JSONData'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QuerySearchMentionsArgs = {
  search: Scalars['JSONData'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QuerySharedCollectionArgs = {
  shareId: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QuerySharedCollectionHistoryArgs = {
  folderId?: InputMaybe<Scalars['ID']>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  shareId?: InputMaybe<Scalars['String']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QuerySharedMentionArgs = {
  shareId: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QuerySourceArgs = {
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QuerySourceTypeArgs = {
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QuerySourceTypeCategoriesArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QuerySourceTypeCategoryArgs = {
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QuerySourceTypesArgs = {
  categoryId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QuerySourcesArgs = {
  correlationSchemaId?: InputMaybe<Scalars['ID']>;
  hasContentTemplates?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  includePublic?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  nameMatch?: InputMaybe<StringMatch>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SourceSortField>>;
  permission?: InputMaybe<SourcePermission>;
  sourceTypeId?: InputMaybe<Scalars['ID']>;
  sourceTypeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryStructuredDataArgs = {
  id: Scalars['ID'];
  schemaId: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryStructuredDataObjectArgs = {
  id: Scalars['ID'];
  schemaId: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryStructuredDataObjectsArgs = {
  filter?: InputMaybe<Scalars['JSONData']>;
  id?: InputMaybe<Scalars['ID']>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StructuredDataOrderBy>>;
  owned?: InputMaybe<Scalars['Boolean']>;
  schemaId: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QuerySubscriptionArgs = {
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryTaskArgs = {
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryTaskReplacementEnginesArgs = {
  engineId?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['ID']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryTaskTemplateArgs = {
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryTasksArgs = {
  applicationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  dateTimeFilter?: InputMaybe<Array<TaskDateTimeFilter>>;
  engineId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  id?: InputMaybe<Scalars['ID']>;
  jobId?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  taskTemplateId?: InputMaybe<Scalars['ID']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryTemporalDataObjectArgs = {
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryTemporalDataObjectsArgs = {
  applicationId?: InputMaybe<Scalars['ID']>;
  dateTimeFilter?: InputMaybe<Array<TemporalDataObjectDateTimeFilter>>;
  id?: InputMaybe<Scalars['ID']>;
  includePublic?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  mentionId?: InputMaybe<Scalars['ID']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<TemporalDataObjectOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  organizationId?: InputMaybe<Scalars['ID']>;
  programId?: InputMaybe<Scalars['ID']>;
  sampleMedia?: InputMaybe<Scalars['Boolean']>;
  scheduledJobId?: InputMaybe<Scalars['ID']>;
  sourceId?: InputMaybe<Scalars['ID']>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryTriggerArgs = {
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryUserArgs = {
  id: Scalars['ID'];
  organizationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryUsersArgs = {
  dateTimeFilter?: InputMaybe<Array<UsersDateTimeFilter>>;
  id?: InputMaybe<Scalars['ID']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  includeAllOrgUsers?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  organizationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  status?: InputMaybe<UserStatus>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryWatchlistArgs = {
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryWatchlistsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  isDisabled?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  maxStartDateTime?: InputMaybe<Scalars['DateTime']>;
  maxStopDateTime?: InputMaybe<Scalars['DateTime']>;
  minStartDateTime?: InputMaybe<Scalars['DateTime']>;
  minStopDateTime?: InputMaybe<Scalars['DateTime']>;
  name?: InputMaybe<Scalars['String']>;
  nameMatch?: InputMaybe<StringMatch>;
  names?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<WatchlistOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryWidgetArgs = {
  id: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryWorkflowRuntimeArgs = {
  workflowRuntimeId: Scalars['ID'];
};


/**
 * Queries are used to retrieve data. If you're new to our API,
 * try the `me` query to explore the information you have access to.
 * Hit `ctrl-space` at any time to activate field completion hints, and
 * mouse over a field or parameter to see its documentation.
 */
export type QueryWorkflowRuntimeStorageDataArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  storageKey?: InputMaybe<Scalars['String']>;
  storageKeyPrefix?: InputMaybe<Scalars['String']>;
  workflowRuntimeId: Scalars['ID'];
};

export type RemoveDagFromOrganization = {
  dagTemplateId: Scalars['ID'];
  /** Provide the organization ID to add. */
  organizationId: Scalars['ID'];
};

export type RemoveTaskReplacementEngine = {
  organizationId?: InputMaybe<Scalars['ID']>;
  replacementEngineId: Scalars['ID'];
  sourceEngineId: Scalars['ID'];
};

export type ReplaceSavedSearch = {
  csp: Scalars['JSONData'];
  id: Scalars['ID'];
  name: Scalars['String'];
  sharedWithOrganization?: InputMaybe<Scalars['Boolean']>;
};

export type RequestClone = {
  cloneBlobs?: InputMaybe<Scalars['Boolean']>;
  destinationApplicationId: Scalars['ID'];
  sourceApplicationId: Scalars['ID'];
};

export type RevertScheduledJob = {
  id: Scalars['ID'];
};

export type RightsListing = {
  __typename?: 'RightsListing';
  operations: Array<Scalars['String']>;
  resources?: Maybe<Scalars['JSONData']>;
};

/** A role signifies a user's permissions within a given context. */
export type Role = {
  __typename?: 'Role';
  appName?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  permissions?: Maybe<PermissionList>;
};

export enum RootFolderType {
  Application = 'application',
  Cms = 'cms',
  Collection = 'collection',
  Watchlist = 'watchlist'
}

export type Route = {
  __typename?: 'Route';
  childIoFolderReferenceId?: Maybe<Scalars['ID']>;
  endpoint?: Maybe<Scalars['String']>;
  options?: Maybe<Scalars['JSONData']>;
  parentIoFolderReferenceId?: Maybe<Scalars['ID']>;
};

export enum RunMode {
  /** This will run 24x7 from start to stop */
  Continuous = 'Continuous',
  /** This will run now */
  Now = 'Now',
  /** This will run once and then be complete */
  Once = 'Once',
  /** This will run on a recurring schedule or interval */
  Recurring = 'Recurring'
}

export type SavedSearch = {
  __typename?: 'SavedSearch';
  createdDateTime: Scalars['DateTime'];
  csp?: Maybe<Scalars['JSONData']>;
  id: Scalars['ID'];
  modifiedDateTime: Scalars['DateTime'];
  name: Scalars['String'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['ID'];
  owner?: Maybe<User>;
  ownerId: Scalars['ID'];
  sharedWithOrganization?: Maybe<Scalars['Boolean']>;
};

export type SavedSearchList = Page & {
  __typename?: 'SavedSearchList';
  count?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records?: Maybe<Array<SavedSearch>>;
};

export enum SavedSearchOrderBy {
  CreatedDateTime = 'createdDateTime',
  Name = 'name',
  SharedWithOrganization = 'sharedWithOrganization'
}

export type SchedulePart = {
  __typename?: 'SchedulePart';
  durationSeconds?: Maybe<Scalars['Int']>;
  repeatInterval?: Maybe<Scalars['Int']>;
  repeatIntervalUnit?: Maybe<IntervalUnit>;
  scheduleType: ScheduleType;
  scheduledDay?: Maybe<DayOfWeek>;
  /** The day of week adjusted to source live timezone */
  scheduledDayLocal?: Maybe<DayOfWeek>;
  startTime?: Maybe<Scalars['Time']>;
  stopTime?: Maybe<Scalars['Time']>;
};

export enum ScheduleType {
  Interval = 'Interval',
  Weekly = 'Weekly'
}

export type ScheduledJob = {
  __typename?: 'ScheduledJob';
  affiliates: ProgramAffiliateList;
  /**
   * Retrieve the complete set of job templates associated with this
   * scheduled job, including those that are associated through a job
   * pipeline.
   */
  allJobTemplates: JobTemplateList;
  /**
   * Permissions granted to other organizations. Only the source owner
   * can view or edit this field.
   */
  collaborators: ScheduledJobCollaboratorList;
  /**
   * List of schema-controlled content templates attached
   * to this scheduled job
   */
  contentTemplates: Array<ScheduledJobContentTemplate>;
  createdDateTime?: Maybe<Scalars['DateTime']>;
  /** Description for the scheduledJob */
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['JSONData']>;
  detailsSchemaId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  ingestionStatus?: Maybe<Scalars['String']>;
  ingestionStatusId?: Maybe<Scalars['ID']>;
  /** If true, this is active */
  isActive: Scalars['Boolean'];
  /**
   * A public scheduled job can be viewed and launched by
   * users from any organization. By default, scheduled jobs are
   * private and can only be viewed or launched by the owning organization
   * and organizations that the owner has explicitly shared them with.
   * Only Veritone administrators can create public scheduled jobs.
   */
  isPublic?: Maybe<Scalars['Boolean']>;
  /**
   * deprecated. DO NOT USE.x
   * TODO: Remove
   * @deprecated obsolete v2 construct
   */
  jobPipelineIds?: Maybe<Array<Scalars['ID']>>;
  /**
   * deprecated. DO NOT USE.
   * TODO: Remove
   * @deprecated obsolete v2 construct
   */
  jobPipelines: JobPipelineList;
  /**
   * deprecated. DO NOT USE.
   * TODO(al): Remove
   */
  jobTemplateIds?: Maybe<Array<Scalars['ID']>>;
  /**
   * deprecated. DO NOT USE.
   * TODO(al): Remove
   * @deprecated obsolete v2 construct
   */
  jobTemplates: JobTemplateList;
  jobs: JobList;
  modifiedDateTime?: Maybe<Scalars['DateTime']>;
  /** Name of scheduled job */
  name?: Maybe<Scalars['String']>;
  /** Organization that owns this scheduled job */
  organization?: Maybe<Organization>;
  /** Organization ID */
  organizationId?: Maybe<Scalars['ID']>;
  /** If the scheduled job is recurring, this is the day and times for the recurring schedule */
  parts?: Maybe<Array<SchedulePart>>;
  /** The user's permission on this scheduled job */
  permission?: Maybe<ScheduledJobPermission>;
  /** The primary source. See `primarySourceId` above. */
  primarySource?: Maybe<Source>;
  /**
   * The ID of the primary source on this scheduled job, if applicable.
   * This is based on the payloads of the tasks that are invoked for
   * this scheduled job.
   */
  primarySourceId?: Maybe<Scalars['ID']>;
  primarySourceType?: Maybe<SourceType>;
  primarySourceTypeId?: Maybe<Scalars['ID']>;
  /**
   * This is the scheduledJob Run Mode.  Recurring, Continuous, Once or On Demand.
   *
   * On Demand will be launched when the API is called
   */
  runMode: RunMode;
  /**
   * Get a list of sources that are used
   * by engine configurations that reference
   * this schedule through the schedule -> job -> task relationship.
   */
  sources?: Maybe<SourceList>;
  /**
   * This is the time the scheduled job will start ingesting.
   *
   * This is in Source Local Time
   *
   * Notes:
   * - If this is in the past, then ingestion will start here and go forward
   * - If this is the future, then ingestion will not start until that time is reached
   */
  startDateTime?: Maybe<Scalars['DateTime']>;
  /**
   * The stop time for the scheduledJob.
   *
   * This is in Source Local Time
   */
  stopDateTime?: Maybe<Scalars['DateTime']>;
};


export type ScheduledJobAllJobTemplatesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ScheduledJobJobPipelinesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ScheduledJobJobTemplatesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ScheduledJobJobsArgs = {
  clusterId?: InputMaybe<Scalars['ID']>;
  dateTimeFilter?: InputMaybe<Array<JobDateTimeFilter>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobSortField>>;
  status?: InputMaybe<Array<JobStatusFilter>>;
  targetId?: InputMaybe<Scalars['ID']>;
};


export type ScheduledJobSourcesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** A source ACL grants a single organization limited rights to a private source */
export type ScheduledJobCollaborator = {
  __typename?: 'ScheduledJobCollaborator';
  /** The organization the source was shared with */
  organization?: Maybe<Organization>;
  /** Organization ID the source was shared with */
  organizationId: Scalars['ID'];
  /** The permission granted. Either `viewer` or `editor`. */
  permission: ScheduledJobPermission;
};

export type ScheduledJobCollaboratorList = Page & {
  __typename?: 'ScheduledJobCollaboratorList';
  count?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records: Array<ScheduledJobCollaborator>;
};

export type ScheduledJobContentTemplate = {
  __typename?: 'ScheduledJobContentTemplate';
  createdDateTime?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['JSONData']>;
  id: Scalars['ID'];
  modifiedDateTime?: Maybe<Scalars['DateTime']>;
  scheduledJobId: Scalars['ID'];
  schemaId: Scalars['ID'];
  sdo?: Maybe<StructuredData>;
  sdoId: Scalars['ID'];
};

export enum ScheduledJobDateTimeField {
  DateCreated = 'dateCreated',
  DateModified = 'dateModified',
  StartDateTime = 'startDateTime',
  StopDateTime = 'stopDateTime'
}

export type ScheduledJobDateTimeFilter = {
  field: ScheduledJobDateTimeField;
  fromDateTime?: InputMaybe<Scalars['DateTime']>;
  includeEmpty?: InputMaybe<Scalars['Boolean']>;
  toDateTime?: InputMaybe<Scalars['DateTime']>;
};

export type ScheduledJobList = Page & {
  __typename?: 'ScheduledJobList';
  count: Scalars['Int'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records: Array<ScheduledJob>;
};

export type ScheduledJobOrderBy = {
  direction?: InputMaybe<OrderDirection>;
  field: ScheduledJobOrderField;
};

export enum ScheduledJobOrderField {
  CreatedDateTime = 'createdDateTime',
  Id = 'id',
  IsActive = 'isActive',
  ModifiedDateTime = 'modifiedDateTime',
  Name = 'name',
  RunMode = 'runMode',
  StartDateTime = 'startDateTime',
  StopDateTime = 'stopDateTime'
}

export enum ScheduledJobPartTimeField {
  EndTime = 'endTime',
  StartTime = 'startTime'
}

export type ScheduledJobPartTimeFilter = {
  field: ScheduledJobPartTimeField;
  fromTime?: InputMaybe<Scalars['Time']>;
  toTime?: InputMaybe<Scalars['Time']>;
};

/** Permissions or roles on source objects */
export enum ScheduledJobPermission {
  /**
   * A source editor can make updates to some source fields, but cannot
   * delete or share the source.
   */
  Editor = 'editor',
  /** A source owner has full rights to update and delete the source. */
  Owner = 'owner',
  /**
   * A viewer can view the source and use it in ingestion jobs,
   * but not make any updates to it.
   */
  Viewer = 'viewer'
}

export type Schema = {
  __typename?: 'Schema';
  createdBy?: Maybe<User>;
  createdDateTime?: Maybe<Scalars['DateTime']>;
  dataRegistry?: Maybe<DataRegistry>;
  dataRegistryId: Scalars['ID'];
  definition?: Maybe<Scalars['JSONData']>;
  id: Scalars['ID'];
  majorVersion: Scalars['Int'];
  minorVersion: Scalars['Int'];
  modifiedBy?: Maybe<User>;
  modifiedDateTime?: Maybe<Scalars['DateTime']>;
  /** The organization that owns this schema. */
  organization?: Maybe<Organization>;
  /** The Id of the organization that owns this schema. */
  organizationId?: Maybe<Scalars['ID']>;
  status?: Maybe<SchemaStatus>;
  /** SDOs under this schema */
  structuredDataObjects?: Maybe<StructuredDataList>;
  /** List of status the Schema can transition to. */
  validActions?: Maybe<Array<Maybe<SchemaAction>>>;
};


export type SchemaStructuredDataObjectsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export enum SchemaAction {
  Deactivate = 'deactivate',
  Delete = 'delete',
  Edit = 'edit',
  Publish = 'publish',
  View = 'view'
}

export type SchemaList = Page & {
  __typename?: 'SchemaList';
  /** Number of records returned in this response */
  count?: Maybe<Scalars['Int']>;
  /** Maximum number of results that were retrieved in this query; page size */
  limit: Scalars['Int'];
  /** The starting index for records that were returned in this query. */
  offset: Scalars['Int'];
  records?: Maybe<Array<Maybe<Schema>>>;
};

export type SchemaOrder = {
  direction?: InputMaybe<OrderDirection>;
  field: SchemaOrderFields;
};

export enum SchemaOrderFields {
  CreatedDateTime = 'createdDateTime',
  MajorVersion = 'majorVersion',
  MinorVersion = 'minorVersion',
  ModifiedDateTime = 'modifiedDateTime',
  Status = 'status'
}

export enum SchemaOwnership {
  All = 'all',
  Mine = 'mine',
  Others = 'others'
}

export type SchemaProperty = {
  __typename?: 'SchemaProperty';
  dataRegistryId: Scalars['ID'];
  majorVersion: Scalars['Int'];
  path: Scalars['String'];
  schema: Schema;
  searchPath: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type SchemaPropertyList = Page & {
  __typename?: 'SchemaPropertyList';
  /** Number of records returned in this response */
  count?: Maybe<Scalars['Int']>;
  /** Maximum number of results that were retrieved in this query; page size */
  limit: Scalars['Int'];
  /** The starting index for records that were returned in this query. */
  offset: Scalars['Int'];
  records?: Maybe<Array<Maybe<SchemaProperty>>>;
};

export enum SchemaStatus {
  Deleted = 'deleted',
  Draft = 'draft',
  Inactive = 'inactive',
  Published = 'published'
}

export enum ScopeRequirement {
  All = 'All',
  Any = 'Any'
}

export type SearchFieldConfig = {
  __typename?: 'SearchFieldConfig';
  indexField?: Maybe<Scalars['String']>;
  searchField?: Maybe<Scalars['String']>;
};

export enum SearchIndex {
  Global = 'global',
  Mine = 'mine'
}

export type SearchInput = {
  index: Array<InputMaybe<Scalars['String']>>;
  /** Maximum number of results that were retrieved in this query; page size */
  limit?: InputMaybe<Scalars['Int']>;
  /** Provide an offset to skip to a certain element in the result, for paging. */
  offset?: InputMaybe<Scalars['Int']>;
  query: Scalars['JSONData'];
  select?: InputMaybe<Scalars['JSONData']>;
};

/**
 * Results from a mention or media search.
 * ```
 * Example to search mention query:
 *   query {
 *       searchMentions(search: {
 *         index: ["mine"],
 *         limit: 50,
 *         offset: 0,
 *         query: {
 *           operator: "and",
 *           conditions: [{
 *             field: "trackingUnitId"
 *             operator: "terms"
 *             values: ["1"]
 *           },
 *           {
 *             field: "hitStartTime"
 *             operator: "range"
 *             gte: "2020-10-14T00:00:00.000Z"
 *             lt: "2020-11-05T23:59:59.000Z"
 *           }]
 *         }
 *       }) {
 *         jsondata
 *       }
 *     }
 * ```
 * See https://docs.veritone.com/#/apis/search-quickstart for full details on the search result syntax
 */
export type SearchResult = {
  __typename?: 'SearchResult';
  jsondata: Scalars['JSONData'];
};

export type SecurableObject = {
  /** Add ACEs to the resource. */
  addACEs?: Maybe<AuthAcl>;
};


export type SecurableObjectAddAcEsArgs = {
  entries: Array<AuthAcePermissionInput>;
};

/** Contains security settings on an asset container */
export type Security = {
  __typename?: 'Security';
  /** Whether or not the object is globally visible */
  global?: Maybe<Scalars['Boolean']>;
};

export type SendEmail = {
  bcc?: InputMaybe<Scalars['String']>;
  cc?: InputMaybe<Scalars['String']>;
  /** For security considerations this value is now ignored. The from address will be set by the server" */
  from: Scalars['String'];
  /** Message can be either text or HTML */
  message: Scalars['String'];
  replyTo: Scalars['String'];
  subject: Scalars['String'];
  to: Scalars['String'];
};

/** Input type for AssetFileData */
export type SetAssetFileData = {
  /** The file size in bytes */
  fileSize?: InputMaybe<Scalars['BigInt']>;
  /** The MD5 checksum of the file */
  md5sum?: InputMaybe<Scalars['String']>;
  /** Media duration in milliseconds */
  mediaDurationMs?: InputMaybe<Scalars['Int']>;
  /** The insertion mode of the asset */
  mode?: InputMaybe<AssetCreationMode>;
  /** Original file URI, if provided on asset creation */
  originalFileUri?: InputMaybe<Scalars['String']>;
};

/** Input type for AssetSourceData */
export type SetAssetSourceData = {
  /**
   * Optional ID of the asset this asset was created from.
   * This will usually be assets with edits to a previous
   * asset.
   */
  assetId?: InputMaybe<Scalars['ID']>;
  /** ID of the engine that created the asset */
  engineId?: InputMaybe<Scalars['ID']>;
  /** The name of the asset source engine or engine category */
  name?: InputMaybe<Scalars['String']>;
  /** Optional ID of the scheduled job that created this asset */
  scheduledJobId?: InputMaybe<Scalars['ID']>;
  /**
   * Optional ID of the source from which this asset
   * was created. This field will typically be set only
   * by adapters that ingest data.
   */
  sourceId?: InputMaybe<Scalars['ID']>;
  /** ID of the specific task that created the asset */
  taskId?: InputMaybe<Scalars['ID']>;
};

export enum SetClusterPermission {
  None = 'none',
  Viewer = 'viewer'
}

export type SetEngineBlacklist = {
  /** Provide the IDs of engine categories to set. */
  engineCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Provide the IDs of engines to set. */
  engineIds?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * Provide the organization ID to update. This field is required only
   * when using addToEngineBlacklist or deleteFromEngineBlacklist.
   */
  organizationId?: InputMaybe<Scalars['ID']>;
};

export type SetEngineWhitelist = {
  engineIds?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * Provide the organization ID to update. This field is required only
   * when using addToEngineWhitelist or deleteFromEngineWhitelist.
   */
  organizationId?: InputMaybe<Scalars['ID']>;
};

/**
 * Settings that determine when to set a new entity identifier
 * as the entity profile image.
 */
export enum SetEntityProfileImage {
  /**
   * Set the entity identifier as the new entity profile image,
   * overwriting whatever value is present. Will cause an error
   * if the entity identifier type is not an image.
   */
  Always = 'always',
  /**
   * Set the the entity identifier URL as the entity profile image
   * only if there is no current profile image. Will cause an error
   * if the entity identifier type is not an image.
   */
  IfNotSet = 'ifNotSet',
  /** Do not update the entity profile image */
  None = 'none'
}

export type SetNotificationFlag = {
  notificationId: Scalars['ID'];
  setFlags?: InputMaybe<Array<InputMaybe<NotificationFlag>>>;
  unsetFlags?: InputMaybe<Array<InputMaybe<NotificationFlag>>>;
};

export type SetOktaConfiguration = {
  /**
   * The organization's Okta client ID. # If Okta integration is being enabled, this value must be set.
   * The correct value can be found in the organization's Okta dashboard.
   */
  clientId?: InputMaybe<Scalars['String']>;
  /**
   * The organization's Okta client secret. This value is stored in
   * encrypted form and cannot later be retrieved through the Veritone API.
   * If Okta integration is being enabled, this value must be set.
   * The correct value can be found in the organization's Okta dashboard.
   */
  clientSecret?: InputMaybe<Scalars['String']>;
  /**
   * An optional login alias for the organization. If provided, the organization's users
   * will have a dedicated Veritone login endpoint.
   */
  loginAlias?: InputMaybe<Scalars['String']>;
  /**
   * Indicates whether or not authentication with Okta is enabled
   * for the organization. If enabled, this applies to all users # within the organization.
   */
  oktaAuthenticationEnabled?: InputMaybe<Scalars['Boolean']>;
  /** The organization's Okta domain. For example, Veritone's is veritone.okta.com. */
  oktaDomain?: InputMaybe<Scalars['String']>;
};

export type SetOrganizationApplicationAccess = {
  /** Provide the applicaitonID to add/remove to the org access list */
  applicationId: Scalars['ID'];
  /**
   * Set enabled to true to allow the organization to use the application.
   * Set enabled to false to remove from the list of available applications.
   */
  enable: Scalars['Boolean'];
};

export type SetOrganizationIntegrationConfig = {
  /** The JSON config of organization integration */
  config: Scalars['JSONData'];
  /** input integrationId */
  integrationId: Scalars['String'];
  /** input organizationId */
  organizationId: Scalars['ID'];
  /**
   * If userVisible is set to true, then this can be accessed
   * by any type of auth token
   * (as long as the user belongs to that organization or is a superadmin).
   * If userVisible is set to false, then this can only be
   * accessed by an API key of that org or by superadmins.
   */
  userVisible: Scalars['Boolean'];
};

/**
 * Input used to set the primary asset of a given type on a TDO.
 * The type must be supported by the server; primary asset is used
 * by certain engines and front end components.
 * Currently "media" and "transcript" are supported.
 */
export type SetPrimaryAsset = {
  /** The asset type -- "media" or "transcript" */
  assetType: Scalars['String'];
  /** ID of the asset */
  id: Scalars['ID'];
};

export enum SetScheduledJobPermission {
  Editor = 'editor',
  None = 'none',
  Viewer = 'viewer'
}

export enum SetSourcePermission {
  Editor = 'editor',
  None = 'none',
  Viewer = 'viewer'
}

/** Identifies the task that created a TDO. */
export type SetTdoSourceData = {
  /** Optional ID of the cluster that TDO belongs to */
  clusterId?: InputMaybe<Scalars['ID']>;
  /** Optional ID of the scheduled job that created this TDO. */
  scheduledJobId?: InputMaybe<Scalars['ID']>;
  /**
   * Optional ID of the source from which this TDO's initial
   * data was created. This field will typically be set only
   * by adapters that ingest data and create TDOs.
   */
  sourceId?: InputMaybe<Scalars['ID']>;
  /** ID of the task that created this TDO */
  taskId?: InputMaybe<Scalars['ID']>;
};

export type Share = {
  __typename?: 'Share';
  folderId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  mediaShare?: Maybe<MediaShareInfo>;
  mentionId?: Maybe<Scalars['ID']>;
  recipients?: Maybe<Array<Maybe<Scalars['String']>>>;
  shareMessage?: Maybe<Scalars['String']>;
  shareOptionsJson?: Maybe<Scalars['JSONData']>;
  type?: Maybe<ShareType>;
};

export type ShareCollection = {
  /** id of the collection */
  folderId: Scalars['ID'];
  /** list of recipients */
  recipients?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** message in email */
  shareMessage?: InputMaybe<Scalars['String']>;
  /** collection specific share options */
  shareOptions?: InputMaybe<ShareOptions>;
};

export type ShareFolderInput = {
  /** The organizations that will have read permissions to the Folder */
  readOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** The treeObjectId of the Folder to share */
  treeObjectId: Scalars['ID'];
  /** The organizations that will have write permissions to the Folder */
  writeOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type ShareMention = {
  /** id of the mention */
  mentionId: Scalars['ID'];
  /** Internal API token can create shared mention for other orgs */
  organizationId?: InputMaybe<Scalars['ID']>;
  /** list of recipients */
  recipients?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** message in email */
  shareMessage?: InputMaybe<Scalars['String']>;
  /** app specific share options */
  shareOptions?: InputMaybe<Scalars['JSONData']>;
  /** UserID the shared mention is being created for */
  userId?: InputMaybe<Scalars['ID']>;
};

export type ShareMentionFromCollection = {
  /** id of the collection */
  folderId: Scalars['ID'];
  /** id of the mention from collection */
  mentionId: Scalars['ID'];
  /** list of recipients */
  recipients?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** message in email */
  shareMessage?: InputMaybe<Scalars['String']>;
  /** Collection image */
  shareOptions?: InputMaybe<ShareOptions>;
};

export type ShareMentionInBulk = {
  /** Array ids of the mentions */
  mentionIds: Array<Scalars['ID']>;
  /** list of recipients */
  recipients?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** message in email */
  shareMessage?: InputMaybe<Scalars['String']>;
  /** Collection image */
  shareOptions?: InputMaybe<Scalars['JSONData']>;
};

export type ShareOptions = {
  generateAccessToken?: InputMaybe<Scalars['Boolean']>;
  mentionPostPaddingSeconds?: InputMaybe<Scalars['Float']>;
  mentionPrePaddingSeconds?: InputMaybe<Scalars['Float']>;
  organizationLogoUrl?: InputMaybe<Scalars['Boolean']>;
  showAffiliateStripdown?: InputMaybe<Scalars['Boolean']>;
  showComments?: InputMaybe<Scalars['Boolean']>;
  showDescription?: InputMaybe<Scalars['Boolean']>;
  showDownload?: InputMaybe<Scalars['Boolean']>;
  showEngineResults?: InputMaybe<Scalars['Boolean']>;
  showHeader?: InputMaybe<Scalars['Boolean']>;
  showHits?: InputMaybe<Scalars['Boolean']>;
  showImage?: InputMaybe<Scalars['Boolean']>;
  showOrganizationLogo?: InputMaybe<Scalars['Boolean']>;
  showRating?: InputMaybe<Scalars['Boolean']>;
};

export enum ShareType {
  Collection = 'collection',
  Mention = 'mention'
}

export type SharedCollection = {
  __typename?: 'SharedCollection';
  createdDateTime?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  folderId?: Maybe<Scalars['ID']>;
  folderTypeId?: Maybe<Scalars['ID']>;
  image?: Maybe<Scalars['String']>;
  itemCount?: Maybe<Scalars['Int']>;
  mentions?: Maybe<SharedMentionList>;
  modifiedDateTime?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['ID']>;
  programCount?: Maybe<Scalars['Int']>;
  shareInfo?: Maybe<Share>;
  /** A signed url to get the collection image. It will only be signed if it is an s3 url. */
  signedImageUrl?: Maybe<Scalars['String']>;
};


export type SharedCollectionMentionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** Provides status information on the creation or update of a shared collection. */
export type SharedCollectionHistory = {
  __typename?: 'SharedCollectionHistory';
  /** Creation date of this history record */
  createdDateTime: Scalars['DateTime'];
  /** The folder ID for the new or updated shared collection */
  folderId: Scalars['ID'];
  /** History ID */
  id: Scalars['ID'];
  mentionId?: Maybe<Scalars['ID']>;
  /** Last modified date of this history record */
  modifiedDateTime: Scalars['DateTime'];
  /** Number of times the creation or update has been retried */
  retryCount?: Maybe<Scalars['Int']>;
  /** The share ID of the shared collection */
  shareId: Scalars['ID'];
  /**
   * The status of the shared collection creation or update
   * Options: New, InProgress, Complete, Failed
   */
  status: SharedCollectionHistoryStatus;
  /** Type of history record, New, AddMention, or RemoveMention */
  type: Scalars['String'];
};

export type SharedCollectionHistoryList = Page & {
  __typename?: 'SharedCollectionHistoryList';
  /** Count of records in this page. Will be less than or equal to `limit`. */
  count?: Maybe<Scalars['Int']>;
  /** Limit used in the query that generated this page. */
  limit: Scalars['Int'];
  /** Offset used in the query that generated this page. */
  offset: Scalars['Int'];
  /** List of shared collection history records */
  records?: Maybe<Array<Maybe<SharedCollectionHistory>>>;
};

export enum SharedCollectionHistoryStatus {
  Complete = 'Complete',
  Failed = 'Failed',
  InProgress = 'InProgress',
  New = 'New'
}

export enum SharedCollectionUpdateType {
  /** Indicates a mention has to be added to the shared collection */
  AddMentions = 'AddMentions',
  /** Indicates a mention has to be removed from the shared collection */
  RemoveMentions = 'RemoveMentions',
  /** Indicates a mention has to be updated so the shared mention details needs to be updated */
  UpdateMentions = 'UpdateMentions'
}

export type SharedMention = {
  __typename?: 'SharedMention';
  adCreative?: Maybe<Scalars['JSONData']>;
  advertiserId?: Maybe<Scalars['ID']>;
  audience?: Maybe<Scalars['Int']>;
  audienceAffiliateCount?: Maybe<Scalars['Int']>;
  audienceMarketCount?: Maybe<Scalars['Int']>;
  brandId?: Maybe<Scalars['ID']>;
  campaignId?: Maybe<Scalars['ID']>;
  cognitiveEngineResults?: Maybe<Scalars['JSONData']>;
  comments?: Maybe<Array<Maybe<MentionComment>>>;
  complianceStatusId?: Maybe<Scalars['ID']>;
  /** The shared mention description if it is in a collection */
  description?: Maybe<Scalars['String']>;
  fingerprint?: Maybe<Scalars['JSONData']>;
  hash?: Maybe<Scalars['ID']>;
  hitEndDateTime?: Maybe<Scalars['DateTime']>;
  hitStartDateTime?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isMatch?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['ID']>;
  mentionDate?: Maybe<Scalars['DateTime']>;
  mentionHitCount?: Maybe<Scalars['Int']>;
  mentionRating?: Maybe<Scalars['Int']>;
  mentionSnippets?: Maybe<Array<Maybe<MentionSnippets>>>;
  metadata?: Maybe<Scalars['JSONData']>;
  organization?: Maybe<Scalars['JSONData']>;
  organizationId: Scalars['ID'];
  scheduledJob?: Maybe<Scalars['JSONData']>;
  scheduledJobId?: Maybe<Scalars['ID']>;
  share?: Maybe<Share>;
  sourceId?: Maybe<Scalars['ID']>;
  sourceTypeId?: Maybe<Scalars['ID']>;
  spotTypeId?: Maybe<Scalars['ID']>;
  statusId?: Maybe<Scalars['ID']>;
  temporalDataObject?: Maybe<Scalars['JSONData']>;
  userSnippets?: Maybe<Array<Maybe<MentionUserSnippets>>>;
  watchlist?: Maybe<Scalars['JSONData']>;
  watchlistId?: Maybe<Scalars['ID']>;
};

export type SharedMentionList = Page & {
  __typename?: 'SharedMentionList';
  /** Number of records returned in this response */
  count?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
  /** The starting index for records that were returned in this query. */
  offset: Scalars['Int'];
  records?: Maybe<Array<Maybe<SharedMention>>>;
};

export type SharedWith = {
  __typename?: 'SharedWith';
  /** List of organizationIds that have read access to this object */
  read?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** List of organizationIds that have write access to this object */
  write?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type SingleEngineJobInput = {
  /** Cluster ID when creating job */
  clusterId?: InputMaybe<Scalars['ID']>;
  /** Engine ID to be used for the task. */
  engineId: Scalars['ID'];
  /** Engine field values for the default engine template */
  fields?: InputMaybe<Array<InputMaybe<EngineFieldValue>>>;
  priority?: InputMaybe<Scalars['Int']>;
  /** Target tdo ID. Either targetId or uploadUri must be defined, but not both */
  targetId?: InputMaybe<Scalars['ID']>;
  /** The upload url for the engine. Either targetId or uploadUri must be defined, but not both */
  uploadUrl?: InputMaybe<Scalars['String']>;
};

/**
 * A source represents a source of data and is used by adapters to ingest
 * data into the platform for use by an engine workflow.
 */
export type Source = {
  __typename?: 'Source';
  /**
   * Permissions granted to other organizations. Only the source owner
   * can view or edit this field.
   */
  collaborators: SourceCollaboratorList;
  contentTemplates: Array<SourceContentTemplate>;
  /** Id of a structured data object for the correlationSchemaId */
  correlationSDOId?: Maybe<Scalars['ID']>;
  /** Id of a published data registry schema */
  correlationSchemaId?: Maybe<Scalars['ID']>;
  /** Date and time this source was created */
  createdDateTime?: Maybe<Scalars['DateTime']>;
  /**
   * Metadata associated with this source. The schema for this data is
   * specific to the source type and controlled by a schema.
   */
  details?: Maybe<Scalars['JSONData']>;
  /** Unique ID of this source */
  id: Scalars['ID'];
  /**
   * Indicates whether this source is public and available to all organizations
   * or restricted to the organization that owns id.
   */
  isPublic: Scalars['Boolean'];
  /** Date and time this source was last modified */
  modifiedDateTime?: Maybe<Scalars['DateTime']>;
  /** A name for this source */
  name: Scalars['String'];
  /** The organization that owns this source */
  organization?: Maybe<Organization>;
  /** ID of the organization that owns this source */
  organizationId: Scalars['ID'];
  /** permission the currently authenticated principal has on this source. */
  permission: SourcePermission;
  /** The source type for this source */
  sourceType?: Maybe<SourceType>;
  /** ID of the source type for this source. */
  sourceTypeId: Scalars['ID'];
  /**
   * Current state for the source object. This is controlled by
   * the adapters that use the source and should not be set by
   * other clients.
   */
  state?: Maybe<Scalars['JSONData']>;
  /** An optional thumbnail image URL for the source */
  thumbnailUrl?: Maybe<Scalars['String']>;
};


/**
 * A source represents a source of data and is used by adapters to ingest
 * data into the platform for use by an engine workflow.
 */
export type SourceCollaboratorsArgs = {
  orderBy?: InputMaybe<SourceCollaboratorOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};

/** A source ACL grants a single organization limited rights to a private source */
export type SourceCollaborator = {
  __typename?: 'SourceCollaborator';
  /** The organization the source was shared with */
  organization?: Maybe<Organization>;
  /** Organization ID the source was shared with */
  organizationId: Scalars['ID'];
  /** The permission granted. Either `viewer` or `editor`. */
  permission: SourcePermission;
};

export type SourceCollaboratorList = Page & {
  __typename?: 'SourceCollaboratorList';
  count?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records: Array<SourceCollaborator>;
};

export enum SourceCollaboratorOrderBy {
  OrganizationId = 'organizationId',
  Permission = 'permission'
}

export type SourceContentTemplate = {
  __typename?: 'SourceContentTemplate';
  createdDateTime?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['JSONData']>;
  id: Scalars['ID'];
  modifiedDateTime?: Maybe<Scalars['DateTime']>;
  schemaId: Scalars['ID'];
  sdo?: Maybe<StructuredData>;
  sdoId: Scalars['ID'];
  sourceId: Scalars['ID'];
};

export type SourceList = Page & {
  __typename?: 'SourceList';
  count: Scalars['Int'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records: Array<Source>;
};

/** Source list sort field options */
export enum SourceOrderField {
  CreatedDateTime = 'createdDateTime',
  Id = 'id',
  ModifiedDateTime = 'modifiedDateTime',
  Name = 'name',
  SourceTypeId = 'sourceTypeId'
}

/** Permissions or roles on source objects */
export enum SourcePermission {
  /**
   * A source editor can make updates to some source fields, but cannot
   * delete or share the source.
   */
  Editor = 'editor',
  /** A source owner has full rights to update and delete the source. */
  Owner = 'owner',
  /**
   * A viewer can view the source and use it in ingestion jobs,
   * but not make any updates to it.
   */
  Viewer = 'viewer'
}

/** Source list sort information */
export type SourceSortField = {
  /** Specify the sort direction. Default is descending. */
  direction?: InputMaybe<OrderDirection>;
  /** Specify the field to sort by. Required. */
  field: SourceOrderField;
};

/**
 * A source type represents a category of sources that share common
 * attributes, such as "TV station" or "Real-time camera feed".
 */
export type SourceType = {
  __typename?: 'SourceType';
  /**
   * The source type category for this source type.
   * Used primarily by Veritone platform components.
   */
  category: SourceTypeCategory;
  /**
   * The source type category ID for this source type.
   * Used primarily by Veritone platform components.
   */
  categoryId: Scalars['ID'];
  /** Date and time this object was created. */
  createdDateTime?: Maybe<Scalars['DateTime']>;
  /**
   * The schema used to validate credentials associated with sources
   * of this type.
   */
  credentialSchema?: Maybe<Schema>;
  /**
   * The ID of an optional schema for credentials associated with
   * sources of this type.
   */
  credentialSchemaId?: Maybe<Scalars['ID']>;
  credentialType?: Maybe<CredentialType>;
  /** The icon representing the type of source */
  iconClass?: Maybe<Scalars['String']>;
  /** Unique ID of this source type */
  id: Scalars['ID'];
  /** Indicates whether or not the source is "live", such as a camera feed */
  isLive?: Maybe<Scalars['Boolean']>;
  isPublic?: Maybe<Scalars['Boolean']>;
  /** Date and time this object was last modified */
  modifiedDateTime?: Maybe<Scalars['DateTime']>;
  /** A name for this source type */
  name: Scalars['String'];
  organizationId?: Maybe<Scalars['ID']>;
  /**
   * List of program formats applicable to this source type.
   * Only applies to certain source types; many will have an
   * empty list.
   */
  programFormats: Array<Scalars['String']>;
  /** Indicates whether the source requires a scan job pipeline */
  requiresScanPipeline?: Maybe<Scalars['Boolean']>;
  /**
   * List of source formats applicable to this source type.
   * Only applies to certain source types; many will have an
   * empty list.
   */
  sourceFormats: Array<Scalars['String']>;
  /**
   * The schema object used to validate details for instances (sources)
   * of this source type
   */
  sourceSchema?: Maybe<Schema>;
  /**
   * The ID of an optional schema for instances (sources) of
   * this source type
   */
  sourceSchemaId?: Maybe<Scalars['ID']>;
  /** Sources created under this source type */
  sources: SourceList;
  supportedRunModes: Array<RunMode>;
};


/**
 * A source type represents a category of sources that share common
 * attributes, such as "TV station" or "Real-time camera feed".
 */
export type SourceTypeSourcesArgs = {
  correlationSchemaId?: InputMaybe<Scalars['ID']>;
  hasContentTemplates?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  includePublic?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  nameMatch?: InputMaybe<StringMatch>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SourceSortField>>;
};

/** Source type categories are managed by Veritone. */
export type SourceTypeCategory = {
  __typename?: 'SourceTypeCategory';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type SourceTypeCategoryList = Page & {
  __typename?: 'SourceTypeCategoryList';
  count?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records: Array<SourceTypeCategory>;
};

export type SourceTypeList = Page & {
  __typename?: 'SourceTypeList';
  count: Scalars['Int'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records: Array<SourceType>;
};

export type StaticAppConfig = {
  __typename?: 'StaticAppConfig';
  adminAppUrl?: Maybe<Scalars['String']>;
  apiRoot?: Maybe<Scalars['String']>;
  automateControllerUrl?: Maybe<Scalars['String']>;
  automateUrl?: Maybe<Scalars['String']>;
  cmsAppUrl?: Maybe<Scalars['String']>;
  controllerNodeRedImage?: Maybe<Scalars['String']>;
  graphEndpoint?: Maybe<Scalars['String']>;
  graphEndpointWS?: Maybe<Scalars['String']>;
  loginUrl?: Maybe<Scalars['String']>;
  sessionTimeout?: Maybe<Scalars['Int']>;
  switchAppUrl?: Maybe<Scalars['String']>;
};

/** Used to control string matching on fields that support it */
export enum StringMatch {
  /**
   * Match if the target string field contains the supplied value
   * anywhere in its content. Use only when strictly necessary, as
   * startsWith and endsWith offer better performance.
   * Case-insensitive.
   */
  Contains = 'contains',
  /**
   * Match if the target string field ends with the supplied value.
   * Case-insensive.
   */
  EndsWith = 'endsWith',
  /**
   * Match if the target string field exactly matches the
   * supplied value. Case-insensitive.
   */
  Exact = 'exact',
  /**
   * Match if the target string field starts with the supplied value.
   * Case-insensitive.
   */
  StartsWith = 'startsWith'
}

/** Type representing a string property */
export type StringProperty = Property & {
  __typename?: 'StringProperty';
  name: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type StructuredData = {
  __typename?: 'StructuredData';
  createdDateTime?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['JSONData']>;
  dataString?: Maybe<Scalars['String']>;
  /** The ID */
  id: Scalars['ID'];
  modifiedDateTime?: Maybe<Scalars['DateTime']>;
  /** The schema used to validate this object */
  schema?: Maybe<Schema>;
  /** Id of the schema used to validate this object */
  schemaId: Scalars['ID'];
};


export type StructuredDataDataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


export type StructuredDataDataStringArgs = {
  indent?: InputMaybe<Scalars['Int']>;
};

export type StructuredDataList = Page & {
  __typename?: 'StructuredDataList';
  count?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy?: Maybe<Array<StructuredDataOrderByType>>;
  owned?: Maybe<Scalars['Boolean']>;
  records?: Maybe<Array<Maybe<StructuredData>>>;
};

export type StructuredDataOrderBy = {
  direction?: InputMaybe<OrderDirection>;
  field: StructuredDataOrderByField;
};

export enum StructuredDataOrderByField {
  CreatedDateTime = 'createdDateTime',
  ModifiedDateTime = 'modifiedDateTime'
}

export type StructuredDataOrderByType = {
  __typename?: 'StructuredDataOrderByType';
  direction: OrderDirection;
  field: StructuredDataOrderByField;
};

/**
 * An object containing custom structured data.
 * This type is not fully implemented.
 */
export type StructuredJsonObject = Metadata & {
  __typename?: 'StructuredJSONObject';
  data?: Maybe<Scalars['JSONData']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  schema: StructuredJsonSchema;
};

/**
 * A custom structured data schema, specified in JSON.
 * This type is not fully implemented.
 */
export type StructuredJsonSchema = {
  __typename?: 'StructuredJSONSchema';
  id: Scalars['ID'];
  name: Scalars['String'];
  organization: Organization;
  ownerOrganizationId: Scalars['ID'];
  schema?: Maybe<Scalars['JSONData']>;
};

export type SubscribeEvent = {
  /** Identifier of the app using the event */
  application: Scalars['String'];
  /** The conditions to filter the event */
  conditions?: InputMaybe<Scalars['JSONData']>;
  /** a string payload, it should be serialized Protobuf data with base64 encoding */
  delivery: EventDelivery;
  /** Existing event name */
  eventName?: InputMaybe<Scalars['String']>;
  /** Existing event type */
  eventType?: InputMaybe<Scalars['String']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  contact: SubscriptionContact;
  createdDateTime?: Maybe<Scalars['DateTime']>;
  frequency: SubscriptionFrequency;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  jsondata?: Maybe<Scalars['JSONData']>;
  modifiedDateTime?: Maybe<Scalars['DateTime']>;
  objectType: SubscriptionObjectType;
  organizationId: Scalars['ID'];
  /** Scheduled day of the week */
  scheduledDay?: Maybe<DayOfWeek>;
  /** Scheduled time of day */
  scheduledTime?: Maybe<Scalars['Time']>;
  /** Time zone of the scheduled time */
  scheduledTimeZone?: Maybe<Scalars['String']>;
  /**
   * The ID of the object on which this subscription is set,
   * such as a watchlist ID.
   */
  targetId: Scalars['ID'];
  unsubscribeHash?: Maybe<Scalars['String']>;
};

export type SubscriptionContact = {
  __typename?: 'SubscriptionContact';
  emailAddress?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
  webhookUri?: Maybe<Scalars['String']>;
};

export enum SubscriptionFrequency {
  Daily = 'daily',
  Immediate = 'immediate',
  Never = 'never',
  Weekly = 'weekly'
}

export enum SubscriptionObjectType {
  Mention = 'mention'
}

export type SubscriptionService = {
  __typename?: 'SubscriptionService';
  notificationPosted?: Maybe<Notification>;
};


export type SubscriptionServiceNotificationPostedArgs = {
  notificationMailboxId?: InputMaybe<Scalars['ID']>;
  notificationMailboxIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export enum SupportedGpu {
  G2 = 'G2',
  G3 = 'G3',
  P2 = 'P2'
}

export type SystemEventInfo = {
  __typename?: 'SystemEventInfo';
  id: Scalars['ID'];
  payload: Scalars['JSONData'];
  timestamp: Scalars['DateTime'];
  topic: Scalars['String'];
};

/** Options used by the cleanupTDO mutation to select which data is deleted. */
export enum TdoCleanupOption {
  /**
   * Indicates that engine results stored on related task objects should be deleted.
   * Engine results stored as assets will remain until assets are removed
   * using the storage option.
   */
  EngineResults = 'engineResults',
  /**
   * Indicates that all search index data should be deleted. The TemporalDataObject
   * and its assets will no longer be accessible through search.
   */
  SearchIndex = 'searchIndex',
  /**
   * Indicates that all assets should be deleted from storage, including
   * those used to store engine results. Metadata about the assets will remain
   * until the container TemporalDataObject is permanently deleted.
   */
  Storage = 'storage'
}

export type TdoList = Page & {
  __typename?: 'TDOList';
  /** Number of records returned in this response */
  count?: Maybe<Scalars['Int']>;
  /** Maximum number of results that were retrieved in this query; page size */
  limit: Scalars['Int'];
  /** The starting index for records that were returned in this query. */
  offset: Scalars['Int'];
  records?: Maybe<Array<Maybe<TemporalDataObject>>>;
};

/**
 * Describes source information about a TDO. That is,
 * the components and processes that produced it.
 * Each field may or may not have a value, depending on
 * how the TDO was created.
 */
export type TdoSourceData = {
  __typename?: 'TDOSourceData';
  /** ID of the cluster, if any, under which TDO belongs to */
  clusterId?: Maybe<Scalars['ID']>;
  /** The engine used in the task that created this TDO. */
  engine?: Maybe<Engine>;
  /** ID of the engine used in the task that created this TDO */
  engineId?: Maybe<Scalars['ID']>;
  /** The scheduled job under which this TDO was created, if any */
  scheduledJob?: Maybe<ScheduledJob>;
  /** ID of the scheduled job, if any, under which this TDO was created */
  scheduledJobId?: Maybe<Scalars['ID']>;
  /** The source from which this TDO was created, if any */
  source?: Maybe<Source>;
  /** Ingestion source ID */
  sourceId?: Maybe<Scalars['ID']>;
  /** The task object. */
  task?: Maybe<Task>;
  /** Task ID, typically of an ingestion task. */
  taskId?: Maybe<Scalars['ID']>;
};

/** Describes a stream that is available on a TDO */
export type TdoStreamData = {
  __typename?: 'TDOStreamData';
  /** The protocol, such as "dash" or "hls" */
  protocol: Scalars['String'];
  /** The stream URI */
  uri: Scalars['String'];
};

export type TdoStreamManifest = {
  __typename?: 'TDOStreamManifest';
  initSegment?: Maybe<Scalars['JSONData']>;
  segments?: Maybe<Array<Scalars['JSONData']>>;
};

/** Represents a single engine task */
export type Task = {
  __typename?: 'Task';
  /** Application ID that owns the task */
  applicationId?: Maybe<Scalars['String']>;
  /** The engine build used for this task */
  build?: Maybe<Build>;
  /** ID of the engine build used for this task. */
  buildId?: Maybe<Scalars['ID']>;
  childTaskIds?: Maybe<Array<Scalars['ID']>>;
  childTasks?: Maybe<Array<Task>>;
  /** Date and time the task completed. */
  completedDateTime?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  /** Date and time the task was created */
  createdDateTime?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  /** The engine for the task */
  engine?: Maybe<Engine>;
  engineConfiguration?: Maybe<EngineConfiguration>;
  engineConfigurationId?: Maybe<Scalars['ID']>;
  /** ID of the engine for the task. */
  engineId?: Maybe<Scalars['ID']>;
  executionLocation?: Maybe<ExecutionLocation>;
  executionLocationId?: Maybe<Scalars['ID']>;
  /** Execution preferences for the current task */
  executionPreferences?: Maybe<ExecutionPreferences>;
  /**
   * Failure message from the engine. This will be set only if the task final
   * status was `failed` and `failureReason` is set.
   */
  failureMessage?: Maybe<Scalars['String']>;
  /**
   * Failure reason code. This will be set only if the task final status
   * was `failed`.
   */
  failureReason?: Maybe<TaskFailureReason>;
  /** The task ID */
  id: Scalars['ID'];
  ioFolders?: Maybe<Array<Maybe<IoFolder>>>;
  /** Whether or not the task is run on the clone of a TDO */
  isClone?: Maybe<Scalars['Boolean']>;
  /** The job that contains this task. */
  job?: Maybe<Job>;
  /** The ID of the job that contains this task */
  jobId?: Maybe<Scalars['ID']>;
  /** The log file produced during task execution */
  log?: Maybe<TaskLog>;
  mediaFileName?: Maybe<Scalars['String']>;
  mediaLengthSec?: Maybe<Scalars['Int']>;
  mediaStorageBytes?: Maybe<Scalars['Int']>;
  modifiedBy?: Maybe<Scalars['String']>;
  /** Date and time the task was last modified */
  modifiedDateTime?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  /** This contains a list of URIs engine toolkit will send completed chunks. */
  notificationUris?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Optional order in which the task should run, relative to other tasks
   * in the job that contains it.
   */
  order?: Maybe<Scalars['Int']>;
  /** The task output, in JSON format. */
  output?: Maybe<Scalars['JSONData']>;
  /** The task output, in String format. */
  outputString?: Maybe<Scalars['String']>;
  parentTask?: Maybe<Task>;
  parentTaskId?: Maybe<Scalars['ID']>;
  /** The incoming task payload, in JSON format */
  payload?: Maybe<Scalars['JSONData']>;
  /** The incoming task payload, in String format. */
  payloadString?: Maybe<Scalars['String']>;
  /** Date and time the task was queued for execution. */
  queuedDateTime?: Maybe<Scalars['DateTime']>;
  /**
   * Contains metadata used by the platform run-time system to execute
   * the task. This field is accessible only to platform components.
   */
  runtimePayload?: Maybe<Scalars['JSONData']>;
  /** The source asset for this task, if there is one. */
  sourceAsset?: Maybe<Asset>;
  /** The ID of the source asset for this task, if there is one. */
  sourceAssetId?: Maybe<Scalars['ID']>;
  /**
   * The task that this task is a standby for. If the task
   * identified in this field fails, the current task will execute.
   */
  standbyForTask?: Maybe<Task>;
  /** A standby task that will execute if this one fails. */
  standbyTask?: Maybe<Task>;
  /** Date and time task execution started */
  startedDateTime?: Maybe<Scalars['DateTime']>;
  /** The task status. See TaskStatus enum for details. */
  status?: Maybe<TaskStatus>;
  /** The TemporalDataObject the task was created for. */
  target?: Maybe<TemporalDataObject>;
  /**
   * The ID of the TemporalDataObject the task
   * was created for.
   */
  targetId?: Maybe<Scalars['ID']>;
  /** For backwards compatibility only */
  taskOutput?: Maybe<Scalars['JSONData']>;
  /** For backwards compatibility only */
  taskPayload?: Maybe<Scalars['JSONData']>;
  template?: Maybe<TaskTemplate>;
  templateId?: Maybe<Scalars['ID']>;
  /** True if this task was created as a test task */
  testTask?: Maybe<Scalars['Boolean']>;
  warnings?: Maybe<Array<Maybe<TaskWarning>>>;
};

export enum TaskDateTimeField {
  CreatedDateTime = 'createdDateTime',
  ModifiedDateTime = 'modifiedDateTime'
}

export type TaskDateTimeFilter = {
  field: TaskDateTimeField;
  fromDateTime?: InputMaybe<Scalars['DateTime']>;
  toDateTime?: InputMaybe<Scalars['DateTime']>;
};

export type TaskEngineReplacement = {
  __typename?: 'TaskEngineReplacement';
  organizationId?: Maybe<Scalars['ID']>;
  replacementEngineId: Scalars['ID'];
  sourceEngineId: Scalars['ID'];
};

/** Need to keep in sync with https://github.com/veritone/edge-messages/blob/master/failure_reason.go */
export enum TaskFailureReason {
  /**
   * The engine received an authentication error from the Veritone API using
   * the token provided in the task payload.
   */
  ApiAuthenticationError = 'api_authentication_error',
  /**
   * An unexpected error was received from the Veritone API, such as
   * HTTP 500, HTTP 502, or an `internal_error` error.
   */
  ApiError = 'api_error',
  /** The engine received an authorization error from the Veritone API. */
  ApiNotAllowed = 'api_not_allowed',
  /**
   * The engine received a "not found" error from the Veritone API on
   * a required object.
   */
  ApiNotFound = 'api_not_found',
  /** The engine failed to send chunk result, or Edge didn't receive it in time */
  ChunkTimeout = 'chunk_timeout',
  /** The task definition doesn't meet edge validation criteria */
  EdgeValidation = 'edge_validation',
  /** The engine calls third party for processing and receives error */
  ExternalError = 'external_error',
  /**
   * The engine could not write temporary files to disk for processing
   * due to disk space full or other system error.
   */
  FileWriteError = 'file_write_error',
  /** The engine failed to send heartbeat or Edge didn't receive it in time */
  HeartbeatTimeout = 'heartbeat_timeout',
  /** The engine encountered an unexpected internal error. */
  InternalError = 'internal_error',
  /**
   * The input to the engine was incompatible with the engine
   * requirements. For example, an input media file had an
   * unsupported MIME type or the file was empty.
   */
  InvalidData = 'invalid_data',
  /**
   * The error cause is known, but could not be mapped to a `TaskFailureReason`
   * value. The `failureMessage` input field should contain details.
   */
  Other = 'other',
  /** An engine operation was subject to rate limiting. */
  RateLimited = 'rate_limited',
  /**
   * The engine could not read from stream input for processing
   * due to stream link broken or cannot connect to stream link
   */
  StreamReadError = 'stream_read_error',
  /**
   * The engine encountered a missing binary dependency or configuration,
   * such as a missing executable or package or incompatible hardware.
   */
  SystemDependencyMissing = 'system_dependency_missing',
  /**
   * The engine encountered an operating system, hardware, or other
   * system-level error.
   */
  SystemError = 'system_error',
  /** The cause of the failure could not be determined. */
  Unknown = 'unknown',
  /**
   * The engine attempted to download
   * content from a URL provided in the task payload and
   * the connection was refused.
   */
  UrlConnectionRefused = 'url_connection_refused',
  /**
   * The engine attempted to download content from a URL
   * provided in the task payload an received an error.
   */
  UrlError = 'url_error',
  /**
   * The engine attempted to download
   * content from a URL provided in the task payload and
   * received a 401 or 403.
   */
  UrlNotAllowed = 'url_not_allowed',
  /**
   * The engine attempted to download
   * content from a URL provided in the task payload and
   * received a 404.
   */
  UrlNotFound = 'url_not_found',
  /**
   * The engine attempted to download
   * content from a URL provided in the task payload and
   * the download timed out
   */
  UrlTimeout = 'url_timeout'
}

export type TaskList = Page & {
  __typename?: 'TaskList';
  /** Number of records returned in this response */
  count?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
  /** The starting index for records that were returned in this query. */
  offset: Scalars['Int'];
  records?: Maybe<Array<Maybe<Task>>>;
};

export type TaskLog = {
  __typename?: 'TaskLog';
  /**
   * The log file in JSON form. If the log file contains valid JSON,
   * this field will contain the native structure. If the log file does not
   * contain valid JSON, this field will contain a single property called
   * `text` with a string value containing the entire log file.
   */
  jsondata?: Maybe<Scalars['JSONData']>;
  /** The entire text contents of the log file. Note that this value can long. */
  text?: Maybe<Scalars['String']>;
  /** URI to the task log file */
  uri?: Maybe<Scalars['String']>;
};

export enum TaskOrderField {
  CompletedDateTime = 'completedDateTime',
  CreatedDateTime = 'createdDateTime',
  ModifiedDateTime = 'modifiedDateTime',
  QueuedDateTime = 'queuedDateTime'
}

export type TaskReplacementEngineList = Page & {
  __typename?: 'TaskReplacementEngineList';
  count?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records?: Maybe<Array<TaskEngineReplacement>>;
};

export type TaskSortField = {
  direction?: InputMaybe<OrderDirection>;
  field: TaskOrderField;
};

export enum TaskStatus {
  Aborted = 'aborted',
  Accepted = 'accepted',
  Cancelled = 'cancelled',
  Complete = 'complete',
  Failed = 'failed',
  Paused = 'paused',
  Pending = 'pending',
  Queued = 'queued',
  Resuming = 'resuming',
  Running = 'running',
  StandbyPending = 'standby_pending',
  Waiting = 'waiting'
}

export type TaskTemplate = {
  __typename?: 'TaskTemplate';
  childTaskIds: Array<Scalars['ID']>;
  childTasks: TaskTemplateList;
  engine?: Maybe<Engine>;
  engineConfig?: Maybe<EngineConfiguration>;
  engineConfigId?: Maybe<Scalars['ID']>;
  engineId?: Maybe<Scalars['ID']>;
  executionLocation?: Maybe<ExecutionLocation>;
  executionLocationId?: Maybe<Scalars['ID']>;
  /** Execution preferences for the current task */
  executionPreferences?: Maybe<ExecutionPreferences>;
  id: Scalars['ID'];
  /** IO folders for the task. */
  ioFolders?: Maybe<Array<Maybe<IoFolder>>>;
  jobTemplate?: Maybe<JobTemplate>;
  jobTemplateId?: Maybe<Scalars['ID']>;
  /** This contains a list of URIs engine toolkit will send completed chunks. */
  notificationUris?: Maybe<Array<Maybe<Scalars['String']>>>;
  parentTask?: Maybe<Task>;
  parentTaskId?: Maybe<Scalars['ID']>;
  payload?: Maybe<Scalars['JSONData']>;
  payloadString?: Maybe<Scalars['String']>;
};

export type TaskTemplateList = Page & {
  __typename?: 'TaskTemplateList';
  count: Scalars['Int'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records: Array<TaskTemplate>;
};

export type TaskWarning = {
  __typename?: 'TaskWarning';
  message?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  referenceId?: Maybe<Scalars['ID']>;
};

export enum TemplateLanguage {
  Handlebars = 'Handlebars'
}

export type TemporalDataObject = SecurableObject & {
  __typename?: 'TemporalDataObject';
  /** Add ACEs to the TDO. */
  addACEs?: Maybe<AuthAcl>;
  /**
   * The "application ID" of the organization that owns this TDO.
   * Maps directly to an organization ID.
   * @deprecated Duplicate, redundant field
   */
  applicationId: Scalars['ID'];
  assetCount: Scalars['Int'];
  /**
   * Assets this object contains. Can be of any size.
   * This field does not support paging.
   */
  assets?: Maybe<AssetList>;
  createdBy?: Maybe<Scalars['String']>;
  /** Object creation timestamp. Does not change. In seconds since epoch (TODO change!). */
  createdDateTime?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['JSONData']>;
  /** Statuses of the engines run on the TDO. */
  engineRuns?: Maybe<EngineRunList>;
  /** Folders that this TDO is filed in */
  folders?: Maybe<Array<Folder>>;
  /** TreeObjectIds of all parents folders in the tdo folder path */
  foldersTreeObjectIds?: Maybe<Array<Scalars['ID']>>;
  /** The object's unique ID */
  id: Scalars['ID'];
  /**
   * Indicates whether or not media contained in this TDO is
   * public (accessible to all orgs).
   */
  isPublic?: Maybe<Scalars['Boolean']>;
  /** Jobs running against this temporalDataObject */
  jobs?: Maybe<JobList>;
  /**
   * Direct access to metadata in raw JSON format
   * @deprecated Duplicate, redundant field
   */
  jsondata?: Maybe<Scalars['JSONData']>;
  /** @deprecated Duplicate, redundant field */
  mediaId?: Maybe<Scalars['ID']>;
  /**
   * Modular metadata
   * @deprecated Duplicate, redundant field
   */
  metadata?: Maybe<Array<Maybe<Metadata>>>;
  modifiedBy?: Maybe<Scalars['String']>;
  /** Object modification timestamp. In seconds since epoch (TODO change!). */
  modifiedDateTime?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  /** The organization that owns this TDO */
  organization?: Maybe<Organization>;
  /** The ID of the organization that owns this TDO. */
  organizationId: Scalars['ID'];
  /**
   * An optional URL for a preview asset for this document
   * object. If the URL is to an object in Veritone's
   * object storage, it will be signed.
   */
  previewUrl?: Maybe<Scalars['String']>;
  /** Retrieve the primary asset of a given type */
  primaryAsset?: Maybe<Asset>;
  /** Security settings for the asset container */
  security?: Maybe<Security>;
  source?: Maybe<Scalars['String']>;
  sourceData?: Maybe<TdoSourceData>;
  /**
   * An optional URL for a source image for this object.
   * If the URL is to an object in Veritone's
   * object storage, it will be signed.
   */
  sourceImageUrl?: Maybe<Scalars['String']>;
  /** Recording start time. In seconds since epoch. */
  startDateTime: Scalars['DateTime'];
  /** status. Downloaded, recording, etc. */
  status?: Maybe<Scalars['String']>;
  /** Recording stop time. In seconds since epoch. */
  stopDateTime: Scalars['DateTime'];
  /**
   * If this is a segmented TDO, returns the stream manifest
   * contents in normalized JSON form.
   */
  streamManifest?: Maybe<TdoStreamManifest>;
  /**
   * If this TDO supports streams, contains stream listings.
   * Might be an empty list but will not be null.
   */
  streams: Array<TdoStreamData>;
  /** Tasks running against this TemporalDataObject */
  tasks?: Maybe<TaskList>;
  /**
   * An optional URL for a thumbnail or preview image for
   * this object. If the URL is to an object in Veritone's
   * object storage, it will be signed.
   */
  thumbnailUrl?: Maybe<Scalars['String']>;
};


export type TemporalDataObjectAddAcEsArgs = {
  entries: Array<AuthAcePermissionInput>;
};


export type TemporalDataObjectAssetsArgs = {
  assetType?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['ID']>;
  includeVirtualMediaAsset?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<AssetOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  sourceTaskId?: InputMaybe<Scalars['ID']>;
};


export type TemporalDataObjectDetailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


export type TemporalDataObjectEngineRunsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type TemporalDataObjectJobsArgs = {
  dateTimeFilter?: InputMaybe<Array<JobDateTimeFilter>>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobSortField>>;
};


export type TemporalDataObjectPrimaryAssetArgs = {
  assetType: Scalars['String'];
};


export type TemporalDataObjectTasksArgs = {
  dateTimeFilter?: InputMaybe<Array<InputMaybe<TaskDateTimeFilter>>>;
  hasSourceAsset?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TaskSortField>>;
};

export enum TemporalDataObjectDateTimeField {
  CreatedDateTime = 'createdDateTime',
  ModifiedDateTime = 'modifiedDateTime',
  StartDateTime = 'startDateTime',
  StopDateTime = 'stopDateTime'
}

/**
 * Specify a filter on a TemporalDataObject date/time field.
 * At least one of `toDateTime` and `fromDateTime` must be provided.
 */
export type TemporalDataObjectDateTimeFilter = {
  /** Identify the field to filter on. */
  field: TemporalDataObjectDateTimeField;
  /** Match if the field value is `fromDateTime` or later */
  fromDateTime?: InputMaybe<Scalars['DateTime']>;
  /** Whether the fromDateTime is inclusive or exclusive of the input timestamp */
  fromDateTimeExclusive?: InputMaybe<Scalars['Boolean']>;
  /** Match if the field value is `toDateTime` or earlier */
  toDateTime?: InputMaybe<Scalars['DateTime']>;
  /** Whether the toDateTime is inclusive or exclusive of the input timestamp */
  toDateTimeExclusive?: InputMaybe<Scalars['Boolean']>;
};

export enum TemporalDataObjectOrderBy {
  CreatedDateTime = 'createdDateTime',
  ModifiedDateTime = 'modifiedDateTime',
  StartDateTime = 'startDateTime',
  StopDateTime = 'stopDateTime'
}

export type TestingDetailsField = {
  buildIdCertified?: InputMaybe<Scalars['String']>;
  customFields?: InputMaybe<Scalars['JSONData']>;
  dataCertified?: InputMaybe<Scalars['JSONData']>;
  email: Scalars['String'];
  isCertified?: InputMaybe<Scalars['Boolean']>;
  mediaFileUri: Scalars['String'];
};

export type TestingDetailsType = {
  __typename?: 'TestingDetailsType';
  buildIdCertified?: Maybe<Scalars['String']>;
  customFields?: Maybe<Scalars['JSONData']>;
  dataCertified?: Maybe<Scalars['JSONData']>;
  email?: Maybe<Scalars['String']>;
  isCertified?: Maybe<Scalars['Boolean']>;
  mediaFileUri?: Maybe<Scalars['String']>;
};

/** Information about a time zone */
export type TimeZone = {
  __typename?: 'TimeZone';
  /**
   * Known abbreviations for the time zone. These may include
   * offset variations such as those caused by daylight savings time.
   */
  abbreviations: Array<TimeZoneAbbreviation>;
  /** Time zone name, such as `America/Los_Angeles` */
  name: Scalars['String'];
};

/** Information about a time zone abbreviation or variant. */
export type TimeZoneAbbreviation = {
  __typename?: 'TimeZoneAbbreviation';
  /** The abbreviation, such as "PST" or "UTC" */
  name: Scalars['String'];
  /** The offset from UTC in string form, such as `-08:00` for `PST`. */
  offset?: Maybe<Scalars['String']>;
  /** The offset from UTC in minutes, such as `-480` for `PST`. */
  offsetMinutes?: Maybe<Scalars['Int']>;
};

export type Token = {
  __typename?: 'Token';
  applicationId?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['String']>;
  /** The token ID */
  id?: Maybe<Scalars['String']>;
  json?: Maybe<TokenJson>;
};

export type TokenJson = {
  __typename?: 'TokenJson';
  rights?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum TokenType {
  Api = 'API',
  User = 'User'
}

/** The possible transformer functions which can be used with assets */
export enum TransformFunction {
  /** Get asset JSON data as JSON */
  Json = 'JSON',
  /** Transfrom asset with XML Transcript format to JSON */
  Transcript2Json = 'Transcript2JSON',
  /** Transform asset with XML format to JSON */
  Xml2Json = 'XML2JSON'
}

/** Contains information of a event hook */
export type Trigger = {
  __typename?: 'Trigger';
  consumerParams?: Maybe<Scalars['JSONData']>;
  createdBy: Scalars['String'];
  createdDateTime: Scalars['DateTime'];
  event: Scalars['String'];
  id: Scalars['ID'];
  modifiedDateTime: Scalars['DateTime'];
  target: Scalars['String'];
  updatedBy: Scalars['String'];
};

export type UnfileApplication = {
  /** ID of the application to unfile */
  appId: Scalars['ID'];
  /** ID of the parent folder. The application will be removed from this folder. */
  folderId: Scalars['ID'];
};

export type UnfileTemporalDataObject = {
  /** ID of the parent folder. The TDO will be removed from this folder. */
  folderId: Scalars['ID'];
  /** ID of the TDO to unfile */
  tdoId: Scalars['ID'];
};

export type UnfileWatchlist = {
  /** ID of the parent folder. The watchlist will be removed from this folder. */
  folderId: Scalars['ID'];
  /** ID of the watchlist to unfile */
  watchlistId: Scalars['ID'];
};

export type UnpauseCluster = {
  id: Scalars['ID'];
};

export type UnpauseClusterNode = {
  /** Node ID */
  id: Scalars['ID'];
};

export type UnsubscribeEvent = {
  __typename?: 'UnsubscribeEvent';
  /** ID of the object that was deleted */
  id: Scalars['ID'];
  /** Message */
  message?: Maybe<Scalars['String']>;
};

export type UpdateApplication = {
  category?: InputMaybe<Scalars['String']>;
  checkPermissions?: InputMaybe<Scalars['Boolean']>;
  contextMenuExtensions?: InputMaybe<UpdateContextMenuExtensions>;
  deploymentModel?: InputMaybe<DeploymentModel>;
  description?: InputMaybe<Scalars['String']>;
  /** The tags associated with the application. */
  entityTags?: InputMaybe<Array<InputMaybe<EntityTagInput>>>;
  eventEndpoint?: InputMaybe<Scalars['String']>;
  /** The headerbar configuration to be used with this application */
  headerbar?: InputMaybe<ApplicationHeaderbarUpdate>;
  headerbarEnabled?: InputMaybe<Scalars['Boolean']>;
  iconSvg?: InputMaybe<Scalars['String']>;
  iconUrl?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  isPublic?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  /** The node modules that need to be installed with the application and will be added to the same package as this application. */
  nodeModules?: InputMaybe<Array<InputMaybe<NodeModuleInput>>>;
  oauth2RedirectUrls?: InputMaybe<Array<Scalars['String']>>;
  permissionsRequired?: InputMaybe<Array<Scalars['String']>>;
  /**
   * The resources (engines, flows, and schemas) which will be added
   * to the new application in the form of components and package resources.
   */
  resources?: InputMaybe<Array<InputMaybe<ApplicationResourceUpdate>>>;
  status?: InputMaybe<ApplicationStatus>;
  url?: InputMaybe<Scalars['String']>;
};

export type UpdateApplicationComponent = {
  action: UpdateApplicationComponentAction;
  /** ids of the components to associate with application */
  componentIds: Array<Scalars['ID']>;
  /** the application id */
  id: Scalars['ID'];
  type: ApplicationComponentType;
};

export enum UpdateApplicationComponentAction {
  Add = 'add',
  Remove = 'remove'
}

export type UpdateApplicationEventEndpoint = {
  /** Event endpoint of application */
  eventEndpoint: Scalars['String'];
  /** ID of application */
  id: Scalars['ID'];
};

export type UpdateApplicationRoleInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  isAppEventRole?: InputMaybe<Scalars['Boolean']>;
  isPrivate?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<InputMaybe<AuthPermissionType>>>;
};

/**
 * Input needed to update an asset. The asset data itself -- file or URI --
 * is immutable. Only supplemental metadata can be updated with this input type.
 */
export type UpdateAsset = {
  /** The asset description. */
  description?: InputMaybe<Scalars['String']>;
  /** Application- or type-specific metadata */
  details?: InputMaybe<Scalars['JSONData']>;
  /** Optionally, set attributes about the file */
  fileData?: InputMaybe<SetAssetFileData>;
  /** The asset ID. Required. */
  id: Scalars['ID'];
  /** File name or other name for the asset */
  name?: InputMaybe<Scalars['String']>;
  /** Optionally, set attributes about the source engine and task */
  sourceData?: InputMaybe<SetAssetSourceData>;
};

export type UpdateBuild = {
  action: BuildUpdateAction;
  dataCertified?: InputMaybe<Scalars['JSONData']>;
  dockerImage?: InputMaybe<Scalars['String']>;
  engineId: Scalars['ID'];
  id: Scalars['ID'];
  releaseNotes?: InputMaybe<Scalars['String']>;
  taskRuntime?: InputMaybe<Scalars['JSONData']>;
};

export type UpdateCluster = {
  allowedEngines?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bypassAllowedEngines?: InputMaybe<Scalars['Boolean']>;
  /** Update the cluster config */
  clusterConfig?: InputMaybe<Scalars['JSONData']>;
  /**
   * Permissions granted to other organizations. Only the cluster owner
   * can view or edit this field.
   */
  collaborators?: InputMaybe<Array<CreateClusterCollaborator>>;
  containerTag?: InputMaybe<Scalars['String']>;
  /** Update base URL controller */
  controllerUrl?: InputMaybe<Scalars['String']>;
  /** ID of the core that the cluster is pulling jobs from */
  coreId?: InputMaybe<Scalars['String']>;
  dockerCredentials?: InputMaybe<Scalars['JSONData']>;
  edgeVersion?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  /**
   * Designate a management node ID. Used only for edge/portable clusters.
   * Must be the ID of an existing node in the cluster.
   */
  managementNodeID?: InputMaybe<Scalars['ID']>;
  /** Media storage path. Optional -- use only for edge. */
  mediaStoragePath?: InputMaybe<Scalars['String']>;
  memorySize?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  /**
   * Optionally, specify a time at which the edge cluster should
   * be restarted daily. Applies only to edge clusters.
   */
  restartTimeUTC?: InputMaybe<Scalars['Time']>;
  /** Optionally, specify an api-token for cluster */
  serviceToken?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ClusterStatus>;
  storageSize?: InputMaybe<Scalars['Int']>;
  /** Update subscriptions on the cluster. */
  subscriptions?: InputMaybe<Array<InputMaybe<UpdateClusterSubscription>>>;
  /** Tags for cluster */
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type UpdateClusterNode = {
  id: Scalars['ID'];
  metrics?: InputMaybe<Scalars['JSONData']>;
  name?: InputMaybe<Scalars['String']>;
  /** Update the cluster node config */
  nodeConfig?: InputMaybe<Scalars['JSONData']>;
};

/** Updates the state information for a given cluster */
export type UpdateClusterState = {
  /** The cluster ID */
  id: Scalars['ID'];
  nodes?: InputMaybe<Array<InputMaybe<ClusterNodeUpdate>>>;
  state: Scalars['JSONData'];
  /** Optionally, update current the cluster status. */
  targetStatus?: InputMaybe<ClusterStatus>;
};

export type UpdateClusterSubscription = {
  isActive?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['ID'];
};

export type UpdateCognitiveSearch = {
  id: Scalars['ID'];
  jsonstring?: InputMaybe<Scalars['String']>;
  mentionStatusId?: InputMaybe<Scalars['ID']>;
  profile?: InputMaybe<Scalars['JSONData']>;
};

export type UpdateCollection = {
  /** description of the collection */
  folderDescription?: InputMaybe<Scalars['String']>;
  /** id of the collection */
  folderId: Scalars['ID'];
  /** Collection image */
  image?: InputMaybe<Scalars['String']>;
  /** the name of the collection */
  name?: InputMaybe<Scalars['String']>;
  parentFolderId?: InputMaybe<Scalars['ID']>;
};

export type UpdateCollectionMention = {
  description: Scalars['String'];
  folderId: Scalars['ID'];
  mentionId: Scalars['ID'];
};

export type UpdateContextMenuExtension = {
  /** The ID of the context menu extension to update */
  id: Scalars['ID'];
  label: Scalars['String'];
  url?: InputMaybe<Scalars['String']>;
};

export type UpdateContextMenuExtensions = {
  collections?: InputMaybe<Array<InputMaybe<UpdateContextMenuExtension>>>;
  mentions?: InputMaybe<Array<InputMaybe<UpdateContextMenuExtension>>>;
  tdos?: InputMaybe<Array<InputMaybe<UpdateContextMenuExtension>>>;
  watchlists?: InputMaybe<Array<InputMaybe<UpdateContextMenuExtension>>>;
};

export type UpdateCreative = {
  advertiserId?: InputMaybe<Scalars['ID']>;
  brandId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  keywords?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateCurrentUser = {
  /** New developer_type for the current user, optional */
  developerType?: InputMaybe<Scalars['String']>;
  /** New first name for the current user, optional */
  firstName?: InputMaybe<Scalars['String']>;
  /** New image URL for the current user, optional */
  imageUrl?: InputMaybe<Scalars['String']>;
  /** New last name for the current user, optional */
  lastName?: InputMaybe<Scalars['String']>;
  /** New MFA info for the current user, optional */
  mfaInfo?: InputMaybe<UpdateMfaInfo>;
  /** Required if updating the MFA phone number */
  passwordToken?: InputMaybe<Scalars['String']>;
  /** New title for current user, optional */
  title?: InputMaybe<Scalars['String']>;
  /** New user settings for the current user, optional */
  userSetting?: InputMaybe<UserSettingInfo>;
};

export type UpdateCustomDashboard = {
  data?: InputMaybe<Scalars['JSONData']>;
  description?: InputMaybe<Scalars['String']>;
  hostAppId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateDagTemplate = {
  cognitiveCategoryId?: InputMaybe<Scalars['ID']>;
  dag?: InputMaybe<Scalars['String']>;
  dagTemplateLanguage?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  mimeType?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateDataRegistry = {
  description: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  source: Scalars['String'];
};

export type UpdateDatasetConfidence = {
  /** allow sources with null confidence values */
  allowNull?: InputMaybe<Scalars['Boolean']>;
  /** Maximum Confidence Filter. Ignore sources having confidence higher than this */
  max?: InputMaybe<Scalars['Float']>;
  /** Mininum Confidence Filter. Ignore sources having confidence lower than this */
  min?: InputMaybe<Scalars['Float']>;
};

/** Input fields used to update an existing engine. */
export type UpdateEngine = {
  categoryId?: InputMaybe<Scalars['String']>;
  /** CPU Resources required for engine to run, in milli-CPUs */
  cpuResourceMcpu?: InputMaybe<Scalars['Int']>;
  /** The engine deployment model. See the DeploymentModel enum for options. */
  deploymentModel?: InputMaybe<DeploymentModel>;
  description?: InputMaybe<Scalars['String']>;
  /** In what way can this engine be distributed */
  distributionType?: InputMaybe<EngineDistributionType>;
  /** Edge version. */
  edgeVersion?: InputMaybe<Scalars['Int']>;
  /**
   * The tags associated with the engine. Current tags will be replaced with passed in entityTags
   * If this is not specified, tags are not modified
   */
  entityTags?: InputMaybe<Array<InputMaybe<EntityTagInput>>>;
  /**
   * Optionally, supply custom fields that the user can set when launching
   * the engine. See developer documentation for details. To update the fields,
   * make sure you supply the complete set of new fields -- new fields,
   * updated existing fields, and unmodified existing fields.
   */
  fields?: InputMaybe<Array<CreateEngineField>>;
  /** CPU Resources required for engine to run, in milli-CPUs */
  gpuSupported?: InputMaybe<GpuSupported>;
  /** The path for an icon image */
  iconPath?: InputMaybe<Scalars['String']>;
  /** Supply the ID of the engine to update */
  id: Scalars['ID'];
  /** List of industries where the capabilities of the engine can be applied */
  industries?: InputMaybe<Array<Scalars['String']>>;
  /**
   * Indicates whether or not the engine should be public -- visible to and
   * usable by users outside the creator's organization.
   * Typically an engine should not be made public until it has been fully
   * configured and tested in production.
   */
  isPublic?: InputMaybe<Scalars['Boolean']>;
  /**
   * JWT rights for engine, which is used for generating jwtToken rights later
   * Limit jwtRights update to private engines only
   */
  jwtRights?: InputMaybe<JwtRightsField>;
  /** Whether or not the engine requires a library. */
  libraryRequired?: InputMaybe<Scalars['Boolean']>;
  /** The path for a logo image */
  logoPath?: InputMaybe<Scalars['String']>;
  /** Generic Manifest for the engine based on data supplied during onboarding */
  manifest?: InputMaybe<Scalars['JSONData']>;
  /**
   * The metadata version gives you the version number of the engine's metadata. This field is incremented by 1 everytime.
   * This field is optional. If specified, the number must be larger than the current version.
   */
  metadataVersion?: InputMaybe<Scalars['Int']>;
  /**
   * Human-readable name for the engine. Changing this value will change
   * how the engine appears to users.
   */
  name?: InputMaybe<Scalars['String']>;
  /** An optional price indicator for the engine. */
  price?: InputMaybe<Scalars['Int']>;
  /** Optionally, supply ID's of schemas that this engine will use as input schemas */
  schemas?: InputMaybe<Array<InputMaybe<EngineSchema>>>;
  /** Template Job definitions for standalone engine execution */
  standaloneJobTemplates?: InputMaybe<Array<InputMaybe<CreateEngineJobTemplate>>>;
  testingDetails?: InputMaybe<Scalars['JSONData']>;
  /** List of use cases the engine serves */
  useCases?: InputMaybe<Array<Scalars['String']>>;
  /** Engine or Organization homepage */
  website?: InputMaybe<Scalars['String']>;
};

export type UpdateEngineConfiguration = {
  credentialIds?: InputMaybe<Array<Scalars['ID']>>;
  id: Scalars['ID'];
};

export type UpdateEngineDependency = {
  /**
   * An optional asset type that the engine will expect to have
   * been created.
   */
  assetType?: InputMaybe<Scalars['String']>;
  /**
   * The category type this engine depends on.
   * Must be a valid categoryType from an existing EngineCategory.
   */
  dependencyType?: InputMaybe<Scalars['String']>;
};

export type UpdateEntity = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  /**
   * GraphQL-formatted JSON-like structure containing freeform metadata.
   * If a schema is associated with the entity type, the input will be
   * validated against the schema. Use this field _or_ `jsonstring`, not both.
   */
  jsondata?: InputMaybe<Scalars['JSONData']>;
  /**
   * A string containing valid JSON with freeform metadata.
   * If a schema is associated with the entity type, the input will be
   * validated against the schema. Use this field _or_ `jsondata`, not both.
   */
  jsonstring?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  profileImageUrl?: InputMaybe<Scalars['String']>;
};

export type UpdateEntityIdentifier = {
  id: Scalars['ID'];
  isPriority?: InputMaybe<Scalars['Boolean']>;
  /**
   * GraphQL-formatted JSON-like structure containing freeform metadata.
   * If a schema is associated with the entity type, the input will be
   * validated against the schema. Use this field _or_ `jsonstring`, not both.
   */
  jsondata?: InputMaybe<Scalars['JSONData']>;
  /**
   * A string containing valid JSON with freeform metadata.
   * If a schema is associated with the entity type, the input will be
   * validated against the schema. Use this field _or_ `jsondata`, not both.
   */
  jsonstring?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type UpdateEntityIdentifierType = {
  dataType?: InputMaybe<EntityIdentifierDataType>;
  description?: InputMaybe<Scalars['String']>;
  iconClass?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  label?: InputMaybe<Scalars['String']>;
  labelPlural?: InputMaybe<Scalars['String']>;
};

export type UpdateEntityType = {
  name?: InputMaybe<Scalars['String']>;
  namePlural?: InputMaybe<Scalars['String']>;
  schema?: InputMaybe<Scalars['JSONData']>;
};

export type UpdateEvent = {
  /** General description of the event */
  description?: InputMaybe<Scalars['String']>;
  /** ID of event */
  id: Scalars['ID'];
};

export type UpdateEventActionTemplate = {
  /** A JSON structure that is compatible with action_type.  For example, if action_type is "webhook", action_attributes contain the mustache compatible template to format the content.  If action_type is "job", then action_attributes need to specify a job template. */
  actionAttributes?: InputMaybe<Scalars['JSONData']>;
  /** dedicated column to specify where/what the action is taking place.  For example, if action is a job, then destination is an engine_id.  For webhook, a uri. */
  actionDestination?: InputMaybe<Scalars['String']>;
  /** Allows you to specify validation for the action_type.  For example, if action_type is "job", perhaps only whitelist a list of engines that could be called. */
  actionValidation?: InputMaybe<Scalars['JSONData']>;
  /** The id of the trigger template */
  id: Scalars['ID'];
  /** A JSON structure that is compatible/specific to the input_type.  For example, if input type is "event", then input_attributes simply contain the entire event payload. */
  inputAttributes?: InputMaybe<Scalars['JSONData']>;
  /** based on the input_type, input_validation describes additional validations.  For example, if input_type is "event", input_validation could be a list of allowed events. */
  inputValidation?: InputMaybe<Scalars['JSONData']>;
  /** The name of template.  e.g. "Run engine X for every new mention in a watchlist". */
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateEventCustomRule = {
  /** The event actions as a mutated copy of EventActionTemplate */
  actions?: InputMaybe<Scalars['JSONData']>;
  /** The description of the custom rule */
  description?: InputMaybe<Scalars['String']>;
  /** The id of the custom rule */
  id: Scalars['ID'];
  /** The name of the custom rule */
  name?: InputMaybe<Scalars['String']>;
  /** The rule params to be used in actions */
  params?: InputMaybe<Scalars['JSONData']>;
  /** The status of the custom rule */
  status?: InputMaybe<EventCustomRuleStatus>;
};

export type UpdateExecutionLocation = {
  __typename?: 'UpdateExecutionLocation';
  clusterId: Scalars['ID'];
  id: Scalars['ID'];
  nodeId?: Maybe<Scalars['ID']>;
};

export type UpdateExportRequest = {
  /** The asset URI */
  assetUri?: InputMaybe<Scalars['String']>;
  /** ID of the export request to update */
  id: Scalars['ID'];
  /** Status change */
  status?: InputMaybe<ExportRequestStatus>;
};

export type UpdateExternalCredential = {
  dataId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
};

export type UpdateFlowExecution = {
  /** The id of the execution to update */
  flowExecutionId: Scalars['ID'];
  /** The url or string of flow input */
  flowExecutionInput?: InputMaybe<Scalars['String']>;
  /** The url to the log file */
  flowExecutionLog?: InputMaybe<Scalars['String']>;
  /** The url to the result file or single string of text */
  flowExecutionResult?: InputMaybe<Scalars['String']>;
  /** The status of the execution after completion */
  flowExecutionStatus?: InputMaybe<Scalars['String']>;
};

export type UpdateFlowRevision = {
  buildId?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  /** The ID of the flow. In this context interchangeable with flowId */
  engineId?: InputMaybe<Scalars['ID']>;
  /** The ID of the flow. In this context interchangeable with engineId */
  flowId?: InputMaybe<Scalars['ID']>;
  flowRevisionId: Scalars['ID'];
  /** Human readable positive increasing integer value */
  flowRevisionNumb?: InputMaybe<Scalars['Int']>;
  /** The flow array and package that describes the flow and dependencies */
  runtime?: InputMaybe<Scalars['JSONData']>;
};

export type UpdateFlowRevisionHead = {
  flowId: Scalars['ID'];
  /** Optionally preserve current head in a new revision. Default false. */
  preserveHead?: InputMaybe<Scalars['Boolean']>;
  runtime: Scalars['JSONData'];
};

export type UpdateFlowTemplate = {
  author?: InputMaybe<Scalars['String']>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  flow?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: InputMaybe<Scalars['String']>;
  learnMoreLink?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['String']>;
  package?: InputMaybe<Scalars['String']>;
  public?: InputMaybe<Scalars['Boolean']>;
  screenshots?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtitle?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Scalars['String']>;
};

/**
 * Information required to update a folder.
 * Currently, the folder can be renamed. No other changes are supported.
 */
export type UpdateFolder = {
  /** ID of the folder to update */
  id: Scalars['ID'];
  /** New name for the folder. */
  name: Scalars['String'];
};

export type UpdateFolderContentTempate = {
  data?: InputMaybe<Scalars['JSONData']>;
  /** The ID of folder */
  folderId?: InputMaybe<Scalars['ID']>;
  /** The ID of Folder Content Template */
  id: Scalars['ID'];
  /** The ID of Data Registry */
  schemaId?: InputMaybe<Scalars['ID']>;
  /** The ID of Structure Data Object */
  sdoId?: InputMaybe<Scalars['ID']>;
};

export type UpdateJobOutput = {
  failureMessage?: InputMaybe<Scalars['String']>;
  failureType?: InputMaybe<TaskFailureReason>;
};

export type UpdateJobTemplate = {
  id: Scalars['ID'];
  jobConfig?: InputMaybe<Scalars['JSONData']>;
  /** This contains a list of URIs engine toolkit will send completed chunks. */
  notificationUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  skipDecider?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateJobs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
  /** This contains a list of URIs engine toolkit will send completed chunks. */
  notificationUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Set this field to modify the status of the job only if the current status is equal to this value */
  requiredCurrentStatus?: InputMaybe<JobStatus>;
  /** The status to set the job and tasks to. */
  status?: InputMaybe<UpdateJobsStatus>;
  /**
   * The optional failureReason and failureMessage output
   * when update job to failed or aborted
   */
  taskOutput?: InputMaybe<UpdateJobOutput>;
};

export enum UpdateJobsStatus {
  Aborted = 'aborted',
  Failed = 'failed',
  Queued = 'queued'
}

export type UpdateLibrary = {
  coverImageUrl?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  libraryTypeId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['Int']>;
};

export type UpdateLibraryCollaborator = {
  /** ID of the library. */
  libraryId: Scalars['ID'];
  /** ID of the collaborator organization. */
  organizationId: Scalars['Int'];
  /** list permissions of collaborator */
  permissions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** status of collaborator */
  status?: InputMaybe<CollaboratorStatus>;
};

export type UpdateLibraryConfiguration = {
  /**
   * This option is used for Dataset Library Only
   * Dataset TDOs confidence filters
   */
  confidence?: InputMaybe<UpdateDatasetConfidence>;
  /** library configuration id */
  id: Scalars['ID'];
  /**
   * This option is used for Dataset Library Only
   * List of selected engine where tdos are extracted from for training data
   * TDOs are extracted from higher ranked engines first then fallback to the lower ones if the priors don't have any matching tdo
   */
  rankedSourceEngineIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** List of selected engines for training */
  targetEngineIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type UpdateLibraryEngineModel = {
  accuracy?: InputMaybe<Scalars['Int']>;
  configurationId?: InputMaybe<Scalars['ID']>;
  /**
   * If a file is uploaded, you can explicitly specify the content type
   * (a valid MIME type string) with this field. Often this is not necessary
   * as the HTTP multipart form POST client will set content type on the
   * file object implicitly.
   */
  contentType?: InputMaybe<Scalars['String']>;
  /**
   * The URL to a file containing or related to the engine model.
   * Submit either this field _or_ `file`, not both.
   * Use this field if the data is stored in a separate, internet-accessible
   * location and not managed by Veritone APIs.
   */
  dataUrl?: InputMaybe<Scalars['String']>;
  /**
   * An optional data file containing or related to the engine model.
   * Use multipart form POST to submit this field.
   * Submit either this field _or_ `dataUrl`, not both. If a file is
   * uploaded, the server will store it and then set `dataUrl` to
   * its location.
   */
  file?: InputMaybe<Scalars['UploadedFile']>;
  /** ID of the library engine model to update. */
  id: Scalars['ID'];
  /** Optional free-form block containing engine-specific metadata. */
  jsondata?: InputMaybe<Scalars['JSONData']>;
  /** Id of the train job. */
  trainJobId?: InputMaybe<Scalars['ID']>;
  /** Status of the train job. */
  trainStatus?: InputMaybe<LibraryEngineModelTrainStatus>;
};

export type UpdateLibraryType = {
  entityIdentifierTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  entityType?: InputMaybe<UpdateEntityType>;
  iconClass?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  label: Scalars['String'];
};

export type UpdateMfaInfo = {
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type UpdateMention = {
  adCreative?: InputMaybe<Scalars['JSONData']>;
  complianceStatusId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  privateNote?: InputMaybe<Scalars['String']>;
  publicNote?: InputMaybe<Scalars['String']>;
  spotTypeId?: InputMaybe<Scalars['ID']>;
  statusId?: InputMaybe<Scalars['ID']>;
  userSnippets?: InputMaybe<Scalars['JSONData']>;
};

export type UpdateMentionComment = {
  commentId: Scalars['ID'];
  commentText: Scalars['String'];
  mentionId: Scalars['ID'];
};

export type UpdateMentionExportRequest = {
  /** The asset URI */
  assetUri?: InputMaybe<Scalars['String']>;
  /** The required mentionExportRequestId will be used for update */
  id: Scalars['ID'];
  /** SQL queries used to retrieve mentions from database */
  sqlQueries?: InputMaybe<Scalars['String']>;
  /** Status of mentionExportRequest record */
  status?: InputMaybe<ExportRequestStatus>;
};

export type UpdateMentionRating = {
  mentionId: Scalars['ID'];
  ratingId: Scalars['ID'];
  ratingValue: Scalars['Int'];
};

export type UpdateMentions = {
  ids: Array<Scalars['ID']>;
  statusId?: InputMaybe<Scalars['ID']>;
};

export type UpdateOpenIdProvider = {
  /** Button color for OpenID Provider on login (e.g.,#FFFFFF,..) */
  btnColor?: InputMaybe<Scalars['String']>;
  /** The link of OpenId Provider Logo */
  btnLogo?: InputMaybe<Scalars['String']>;
  /** Button text for OpenID Provider on login */
  btnText?: InputMaybe<Scalars['String']>;
  /** Button text color for OpenID Provider on login (e.g.,#FFFFFF,..) */
  btnTextColor?: InputMaybe<Scalars['String']>;
  /** Secret key of OpenID Connect, it will be hash as sensitive data */
  clientSecret?: InputMaybe<Scalars['String']>;
  /** Description of the OpenID Provider */
  description?: InputMaybe<Scalars['String']>;
  /** The identifier of OpenId Provider */
  id: Scalars['ID'];
  /**
   * The issuer URL of the OpenID Connect application.
   * E.g.. (the /.well-known/ URL for Azure AD, or https://accounts.google.com for Google,...)
   */
  issuerUrl?: InputMaybe<Scalars['String']>;
  /** Name of the OpenID Provider will show in Vertione Platform */
  name?: InputMaybe<Scalars['String']>;
  /** Official website url of the Provider */
  websiteUrl?: InputMaybe<Scalars['String']>;
};

/** Fields used to update an organization. */
export type UpdateOrganization = {
  /** Allow/Dissallow application to be available for use for this org */
  applicationAccess?: InputMaybe<Array<SetOrganizationApplicationAccess>>;
  applications?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * Update the engine blacklist for this organization.
   * Currently only Veritone administrators can modify this field.
   * Updating this field will completely replacing the existing engine
   * and engine category blacklists with the IDs provided.
   */
  blacklist?: InputMaybe<SetEngineBlacklist>;
  businessUnit?: InputMaybe<Scalars['String']>;
  /** ID of the organization to update */
  id: Scalars['ID'];
  /**
   * If set to `true`, all new TDOs created by the organization will, by default, be added
   * to the search index. If `false`, TDOs will not be added to the search index. This
   * behavior can be overridden on specific TDOs.
   */
  indexTDOsByDefault?: InputMaybe<Scalars['Boolean']>;
  /**
   * Enable/disable the limit enforced for organization
   * Only superadmin can set this value
   */
  isLimitEnforced?: InputMaybe<Scalars['Boolean']>;
  /** Currently only Veritone administrators can modify this field. */
  metadata?: InputMaybe<Scalars['JSONData']>;
  /** Name of the organization */
  name?: InputMaybe<Scalars['String']>;
  /**
   * Enable, disable, or configure integration with the organization's
   * own user directory using Okta.
   * Only an organization administrator can modify this field.
   * Veritone administrators cannot do so.
   */
  oktaConfiguration?: InputMaybe<SetOktaConfiguration>;
  /**
   * The budget remaining for organization (cents)
   * Only superadmin can set this value
   */
  remainingBudget?: InputMaybe<Scalars['Int']>;
  /** Set the flag requireOpenId. Only allow org_admin or superadmin. */
  requireOpenId?: InputMaybe<Scalars['Boolean']>;
  seatLimit?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  /**
   * Update the engine whitelist for this organization.
   * Currently only Veritone administrators can modify this field.
   * Updating this field will completely replacing the existing engine
   * and whitelist with the IDs provided.
   */
  whitelist?: InputMaybe<SetEngineWhitelist>;
};

export type UpdateOrganizationCluster = {
  /** Provide the organization ID to add. */
  action?: InputMaybe<UpdateOrganizationClusterAction>;
  /** The ID of the cluster */
  clusterId: Scalars['ID'];
  /** The ID of the organization.  */
  organizationId: Scalars['ID'];
};

export enum UpdateOrganizationClusterAction {
  RemoveDefault = 'removeDefault',
  RemoveOverride = 'removeOverride',
  SetDefault = 'setDefault',
  SetOverride = 'setOverride'
}

export type UpdateOrganizationInviteInput = {
  /** Action to perform on the invite */
  action?: InputMaybe<OrganizationInviteAction>;
  /** List of applications and application-specific roles to grant to the user */
  applicationRoles: Array<ApplicationInviteRoleInput>;
  /** Message shown to the user and the approver of the invite */
  message?: InputMaybe<Scalars['String']>;
  /** Invitation id */
  organizationInviteId: Scalars['ID'];
};

/** Payload required ro update an object */
export type UpdatePayload = {
  __typename?: 'UpdatePayload';
  /** ID of the object that was updated */
  id: Scalars['ID'];
  /** a message */
  message?: Maybe<Scalars['String']>;
};

export type UpdateProcessTemplate = {
  id: Scalars['ID'];
  taskList: Scalars['JSONData'];
};

export type UpdateScheduledJob = {
  affiliates?: InputMaybe<Array<CreateProgramAffiliate>>;
  /** Optionally, associate content templates with the new scheduled job */
  contentTemplates?: InputMaybe<Array<CreateScheduledJobContentTemplateWithScheduledJob>>;
  /** A detailed description. Defaults to name. */
  description?: InputMaybe<Scalars['String']>;
  /**
   * JSON containing metadata details for this scheduled job.
   * If the scheduled job does not already have a schema ID
   * associated with, one must be supplied along with this data.
   * In either case, the supplied data must comply with the
   * schema.
   */
  details?: InputMaybe<Scalars['JSONData']>;
  /** ID of the schema for detail metadata on this scheduled job */
  detailsSchemaId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  /**
   * Indicates whether or not the scheduled job is publicly accessible.
   * Only Veritone administrators can create public scheduled jobs.
   * Other users will get an error if they attempt to set this value to true.
   */
  isPublic?: InputMaybe<Scalars['Boolean']>;
  jobTemplateIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Optionally, specify the job template definitions here. */
  jobTemplates?: InputMaybe<Array<CreateJobTemplate>>;
  /**
   * Indicates whether or not the scheduled job we should upgrade this schedule job
   * to the new data model if an upgrade is possible.
   */
  migrateIfLegacy?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  recurringScheduleParts?: InputMaybe<Array<CreateRecurringSchedulePart>>;
  runMode?: InputMaybe<RunMode>;
  startDateTime?: InputMaybe<Scalars['DateTime']>;
  stopDateTime?: InputMaybe<Scalars['DateTime']>;
  weeklyScheduleParts?: InputMaybe<Array<CreateWeeklySchedulePart>>;
};

export type UpdateSchemaState = {
  /** Specify if publishing this schema would break ingestion */
  breakingChanges?: InputMaybe<Scalars['Boolean']>;
  /** The schemaId to update */
  id: Scalars['ID'];
  /** The new schema status */
  status: SchemaStatus;
};

export type UpdateSharedCollectionHistory = {
  /** The ID of the shared collection history */
  id: Scalars['ID'];
  /** Number of times the shared collection has been retried */
  retryCount?: InputMaybe<Scalars['Int']>;
  /** The new status of the shared collection */
  status: SharedCollectionHistoryStatus;
  /** Additional information regarding the status change */
  statusNote?: InputMaybe<Scalars['String']>;
};

/** Data used to update an existing source */
export type UpdateSource = {
  /**
   * Add or modify collaborators on the source. Permissions for organizations
   * not mentioned in this list will _not_ be modified. To revoke permissions
   * for an organization, use the `none` permission.
   */
  collaborators?: InputMaybe<Array<CreateSourceCollaborator>>;
  /** Optionally, associate content templates with the new source */
  contentTemplates?: InputMaybe<Array<CreateSourceContentTemplateWithSource>>;
  /**
   * Optionally associate a structured data object of the specified correlationSchemaId.
   * Required when correlationSchemaId is specified.
   */
  correlationSDOId?: InputMaybe<Scalars['ID']>;
  /**
   * Optionally associate a schema for correlation.
   * Required when correlationSDOId is specified.
   */
  correlationSchemaId?: InputMaybe<Scalars['ID']>;
  /**
   * Additional metadata to associate with the source. This data may be
   * validated against a schema associated with the source type.
   */
  details?: InputMaybe<Scalars['JSONData']>;
  /** The ID of the source to update */
  id: Scalars['ID'];
  /** Update the isPublic field */
  isPublic?: InputMaybe<Scalars['Boolean']>;
  /** Update the name field */
  name?: InputMaybe<Scalars['String']>;
  /**
   * Set current state for the source. This is used only by the adapters
   * that use the source and should not be set by other clients.
   */
  state?: InputMaybe<Scalars['JSONData']>;
  /** Optional thumbnail image URL for the source */
  thumbnailUrl?: InputMaybe<Scalars['String']>;
};

export type UpdateSourceType = {
  /** Source type category ID */
  categoryId?: InputMaybe<Scalars['ID']>;
  credentialSchemaId?: InputMaybe<Scalars['ID']>;
  credentialType?: InputMaybe<CredentialType>;
  details?: InputMaybe<Scalars['JSONData']>;
  id: Scalars['ID'];
  /**
   * Indicates whether or not the source type is "live", such
   * as a camera feed
   */
  isLive?: InputMaybe<Scalars['Boolean']>;
  /**
   * Indicates that the source type is publicly accessible.
   * If false, is usable only by the owner organization.
   */
  isPublic?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  /**
   * Indicates whether or not the source type requires
   * scan pipeline jobs
   */
  requiresScanPipeline?: InputMaybe<Scalars['Boolean']>;
  sourceSchemaId?: InputMaybe<Scalars['ID']>;
};

export type UpdateSubscription = {
  id: Scalars['ID'];
};

/** Payload required to create a temporal data object */
export type UpdateTdo = {
  /** Optionally, add the data to the search index. */
  addToIndex?: InputMaybe<Scalars['Boolean']>;
  /**
   * Optionally, specify one or more structured data objects to apply as
   * content templates to the TDO. They will be stored as assets of type
   * content-template and will contain an immutable copy of the original data.
   * Setting this field on an update does _not_ affect any content templates
   * previously added to the TDO -- it only creates the new ones.
   */
  contentTemplates?: InputMaybe<Array<CreateTdoContentTemplateWithTdo>>;
  /** A description for the TDO object. */
  description?: InputMaybe<Scalars['String']>;
  details?: InputMaybe<Scalars['JSONData']>;
  /** Optional flags for enforcing certain constrains during tdoCreation */
  flags?: InputMaybe<Array<InputMaybe<UpdateTdoFlag>>>;
  /** ID of the TDO to update */
  id: Scalars['ID'];
  /**
   * True if the new TDO should be made public. If true, security.global
   * will be set to true and users from other organizations will be able to
   * view, but not modify, the TDO's metadata and assets.
   */
  isPublic?: InputMaybe<Scalars['Boolean']>;
  /** A name for the TDO object, such as the name of the primary media file. */
  name?: InputMaybe<Scalars['String']>;
  /** An optional preview asset URL for the TDO */
  previewUrl?: InputMaybe<Scalars['String']>;
  /** Set the primary asset of a given type (transcript or media) */
  primaryAsset?: InputMaybe<Array<SetPrimaryAsset>>;
  /** Source for the TDO, such as an ingestion type or engine ID. */
  source?: InputMaybe<Scalars['String']>;
  /** An optional image representing the TDO source */
  sourceImageUrl?: InputMaybe<Scalars['String']>;
  /** Start date and time in numerical (epoch) format. */
  startDateTime?: InputMaybe<Scalars['DateTime']>;
  /** Current status, such as "downloaded" or "recording". */
  status?: InputMaybe<Scalars['String']>;
  /** Stop date and time in numerical (epoch) format. */
  stopDateTime?: InputMaybe<Scalars['DateTime']>;
  /** An optional thumbnail URL for the TDO */
  thumbnailUrl?: InputMaybe<Scalars['String']>;
};

export enum UpdateTdoFlag {
  PreventTrim = 'preventTrim'
}

export type UpdateTask = {
  /**
   * Optional timestamp used to control change ordering.
   * The client may set this to the `modifiedDateTime` value
   * of most recent copy of the task it has before making the
   * update. The server will _only_ update the task with the
   * requested changes _if_ and only if the current
   * `modifiedDateTime` value is equal to or earlier than
   * the supplied `clientTimestamp` value. Thus, changes
   * that were made after the client last retrieved the task
   * data will not be overwritten.
   */
  clientTimestamp?: InputMaybe<Scalars['DateTime']>;
  /** Save execution location metadata */
  executionLocationData?: InputMaybe<Scalars['JSONData']>;
  /**
   * A human-readable string with detail on the
   * task failure reason. Should be set if and only if
   * task status is `failed` and `failureReason` is set.
   * If set with any other task status or if `failureReason` is not set,
   * the API will return an error.
   */
  failureMessage?: InputMaybe<Scalars['String']>;
  /**
   * A code indicating why the task failed. Should be set
   * if and only if task status is `failed`.
   * If set with any other task status, the API will return an error.
   */
  failureReason?: InputMaybe<TaskFailureReason>;
  id: Scalars['ID'];
  jobId?: InputMaybe<Scalars['ID']>;
  /** This contains a list of URIs engine toolkit will send completed chunks. */
  notificationUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  output?: InputMaybe<Scalars['JSONData']>;
  /**
   * Use this parameter if your task output does not take the form of valid
   * JSON. Provide a key and the server will convert your output into
   * JSON with a single string value. For example,
   * ```
   *   mutation {
   *     updateTask(input: {
   *       id: <id>
   *       outputString: "<xml><stuff id=\"value\">more stuff </stuff></xml>"
   *       outputJsonKey: "response"
   *     }) { id }
   *   }
   *
   * ```
   * Will set the task output JSON to
   *  ` {"response":"<xml><stuff id=\"value\">more stuff </stuff></xml>"}`
   */
  outputJsonKey?: InputMaybe<Scalars['String']>;
  /** Task output as JSON string */
  outputString?: InputMaybe<Scalars['String']>;
  /** Update the task with a new payload */
  payload?: InputMaybe<Scalars['JSONData']>;
  status: TaskStatus;
  /** Backwards compatibility only */
  taskOutput?: InputMaybe<Scalars['JSONData']>;
};

export enum UpdateTaskStatus {
  Complete = 'complete',
  Failed = 'failed',
  Running = 'running',
  Waiting = 'waiting'
}

export type UpdateTaskTemplate = {
  id: Scalars['ID'];
  /** This contains a list of URIs engine toolkit will send completed chunks. */
  notificationUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  parentTaskId?: InputMaybe<Scalars['ID']>;
  payload?: InputMaybe<Scalars['JSONData']>;
  payloadString?: InputMaybe<Scalars['String']>;
};

export type UpdateUser = {
  acls?: InputMaybe<Array<UserAclInput>>;
  authGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Optionally, specify user's developerType */
  developerType?: InputMaybe<Scalars['String']>;
  /** Optionally, specify user's email */
  email?: InputMaybe<Scalars['String']>;
  /** Optionally, specify user's first name */
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  /** Optionally, specify user's image */
  imageUrl?: InputMaybe<Scalars['String']>;
  jsondata?: InputMaybe<Scalars['JSONData']>;
  /** Optionally, specify user's last name */
  lastName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  /**
   * Optionally, the user's roles will be updated for this organization. It should be set if the requester is super-admin.
   * If it is not set when the requester is super-admin, the default organization of user will be used.
   */
  organizationId?: InputMaybe<Scalars['ID']>;
  roleIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Optionally, specify user's title */
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateUserSetting = {
  /** Specify the applicationId (optional) */
  application?: InputMaybe<Scalars['ID']>;
  /** Specify the key of user setting */
  key: Scalars['String'];
  /** Reset is true if we want to remove this setting */
  reset?: InputMaybe<Scalars['Boolean']>;
  /**
   * Specify the userId (optional).
   * If it's not specified, default is current user
   */
  userId?: InputMaybe<Scalars['ID']>;
  /** Specify value of user setting (It's required when "reset" is false) */
  value?: InputMaybe<Scalars['String']>;
};

export type UpdateUserStatus = {
  id: Scalars['ID'];
  status?: InputMaybe<UserStatus>;
};

export type UpdateWatchlist = {
  cognitiveSearches?: InputMaybe<Array<CreateCognitiveSearchInWatchlist>>;
  /**
   * Set structured metadata on the watchlist.
   * The data is subject to a set of schemas.
   */
  details?: InputMaybe<Scalars['JSONData']>;
  /** Indicates whether or not the watchlist expiration notification should be enable */
  enableExpirationNotification?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  /**
   * Indicates whether or not the watchlist should be disabled.
   * The Veritone platform can administratively disable watchlists
   * if the search scope as measured in number of mentions
   * exceeds organization limits. The owner can then modify the
   * watchlist parameters to reduce the scope and re-enable the watchlist.
   */
  isDisabled?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parentFolderId?: InputMaybe<Scalars['ID']>;
  /**
   * Enforce mention regeneration even when cognitive search profile
   * and target filters have not changed.
   */
  regenerateExistingMentions?: InputMaybe<Scalars['Boolean']>;
  searchIndex?: InputMaybe<SearchIndex>;
  sourceIds?: InputMaybe<Array<Scalars['ID']>>;
  sourceTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  startDateTime?: InputMaybe<Scalars['DateTime']>;
  stopDateTime?: InputMaybe<Scalars['DateTime']>;
  subscriptions?: InputMaybe<Array<CreateSubscriptionInWatchlist>>;
};

export type UpdateWidget = {
  adScript?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  borderColor?: InputMaybe<Scalars['String']>;
  createdDateTime?: InputMaybe<Scalars['DateTime']>;
  displayCollectionDescription?: InputMaybe<Scalars['Boolean']>;
  displayCollectionName?: InputMaybe<Scalars['Boolean']>;
  displayLogo?: InputMaybe<Scalars['Boolean']>;
  displayMentionDescription?: InputMaybe<Scalars['Boolean']>;
  displayMentionIntro?: InputMaybe<Scalars['Boolean']>;
  displayTranscription?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  nextButtonColor?: InputMaybe<Scalars['String']>;
  numberOfMentionsToShow?: InputMaybe<Scalars['Int']>;
  seoTags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  textColor?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};

/** Fields needed to upload and store an engine result using multipart form POST. */
export type UploadEngineResult = {
  /**
   * The type of asset to create. Optional -- if not set, it will be
   * deduced from the engine category.
   * See https://docs.veritone.com/#/apis/tutorials/asset-types for supported values.
   */
  assetType?: InputMaybe<Scalars['String']>;
  /**
   * An optional timestamp that the client can send in combination with
   * the `uri` and `isAccumulatedResult` parameters. If set, the uri
   * will only be updated if the currently saved asset metadata is older
   * than the timestamp value.
   */
  clientTimestamp?: InputMaybe<Scalars['DateTime']>;
  /** Whether or not to mark the task as complete. Defaults to true. */
  completeTask?: InputMaybe<Scalars['Boolean']>;
  /**
   * The content type of the file. Optional -- if not set, it will
   * be deduced from the file name.
   */
  contentType?: InputMaybe<Scalars['String']>;
  /**
   * A file to upload. Use multipart form POST to submit this field.
   * Use this field, the `output`, `outputString`, or `uri` field, not more than one.
   */
  file?: InputMaybe<Scalars['UploadedFile']>;
  /** Optionally, set attributes about the file */
  fileData?: InputMaybe<SetAssetFileData>;
  /** The file name */
  filename?: InputMaybe<Scalars['String']>;
  /**
   * Indicates that the result is one of a series of accumulated results
   * for a task and can replace existing data.
   * Used primarily by Veritone platform components.
   */
  isAccumulatedResult?: InputMaybe<Scalars['Boolean']>;
  /**
   * JSON data containing the engine result.
   * A string containing the engine result.
   * Use either this field, `outputString`, `uri`, or `file` with multipart form POST, but not
   * more than one.
   */
  output?: InputMaybe<Scalars['JSONData']>;
  /**
   * If the result data uploaded is not a valid JSON string, then
   * the task output data stored on the task object will be wrapped into
   * a JSON object using this key. The asset created, however, is not
   * modified in any way.
   */
  outputJsonKey?: InputMaybe<Scalars['String']>;
  /**
   * A string containing the engine result.
   * Use either this field, `output`, `uri`, or `file` with multipart form POST, but not
   * more than one.
   */
  outputString?: InputMaybe<Scalars['String']>;
  /**
   * if true, sets the new asset to be the primary asset of its type.
   * Only certain asset types, such as "media" and "transcript",
   * can have primary assets.
   */
  setAsPrimary?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether or not to set the legacy `task_output` data for compatible
   * with older clients.
   */
  setTaskOutput?: InputMaybe<Scalars['Boolean']>;
  /**
   * Skips indexing the engine result, preventing mentions from being
   * generated over the results.
   */
  skipIndexing?: InputMaybe<Scalars['Boolean']>;
  /** ID of the task that created this engine result */
  taskId: Scalars['ID'];
  /** A URI to the file. Use one and only one of `uri`, `file`, or `output`/`outputString`. */
  uri?: InputMaybe<Scalars['String']>;
};

export type UpsertSchemaDraft = {
  dataRegistryId: Scalars['ID'];
  majorVersion?: InputMaybe<Scalars['Int']>;
  schema: Scalars['JSONData'];
};

export type Usage = {
  __typename?: 'Usage';
  cost?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  engineId?: Maybe<Scalars['ID']>;
};

export type UsageByTaskType = {
  __typename?: 'UsageByTaskType';
  billingType?: Maybe<Scalars['String']>;
  endDateTime?: Maybe<Scalars['DateTime']>;
  startDateTime?: Maybe<Scalars['DateTime']>;
  totalCost?: Maybe<Scalars['String']>;
  totalDuration?: Maybe<Scalars['Int']>;
  usageItems?: Maybe<Array<Maybe<Usage>>>;
};

/** A user represents a user account within an organization. */
export type User = {
  __typename?: 'User';
  acls?: Maybe<Array<UserAcl>>;
  /** The application keys that allowed to run as system user. */
  appsAllowedToRunAsUser?: Maybe<Array<Maybe<Scalars['String']>>>;
  authGroupIds?: Maybe<Array<Scalars['ID']>>;
  authGroups?: Maybe<AuthGroupList>;
  /** Date and time this user account was created */
  createdDateTime?: Maybe<Scalars['DateTime']>;
  developerType?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  /**
   * The user's unique ID.
   * A user ID is a string in UUID format.
   */
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  /** Freeform metadata in JSON form */
  jsondata?: Maybe<Scalars['JSONData']>;
  /** Date and time this user last logged in */
  lastLoginDateTime?: Maybe<Scalars['DateTime']>;
  lastName?: Maybe<Scalars['String']>;
  /** Multi-factor authentication information for the user */
  mfaInfo: MfaInfo;
  /** Date and time this user account was last modified */
  modifiedDateTime?: Maybe<Scalars['DateTime']>;
  /** The user's name */
  name: Scalars['String'];
  /** Notifications from user default mailbox */
  notifications?: Maybe<NotificationList>;
  /** Organization to which the user belongs. */
  organization?: Maybe<Organization>;
  /** GUID of the organization to which the user belongs. */
  organizationGuid?: Maybe<Scalars['ID']>;
  /** GUID of organizations to which the user belongs. */
  organizationGuids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** ID of the organization to which the user belongs. */
  organizationId?: Maybe<Scalars['ID']>;
  /** Multi Organization Invite */
  organizationInvites?: Maybe<Array<Maybe<OrganizationInvite>>>;
  /** Date and time this user last changed their password */
  passwordUpdatedDateTime?: Maybe<Scalars['DateTime']>;
  /** The set of permissions granted to the user */
  permissions?: Maybe<PermissionList>;
  roleIds?: Maybe<Array<Scalars['ID']>>;
  /** The set of roles granted to the user */
  roles?: Maybe<Array<Role>>;
  /** Folder tree for this organization */
  rootFolder?: Maybe<Folder>;
  /** Status of user account */
  status?: Maybe<UserStatus>;
  /** The flag indicate that the user is "virtual" system user */
  systemUser?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  /** User Settings for the user */
  userSettings?: Maybe<Array<UserSetting>>;
};


/** A user represents a user account within an organization. */
export type UserAuthGroupsArgs = {
  appRoleID?: InputMaybe<Scalars['ID']>;
  createdDateTime?: InputMaybe<AuditDateTimeFilter>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  modifiedDateTime?: InputMaybe<AuditDateTimeFilter>;
  nameRegex?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  source?: InputMaybe<AuthGroupSourceType>;
};


/** A user represents a user account within an organization. */
export type UserNotificationsArgs = {
  dateTimeFilter?: InputMaybe<Array<NotificationDateTimeFilter>>;
  flags?: InputMaybe<Array<NotificationFlag>>;
  flagsMode?: InputMaybe<FilterCombineOperator>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<NotificationDateTimeField>;
  orderDirection?: InputMaybe<OrderDirection>;
};


/** A user represents a user account within an organization. */
export type UserOrganizationInvitesArgs = {
  organizationInviteId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<OrganizationInviteStatus>;
};


/** A user represents a user account within an organization. */
export type UserRootFolderArgs = {
  type?: InputMaybe<RootFolderType>;
};

export type UserAcl = {
  __typename?: 'UserACL';
  access?: Maybe<UserAclAccessRights>;
  applicationId?: Maybe<Scalars['ID']>;
  objectId?: Maybe<Scalars['String']>;
  objectType?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['ID']>;
  userId?: Maybe<Scalars['ID']>;
};

export type UserAclAccessRights = {
  __typename?: 'UserACLAccessRights';
  owner?: Maybe<Scalars['Boolean']>;
};

export type UserAclAccessRightsInput = {
  owner?: InputMaybe<Scalars['Boolean']>;
};

export type UserAclInput = {
  access?: InputMaybe<UserAclAccessRightsInput>;
  applicationId?: InputMaybe<Scalars['ID']>;
  objectId?: InputMaybe<Scalars['String']>;
  objectType?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type UserList = Page & {
  __typename?: 'UserList';
  /** Number of records returned in this response */
  count?: Maybe<Scalars['Int']>;
  /** Maximum number of results that were retrieved in this query; page size */
  limit: Scalars['Int'];
  /** The starting index for records that were returned in this query. */
  offset: Scalars['Int'];
  records?: Maybe<Array<Maybe<User>>>;
};

/** Input fields required by the userLogin mutation. */
export type UserLogin = {
  /**
   * GUID of organization. If not specified, it will be default to that of
   * user's organization with lowest priority.
   */
  organizationGuid?: InputMaybe<Scalars['ID']>;
  /**
   * The user password. Note that this value is only ever transmitted over
   * the encrypted SSL protocol.
   */
  password: Scalars['String'];
  /** The user login name -- typically, email address. */
  userName: Scalars['String'];
};

/** Type that holds user setting for a user */
export type UserSetting = {
  __typename?: 'UserSetting';
  applicationId?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['ID']>;
  value?: Maybe<Scalars['String']>;
};

export type UserSettingInfo = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export enum UserStatus {
  Active = 'active',
  Deactivated = 'deactivated',
  Deleted = 'deleted',
  Suspended = 'suspended'
}

export enum UsersDateTimeField {
  CreatedDateTime = 'createdDateTime',
  LastLoginDateTime = 'lastLoginDateTime'
}

export type UsersDateTimeFilter = {
  /** Field to fallback on if the initial field is NULL in the DB */
  fallbackField?: InputMaybe<UsersDateTimeField>;
  /** Identify the field to filter on. */
  field?: InputMaybe<UsersDateTimeField>;
  /** Match if the field value is `fromDateTime` or later */
  fromDateTime?: InputMaybe<Scalars['DateTime']>;
  /** Whether the fromDateTime is inclusive or exclusive of the input timestamp */
  fromDateTimeExclusive?: InputMaybe<Scalars['Boolean']>;
  /** Match if the field value is `toDateTime` or earlier */
  toDateTime?: InputMaybe<Scalars['DateTime']>;
  /** Whether the toDateTime is inclusive or exclusive of the input timestamp */
  toDateTimeExclusive?: InputMaybe<Scalars['Boolean']>;
};

export type VerifyJwtPayload = {
  __typename?: 'VerifyJWTPayload';
  /** the same JWT input */
  jwtToken: Scalars['String'];
  /** the payload contained within the JWT */
  payload: Scalars['JSONData'];
};

export type Watchlist = {
  __typename?: 'Watchlist';
  /** advertiser associated with the watchlist */
  advertiser?: Maybe<Scalars['JSONData']>;
  /** ID of the advertiser directly with the watchlist */
  advertiserId?: Maybe<Scalars['ID']>;
  /** brand associated with the watchlist */
  brand?: Maybe<Scalars['JSONData']>;
  /** ID of the brand directly with the watchlist */
  brandId?: Maybe<Scalars['ID']>;
  /** Cognitives searches associated with the watchlist */
  cognitiveSearches?: Maybe<Array<CognitiveSearch>>;
  /**
   * Contains the list of all source type IDs
   * associated with this watchlist, including
   * those for sources on schedules.
   */
  combinedSourceTypeIds?: Maybe<Array<Scalars['ID']>>;
  /** Date and time the watchlist was created */
  createdDateTime?: Maybe<Scalars['DateTime']>;
  /** creative associated with the watchlist */
  creative?: Maybe<Creative>;
  /**
   * Structured metadata associated with the watchlist.
   * Elements of the metadata are validated against specific schemas.
   */
  details?: Maybe<Scalars['JSONData']>;
  /** Is enable the expiration notification */
  enableExpirationNotification?: Maybe<Scalars['Boolean']>;
  /**
   * Folders that the watchlist is filed in.
   * At present, a watchlist can only be filed in a single folder.
   */
  folders?: Maybe<Array<Folder>>;
  /** The primary ID */
  id: Scalars['ID'];
  /**
   * Indicates whether or not the watchlist should be disabled.
   * The Veritone platform can administratively disable watchlists
   * if the search scope as measured in number of mentions
   * exceeds organization limits. The owner can then modify the
   * watchlist parameters to reduce the scope and re-enable the watchlist.
   */
  isDisabled?: Maybe<Scalars['Boolean']>;
  /** Indicates whether the watchlist is currently creating mentions from exising media */
  isUpdating?: Maybe<Scalars['Boolean']>;
  /** Get mentions generated for this watchlist */
  mentions?: Maybe<MentionList>;
  /** Date and time the watchlist was last modified */
  modifiedDateTime?: Maybe<Scalars['DateTime']>;
  /** A human-readable name for the watchlist */
  name: Scalars['String'];
  /** The organization that owns the watchlist */
  organization: Organization;
  /** ID of the organization that owns the watchlist */
  organizationId: Scalars['ID'];
  query?: Maybe<Scalars['JSONData']>;
  /** IDs of the schedules associated with the watchlist */
  scheduleIds?: Maybe<Array<Scalars['ID']>>;
  scheduledJobs: ScheduledJobList;
  /** TODO for backward compat with v3 search? */
  schedules: ScheduledJobList;
  searchIndex: SearchIndex;
  /** IDs of the sources associated directly with the watchlist */
  sourceIds?: Maybe<Array<Scalars['ID']>>;
  /** Ids of the source types associated directly with the watchlist */
  sourceTypeIds?: Maybe<Array<Scalars['ID']>>;
  /** Date and time at which the watchlist takes effect */
  startDateTime?: Maybe<Scalars['DateTime']>;
  /** Date and time at which the watchlist is no longer in effect */
  stopDateTime?: Maybe<Scalars['DateTime']>;
  subscriptions: Array<Subscription>;
  /** The reference to the watchlist in a folder */
  treeObjectId?: Maybe<Scalars['ID']>;
  watchlistType?: Maybe<Scalars['String']>;
};


export type WatchlistMentionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type WatchlistScheduledJobsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type WatchlistSchedulesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type WatchlistList = Page & {
  __typename?: 'WatchlistList';
  /** Number of records returned in this response */
  count?: Maybe<Scalars['Int']>;
  /** Maximum number of results that were retrieved in this query; page size */
  limit: Scalars['Int'];
  /** Provide an offset to skip to a certain element in the result, for paging. */
  offset: Scalars['Int'];
  records?: Maybe<Array<Maybe<Watchlist>>>;
};

export enum WatchlistOrderBy {
  CreatedDateTime = 'createdDateTime',
  ModifiedDateTime = 'modifiedDateTime',
  Name = 'name',
  StartDateTime = 'startDateTime',
  StopDateTime = 'stopDateTime'
}

export type Widget = {
  __typename?: 'Widget';
  adScript?: Maybe<Scalars['String']>;
  backgroundColor?: Maybe<Scalars['String']>;
  borderColor?: Maybe<Scalars['String']>;
  collection?: Maybe<Collection>;
  collectionId: Scalars['ID'];
  /** A limited view of the collection metadata backing the widget */
  collectionJSON?: Maybe<Scalars['JSONData']>;
  createdDateTime?: Maybe<Scalars['DateTime']>;
  displayCollectionDescription?: Maybe<Scalars['Boolean']>;
  displayCollectionName?: Maybe<Scalars['Boolean']>;
  displayLogo?: Maybe<Scalars['Boolean']>;
  displayMentionDescription?: Maybe<Scalars['Boolean']>;
  displayMentionIntro?: Maybe<Scalars['Boolean']>;
  displayTranscription?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  mentions?: Maybe<SharedMentionList>;
  name?: Maybe<Scalars['String']>;
  nextButtonColor?: Maybe<Scalars['String']>;
  numberOfMentionsToShow?: Maybe<Scalars['Int']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['ID']>;
  seoTags?: Maybe<Array<Maybe<Scalars['String']>>>;
  textColor?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
};


export type WidgetMentionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type WidgetList = Page & {
  __typename?: 'WidgetList';
  /** Number of records returned in this response */
  count?: Maybe<Scalars['Int']>;
  /** Maximum number of results that were retrieved in this query; page size */
  limit: Scalars['Int'];
  /** Provide an offset to skip to a certain element in the result, for paging. */
  offset: Scalars['Int'];
  records?: Maybe<Array<Maybe<Widget>>>;
};

export type WorkflowMetric = {
  __typename?: 'WorkflowMetric';
  /** The number of users who have access to Flow */
  flowSeatCount: Scalars['Int'];
  /** The flow engine task count */
  flowTaskCount: Scalars['Int'];
};

export type WorkflowRuntimeResponse = {
  __typename?: 'WorkflowRuntimeResponse';
  /** Authentication token used for webhooks */
  authToken?: Maybe<Scalars['String']>;
  /** Creation date of this history record */
  createdDateTime?: Maybe<Scalars['DateTime']>;
  /** Error message if success is false */
  message?: Maybe<Scalars['String']>;
  /** Last modified date of this history record */
  modifiedDateTime?: Maybe<Scalars['DateTime']>;
  success: Scalars['Boolean'];
  /**
   * uri of veritone workflow instance.
   * This is only available when Workflow request is successful
   */
  uri?: Maybe<Scalars['String']>;
};

export type WorkflowRuntimeStorageData = {
  __typename?: 'WorkflowRuntimeStorageData';
  /** Data content - base64 encoded binary, plain string or encoded JSON */
  storageData: Scalars['String'];
  /** Unique lookup id for the workflowRuntimeData */
  storageKey: Scalars['String'];
  /** Optional metadata for the workflowRuntimeData */
  storageMetadata?: Maybe<Scalars['String']>;
};

export type WorkflowRuntimeStorageDataList = Page & {
  __typename?: 'WorkflowRuntimeStorageDataList';
  count?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  records?: Maybe<Array<Maybe<WorkflowRuntimeStorageData>>>;
};

/**
 * Contains information about a signed writable URL retrieved from the
 * getSignedWritableUrl mutation.
 */
export type WritableUrlInfo = {
  __typename?: 'WritableUrlInfo';
  /** The storage bucket ID */
  bucket: Scalars['String'];
  /** Absolute time at which this URL expires */
  expiresAtDateTime: Scalars['DateTime'];
  /** Time interval, in seconds, after which this URL is expired and no longer valid. */
  expiresInSeconds: Scalars['Int'];
  /**
   * A signed URL that can be used with HTTP GET to retrieve the
   * new resource.
   */
  getUrl: Scalars['String'];
  /** The storage object key */
  key: Scalars['String'];
  /**
   * The unsigned, base URL to the object, which can be safely persisted
   * and re-signed later by a client with the necessary storage credentials.
   */
  unsignedUrl?: Maybe<Scalars['String']>;
  /**
   * The signed URL, which can be uploaded to with an HTTP PUT (note:  PUT is
   * required. POST will generate an error).
   */
  url: Scalars['String'];
};

export enum FilterCombineOperator {
  And = 'AND',
  Or = 'OR'
}

export type GetEngineJwt = {
  /** The ID of the engine that created the asset */
  engineId?: InputMaybe<Scalars['ID']>;
  /** The set of IDs by resource type */
  resource: GetEngineJwtResource;
};

export type NotificationDelivery = {
  deliveryType?: InputMaybe<NotificationDeliveryType>;
  params?: InputMaybe<Scalars['JSONData']>;
};

export type PauseFlow = {
  /** flowId wo pause */
  flowId: Scalars['ID'];
};

export type AllowDagInOrgMutationVariables = Exact<{
  orgId: Scalars['ID'];
  dagTemplateId: Scalars['ID'];
}>;


export type AllowDagInOrgMutation = { __typename?: 'Mutation', addDagTemplateToOrganization: { __typename?: 'DagTemplateOrganizations', dagTemplateId: string } };

export type AllowEngineCategoriesInOrgMutationVariables = Exact<{
  orgId: Scalars['ID'];
  categoryIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type AllowEngineCategoriesInOrgMutation = { __typename?: 'Mutation', deleteFromEngineBlacklist?: { __typename?: 'EngineBlacklist', organizationId: string } | null };

export type AllowEnginesInOrgMutationVariables = Exact<{
  organizationId: Scalars['ID'];
  engineIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type AllowEnginesInOrgMutation = { __typename?: 'Mutation', addToEngineWhitelist?: { __typename?: 'EngineWhitelist', organizationId: string } | null };

export type CreateRadioJobScheduleMutationVariables = Exact<{
  dagTemplateId: Scalars['String'];
  name: Scalars['String'];
  jobTemplateId: Scalars['ID'];
  programFormat: Scalars['String'];
  startDateTime: Scalars['DateTime'];
  thumbnailUrl: Scalars['String'];
  weeklyScheduleParts?: InputMaybe<Array<CreateWeeklySchedulePart> | CreateWeeklySchedulePart>;
}>;


export type CreateRadioJobScheduleMutation = { __typename?: 'Mutation', createScheduledJob: { __typename?: 'ScheduledJob', id: string } };

export type CreateRadioJobTemplateMutationVariables = Exact<{
  clusterId: Scalars['ID'];
  sourceId: Scalars['ID'];
}>;


export type CreateRadioJobTemplateMutation = { __typename?: 'Mutation', createJobTemplate: { __typename?: 'JobTemplate', id: string } };

export type CreateRadioSourceMutationVariables = Exact<{
  band: Scalars['String'];
  callSign: Scalars['String'];
  collaborators?: InputMaybe<Array<CreateSourceCollaborator> | CreateSourceCollaborator>;
  format: Scalars['String'];
  isPublic: Scalars['Boolean'];
  siteUrl: Scalars['String'];
  sourceName: Scalars['String'];
  sourceTypeId: Scalars['ID'];
  station: Scalars['String'];
  streamUrl: Scalars['String'];
  thumbnailUrl: Scalars['String'];
  tz: Scalars['String'];
}>;


export type CreateRadioSourceMutation = { __typename?: 'Mutation', createSource?: { __typename?: 'Source', id: string } | null };

export type CreateUserMutationVariables = Exact<{
  username: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  orgId: Scalars['ID'];
  sendUserEmail?: InputMaybe<Scalars['Boolean']>;
  roleIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser?: { __typename?: 'User', id: string } | null };

export type CreateWideOrbitJobScheduleMutationVariables = Exact<{
  name: Scalars['String'];
  jobTemplateId: Scalars['ID'];
  startDateTime: Scalars['DateTime'];
  weeklyScheduleParts?: InputMaybe<Array<CreateWeeklySchedulePart> | CreateWeeklySchedulePart>;
}>;


export type CreateWideOrbitJobScheduleMutation = { __typename?: 'Mutation', createScheduledJob: { __typename?: 'ScheduledJob', id: string } };

export type CreateWideOrbitJobTemplateMutationVariables = Exact<{
  clusterId: Scalars['ID'];
  orgId: Scalars['ID'];
  sourceId: Scalars['ID'];
  apiKey: Scalars['String'];
}>;


export type CreateWideOrbitJobTemplateMutation = { __typename?: 'Mutation', createJobTemplate: { __typename?: 'JobTemplate', id: string } };

export type CreateWideOrbitStationMutationVariables = Exact<{
  input: CreateStructuredData;
}>;


export type CreateWideOrbitStationMutation = { __typename?: 'Mutation', createStructuredData?: { __typename?: 'StructuredData', id: string } | null };

export type GetAttributeSourcesQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetAttributeSourcesQuery = { __typename?: 'Query', sources: { __typename?: 'SourceList', count: number, records: Array<{ __typename?: 'Source', id: string, details?: any | null }> } };

export type GetRadioJobScheduleQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type GetRadioJobScheduleQuery = { __typename?: 'Query', scheduledJobs?: { __typename?: 'ScheduledJobList', records: Array<{ __typename?: 'ScheduledJob', details?: any | null, id: string, jobTemplateIds?: Array<string> | null, name?: string | null, runMode: RunMode, startDateTime?: any | null }> } | null };

export type GetRadioSourceQueryVariables = Exact<{
  sourceName: Scalars['String'];
}>;


export type GetRadioSourceQuery = { __typename?: 'Query', sources: { __typename?: 'SourceList', count: number, records: Array<{ __typename?: 'Source', id: string, details?: any | null }> } };

export type GetSourcesByNameQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
}>;


export type GetSourcesByNameQuery = { __typename?: 'Query', sources: { __typename?: 'SourceList', records: Array<{ __typename?: 'Source', id: string, details?: any | null }> } };

export type GetUserQueryVariables = Exact<{
  username?: InputMaybe<Scalars['String']>;
  orgIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type GetUserQuery = { __typename?: 'Query', users?: { __typename?: 'UserList', records?: Array<{ __typename?: 'User', id: string, name: string } | null> | null } | null };

export type GetWatchlistQueryVariables = Exact<{
  watchlistId: Scalars['ID'];
}>;


export type GetWatchlistQuery = { __typename?: 'Query', watchlist?: { __typename?: 'Watchlist', id: string, details?: any | null } | null };

export type UserLoginMutationVariables = Exact<{
  input?: InputMaybe<UserLogin>;
}>;


export type UserLoginMutation = { __typename?: 'Mutation', userLogin?: { __typename?: 'LoginInfo', token?: string | null, user?: { __typename?: 'User', id: string, name: string, email?: string | null } | null } | null };

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, roles?: Array<{ __typename?: 'Role', appName?: string | null, description?: string | null, id: string, name: string }> | null, rootFolder?: { __typename?: 'Folder', id: string, name?: string | null } | null, organization?: { __typename?: 'Organization', id: string, name?: string | null, jsondata?: any | null, rootFolder?: { __typename?: 'Folder', id: string, name?: string | null } | null } | null } | null };

export type GetMentionsInWatchlistQueryVariables = Exact<{
  watchlistId: Scalars['ID'];
  offset: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type GetMentionsInWatchlistQuery = { __typename?: 'Query', mentions?: { __typename?: 'MentionList', count?: number | null, records?: Array<{ __typename?: 'Mention', id: string, mentionDate?: any | null, metadata?: any | null, statusId?: string | null }> | null } | null };

export type UpdateRadioJobScheduleMutationVariables = Exact<{
  dagTemplateId: Scalars['String'];
  id: Scalars['ID'];
  jobTemplateIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  name: Scalars['String'];
  programFormat: Scalars['String'];
  startDateTime: Scalars['DateTime'];
  thumbnailUrl: Scalars['String'];
  weeklyScheduleParts?: InputMaybe<Array<CreateWeeklySchedulePart> | CreateWeeklySchedulePart>;
}>;


export type UpdateRadioJobScheduleMutation = { __typename?: 'Mutation', updateScheduledJob: { __typename?: 'ScheduledJob', id: string } };

export type UpdateRadioSourceMutationVariables = Exact<{
  band: Scalars['String'];
  callSign: Scalars['String'];
  collaborators?: InputMaybe<Array<CreateSourceCollaborator> | CreateSourceCollaborator>;
  format: Scalars['String'];
  isPublic: Scalars['Boolean'];
  siteUrl: Scalars['String'];
  sourceId: Scalars['ID'];
  sourceName: Scalars['String'];
  station: Scalars['String'];
  streamUrl: Scalars['String'];
  thumbnailUrl: Scalars['String'];
  tz: Scalars['String'];
}>;


export type UpdateRadioSourceMutation = { __typename?: 'Mutation', updateSource?: { __typename?: 'Source', id: string } | null };

export type UpdateWatchlistMutationVariables = Exact<{
  id: Scalars['ID'];
  details?: InputMaybe<Scalars['JSONData']>;
}>;


export type UpdateWatchlistMutation = { __typename?: 'Mutation', updateWatchlist?: { __typename?: 'Watchlist', id: string, details?: any | null } | null };


export const AllowDagInOrgDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AllowDagInOrg"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dagTemplateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addDagTemplateToOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"dagTemplateId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dagTemplateId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dagTemplateId"}}]}}]}}]} as unknown as DocumentNode<AllowDagInOrgMutation, AllowDagInOrgMutationVariables>;
export const AllowEngineCategoriesInOrgDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AllowEngineCategoriesInOrg"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteFromEngineBlacklist"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"toDelete"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"engineCategoryIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationId"}}]}}]}}]} as unknown as DocumentNode<AllowEngineCategoriesInOrgMutation, AllowEngineCategoriesInOrgMutationVariables>;
export const AllowEnginesInOrgDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AllowEnginesInOrg"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"engineIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addToEngineWhitelist"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"toAdd"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"engineIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"engineIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationId"}}]}}]}}]} as unknown as DocumentNode<AllowEnginesInOrgMutation, AllowEnginesInOrgMutationVariables>;
export const CreateRadioJobScheduleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createRadioJobSchedule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dagTemplateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobTemplateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programFormat"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDateTime"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailUrl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"weeklyScheduleParts"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateWeeklySchedulePart"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createScheduledJob"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"details"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dagTemplateId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dagTemplateId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"isNational"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"isNationallySyndicated"},"value":{"kind":"BooleanValue","value":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"programFormat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programFormat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"programImage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailUrl"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"programLiveImage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailUrl"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"jobTemplateIds"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"jobTemplateId"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"runMode"},"value":{"kind":"EnumValue","value":"Recurring"}},{"kind":"ObjectField","name":{"kind":"Name","value":"startDateTime"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDateTime"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"weeklyScheduleParts"},"value":{"kind":"Variable","name":{"kind":"Name","value":"weeklyScheduleParts"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateRadioJobScheduleMutation, CreateRadioJobScheduleMutationVariables>;
export const CreateRadioJobTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createRadioJobTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clusterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createJobTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"clusterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clusterId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"jobConfig"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createTDOInput"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"details"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tags"},"value":{"kind":"ListValue","values":[]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"sourceData"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sourceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"maxTDODuration"},"value":{"kind":"IntValue","value":"15"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"routes"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"childIoFolderReferenceId"},"value":{"kind":"StringValue","value":"PB_INPUT","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"parentIoFolderReferenceId"},"value":{"kind":"StringValue","value":"TVR_OUTPUT","block":false}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"childIoFolderReferenceId"},"value":{"kind":"StringValue","value":"CHUNK_INPUT","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"parentIoFolderReferenceId"},"value":{"kind":"StringValue","value":"TVR_OUTPUT","block":false}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"childIoFolderReferenceId"},"value":{"kind":"StringValue","value":"SM_INPUT","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"parentIoFolderReferenceId"},"value":{"kind":"StringValue","value":"CHUNK_OUTPUT","block":false}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"childIoFolderReferenceId"},"value":{"kind":"StringValue","value":"OW_INPUT","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"parentIoFolderReferenceId"},"value":{"kind":"StringValue","value":"SM_OUTPUT","block":false}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"taskTemplates"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"engineId"},"value":{"kind":"StringValue","value":"74dfd76b-472a-48f0-8395-c7e01dd7f255","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"ioFolders"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"mode"},"value":{"kind":"EnumValue","value":"stream"}},{"kind":"ObjectField","name":{"kind":"Name","value":"referenceId"},"value":{"kind":"StringValue","value":"TVR_OUTPUT","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"output"}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"payload"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"mode"},"value":{"kind":"StringValue","value":"ingest","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"sourceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"engineId"},"value":{"kind":"StringValue","value":"352556c7-de07-4d55-b33f-74b1cf237f25","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"executionPreferences"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parentCompleteBeforeStarting"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ioFolders"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"mode"},"value":{"kind":"EnumValue","value":"stream"}},{"kind":"ObjectField","name":{"kind":"Name","value":"referenceId"},"value":{"kind":"StringValue","value":"PB_INPUT","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"input"}}]}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"engineId"},"value":{"kind":"StringValue","value":"8bdb0e3b-ff28-4f6e-a3ba-887bd06e6440","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"executionPreferences"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parentCompleteBeforeStarting"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ioFolders"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"mode"},"value":{"kind":"EnumValue","value":"stream"}},{"kind":"ObjectField","name":{"kind":"Name","value":"referenceId"},"value":{"kind":"StringValue","value":"CHUNK_INPUT","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"input"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"mode"},"value":{"kind":"EnumValue","value":"chunk"}},{"kind":"ObjectField","name":{"kind":"Name","value":"referenceId"},"value":{"kind":"StringValue","value":"CHUNK_OUTPUT","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"output"}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"payload"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ffmpegTemplate"},"value":{"kind":"StringValue","value":"audio","block":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"engineId"},"value":{"kind":"StringValue","value":"bbb11671-e21e-4e0f-a790-2ef1841ee554","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"ioFolders"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"mode"},"value":{"kind":"EnumValue","value":"chunk"}},{"kind":"ObjectField","name":{"kind":"Name","value":"referenceId"},"value":{"kind":"StringValue","value":"SM_INPUT","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"input"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"mode"},"value":{"kind":"EnumValue","value":"chunk"}},{"kind":"ObjectField","name":{"kind":"Name","value":"referenceId"},"value":{"kind":"StringValue","value":"SM_OUTPUT","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"output"}}]}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"engineId"},"value":{"kind":"StringValue","value":"8eccf9cc-6b6d-4d7d-8cb3-7ebf4950c5f3","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"ioFolders"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"mode"},"value":{"kind":"EnumValue","value":"chunk"}},{"kind":"ObjectField","name":{"kind":"Name","value":"referenceId"},"value":{"kind":"StringValue","value":"OW_INPUT","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"input"}}]}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateRadioJobTemplateMutation, CreateRadioJobTemplateMutationVariables>;
export const CreateRadioSourceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createRadioSource"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"band"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"callSign"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collaborators"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateSourceCollaborator"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"format"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isPublic"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteUrl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"station"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"streamUrl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailUrl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tz"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSource"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"collaborators"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collaborators"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"details"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"liveTimezone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tz"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"radioStreamUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"streamUrl"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sourceFormat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"format"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"stationBand"},"value":{"kind":"Variable","name":{"kind":"Name","value":"band"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"stationCallSign"},"value":{"kind":"Variable","name":{"kind":"Name","value":"callSign"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"stationChannel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"station"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"webSiteUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteUrl"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isPublic"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isPublic"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sourceTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceTypeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"thumbnailUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailUrl"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateRadioSourceMutation, CreateRadioSourceMutationVariables>;
export const CreateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"username"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sendUserEmail"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roleIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"acls"},"value":{"kind":"ListValue","values":[]}},{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"firstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"username"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"roleIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roleIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sendNewUserEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sendUserEmail"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateUserMutation, CreateUserMutationVariables>;
export const CreateWideOrbitJobScheduleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createWideOrbitJobSchedule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobTemplateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDateTime"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"weeklyScheduleParts"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateWeeklySchedulePart"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createScheduledJob"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobTemplateIds"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"jobTemplateId"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"runMode"},"value":{"kind":"EnumValue","value":"Recurring"}},{"kind":"ObjectField","name":{"kind":"Name","value":"startDateTime"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDateTime"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"weeklyScheduleParts"},"value":{"kind":"Variable","name":{"kind":"Name","value":"weeklyScheduleParts"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateWideOrbitJobScheduleMutation, CreateWideOrbitJobScheduleMutationVariables>;
export const CreateWideOrbitJobTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createWideOrbitJobTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clusterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"apiKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createJobTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"clusterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clusterId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"taskTemplates"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"engineId"},"value":{"kind":"StringValue","value":"c90bfb8a-bde3-4a1f-ae42-6c47f69812da","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"payload"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ingestionType"},"value":{"kind":"StringValue","value":"spots","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"mediaSourceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"maxAttempts"},"value":{"kind":"IntValue","value":"3"}},{"kind":"ObjectField","name":{"kind":"Name","value":"wideOrbitKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"apiKey"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateWideOrbitJobTemplateMutation, CreateWideOrbitJobTemplateMutationVariables>;
export const CreateWideOrbitStationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateWideOrbitStation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateStructuredData"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createStructuredData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateWideOrbitStationMutation, CreateWideOrbitStationMutationVariables>;
export const GetAttributeSourcesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAttributeSources"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sources"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sourceTypeIds"},"value":{"kind":"ListValue","values":[{"kind":"IntValue","value":"1"},{"kind":"IntValue","value":"2"}]}},{"kind":"Argument","name":{"kind":"Name","value":"permission"},"value":{"kind":"EnumValue","value":"viewer"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"includePublic"},"value":{"kind":"BooleanValue","value":false}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"id"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"details"}}]}}]}}]}}]} as unknown as DocumentNode<GetAttributeSourcesQuery, GetAttributeSourcesQueryVariables>;
export const GetRadioJobScheduleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRadioJobSchedule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduledJobs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"details"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"jobTemplateIds"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"runMode"}},{"kind":"Field","name":{"kind":"Name","value":"startDateTime"}}]}}]}}]}}]} as unknown as DocumentNode<GetRadioJobScheduleQuery, GetRadioJobScheduleQueryVariables>;
export const GetRadioSourceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRadioSource"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sources"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceName"}}},{"kind":"Argument","name":{"kind":"Name","value":"nameMatch"},"value":{"kind":"EnumValue","value":"exact"}},{"kind":"Argument","name":{"kind":"Name","value":"includePublic"},"value":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"details"}}]}}]}}]}}]} as unknown as DocumentNode<GetRadioSourceQuery, GetRadioSourceQueryVariables>;
export const GetSourcesByNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSourcesByName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sources"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"details"}}]}}]}}]}}]} as unknown as DocumentNode<GetSourcesByNameQuery, GetSourcesByNameQueryVariables>;
export const GetUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"username"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"username"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserQuery, GetUserQueryVariables>;
export const GetWatchlistDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWatchlist"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"watchlistId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"watchlist"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"watchlistId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"details"}}]}}]}}]} as unknown as DocumentNode<GetWatchlistQuery, GetWatchlistQueryVariables>;
export const UserLoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UserLogin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserLogin"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userLogin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]} as unknown as DocumentNode<UserLoginMutation, UserLoginMutationVariables>;
export const GetMeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rootFolder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"jsondata"}},{"kind":"Field","name":{"kind":"Name","value":"rootFolder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetMeQuery, GetMeQueryVariables>;
export const GetMentionsInWatchlistDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMentionsInWatchlist"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"watchlistId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mentions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"watchlistId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"watchlistId"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"mentionDate"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mentionDate"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"statusId"}}]}}]}}]}}]} as unknown as DocumentNode<GetMentionsInWatchlistQuery, GetMentionsInWatchlistQueryVariables>;
export const UpdateRadioJobScheduleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateRadioJobSchedule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dagTemplateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobTemplateIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programFormat"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDateTime"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailUrl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"weeklyScheduleParts"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateWeeklySchedulePart"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateScheduledJob"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"details"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dagTemplateId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dagTemplateId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"isNational"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"isNationallySyndicated"},"value":{"kind":"BooleanValue","value":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"programFormat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programFormat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"programImage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailUrl"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"programLiveImage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailUrl"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"jobTemplateIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobTemplateIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"runMode"},"value":{"kind":"EnumValue","value":"Recurring"}},{"kind":"ObjectField","name":{"kind":"Name","value":"startDateTime"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDateTime"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"weeklyScheduleParts"},"value":{"kind":"Variable","name":{"kind":"Name","value":"weeklyScheduleParts"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateRadioJobScheduleMutation, UpdateRadioJobScheduleMutationVariables>;
export const UpdateRadioSourceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateRadioSource"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"band"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"callSign"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collaborators"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateSourceCollaborator"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"format"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isPublic"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteUrl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"station"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"streamUrl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailUrl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tz"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSource"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"collaborators"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collaborators"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"details"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"liveTimezone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tz"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"radioStreamUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"streamUrl"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sourceFormat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"format"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"stationBand"},"value":{"kind":"Variable","name":{"kind":"Name","value":"band"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"stationCallSign"},"value":{"kind":"Variable","name":{"kind":"Name","value":"callSign"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"stationChannel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"station"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"webSiteUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteUrl"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isPublic"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isPublic"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"thumbnailUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thumbnailUrl"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateRadioSourceMutation, UpdateRadioSourceMutationVariables>;
export const UpdateWatchlistDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateWatchlist"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"details"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSONData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateWatchlist"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"details"},"value":{"kind":"Variable","name":{"kind":"Name","value":"details"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"details"}}]}}]}}]} as unknown as DocumentNode<UpdateWatchlistMutation, UpdateWatchlistMutationVariables>;
